//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const PROCESSAPI_BASE_URL = new InjectionToken<string>('PROCESSAPI_BASE_URL');

@Injectable()
export class AccessCardReaderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Receive a new access card detection signal
     * @param body (optional) 
     * @return OK
     */
    detectAccessCard(body: AccessCardDetectionInputDto | undefined): Observable<AccessCardDetectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/AccessCardReader/DetectAccessCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetectAccessCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetectAccessCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessCardDetectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessCardDetectionOutputDto>;
        }));
    }

    protected processDetectAccessCard(response: HttpResponseBase): Observable<AccessCardDetectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessCardDetectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Return whether the report with the given id can be edited.
     * @param id (optional) 
     * @return OK
     */
    canEditWoodActivityReport(id: number | undefined): Observable<CanEditReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/CanEditWoodActivityReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanEditWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanEditWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanEditReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanEditReportOutput>;
        }));
    }

    protected processCanEditWoodActivityReport(response: HttpResponseBase): Observable<CanEditReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanEditReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates an origin for the report being edited
     * @param body (optional) 
     * @return OK
     */
    validateOriginForReportEdition(body: ValidateOriginForReportEditionInput | undefined): Observable<ValidateOriginForReportEditionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateOriginForReportEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateOriginForReportEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateOriginForReportEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateOriginForReportEditionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateOriginForReportEditionOutput>;
        }));
    }

    protected processValidateOriginForReportEdition(response: HttpResponseBase): Observable<ValidateOriginForReportEditionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateOriginForReportEditionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates a stand for the report being edited
     * @param body (optional) 
     * @return OK
     */
    validateStandForReportEdition(body: ValidateStandForReportEditionInput | undefined): Observable<ValidateStandForReportEditionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateStandForReportEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateStandForReportEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateStandForReportEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateStandForReportEditionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateStandForReportEditionOutput>;
        }));
    }

    protected processValidateStandForReportEdition(response: HttpResponseBase): Observable<ValidateStandForReportEditionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateStandForReportEditionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all activity reports with the given search filters
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchReport(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/SearchReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchReport(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject activity report exit
     * @param receiptId (optional) 
     * @param entranceOnly (optional) 
     * @param zoneId (optional) 
     * @return OK
     */
    rejectReceipt(receiptId: number | undefined, entranceOnly: boolean | undefined, zoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/RejectReceipt?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (entranceOnly === null)
            throw new Error("The parameter 'entranceOnly' cannot be null.");
        else if (entranceOnly !== undefined)
            url_ += "entranceOnly=" + encodeURIComponent("" + entranceOnly) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged and sorted list of wood activity reports to be mass edited,
    and whether these can be edited or not, filtered by the input parameters
     * @param originId (optional) 
     * @param standId (optional) 
     * @param articleId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getWoodActivityReportForMassEditGrid(originId: number | undefined, standId: number | undefined, articleId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetWoodActivityReportForMassEditGrid?";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportForMassEditGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportForMassEditGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto>;
        }));
    }

    protected processGetWoodActivityReportForMassEditGrid(response: HttpResponseBase): Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodActivityReportForMassEditGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates the new origin of a mass edit
     * @param body (optional) 
     * @return OK
     */
    validateOriginForMassEdit(body: ValidateOriginForMassEditInput | undefined): Observable<ValidateOriginForMassEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateOriginForMassEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateOriginForMassEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateOriginForMassEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateOriginForMassEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateOriginForMassEditOutput>;
        }));
    }

    protected processValidateOriginForMassEdit(response: HttpResponseBase): Observable<ValidateOriginForMassEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateOriginForMassEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Registers the mass edit to be executed
     * @param body (optional) 
     * @return OK
     */
    executeMassEdit(body: ExecuteMassEditInputDto | undefined): Observable<ExecuteMassEditOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ExecuteMassEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteMassEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteMassEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExecuteMassEditOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExecuteMassEditOutputDto>;
        }));
    }

    protected processExecuteMassEdit(response: HttpResponseBase): Observable<ExecuteMassEditOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExecuteMassEditOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all activity reports for logyards with the given search filters
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchReportForLogyards(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/SearchReportForLogyards?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReportForLogyards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReportForLogyards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchReportForLogyards(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export all activity reports for logyards with the given search filters
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    exportSearchReportForLogyardsResult(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ExportSearchReportForLogyardsResult?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSearchReportForLogyardsResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSearchReportForLogyardsResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportSearchReportForLogyardsResult(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood activity reports for samples grid
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param includeAlreadySampled (optional) 
     * @param includeInPlantSamples (optional) 
     * @param includeNotAssigned (optional) 
     * @param standNumber (optional) 
     * @param isChip (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param id (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getWoodActivityReportsForSamplesGrid(dateFrom: DateTime | undefined, dateTo: DateTime | undefined, sampleType: SampleAssignmentType, includeAlreadySampled: boolean | undefined, includeInPlantSamples: boolean | undefined, includeNotAssigned: boolean | undefined, standNumber: number | undefined, isChip: boolean | undefined, licensePlate: string | undefined, originId: number | undefined, id: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodActivityReportForSamplesGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetWoodActivityReportsForSamplesGrid?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (sampleType === undefined || sampleType === null)
            throw new Error("The parameter 'sampleType' must be defined and cannot be null.");
        else
            url_ += "SampleType=" + encodeURIComponent("" + sampleType) + "&";
        if (includeAlreadySampled === null)
            throw new Error("The parameter 'includeAlreadySampled' cannot be null.");
        else if (includeAlreadySampled !== undefined)
            url_ += "IncludeAlreadySampled=" + encodeURIComponent("" + includeAlreadySampled) + "&";
        if (includeInPlantSamples === null)
            throw new Error("The parameter 'includeInPlantSamples' cannot be null.");
        else if (includeInPlantSamples !== undefined)
            url_ += "IncludeInPlantSamples=" + encodeURIComponent("" + includeInPlantSamples) + "&";
        if (includeNotAssigned === null)
            throw new Error("The parameter 'includeNotAssigned' cannot be null.");
        else if (includeNotAssigned !== undefined)
            url_ += "IncludeNotAssigned=" + encodeURIComponent("" + includeNotAssigned) + "&";
        if (standNumber === null)
            throw new Error("The parameter 'standNumber' cannot be null.");
        else if (standNumber !== undefined)
            url_ += "StandNumber=" + encodeURIComponent("" + standNumber) + "&";
        if (isChip === null)
            throw new Error("The parameter 'isChip' cannot be null.");
        else if (isChip !== undefined)
            url_ += "IsChip=" + encodeURIComponent("" + isChip) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportsForSamplesGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportsForSamplesGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodActivityReportForSamplesGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodActivityReportForSamplesGridDto>;
        }));
    }

    protected processGetWoodActivityReportsForSamplesGrid(response: HttpResponseBase): Observable<PagedResultDtoOfWoodActivityReportForSamplesGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodActivityReportForSamplesGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ArchimedesSampleIndicatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getArchimedesStandMonitorIndicator(): Observable<ArchimedesStandMonitorDtoOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/ArchimedesSampleIndicator/GetArchimedesStandMonitorIndicator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchimedesStandMonitorIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchimedesStandMonitorIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchimedesStandMonitorDtoOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchimedesStandMonitorDtoOutput[]>;
        }));
    }

    protected processGetArchimedesStandMonitorIndicator(response: HttpResponseBase): Observable<ArchimedesStandMonitorDtoOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArchimedesStandMonitorDtoOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ArticleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the wood article for the given id
     * @param articleId (optional) 
     * @return OK
     */
    get(articleId: number | undefined): Observable<ArticleDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/Get?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDtoOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ArticleDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood articles for the given location id
     * @param locationId (optional) 
     * @param checkActiveContract (optional) If true, only articles with active contract will be returned. If false, articles with both active and inactive contract will be returned
     * @return OK
     */
    getArticleByLocationId(locationId: number | undefined, checkActiveContract: boolean | undefined): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (checkActiveContract === null)
            throw new Error("The parameter 'checkActiveContract' cannot be null.");
        else if (checkActiveContract !== undefined)
            url_ += "checkActiveContract=" + encodeURIComponent("" + checkActiveContract) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
        }));
    }

    protected processGetArticleByLocationId(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all internal movement articles containing the given string in their name
     * @param articleName (optional) 
     * @return OK
     */
    getArticleInternalMovements(articleName: string | undefined): Observable<CustomPagedResultDtoOfArticleInternalMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleInternalMovements?";
        if (articleName === null)
            throw new Error("The parameter 'articleName' cannot be null.");
        else if (articleName !== undefined)
            url_ += "articleName=" + encodeURIComponent("" + articleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleInternalMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleInternalMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleInternalMovementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleInternalMovementDto>;
        }));
    }

    protected processGetArticleInternalMovements(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleInternalMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleInternalMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood articles containing the given string in their name
     * @param articleName (optional) 
     * @return OK
     */
    getArticleByName(articleName: string | undefined): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleByName?";
        if (articleName === null)
            throw new Error("The parameter 'articleName' cannot be null.");
        else if (articleName !== undefined)
            url_ += "articleName=" + encodeURIComponent("" + articleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
        }));
    }

    protected processGetArticleByName(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood articles
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of lengths)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getAllArticles(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetAllArticles?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
        }));
    }

    protected processGetAllArticles(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all diverse product articles containing the given string in their name
     * @param articleName (optional) 
     * @return OK
     */
    getArticleDiverseProduct(articleName: string | undefined): Observable<CustomPagedResultDtoOfArticleDiverseProductsDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleDiverseProduct?";
        if (articleName === null)
            throw new Error("The parameter 'articleName' cannot be null.");
        else if (articleName !== undefined)
            url_ += "articleName=" + encodeURIComponent("" + articleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleDiverseProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleDiverseProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleDiverseProductsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleDiverseProductsDto>;
        }));
    }

    protected processGetArticleDiverseProduct(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleDiverseProductsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleDiverseProductsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood articles for the given location id, with the given FSC certification
     * @param locationId (optional) 
     * @param isFsc (optional) If true, only articles with FSC certification will be returned. If false, only articles with no FSC certification will be returned
     * @param checkActiveContract (optional) If true, only articles with active contract will be returned. If false, articles with both active and inactive contract will be returned
     * @return OK
     */
    getFscArticlesByLocationId(locationId: number | undefined, isFsc: boolean | undefined, checkActiveContract: boolean | undefined): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetFscArticlesByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (isFsc === null)
            throw new Error("The parameter 'isFsc' cannot be null.");
        else if (isFsc !== undefined)
            url_ += "isFsc=" + encodeURIComponent("" + isFsc) + "&";
        if (checkActiveContract === null)
            throw new Error("The parameter 'checkActiveContract' cannot be null.");
        else if (checkActiveContract !== undefined)
            url_ += "checkActiveContract=" + encodeURIComponent("" + checkActiveContract) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFscArticlesByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFscArticlesByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleDtoOutput>;
        }));
    }

    protected processGetFscArticlesByLocationId(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood article lengths
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of lengths)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getAllLengths(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfLengthDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetAllLengths?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLengths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLengths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLengthDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLengthDto>;
        }));
    }

    protected processGetAllLengths(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLengthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLengthDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood article species
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of lengths)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getAllSpecies(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSpeciesDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetAllSpecies?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSpecies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpecies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSpeciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSpeciesDto>;
        }));
    }

    protected processGetAllSpecies(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSpeciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSpeciesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the wood article of the given length and FSC certification, containing the given string on its speciesGroupName
     * @param lengthId (optional) 
     * @param speciesGroupName (optional) 
     * @param isFscCertified (optional) If true, only articles with FSC certification will be returned. If false, only articles with no FSC certification will be returned
     * @return OK
     */
    getArticleByLengthSpeciesGroupNameAndFsc(lengthId: number | undefined, speciesGroupName: string | undefined, isFscCertified: boolean | undefined): Observable<ArticleDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleByLengthSpeciesGroupNameAndFsc?";
        if (lengthId === null)
            throw new Error("The parameter 'lengthId' cannot be null.");
        else if (lengthId !== undefined)
            url_ += "lengthId=" + encodeURIComponent("" + lengthId) + "&";
        if (speciesGroupName === null)
            throw new Error("The parameter 'speciesGroupName' cannot be null.");
        else if (speciesGroupName !== undefined)
            url_ += "speciesGroupName=" + encodeURIComponent("" + speciesGroupName) + "&";
        if (isFscCertified === null)
            throw new Error("The parameter 'isFscCertified' cannot be null.");
        else if (isFscCertified !== undefined)
            url_ += "isFscCertified=" + encodeURIComponent("" + isFscCertified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleByLengthSpeciesGroupNameAndFsc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleByLengthSpeciesGroupNameAndFsc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDtoOutput>;
        }));
    }

    protected processGetArticleByLengthSpeciesGroupNameAndFsc(response: HttpResponseBase): Observable<ArticleDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all third property wood articles associated to their corresponding third property
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of third property articles)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getThirdPropertyArticles(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfArticleByLocationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetThirdPropertyArticles?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThirdPropertyArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThirdPropertyArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleByLocationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleByLocationOutput>;
        }));
    }

    protected processGetThirdPropertyArticles(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleByLocationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleByLocationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all logyard wood articles associated to their corresponding logyard
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of logyard articles)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getLogyardArticles(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfArticleByLocationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetLogyardArticles?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogyardArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogyardArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleByLocationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleByLocationOutput>;
        }));
    }

    protected processGetLogyardArticles(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleByLocationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleByLocationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all stand wood articles associated to their corresponding stand
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of stand articles)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getStandArticles(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfArticleByLocationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetStandArticles?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArticleByLocationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArticleByLocationOutput>;
        }));
    }

    protected processGetStandArticles(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArticleByLocationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArticleByLocationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get diverse product article by id
     * @param articleId (optional) Article id
     * @return OK
     */
    getDiverseProductArticleById(articleId: number | undefined): Observable<ArticleDiverseProductsDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetDiverseProductArticleById?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductArticleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductArticleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDiverseProductsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDiverseProductsDto>;
        }));
    }

    protected processGetDiverseProductArticleById(response: HttpResponseBase): Observable<ArticleDiverseProductsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDiverseProductsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all auditing logs with the properties of the given input
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfProcessAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProcessAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProcessAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfProcessAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProcessAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export all auditing logs with the properties of the given input to an Excel file
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all integration logs of the report with the given id
     * @param reportId (optional) 
     * @return OK
     */
    getIntegrationLogs(reportId: number | undefined): Observable<IntegrationLogOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetIntegrationLogs?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationLogOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationLogOutputDto[]>;
        }));
    }

    protected processGetIntegrationLogs(response: HttpResponseBase): Observable<IntegrationLogOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationLogOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all caches
     * @return OK
     */
    getAllCaches(): Observable<ListResultDtoOfProcessCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfProcessCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfProcessCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfProcessCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfProcessCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clear cache by given id
     * @param body (optional) 
     * @return OK
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clear all caches
     * @return OK
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CheckPointServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Complete current entering report with access card an weight detection information
     * @param tenantId (optional) 
     * @param placeId (optional) 
     * @param zoneId (optional) 
     * @param body (optional) 
     * @return OK
     */
    executeEntryProcessByAccessCardDetection(tenantId: number | undefined, placeId: number | undefined, zoneId: number | undefined, body: AccessCardDetectionInputDto | undefined): Observable<AccessCardDetectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ExecuteEntryProcessByAccessCardDetection?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteEntryProcessByAccessCardDetection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteEntryProcessByAccessCardDetection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessCardDetectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessCardDetectionOutputDto>;
        }));
    }

    protected processExecuteEntryProcessByAccessCardDetection(response: HttpResponseBase): Observable<AccessCardDetectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessCardDetectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start a new entry automatic process using license plate.
     * @param body (optional) 
     * @return OK
     */
    beginEntryProcessWithLicensePlate(body: BeginEntryProcessWithLicensePlateInput | undefined): Observable<ProcessWithLicensePlateOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/BeginEntryProcessWithLicensePlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginEntryProcessWithLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginEntryProcessWithLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessWithLicensePlateOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessWithLicensePlateOutputDto>;
        }));
    }

    protected processBeginEntryProcessWithLicensePlate(response: HttpResponseBase): Observable<ProcessWithLicensePlateOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessWithLicensePlateOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Continues wood entry process using given QR code
     * @param reportId (optional) 
     * @param qrCode (optional) 
     * @return OK
     */
    continueEntryProcessUsingQR(reportId: number | undefined, qrCode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ContinueEntryProcessUsingQR?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (qrCode === null)
            throw new Error("The parameter 'qrCode' cannot be null.");
        else if (qrCode !== undefined)
            url_ += "qrCode=" + encodeURIComponent("" + qrCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContinueEntryProcessUsingQR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContinueEntryProcessUsingQR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContinueEntryProcessUsingQR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start entry process with RFID tag detected
     * @param body (optional) 
     * @return OK
     */
    executeEntryProcessByRfid(body: ExecuteEntryProcessByRfidInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ExecuteEntryProcessByRfid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteEntryProcessByRfid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteEntryProcessByRfid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteEntryProcessByRfid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Process detected or external semitrailers
     * @param entryZoneId (optional) 
     * @return OK
     */
    processDetectedOrExternalSemitrailers(entryZoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ProcessDetectedOrExternalSemitrailers?";
        if (entryZoneId === null)
            throw new Error("The parameter 'entryZoneId' cannot be null.");
        else if (entryZoneId !== undefined)
            url_ += "entryZoneId=" + encodeURIComponent("" + entryZoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessDetectedOrExternalSemitrailers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessDetectedOrExternalSemitrailers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessDetectedOrExternalSemitrailers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Continues wood entry process
     * @param body (optional) parameters
     * @return OK
     */
    confirmEntry(body: ConfirmEntryInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ConfirmEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send reject entry notification
     * @param zoneId (optional) 
     * @return OK
     */
    sendRejectEntryNotification(zoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/SendRejectEntryNotification?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRejectEntryNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRejectEntryNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendRejectEntryNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active entrance zones by place or current user place if parameter is default
     * @param placeId (optional) 
     * @return OK
     */
    getActiveMonitorsZones(placeId: number | undefined): Observable<MonitorZonesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/GetActiveMonitorsZones?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMonitorsZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMonitorsZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitorZonesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitorZonesOutputDto>;
        }));
    }

    protected processGetActiveMonitorsZones(response: HttpResponseBase): Observable<MonitorZonesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitorZonesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm truck flow type when truck exist in system api and products.
     * @param body (optional) 
     * @return OK
     */
    confirmTruckTypeSelection(body: ConfirmTruckTypeSelection | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ConfirmTruckTypeSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmTruckTypeSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmTruckTypeSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmTruckTypeSelection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Continues wood entry process with gross weight outside tolerance
     * @param zoneId (optional) 
     * @param activityReportId (optional) 
     * @return OK
     */
    confirmEntryWithGrossWeightOutsideTolerance(zoneId: number | undefined, activityReportId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckPoint/ConfirmEntryWithGrossWeightOutsideTolerance?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEntryWithGrossWeightOutsideTolerance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEntryWithGrossWeightOutsideTolerance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmEntryWithGrossWeightOutsideTolerance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get contract by Id
     * @param tenantId (optional) 
     * @param id (optional) 
     * @return OK
     */
    get(tenantId: number | undefined, id: number | undefined): Observable<ContractDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Get?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDtoOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contract with contract type by Id
     * @param contractId (optional) 
     * @return OK
     */
    getContractAndContractTypeByContractID(contractId: number | undefined): Observable<ContractDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetContractAndContractTypeByContractID?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractAndContractTypeByContractID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractAndContractTypeByContractID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDtoOutput>;
        }));
    }

    protected processGetContractAndContractTypeByContractID(response: HttpResponseBase): Observable<ContractDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contract and contract type by location Id
     * @param locationId (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getContractAndContractTypeByLocationID(locationId: number | undefined, originId: number | undefined, destinationId: number | undefined, originType: LocationType): Observable<ContractDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetContractAndContractTypeByLocationID?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (originType === undefined || originType === null)
            throw new Error("The parameter 'originType' must be defined and cannot be null.");
        else
            url_ += "originType=" + encodeURIComponent("" + originType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractAndContractTypeByLocationID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractAndContractTypeByLocationID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDtoOutput>;
        }));
    }

    protected processGetContractAndContractTypeByLocationID(response: HttpResponseBase): Observable<ContractDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contract and contract type with type group by location Id
     * @param locationId (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getContractAndContractTypeWithTypeGroupByLocationID(locationId: number | undefined, originId: number | undefined, destinationId: number | undefined, originType: LocationType): Observable<ContractDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetContractAndContractTypeWithTypeGroupByLocationID?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (originType === undefined || originType === null)
            throw new Error("The parameter 'originType' must be defined and cannot be null.");
        else
            url_ += "originType=" + encodeURIComponent("" + originType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractAndContractTypeWithTypeGroupByLocationID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractAndContractTypeWithTypeGroupByLocationID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDtoOutput>;
        }));
    }

    protected processGetContractAndContractTypeWithTypeGroupByLocationID(response: HttpResponseBase): Observable<ContractDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of contracts
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfContractDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfContractDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of contract types
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllContractTypes(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfContractTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAllContractTypes?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContractTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContractTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfContractTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfContractTypeDto>;
        }));
    }

    protected processGetAllContractTypes(response: HttpResponseBase): Observable<CustomPagedResultDtoOfContractTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfContractTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a contract type by id
     * @param contractTypeId (optional) 
     * @return OK
     */
    getContractTypeById(contractTypeId: number | undefined): Observable<ContractTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetContractTypeById?";
        if (contractTypeId === null)
            throw new Error("The parameter 'contractTypeId' cannot be null.");
        else if (contractTypeId !== undefined)
            url_ += "contractTypeId=" + encodeURIComponent("" + contractTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTypeDto>;
        }));
    }

    protected processGetContractTypeById(response: HttpResponseBase): Observable<ContractTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of contract type usages
     * @param name (optional) 
     * @return OK
     */
    getAllContractTypeUsageByName(name: string | undefined): Observable<CustomPagedResultDtoOfContractTypeUsageDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAllContractTypeUsageByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContractTypeUsageByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContractTypeUsageByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfContractTypeUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfContractTypeUsageDto>;
        }));
    }

    protected processGetAllContractTypeUsageByName(response: HttpResponseBase): Observable<CustomPagedResultDtoOfContractTypeUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfContractTypeUsageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of logyards with tree volume information
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLogyardTreeVolumes(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfLogyardWithSpeciesDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAllLogyardTreeVolumes?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogyardTreeVolumes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogyardTreeVolumes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLogyardWithSpeciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLogyardWithSpeciesDto>;
        }));
    }

    protected processGetAllLogyardTreeVolumes(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLogyardWithSpeciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLogyardWithSpeciesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustodyChainServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfCustodyChainDto> {
        let url_ = this.baseUrl + "/api/services/app/CustodyChain/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfCustodyChainDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfCustodyChainDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfCustodyChainDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfCustodyChainDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DensityPerSpeciesGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDensityPerSpeciesGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/DensityPerSpeciesGroup/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDensityPerSpeciesGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDensityPerSpeciesGroupDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDensityPerSpeciesGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDensityPerSpeciesGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<DensityPerSpeciesGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/DensityPerSpeciesGroup/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DensityPerSpeciesGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DensityPerSpeciesGroupDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DensityPerSpeciesGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DensityPerSpeciesGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DetourServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Execute detour detection
     * @param tagValue (optional) 
     * @param detourZoneId (optional) 
     * @param placeId (optional) 
     * @return OK
     */
    executeDetourDetection(tagValue: number | undefined, detourZoneId: number | undefined, placeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Detour/ExecuteDetourDetection?";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (detourZoneId === null)
            throw new Error("The parameter 'detourZoneId' cannot be null.");
        else if (detourZoneId !== undefined)
            url_ += "detourZoneId=" + encodeURIComponent("" + detourZoneId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteDetourDetection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteDetourDetection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteDetourDetection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Execute detour detection for products truck
     * @param licensePlate (optional) 
     * @param placeId (optional) 
     * @param isValid (optional) 
     * @param zoneId (optional) 
     * @return OK
     */
    executeProductsDetourDetection(licensePlate: string | undefined, placeId: number | undefined, isValid: boolean | undefined, zoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Detour/ExecuteProductsDetourDetection?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (isValid === null)
            throw new Error("The parameter 'isValid' cannot be null.");
        else if (isValid !== undefined)
            url_ += "isValid=" + encodeURIComponent("" + isValid) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteProductsDetourDetection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteProductsDetourDetection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteProductsDetourDetection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiverseProductActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create diverse product activity report with the given properties
     * @param body (optional) 
     * @return OK
     */
    createManualDiverseProductReceipt(body: CreateManualDiverseProductActivityReportInput | undefined): Observable<CreateManualDiverseProductActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/CreateManualDiverseProductReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualDiverseProductReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualDiverseProductReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
        }));
    }

    protected processCreateManualDiverseProductReceipt(response: HttpResponseBase): Observable<CreateManualDiverseProductActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualDiverseProductActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all diverse product locations containing the given string on its name
     * @param input (optional) 
     * @return OK
     */
    getAllLocationsForDiverseProducts(input: string | undefined): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetAllLocationsForDiverseProducts?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationsForDiverseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationsForDiverseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
        }));
    }

    protected processGetAllLocationsForDiverseProducts(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSimpleLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all articles for the location of the given id and the given active contract validation
     * @param locationId (optional) 
     * @param checkActiveContract (optional) If true, only articles with active contract will be returned. If false, articles with both active and inactive contract will be returned
     * @return OK
     */
    getAllArticlesByLocation(locationId: number | undefined, checkActiveContract: boolean | undefined): Observable<ArticleDiverseProductsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetAllArticlesByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (checkActiveContract === null)
            throw new Error("The parameter 'checkActiveContract' cannot be null.");
        else if (checkActiveContract !== undefined)
            url_ += "checkActiveContract=" + encodeURIComponent("" + checkActiveContract) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllArticlesByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArticlesByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticleDiverseProductsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticleDiverseProductsDto[]>;
        }));
    }

    protected processGetAllArticlesByLocation(response: HttpResponseBase): Observable<ArticleDiverseProductsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleDiverseProductsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get article DUA of the article of the given id and the given date
     * @param articleId (optional) 
     * @param date (optional) 
     * @param originId (optional) 
     * @return OK
     */
    getDuaByArticle(articleId: number | undefined, date: DateTime | undefined, originId: number | undefined): Observable<SingleCustomDeclarationOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDuaByArticle?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDuaByArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuaByArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCustomDeclarationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCustomDeclarationOutput>;
        }));
    }

    protected processGetDuaByArticle(response: HttpResponseBase): Observable<SingleCustomDeclarationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SingleCustomDeclarationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The diverse product activity report of the given id
     * @param diverseProductId (optional) 
     * @return OK
     */
    getDiverseProductActivityReportById(diverseProductId: number | undefined): Observable<DiverseProductActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductActivityReportById?";
        if (diverseProductId === null)
            throw new Error("The parameter 'diverseProductId' cannot be null.");
        else if (diverseProductId !== undefined)
            url_ += "diverseProductId=" + encodeURIComponent("" + diverseProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductActivityReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductActivityReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductActivityReportDto>;
        }));
    }

    protected processGetDiverseProductActivityReportById(response: HttpResponseBase): Observable<DiverseProductActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Complete diverse product activity report on semi automatic entrance
     * @param body (optional) 
     * @return OK
     */
    completeDiverseProductsSemiAutomaticEntrance(body: UpdateDiverseProductActivityReportInput | undefined): Observable<CreateManualDiverseProductActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/CompleteDiverseProductsSemiAutomaticEntrance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteDiverseProductsSemiAutomaticEntrance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteDiverseProductsSemiAutomaticEntrance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
        }));
    }

    protected processCompleteDiverseProductsSemiAutomaticEntrance(response: HttpResponseBase): Observable<CreateManualDiverseProductActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualDiverseProductActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify if the diverse product activity report of the given id can be modified
     * @param diverseProductId (optional) 
     * @return OK
     */
    canEditDiverseProducts(diverseProductId: number | undefined): Observable<CanEditDiverseProductsOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/CanEditDiverseProducts?";
        if (diverseProductId === null)
            throw new Error("The parameter 'diverseProductId' cannot be null.");
        else if (diverseProductId !== undefined)
            url_ += "diverseProductId=" + encodeURIComponent("" + diverseProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanEditDiverseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanEditDiverseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanEditDiverseProductsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanEditDiverseProductsOutput>;
        }));
    }

    protected processCanEditDiverseProducts(response: HttpResponseBase): Observable<CanEditDiverseProductsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanEditDiverseProductsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit diverse product activity report of the given id with the given properties
     * @param body (optional) 
     * @return OK
     */
    editDiverseProducts(body: EditDiverseProductsInput | undefined): Observable<EditActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/EditDiverseProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDiverseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDiverseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditActivityReportOutput>;
        }));
    }

    protected processEditDiverseProducts(response: HttpResponseBase): Observable<EditActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Force the diverse product activity report of the given id to exit with the given properties
     * @param body (optional) 
     * @return OK
     */
    forceDiverseProductsActivityReportExit(body: EditDiverseProductsInput | undefined): Observable<ForceWoodActivityReportExitOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/ForceDiverseProductsActivityReportExit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceDiverseProductsActivityReportExit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceDiverseProductsActivityReportExit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForceWoodActivityReportExitOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForceWoodActivityReportExitOutput>;
        }));
    }

    protected processForceDiverseProductsActivityReportExit(response: HttpResponseBase): Observable<ForceWoodActivityReportExitOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForceWoodActivityReportExitOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the diverse product activity report of the given id with the given reason
     * @return OK
     */
    deleteDiverseProductActivityReport(activityReportId: number, deletionComment: string, deletionReasonId: number): Observable<ActivityReportDeletionResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/DeleteDiverseProductActivityReport?";
        if (activityReportId === undefined || activityReportId === null)
            throw new Error("The parameter 'activityReportId' must be defined and cannot be null.");
        else
            url_ += "ActivityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (deletionComment === undefined || deletionComment === null)
            throw new Error("The parameter 'deletionComment' must be defined and cannot be null.");
        else
            url_ += "DeletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        if (deletionReasonId === undefined || deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' must be defined and cannot be null.");
        else
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDiverseProductActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDiverseProductActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityReportDeletionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityReportDeletionResultDto>;
        }));
    }

    protected processDeleteDiverseProductActivityReport(response: HttpResponseBase): Observable<ActivityReportDeletionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityReportDeletionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @return OK
     */
    getServiceEntrySheetInformation(activityReportId: number | undefined): Observable<ServiceEntrySheetInformationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetServiceEntrySheetInformation?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceEntrySheetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceEntrySheetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceEntrySheetInformationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceEntrySheetInformationDto[]>;
        }));
    }

    protected processGetServiceEntrySheetInformation(response: HttpResponseBase): Observable<ServiceEntrySheetInformationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceEntrySheetInformationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiverseProductDestinationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Activate destination by id
     * @param destinationId (optional) 
     * @return OK
     */
    activateDestination(destinationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductDestination/ActivateDestination?";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateDestination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all diverse product destinations
     * @return OK
     */
    updateDiverseProductsDestinations(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductDestination/UpdateDiverseProductsDestinations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiverseProductsDestinations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiverseProductsDestinations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDiverseProductsDestinations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiverseProductsTruckTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductsTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductsTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductsTruckTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductsTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductsTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<DiverseProductsTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductsTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductsTruckTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DiverseProductsTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductsTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DriverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all drivers containing the given string on their name which are valid for the given vendor id and pays transport validation
     * @param vendorId (optional) 
     * @param name (optional) 
     * @param paysTransport (optional) 
     * @return OK
     */
    getAll(vendorId: number | undefined, name: string | undefined, paysTransport: boolean | undefined): Observable<CustomPagedResultDtoOfDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/Driver/GetAll?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (paysTransport === null)
            throw new Error("The parameter 'paysTransport' cannot be null.");
        else if (paysTransport !== undefined)
            url_ += "paysTransport=" + encodeURIComponent("" + paysTransport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDriverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDriverDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDriverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all drivers with the given identity card or containing the given string on their name
     * @param identityCard (optional) 
     * @param name (optional) 
     * @return OK
     */
    getAllByNameOrIdentityCard(identityCard: string | undefined, name: string | undefined): Observable<CustomPagedResultDtoOfDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/Driver/GetAllByNameOrIdentityCard?";
        if (identityCard === null)
            throw new Error("The parameter 'identityCard' cannot be null.");
        else if (identityCard !== undefined)
            url_ += "identityCard=" + encodeURIComponent("" + identityCard) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByNameOrIdentityCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByNameOrIdentityCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDriverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDriverDto>;
        }));
    }

    protected processGetAllByNameOrIdentityCard(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDriverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the driver with the given id if it is valid for the given pays transport validation, origin vendor id and vehicle vendor id
     * @param placeId (optional) 
     * @param driverId (optional) 
     * @param paysTransport (optional) 
     * @param originVendorId (optional) 
     * @param vehicleVendorId (optional) 
     * @return OK
     */
    getById(placeId: number | undefined, driverId: number | undefined, paysTransport: boolean | undefined, originVendorId: number | undefined, vehicleVendorId: number | undefined): Observable<DriverOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Driver/GetById?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        if (paysTransport === null)
            throw new Error("The parameter 'paysTransport' cannot be null.");
        else if (paysTransport !== undefined)
            url_ += "paysTransport=" + encodeURIComponent("" + paysTransport) + "&";
        if (originVendorId === null)
            throw new Error("The parameter 'originVendorId' cannot be null.");
        else if (originVendorId !== undefined)
            url_ += "originVendorId=" + encodeURIComponent("" + originVendorId) + "&";
        if (vehicleVendorId === null)
            throw new Error("The parameter 'vehicleVendorId' cannot be null.");
        else if (vehicleVendorId !== undefined)
            url_ += "vehicleVendorId=" + encodeURIComponent("" + vehicleVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DriverOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DriverOutputDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DriverOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate driver with the given id by the given prereport vendor id
     * @param placeId (optional) 
     * @param driverVendorId (optional) 
     * @param preReportVendorId (optional) 
     * @return OK
     */
    isValidDriverVendorForPreReport(placeId: number | undefined, driverVendorId: number | undefined, preReportVendorId: number | undefined): Observable<ValidateDriverVendorOutput> {
        let url_ = this.baseUrl + "/api/services/app/Driver/IsValidDriverVendorForPreReport?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (driverVendorId === null)
            throw new Error("The parameter 'driverVendorId' cannot be null.");
        else if (driverVendorId !== undefined)
            url_ += "driverVendorId=" + encodeURIComponent("" + driverVendorId) + "&";
        if (preReportVendorId === null)
            throw new Error("The parameter 'preReportVendorId' cannot be null.");
        else if (preReportVendorId !== undefined)
            url_ += "preReportVendorId=" + encodeURIComponent("" + preReportVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidDriverVendorForPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidDriverVendorForPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateDriverVendorOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateDriverVendorOutput>;
        }));
    }

    protected processIsValidDriverVendorForPreReport(response: HttpResponseBase): Observable<ValidateDriverVendorOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateDriverVendorOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all drivers
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of drivers)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getAllDrivers(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/Driver/GetAllDrivers?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDrivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDrivers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDriverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDriverDto>;
        }));
    }

    protected processGetAllDrivers(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDriverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTritrainDrivers(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfTritrainDriverDto> {
        let url_ = this.baseUrl + "/api/services/app/Driver/GetAllTritrainDrivers?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTritrainDrivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTritrainDrivers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfTritrainDriverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfTritrainDriverDto>;
        }));
    }

    protected processGetAllTritrainDrivers(response: HttpResponseBase): Observable<CustomPagedResultDtoOfTritrainDriverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfTritrainDriverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DriverValidationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Validate driver
     * @param body (optional) 
     * @return OK
     */
    validateDriver(body: { [key: string]: string; } | undefined): Observable<ResponseContent> {
        let url_ = this.baseUrl + "/api/services/app/DriverValidation/ValidateDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseContent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseContent>;
        }));
    }

    protected processValidateDriver(response: HttpResponseBase): Observable<ResponseContent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseContent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExitCheckpointServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param zoneId (optional) 
     * @param placeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    executeExitProcessByAccessCardDetection(zoneId: number | undefined, placeId: number | undefined, body: AccessCardDetectionInputDto | undefined): Observable<AccessCardDetectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitCheckpoint/ExecuteExitProcessByAccessCardDetection?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteExitProcessByAccessCardDetection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteExitProcessByAccessCardDetection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessCardDetectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessCardDetectionOutputDto>;
        }));
    }

    protected processExecuteExitProcessByAccessCardDetection(response: HttpResponseBase): Observable<AccessCardDetectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessCardDetectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start exit process to receipt in place by plate
     * @param body (optional) 
     * @return OK
     */
    beginExitProcessWithLicensePlate(body: BeginExitProcessWithLicensePlateInput | undefined): Observable<ProcessWithLicensePlateOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitCheckpoint/BeginExitProcessWithLicensePlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginExitProcessWithLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginExitProcessWithLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessWithLicensePlateOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessWithLicensePlateOutputDto>;
        }));
    }

    protected processBeginExitProcessWithLicensePlate(response: HttpResponseBase): Observable<ProcessWithLicensePlateOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessWithLicensePlateOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active entrance zones by place or current user place if parameter is default
     * @param placeId (optional) 
     * @return OK
     */
    getActiveMonitorsZones(placeId: number | undefined): Observable<MonitorZonesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitCheckpoint/GetActiveMonitorsZones?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMonitorsZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMonitorsZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitorZonesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitorZonesOutputDto>;
        }));
    }

    protected processGetActiveMonitorsZones(response: HttpResponseBase): Observable<MonitorZonesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitorZonesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send reinitialize notification to exit monitor
     * @param zoneId (optional) 
     * @return OK
     */
    reinitializeExitMonitor(zoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitCheckpoint/ReinitializeExitMonitor?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReinitializeExitMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReinitializeExitMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReinitializeExitMonitor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinalDispositionActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param reportId (optional) 
     * @param deletionComment (optional) 
     * @return OK
     */
    rejectFinalDispositionPreActivityReport(reportId: number | undefined, deletionComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinalDispositionActivityReport/RejectFinalDispositionPreActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (deletionComment === null)
            throw new Error("The parameter 'deletionComment' cannot be null.");
        else if (deletionComment !== undefined)
            url_ += "deletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectFinalDispositionPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectFinalDispositionPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectFinalDispositionPreActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GeneticMaterialTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Return a genetic material type by id
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<GeneticMaterialTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneticMaterialType/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneticMaterialTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneticMaterialTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GeneticMaterialTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneticMaterialTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all genetic material types
     * @return OK
     */
    getAllGeneticMaterialTypes(): Observable<GeneticMaterialTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneticMaterialType/GetAllGeneticMaterialTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGeneticMaterialTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGeneticMaterialTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneticMaterialTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneticMaterialTypeDto[]>;
        }));
    }

    protected processGetAllGeneticMaterialTypes(response: HttpResponseBase): Observable<GeneticMaterialTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneticMaterialTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthCheckServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Check health
     * @param body (optional) 
     * @return OK
     */
    checkHealth(body: HealthCheckContext | undefined): Observable<HealthCheckResult> {
        let url_ = this.baseUrl + "/api/services/app/HealthCheck/CheckHealth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCheckResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCheckResult>;
        }));
    }

    protected processCheckHealth(response: HttpResponseBase): Observable<HealthCheckResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check connection status
     * @return OK
     */
    checkConnectionStatus(): Observable<Location[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthCheck/CheckConnectionStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckConnectionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckConnectionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Location[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Location[]>;
        }));
    }

    protected processCheckConnectionStatus(response: HttpResponseBase): Observable<Location[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Location.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegrationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Execute the external integrations for wood report. This process is executed in current thread and returns result
     * @param reportId (optional) The report id
     * @param logId (optional) The log id
     * @return OK
     */
    executeWoodExternalIntegration(reportId: number | undefined, logId: number | undefined): Observable<IntegrationResultOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Integrations/ExecuteWoodExternalIntegration?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (logId === null)
            throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined)
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteWoodExternalIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteWoodExternalIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationResultOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationResultOutputDto>;
        }));
    }

    protected processExecuteWoodExternalIntegration(response: HttpResponseBase): Observable<IntegrationResultOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationResultOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Execute the external integrations for diverse product report. This process is executed in current thread and returns result
     * @param reportId (optional) The report id
     * @param logId (optional) The log id
     * @return OK
     */
    executeDiverseExternalIntegration(reportId: number | undefined, logId: number | undefined): Observable<IntegrationResultOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Integrations/ExecuteDiverseExternalIntegration?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (logId === null)
            throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined)
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteDiverseExternalIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteDiverseExternalIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationResultOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationResultOutputDto>;
        }));
    }

    protected processExecuteDiverseExternalIntegration(response: HttpResponseBase): Observable<IntegrationResultOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationResultOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Execute the externals integrations for both wood and diverse products report. This process is executed in a second thread
     * @param reportId (optional) The report id
     * @param logId (optional) The log id
     * @return OK
     */
    executeExternalIntegration(reportId: number | undefined, logId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integrations/ExecuteExternalIntegration?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (logId === null)
            throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined)
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteExternalIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteExternalIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteExternalIntegration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Execute the integration in mass. This process is executed in a second thread
     * @param executionId (optional) The GUID coming from database
     * @return OK
     */
    executeExternalIntegrationsInMass(executionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integrations/ExecuteExternalIntegrationsInMass?";
        if (executionId === null)
            throw new Error("The parameter 'executionId' cannot be null.");
        else if (executionId !== undefined)
            url_ += "executionId=" + encodeURIComponent("" + executionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteExternalIntegrationsInMass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteExternalIntegrationsInMass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteExternalIntegrationsInMass(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InternalMovementActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a internal movement activity report with the given properties
     * @param body (optional) 
     * @return OK
     */
    createManualInternalMovementReceipt(body: CreateManualInternalMovementActivityReportInput | undefined): Observable<CreateManualInternalMovementActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/CreateManualInternalMovementReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualInternalMovementReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualInternalMovementReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
        }));
    }

    protected processCreateManualInternalMovementReceipt(response: HttpResponseBase): Observable<CreateManualInternalMovementActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualInternalMovementActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Complete internal movement semi automatic entrance with the given properties
     * @param body (optional) 
     * @return OK
     */
    completeInternalMovementsSemiAutomaticEntrance(body: UpdateInternalMovementsInputDto | undefined): Observable<CreateManualInternalMovementActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/CompleteInternalMovementsSemiAutomaticEntrance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteInternalMovementsSemiAutomaticEntrance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteInternalMovementsSemiAutomaticEntrance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
        }));
    }

    protected processCompleteInternalMovementsSemiAutomaticEntrance(response: HttpResponseBase): Observable<CreateManualInternalMovementActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualInternalMovementActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the internal movement activity report of the given id
     * @param activityReportId (optional) 
     * @return OK
     */
    getById(activityReportId: number | undefined): Observable<InternalMovementsActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetById?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalMovementsActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalMovementsActivityReportDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<InternalMovementsActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalMovementsActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all invoice services with optional filtering by service name.
     * @param serviceNameFilter (optional) Service name filter
     * @return OK
     */
    getAllInvoiceServices(serviceNameFilter: string | undefined): Observable<InvoiceServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InvoiceService/GetAllInvoiceServices?";
        if (serviceNameFilter === null)
            throw new Error("The parameter 'serviceNameFilter' cannot be null.");
        else if (serviceNameFilter !== undefined)
            url_ += "serviceNameFilter=" + encodeURIComponent("" + serviceNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInvoiceServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInvoiceServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceServiceDto[]>;
        }));
    }

    protected processGetAllInvoiceServices(response: HttpResponseBase): Observable<InvoiceServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceServiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get invoice service by its Id.
     * @param serviceId (optional) Service id
     * @return OK
     */
    getInvoiceServiceById(serviceId: number | undefined): Observable<InvoiceServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/InvoiceService/GetInvoiceServiceById?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceServiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceServiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceServiceDto>;
        }));
    }

    protected processGetInvoiceServiceById(response: HttpResponseBase): Observable<InvoiceServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LoadCheckpointServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Start load process with RFID tag detected
     * @param tagValueDetected (optional) 
     * @param zoneId (optional) 
     * @return OK
     */
    executeLoadProcessByRfid(tagValueDetected: number | undefined, zoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LoadCheckpoint/ExecuteLoadProcessByRfid?";
        if (tagValueDetected === null)
            throw new Error("The parameter 'tagValueDetected' cannot be null.");
        else if (tagValueDetected !== undefined)
            url_ += "tagValueDetected=" + encodeURIComponent("" + tagValueDetected) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteLoadProcessByRfid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteLoadProcessByRfid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteLoadProcessByRfid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all locations by a partial name
     * @param input (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param includePlantsLocations (optional) 
     * @return OK
     */
    getAll(input: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, includePlantsLocations: boolean | undefined): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAll?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (includePlantsLocations === null)
            throw new Error("The parameter 'includePlantsLocations' cannot be null.");
        else if (includePlantsLocations !== undefined)
            url_ += "includePlantsLocations=" + encodeURIComponent("" + includePlantsLocations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSimpleLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get location by id and location type
     * @param id (optional) 
     * @param checkActiveContract (optional) 
     * @return OK
     */
    getById(id: number | undefined, locationType: LocationType, checkActiveContract: boolean | undefined): Observable<LocationWithPaysTransportDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "locationType=" + encodeURIComponent("" + locationType) + "&";
        if (checkActiveContract === null)
            throw new Error("The parameter 'checkActiveContract' cannot be null.");
        else if (checkActiveContract !== undefined)
            url_ += "checkActiveContract=" + encodeURIComponent("" + checkActiveContract) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationWithPaysTransportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationWithPaysTransportDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<LocationWithPaysTransportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationWithPaysTransportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get location by id and location type
     * @param id (optional) 
     * @return OK
     */
    getBasicLocationById(id: number | undefined, locationType: LocationType): Observable<BasicLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetBasicLocationById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "locationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicLocationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicLocationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicLocationDto>;
        }));
    }

    protected processGetBasicLocationById(response: HttpResponseBase): Observable<BasicLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all wood location by a partial name
     * @param input (optional) 
     * @return OK
     */
    getAllWood(input: string | undefined): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllWood?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
        }));
    }

    protected processGetAllWood(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSimpleLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all location by a vat number
     * @param vatNumber (optional) 
     * @param input (optional) 
     * @return OK
     */
    getAllByVatNumber(vatNumber: string | undefined, input: string | undefined): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllByVatNumber?";
        if (vatNumber === null)
            throw new Error("The parameter 'vatNumber' cannot be null.");
        else if (vatNumber !== undefined)
            url_ += "vatNumber=" + encodeURIComponent("" + vatNumber) + "&";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByVatNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByVatNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
        }));
    }

    protected processGetAllByVatNumber(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSimpleLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all properties
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllProperties(maxResultCount: number | undefined, skipCount: number | undefined): Observable<CustomPagedResultDtoOfLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllProperties?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationDto>;
        }));
    }

    protected processGetAllProperties(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all third properties
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllThirdProperties(maxResultCount: number | undefined, skipCount: number | undefined): Observable<CustomPagedResultDtoOfLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllThirdProperties?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllThirdProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllThirdProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationDto>;
        }));
    }

    protected processGetAllThirdProperties(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all logyards
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllLogyards(maxResultCount: number | undefined, skipCount: number | undefined): Observable<CustomPagedResultDtoOfLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllLogyards?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogyards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogyards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationDto>;
        }));
    }

    protected processGetAllLogyards(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all locations by a vendor id and a partial name
     * @param vendorId (optional) 
     * @param input (optional) 
     * @return OK
     */
    getAllByVendorId(vendorId: number | undefined, input: string | undefined): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllByVendorId?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSimpleLocationDto>;
        }));
    }

    protected processGetAllByVendorId(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSimpleLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSimpleLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns whether a location pays transport or not
     * @param originId (optional) 
     * @return OK
     */
    paysTransport(originId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Location/PaysTransport?";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaysTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaysTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPaysTransport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a third property by a mgsCode
     * @param mgsCode (optional) 
     * @return OK
     */
    getThirdPropertyByMgsCode(mgsCode: string | undefined): Observable<LocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetThirdPropertyByMgsCode?";
        if (mgsCode === null)
            throw new Error("The parameter 'mgsCode' cannot be null.");
        else if (mgsCode !== undefined)
            url_ += "mgsCode=" + encodeURIComponent("" + mgsCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThirdPropertyByMgsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThirdPropertyByMgsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDto>;
        }));
    }

    protected processGetThirdPropertyByMgsCode(response: HttpResponseBase): Observable<LocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a logyard by a stand id
     * @param standId (optional) 
     * @return OK
     */
    getLogyardByStandId(standId: number | undefined): Observable<LocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetLogyardByStandId?";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "standId=" + encodeURIComponent("" + standId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogyardByStandId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogyardByStandId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDto>;
        }));
    }

    protected processGetLogyardByStandId(response: HttpResponseBase): Observable<LocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all pays transport result with location id
     * @return OK
     */
    getAllPaysTransport(): Observable<CustomPagedResultDtoOfGetAllPaysTransportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllPaysTransport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaysTransport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaysTransport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfGetAllPaysTransportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfGetAllPaysTransportOutputDto>;
        }));
    }

    protected processGetAllPaysTransport(response: HttpResponseBase): Observable<CustomPagedResultDtoOfGetAllPaysTransportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfGetAllPaysTransportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all intermediate logyards with accepted origins
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllIntermediateLogyardsWithAcceptedOrigins(maxResultCount: number | undefined, skipCount: number | undefined): Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllIntermediateLogyardsWithAcceptedOrigins?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIntermediateLogyardsWithAcceptedOrigins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIntermediateLogyardsWithAcceptedOrigins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto>;
        }));
    }

    protected processGetAllIntermediateLogyardsWithAcceptedOrigins(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationWithAcceptedOriginsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all logyards with accepted origins
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllLogyardsWithAcceptedOrigins(maxResultCount: number | undefined, skipCount: number | undefined): Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAllLogyardsWithAcceptedOrigins?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogyardsWithAcceptedOrigins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogyardsWithAcceptedOrigins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto>;
        }));
    }

    protected processGetAllLogyardsWithAcceptedOrigins(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationWithAcceptedOriginsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationWithAcceptedOriginsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all third properties by name
     * @param name (optional) 
     * @return OK
     */
    getThirdPropertiesByName(name: string | undefined): Observable<CustomPagedResultDtoOfLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetThirdPropertiesByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThirdPropertiesByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThirdPropertiesByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationDto>;
        }));
    }

    protected processGetThirdPropertiesByName(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all logyards by name
     * @param name (optional) 
     * @return OK
     */
    getLogyardsByName(name: string | undefined): Observable<CustomPagedResultDtoOfLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetLogyardsByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogyardsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogyardsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationDto>;
        }));
    }

    protected processGetLogyardsByName(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves if origin (stand or third property) is valid for logyard destination
     * @param originLocationId (optional) stand id or third property id
     * @param logyardDestinationId (optional) 
     * @return OK
     */
    originIsValidByLogyardDestination(originLocationId: number | undefined, logyardDestinationId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Location/OriginIsValidByLogyardDestination?";
        if (originLocationId === null)
            throw new Error("The parameter 'originLocationId' cannot be null.");
        else if (originLocationId !== undefined)
            url_ += "originLocationId=" + encodeURIComponent("" + originLocationId) + "&";
        if (logyardDestinationId === null)
            throw new Error("The parameter 'logyardDestinationId' cannot be null.");
        else if (logyardDestinationId !== undefined)
            url_ += "logyardDestinationId=" + encodeURIComponent("" + logyardDestinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOriginIsValidByLogyardDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOriginIsValidByLogyardDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOriginIsValidByLogyardDestination(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all plants
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filterName (optional) 
     * @return OK
     */
    getLogyardPlantsByName(maxResultCount: number | undefined, skipCount: number | undefined, filterName: string | undefined): Observable<CustomPagedResultDtoOfLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetLogyardPlantsByName?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filterName === null)
            throw new Error("The parameter 'filterName' cannot be null.");
        else if (filterName !== undefined)
            url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogyardPlantsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogyardPlantsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLocationDto>;
        }));
    }

    protected processGetLogyardPlantsByName(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LogyardActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Synchronize a new entrance or exit logyard wood activity report
     * @param body (optional) 
     * @return OK
     */
    synchronizeWoodActivityReport(body: LogyardWoodActivityReportInput | undefined): Observable<LogyardWoodActivityReportSynchronizeOutput> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/SynchronizeWoodActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogyardWoodActivityReportSynchronizeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogyardWoodActivityReportSynchronizeOutput>;
        }));
    }

    protected processSynchronizeWoodActivityReport(response: HttpResponseBase): Observable<LogyardWoodActivityReportSynchronizeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogyardWoodActivityReportSynchronizeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the logyard wood activity report of the given id
     * @param id (optional) 
     * @return OK
     */
    getLogyardWoodReport(id: number | undefined): Observable<WoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/GetLogyardWoodReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogyardWoodReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogyardWoodReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportDto>;
        }));
    }

    protected processGetLogyardWoodReport(response: HttpResponseBase): Observable<WoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Synchronizes local changes to the given activity report
     * @param body (optional) Activity report's information
     * @return OK
     */
    synchronizeWoodActivityReportUpdates(body: LogyardWoodActivityReportUpdateInput | undefined): Observable<LogyardWoodActivityReportSynchronizeOutput> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/SynchronizeWoodActivityReportUpdates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeWoodActivityReportUpdates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeWoodActivityReportUpdates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogyardWoodActivityReportSynchronizeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogyardWoodActivityReportSynchronizeOutput>;
        }));
    }

    protected processSynchronizeWoodActivityReportUpdates(response: HttpResponseBase): Observable<LogyardWoodActivityReportSynchronizeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogyardWoodActivityReportSynchronizeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify if the logyard activity report of the given id can be modified
     * @param receiptId (optional) 
     * @return OK
     */
    canEditLogyardReceipt(receiptId: number | undefined): Observable<CanEditReceiptOutput> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/CanEditLogyardReceipt?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanEditLogyardReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanEditLogyardReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanEditReceiptOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanEditReceiptOutput>;
        }));
    }

    protected processCanEditLogyardReceipt(response: HttpResponseBase): Observable<CanEditReceiptOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanEditReceiptOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the logyard activity report of the given id with the given properties
     * @param body (optional) 
     * @return OK
     */
    editLogyardReceipt(body: LogyardWoodActivityReportUpdateInput | undefined): Observable<LogyardWoodActivityReportEditionOutput> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/EditLogyardReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLogyardReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLogyardReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogyardWoodActivityReportEditionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogyardWoodActivityReportEditionOutput>;
        }));
    }

    protected processEditLogyardReceipt(response: HttpResponseBase): Observable<LogyardWoodActivityReportEditionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogyardWoodActivityReportEditionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeasurementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all logyards measurement types
     * @param skipCount (optional) 
     * @param totalCount (optional) 
     * @return OK
     */
    getAllLogyardsMeasurementType(skipCount: number | undefined, totalCount: number | undefined): Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto> {
        let url_ = this.baseUrl + "/api/services/app/Measurement/GetAllLogyardsMeasurementType?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (totalCount === null)
            throw new Error("The parameter 'totalCount' cannot be null.");
        else if (totalCount !== undefined)
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogyardsMeasurementType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogyardsMeasurementType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto>;
        }));
    }

    protected processGetAllLogyardsMeasurementType(response: HttpResponseBase): Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfMeasurementTypePerOriginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all stands measurement types
     * @param skipCount (optional) 
     * @param totalCount (optional) 
     * @return OK
     */
    getAllStandsMeasurementType(skipCount: number | undefined, totalCount: number | undefined): Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto> {
        let url_ = this.baseUrl + "/api/services/app/Measurement/GetAllStandsMeasurementType?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (totalCount === null)
            throw new Error("The parameter 'totalCount' cannot be null.");
        else if (totalCount !== undefined)
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStandsMeasurementType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStandsMeasurementType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto>;
        }));
    }

    protected processGetAllStandsMeasurementType(response: HttpResponseBase): Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfMeasurementTypePerOriginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all third properties measurement types
     * @param skipCount (optional) 
     * @param totalCount (optional) 
     * @return OK
     */
    getAllThirdPropertiesMeasurementType(skipCount: number | undefined, totalCount: number | undefined): Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto> {
        let url_ = this.baseUrl + "/api/services/app/Measurement/GetAllThirdPropertiesMeasurementType?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (totalCount === null)
            throw new Error("The parameter 'totalCount' cannot be null.");
        else if (totalCount !== undefined)
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllThirdPropertiesMeasurementType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllThirdPropertiesMeasurementType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto>;
        }));
    }

    protected processGetAllThirdPropertiesMeasurementType(response: HttpResponseBase): Observable<CustomPagedResultDtoOfMeasurementTypePerOriginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfMeasurementTypePerOriginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all measurement types
     * @param skipCount (optional) 
     * @param totalCount (optional) 
     * @return OK
     */
    getAllMeasurementTypes(skipCount: number | undefined, totalCount: number | undefined): Observable<CustomPagedResultDtoOfMeasurementTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Measurement/GetAllMeasurementTypes?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (totalCount === null)
            throw new Error("The parameter 'totalCount' cannot be null.");
        else if (totalCount !== undefined)
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMeasurementTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMeasurementTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfMeasurementTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfMeasurementTypeDto>;
        }));
    }

    protected processGetAllMeasurementTypes(response: HttpResponseBase): Observable<CustomPagedResultDtoOfMeasurementTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfMeasurementTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NetworkMeditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveMeditionsResults(body: NetworkMeditionDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NetworkMedition/SaveMeditionsResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMeditionsResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMeditionsResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveMeditionsResults(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PeriodsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    getByDate(date: DateTime | undefined): Observable<PeriodDto> {
        let url_ = this.baseUrl + "/api/services/app/Periods/GetByDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeriodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeriodDto>;
        }));
    }

    protected processGetByDate(response: HttpResponseBase): Observable<PeriodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfPeriodDto> {
        let url_ = this.baseUrl + "/api/services/app/Periods/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfPeriodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfPeriodDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfPeriodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfPeriodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getPeriodsByDates(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<PeriodDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Periods/GetPeriodsByDates?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriodsByDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodsByDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeriodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeriodDto[]>;
        }));
    }

    protected processGetPeriodsByDates(response: HttpResponseBase): Observable<PeriodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PolygonContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @param includePolygonContractInactives (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined, includePolygonContractInactives: boolean | undefined): Observable<PagedResultDtoOfPolygonContractDto> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (includePolygonContractInactives === null)
            throw new Error("The parameter 'includePolygonContractInactives' cannot be null.");
        else if (includePolygonContractInactives !== undefined)
            url_ += "includePolygonContractInactives=" + encodeURIComponent("" + includePolygonContractInactives) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolygonContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolygonContractDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPolygonContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolygonContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreatePolygonContractInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    edit(body: EditPolygonContractInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param polygonContractId (optional) 
     * @return OK
     */
    getById(polygonContractId: number | undefined): Observable<PolygonContractDto> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/GetById?";
        if (polygonContractId === null)
            throw new Error("The parameter 'polygonContractId' cannot be null.");
        else if (polygonContractId !== undefined)
            url_ += "polygonContractId=" + encodeURIComponent("" + polygonContractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolygonContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolygonContractDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PolygonContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolygonContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contractId (optional) 
     * @return OK
     */
    getBasicContractForPolygonContractCreationByContractId(contractId: number | undefined): Observable<BasicContractForPolygonContractCreationDto> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/GetBasicContractForPolygonContractCreationByContractId?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicContractForPolygonContractCreationByContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicContractForPolygonContractCreationByContractId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicContractForPolygonContractCreationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicContractForPolygonContractCreationDto>;
        }));
    }

    protected processGetBasicContractForPolygonContractCreationByContractId(response: HttpResponseBase): Observable<BasicContractForPolygonContractCreationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicContractForPolygonContractCreationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PreActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param vendorId (optional) 
     * @param transportVendorId (optional) 
     * @param entranceStatusFilter (optional) 
     * @param showActualAndNextTurnDifferentFromTotem (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchWoodPreReports(vendorId: number | undefined, transportVendorId: number | undefined, entranceStatusFilter: string[] | undefined, creationSystem: WoodActivityReportCreationSystemFilter, showActualAndNextTurnDifferentFromTotem: boolean | undefined, licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, serial: string | undefined, number: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/SearchWoodPreReports?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (transportVendorId === null)
            throw new Error("The parameter 'transportVendorId' cannot be null.");
        else if (transportVendorId !== undefined)
            url_ += "TransportVendorId=" + encodeURIComponent("" + transportVendorId) + "&";
        if (entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' cannot be null.");
        else if (entranceStatusFilter !== undefined)
            entranceStatusFilter && entranceStatusFilter.forEach(item => { url_ += "EntranceStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (creationSystem === undefined || creationSystem === null)
            throw new Error("The parameter 'creationSystem' must be defined and cannot be null.");
        else
            url_ += "CreationSystem=" + encodeURIComponent("" + creationSystem) + "&";
        if (showActualAndNextTurnDifferentFromTotem === null)
            throw new Error("The parameter 'showActualAndNextTurnDifferentFromTotem' cannot be null.");
        else if (showActualAndNextTurnDifferentFromTotem !== undefined)
            url_ += "ShowActualAndNextTurnDifferentFromTotem=" + encodeURIComponent("" + showActualAndNextTurnDifferentFromTotem) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodPreReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodPreReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchWoodPreReports(response: HttpResponseBase): Observable<CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param entranceStatusFilter (optional) 
     * @param transportVendorId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchDiverseProductPreReports(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, entranceStatusFilter: string[] | undefined, transportVendorId: number | undefined, creationSystem: DiverseProductActivityReportCreationSystemFilter, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/SearchDiverseProductPreReports?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' cannot be null.");
        else if (entranceStatusFilter !== undefined)
            entranceStatusFilter && entranceStatusFilter.forEach(item => { url_ += "EntranceStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (transportVendorId === null)
            throw new Error("The parameter 'transportVendorId' cannot be null.");
        else if (transportVendorId !== undefined)
            url_ += "TransportVendorId=" + encodeURIComponent("" + transportVendorId) + "&";
        if (creationSystem === undefined || creationSystem === null)
            throw new Error("The parameter 'creationSystem' must be defined and cannot be null.");
        else
            url_ += "CreationSystem=" + encodeURIComponent("" + creationSystem) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductPreReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductPreReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchDiverseProductPreReports(response: HttpResponseBase): Observable<CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param articleId (optional) 
     * @param entranceStatusFilters (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchInternalMovementsPreReports(licensePlate: string | undefined, articleId: number | undefined, entranceStatusFilters: string[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/SearchInternalMovementsPreReports?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (entranceStatusFilters === null)
            throw new Error("The parameter 'entranceStatusFilters' cannot be null.");
        else if (entranceStatusFilters !== undefined)
            entranceStatusFilters && entranceStatusFilters.forEach(item => { url_ += "EntranceStatusFilters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementsPreReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementsPreReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchInternalMovementsPreReports(response: HttpResponseBase): Observable<CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Synchronize all pre reports sorted by scheduled turns
     * @return OK
     */
    processAllPreActivityReportNonBlockingErrors(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/ProcessAllPreActivityReportNonBlockingErrors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessAllPreActivityReportNonBlockingErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessAllPreActivityReportNonBlockingErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessAllPreActivityReportNonBlockingErrors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood pre activity report for view by report id
     * @param reportId (optional) 
     * @return OK
     */
    getWoodPreActivityReportForViewById(reportId: number | undefined): Observable<ViewWoodPreActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetWoodPreActivityReportForViewById?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportForViewById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportForViewById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewWoodPreActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewWoodPreActivityReportDto>;
        }));
    }

    protected processGetWoodPreActivityReportForViewById(response: HttpResponseBase): Observable<ViewWoodPreActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewWoodPreActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDiverseProductPreActivityReportByIdForView(id: number | undefined): Observable<ViewDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetDiverseProductPreActivityReportByIdForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportByIdForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportByIdForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processGetDiverseProductPreActivityReportByIdForView(response: HttpResponseBase): Observable<ViewDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param standsIds (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getLoaderVendorsForStands(standsIds: number[] | undefined, originId: number | undefined, destinationId: number | undefined, originType: LocationType): Observable<GetLoaderVendorsForStandsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetLoaderVendorsForStands?";
        if (standsIds === null)
            throw new Error("The parameter 'standsIds' cannot be null.");
        else if (standsIds !== undefined)
            standsIds && standsIds.forEach(item => { url_ += "standsIds=" + encodeURIComponent("" + item) + "&"; });
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (originType === undefined || originType === null)
            throw new Error("The parameter 'originType' must be defined and cannot be null.");
        else
            url_ += "originType=" + encodeURIComponent("" + originType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoaderVendorsForStands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoaderVendorsForStands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLoaderVendorsForStandsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLoaderVendorsForStandsOutput>;
        }));
    }

    protected processGetLoaderVendorsForStands(response: HttpResponseBase): Observable<GetLoaderVendorsForStandsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLoaderVendorsForStandsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInternalMovementPreActivityReportByIdForView(id: number | undefined): Observable<ViewInternalMovementPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetInternalMovementPreActivityReportByIdForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementPreActivityReportByIdForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementPreActivityReportByIdForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
        }));
    }

    protected processGetInternalMovementPreActivityReportByIdForView(response: HttpResponseBase): Observable<ViewInternalMovementPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewInternalMovementPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    synchronizeWoodPreActivityReport(reportId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/SynchronizeWoodPreActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynchronizeWoodPreActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    synchronizeDiverseProductPreActivityReport(reportId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/SynchronizeDiverseProductPreActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynchronizeDiverseProductPreActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    synchronizeInternalMovementPreActivityReport(reportId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/SynchronizeInternalMovementPreActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeInternalMovementPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeInternalMovementPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynchronizeInternalMovementPreActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectPreReport(body: PreReportRejectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/RejectPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectPreReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editWoodPreReport(body: WoodPreActivityReportEditionFromCCInput | undefined): Observable<WoodPreActivityReportEditionOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/EditWoodPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditWoodPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditWoodPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportEditionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportEditionOutput>;
        }));
    }

    protected processEditWoodPreReport(response: HttpResponseBase): Observable<WoodPreActivityReportEditionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportEditionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param vendorId (optional) 
     * @param originId (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @return OK
     */
    isSerialNumberInUse(reportId: number | undefined, vendorId: number | undefined, originId: number | undefined, serial: string | undefined, number: number | undefined): Observable<boolean | null> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/IsSerialNumberInUse?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSerialNumberInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSerialNumberInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean | null>;
        }));
    }

    protected processIsSerialNumberInUse(response: HttpResponseBase): Observable<boolean | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    getWoodPreReportEntranceRequiredInfo(reportId: number | undefined): Observable<WoodPreReportEntranceRequiredInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetWoodPreReportEntranceRequiredInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreReportEntranceRequiredInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreReportEntranceRequiredInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreReportEntranceRequiredInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreReportEntranceRequiredInfoDto>;
        }));
    }

    protected processGetWoodPreReportEntranceRequiredInfo(response: HttpResponseBase): Observable<WoodPreReportEntranceRequiredInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreReportEntranceRequiredInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    getDiverseProductPreReportEntranceRequiredInfo(reportId: number | undefined): Observable<DiverseProductPreReportEntranceRequiredInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetDiverseProductPreReportEntranceRequiredInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreReportEntranceRequiredInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreReportEntranceRequiredInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductPreReportEntranceRequiredInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductPreReportEntranceRequiredInfoDto>;
        }));
    }

    protected processGetDiverseProductPreReportEntranceRequiredInfo(response: HttpResponseBase): Observable<DiverseProductPreReportEntranceRequiredInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductPreReportEntranceRequiredInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editDiverseProductPreActivityReport(body: DiverseProductPreActivityReportEditionInput | undefined): Observable<ViewDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/EditDiverseProductPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processEditDiverseProductPreActivityReport(response: HttpResponseBase): Observable<ViewDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editInternalMovementPreActivityReport(body: InternalMovementPreActivityReportEditionInput | undefined): Observable<ViewInternalMovementPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/EditInternalMovementPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditInternalMovementPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditInternalMovementPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
        }));
    }

    protected processEditInternalMovementPreActivityReport(response: HttpResponseBase): Observable<ViewInternalMovementPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewInternalMovementPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getInfoForPreReportMonitor(): Observable<PreReportMonitorInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreActivityReport/GetInfoForPreReportMonitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfoForPreReportMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfoForPreReportMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreReportMonitorInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreReportMonitorInfoOutput>;
        }));
    }

    protected processGetInfoForPreReportMonitor(response: HttpResponseBase): Observable<PreReportMonitorInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreReportMonitorInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PrinterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Print diverse products receipt
     * @param activityReportId (optional) 
     * @param deviceId (optional) 
     * @return OK
     */
    printDiverseProductsReceipt(activityReportId: number | undefined, deviceId: number | undefined): Observable<PrintResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/PrintDiverseProductsReceipt?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintDiverseProductsReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintDiverseProductsReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintResultDto>;
        }));
    }

    protected processPrintDiverseProductsReceipt(response: HttpResponseBase): Observable<PrintResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Print wood a5 receipt
     * @param activityReportId (optional) 
     * @param deviceId (optional) 
     * @return OK
     */
    printWoodReceipt(activityReportId: number | undefined, deviceId: number | undefined): Observable<PrintResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/PrintWoodReceipt?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintWoodReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintWoodReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintResultDto>;
        }));
    }

    protected processPrintWoodReceipt(response: HttpResponseBase): Observable<PrintResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Print next travel of activity receipt's truck
     * @param activityReportId (optional) Receipt id to find truck
     * @param deviceId (optional) Receipt id to find truck
     * @return OK
     */
    printNextTripTicket(activityReportId: number | undefined, deviceId: number | undefined): Observable<PrintResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/PrintNextTripTicket?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintNextTripTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintNextTripTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintResultDto>;
        }));
    }

    protected processPrintNextTripTicket(response: HttpResponseBase): Observable<PrintResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @param deviceId (optional) 
     * @return OK
     */
    printSampleTicket(activityReportId: number | undefined, deviceId: number | undefined): Observable<PrintResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/PrintSampleTicket?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintSampleTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintSampleTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintResultDto>;
        }));
    }

    protected processPrintSampleTicket(response: HttpResponseBase): Observable<PrintResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @param printerId (optional) 
     * @return OK
     */
    printDriverResumeActivityReportTicket(activityReportId: number | undefined, printerId: number | undefined): Observable<PrintResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/PrintDriverResumeActivityReportTicket?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (printerId === null)
            throw new Error("The parameter 'printerId' cannot be null.");
        else if (printerId !== undefined)
            url_ += "printerId=" + encodeURIComponent("" + printerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintDriverResumeActivityReportTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintDriverResumeActivityReportTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintResultDto>;
        }));
    }

    protected processPrintDriverResumeActivityReportTicket(response: HttpResponseBase): Observable<PrintResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vehiclePlate (optional) 
     * @param vendorId (optional) 
     * @param deviceId (optional) 
     * @return OK
     */
    printNextTripByTruck(vehiclePlate: string | undefined, vendorId: number | undefined, deviceId: number | undefined): Observable<PrintResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/PrintNextTripByTruck?";
        if (vehiclePlate === null)
            throw new Error("The parameter 'vehiclePlate' cannot be null.");
        else if (vehiclePlate !== undefined)
            url_ += "vehiclePlate=" + encodeURIComponent("" + vehiclePlate) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintNextTripByTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintNextTripByTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintResultDto>;
        }));
    }

    protected processPrintNextTripByTruck(response: HttpResponseBase): Observable<PrintResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProviderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create's a pre report of type wood
     * @param body (optional) An object containing the information needed for the operation
     * @return OK
     */
    createWoodPreActivityReportForProviders(body: ProvidersPreActivityReportCreationInput | undefined): Observable<CreateWoodProvidersPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/CreateWoodPreActivityReportForProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodPreActivityReportForProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodPreActivityReportForProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodProvidersPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodProvidersPreActivityReportOutput>;
        }));
    }

    protected processCreateWoodPreActivityReportForProviders(response: HttpResponseBase): Observable<CreateWoodProvidersPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodProvidersPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return the turns available for the pre receipt to enter in the plant
     * @param receiptId (optional) The receipt id
     * @return OK
     */
    getTurnsWithAvailableQuota(receiptId: number | undefined): Observable<GetAvailableTurnsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetTurnsWithAvailableQuota?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnsWithAvailableQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnsWithAvailableQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableTurnsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableTurnsOutput>;
        }));
    }

    protected processGetTurnsWithAvailableQuota(response: HttpResponseBase): Observable<GetAvailableTurnsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableTurnsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Schedule a trip based on the receipt id and the date
     * @param body (optional) An object containing the receipt id and the dateTime of the schedule
     * @return OK
     */
    scheduleTrip(body: ProvidersModuleScheduleTripInput | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/ScheduleTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processScheduleTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a turn based on receipt id and the date time
     * @param body (optional) An object containing the receipt id and the new date for the turn
     * @return OK
     */
    updateScheduledTrip(body: ProvidersModuleScheduleTripInput | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/UpdateScheduledTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduledTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduledTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processUpdateScheduledTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get pre activity report status
     * @param preActivityReportId (optional) Pre activity report id
     * @return OK
     */
    getPreActivityReportStatus(preActivityReportId: number | undefined): Observable<PreActivityReportStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetPreActivityReportStatus?";
        if (preActivityReportId === null)
            throw new Error("The parameter 'preActivityReportId' cannot be null.");
        else if (preActivityReportId !== undefined)
            url_ += "preActivityReportId=" + encodeURIComponent("" + preActivityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportStatusOutput>;
        }));
    }

    protected processGetPreActivityReportStatus(response: HttpResponseBase): Observable<PreActivityReportStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get driver status
     * @param driverIdentityCard (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getDriverStatus(driverIdentityCard: string | undefined, destinationId: number | undefined): Observable<DriverStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetDriverStatus?";
        if (driverIdentityCard === null)
            throw new Error("The parameter 'driverIdentityCard' cannot be null.");
        else if (driverIdentityCard !== undefined)
            url_ += "DriverIdentityCard=" + encodeURIComponent("" + driverIdentityCard) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDriverStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDriverStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DriverStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DriverStatusOutput>;
        }));
    }

    protected processGetDriverStatus(response: HttpResponseBase): Observable<DriverStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get truck status
     * @param licensePlate (optional) License plate
     * @return OK
     */
    getTruckStatus(licensePlate: string | undefined): Observable<TruckStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetTruckStatus?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckStatusOutput>;
        }));
    }

    protected processGetTruckStatus(response: HttpResponseBase): Observable<TruckStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update pre activity report driver
     * @param preActivityReportId (optional) Pre activity report id
     * @param driverIdentityCard (optional) A driver identification
     * @return OK
     */
    updatePreActivityReportDriver(preActivityReportId: number | undefined, driverIdentityCard: string | undefined): Observable<UpdatePreActivityReportDriverOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/UpdatePreActivityReportDriver?";
        if (preActivityReportId === null)
            throw new Error("The parameter 'preActivityReportId' cannot be null.");
        else if (preActivityReportId !== undefined)
            url_ += "preActivityReportId=" + encodeURIComponent("" + preActivityReportId) + "&";
        if (driverIdentityCard === null)
            throw new Error("The parameter 'driverIdentityCard' cannot be null.");
        else if (driverIdentityCard !== undefined)
            url_ += "driverIdentityCard=" + encodeURIComponent("" + driverIdentityCard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePreActivityReportDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePreActivityReportDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePreActivityReportDriverOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePreActivityReportDriverOutput>;
        }));
    }

    protected processUpdatePreActivityReportDriver(response: HttpResponseBase): Observable<UpdatePreActivityReportDriverOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePreActivityReportDriverOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the activity reports of the logged in provider, filtered by date and license plate
     * @param licensePlate (optional) 
     * @param destinationId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchReportPaged(fromDate: DateTime, toDate: DateTime, licensePlate: string | undefined, destinationId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfReportByProviderOutputPagedDto> {
        let url_ = this.baseUrl + "/api/services/app/Provider/SearchReportPaged?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReportPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReportPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfReportByProviderOutputPagedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfReportByProviderOutputPagedDto>;
        }));
    }

    protected processSearchReportPaged(response: HttpResponseBase): Observable<CustomPagedResultDtoOfReportByProviderOutputPagedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfReportByProviderOutputPagedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleDiverseProductPreReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a diverse product prereport for a vendor with the given properties
     * @param body (optional) 
     * @return OK
     */
    createPreReportForVendor(body: ProvidersModuleDiverseProductPreReportCreationInput | undefined): Observable<ProvidersModuleDiverseProductPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/CreatePreReportForVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePreReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePreReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleDiverseProductPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleDiverseProductPreReportCreationOutput>;
        }));
    }

    protected processCreatePreReportForVendor(response: HttpResponseBase): Observable<ProvidersModuleDiverseProductPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleDiverseProductPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a diverse product prereport for a transport vendor with the given properties
     * @param body (optional) 
     * @return OK
     */
    createPreReportForTransportVendor(body: ProvidersModuleDiverseProductPreReportCreationInput | undefined): Observable<ProvidersModuleDiverseProductPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/CreatePreReportForTransportVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePreReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePreReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleDiverseProductPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleDiverseProductPreReportCreationOutput>;
        }));
    }

    protected processCreatePreReportForTransportVendor(response: HttpResponseBase): Observable<ProvidersModuleDiverseProductPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleDiverseProductPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the diverse product prereport of the given id if it belongs to the logged in vendor
     * @param reportId (optional) 
     * @return OK
     */
    getDiverseProductPreActivityReportForVendorView(reportId: number | undefined): Observable<ViewDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/GetDiverseProductPreActivityReportForVendorView?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportForVendorView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportForVendorView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processGetDiverseProductPreActivityReportForVendorView(response: HttpResponseBase): Observable<ViewDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the diverse product prereport of the given id if it belongs to the logged in transport vendor
     * @param reportId (optional) 
     * @return OK
     */
    getDiverseProductPreActivityReportForTransportVendorView(reportId: number | undefined): Observable<ViewDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/GetDiverseProductPreActivityReportForTransportVendorView?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportForTransportVendorView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportForTransportVendorView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processGetDiverseProductPreActivityReportForTransportVendorView(response: HttpResponseBase): Observable<ViewDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all diverse product prereports for a vendor with the given license plate, origin id, destination id, driver id and entrance status
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchDiverseProductPreActivityReportForVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilter: PreActivityReportEntranceStatusFilter, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/SearchDiverseProductPreActivityReportForVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilter === undefined || entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' must be defined and cannot be null.");
        else
            url_ += "EntranceStatusFilter=" + encodeURIComponent("" + entranceStatusFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductPreActivityReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductPreActivityReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchDiverseProductPreActivityReportForVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all diverse product prereports for a transport vendor with the given license plate, origin id, destination id, driver id and entrance status
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchDiverseProductPreActivityReportForTransportVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilter: PreActivityReportEntranceStatusFilter, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/SearchDiverseProductPreActivityReportForTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilter === undefined || entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' must be defined and cannot be null.");
        else
            url_ += "EntranceStatusFilter=" + encodeURIComponent("" + entranceStatusFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductPreActivityReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductPreActivityReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchDiverseProductPreActivityReportForTransportVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel the diverse product prereport of the given id with the given cancelation comment for vendor
     * @param body (optional) 
     * @return OK
     */
    cancelDiverseProductVendorPreReport(body: ProvidersModuleCancelPreActivityReportInputDto | undefined): Observable<CancelPreActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/CancelDiverseProductVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDiverseProductVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDiverseProductVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutputDto>;
        }));
    }

    protected processCancelDiverseProductVendorPreReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel the diverse product prereport of the given id with the given cancelation comment for transport vendor
     * @param body (optional) 
     * @return OK
     */
    cancelDiverseProductTransportVendorPreReport(body: ProvidersModuleCancelPreActivityReportInputDto | undefined): Observable<CancelPreActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/CancelDiverseProductTransportVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelDiverseProductTransportVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDiverseProductTransportVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutputDto>;
        }));
    }

    protected processCancelDiverseProductTransportVendorPreReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the article and/or driver of the diverse product prereport with the given id if it belongs to the logged in transport vendor
     * @param body (optional) 
     * @return OK
     */
    editTransportVendorDiverseProductPreActivityReport(body: DiverseProductPreActivityReportEditionInput | undefined): Observable<ViewDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/EditTransportVendorDiverseProductPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTransportVendorDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTransportVendorDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processEditTransportVendorDiverseProductPreActivityReport(response: HttpResponseBase): Observable<ViewDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the article and/or driver of the diverse product prereport with the given id if it belongs to the logged in vendor
     * @param body (optional) 
     * @return OK
     */
    editVendorDiverseProductPreActivityReport(body: DiverseProductPreActivityReportEditionInput | undefined): Observable<ViewDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductPreReport/EditVendorDiverseProductPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditVendorDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditVendorDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processEditVendorDiverseProductPreActivityReport(response: HttpResponseBase): Observable<ViewDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleDiverseProductReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param activityReportId (optional) 
     * @return OK
     */
    getDiverseProductReportForTransportVendor(activityReportId: number | undefined): Observable<DiverseProductActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductReport/GetDiverseProductReportForTransportVendor?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductActivityReportDto>;
        }));
    }

    protected processGetDiverseProductReportForTransportVendor(response: HttpResponseBase): Observable<DiverseProductActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @return OK
     */
    getDiverseProductReportForVendor(activityReportId: number | undefined): Observable<DiverseProductActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductReport/GetDiverseProductReportForVendor?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductActivityReportDto>;
        }));
    }

    protected processGetDiverseProductReportForVendor(response: HttpResponseBase): Observable<DiverseProductActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchDiverseProductReportForVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductReport/SearchDiverseProductReportForVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchDiverseProductReportForVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchDiverseProductReportForTransportVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleDiverseProductReport/SearchDiverseProductReportForTransportVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchDiverseProductReportForTransportVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleInternalMovementPreReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create prereport for a transport vendor with the given properties
     * @param body (optional) 
     * @return OK
     */
    createPreReportForTransportVendor(body: ProvidersModuleInternalMovementsPreReportCreationInput | undefined): Observable<ProvidersModuleInternalMovementPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementPreReport/CreatePreReportForTransportVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePreReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePreReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleInternalMovementPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleInternalMovementPreReportCreationOutput>;
        }));
    }

    protected processCreatePreReportForTransportVendor(response: HttpResponseBase): Observable<ProvidersModuleInternalMovementPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleInternalMovementPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the internal movement prereport of the given id if it belongs to the logged in transport vendor
     * @param reportId (optional) 
     * @return OK
     */
    getInternalMovementPreActivityReportForTransportVendorView(reportId: number | undefined): Observable<ViewInternalMovementPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementPreReport/GetInternalMovementPreActivityReportForTransportVendorView?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementPreActivityReportForTransportVendorView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementPreActivityReportForTransportVendorView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
        }));
    }

    protected processGetInternalMovementPreActivityReportForTransportVendorView(response: HttpResponseBase): Observable<ViewInternalMovementPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewInternalMovementPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all internal movement prereports with the given license plate, article id, driver id and entrance status
     * @param licensePlate (optional) 
     * @param articleId (optional) 
     * @param driverId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchInternalMovementPreActivityReportForTransportVendor(licensePlate: string | undefined, articleId: number | undefined, driverId: number | undefined, entranceStatusFilter: PreActivityReportEntranceStatusFilter, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementPreReport/SearchInternalMovementPreActivityReportForTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilter === undefined || entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' must be defined and cannot be null.");
        else
            url_ += "EntranceStatusFilter=" + encodeURIComponent("" + entranceStatusFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementPreActivityReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementPreActivityReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchInternalMovementPreActivityReportForTransportVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel the internal movement prereport of the given id with the given cancellation comment
     * @param body (optional) 
     * @return OK
     */
    cancelInternalMovementTransportVendorPreReport(body: ProvidersModuleCancelPreActivityReportInputDto | undefined): Observable<CancelPreActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementPreReport/CancelInternalMovementTransportVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInternalMovementTransportVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInternalMovementTransportVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutputDto>;
        }));
    }

    protected processCancelInternalMovementTransportVendorPreReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the article and/or driver of the internal movement prereport with the given id if it belongs to the logged in transport vendor
     * @param body (optional) 
     * @return OK
     */
    editTransportVendorInternalMovementPreActivityReport(body: InternalMovementPreActivityReportEditionInput | undefined): Observable<ViewInternalMovementPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementPreReport/EditTransportVendorInternalMovementPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTransportVendorInternalMovementPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTransportVendorInternalMovementPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewInternalMovementPreActivityReportOutput>;
        }));
    }

    protected processEditTransportVendorInternalMovementPreActivityReport(response: HttpResponseBase): Observable<ViewInternalMovementPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewInternalMovementPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleInternalMovementsReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchInternalMovementsReportForTransportVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementsReport/SearchInternalMovementsReportForTransportVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementsReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementsReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchInternalMovementsReportForTransportVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @return OK
     */
    getInternalMovementsReportForTransportVendor(activityReportId: number | undefined): Observable<InternalMovementsActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleInternalMovementsReport/GetInternalMovementsReportForTransportVendor?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementsReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementsReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalMovementsActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalMovementsActivityReportDto>;
        }));
    }

    protected processGetInternalMovementsReportForTransportVendor(response: HttpResponseBase): Observable<InternalMovementsActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalMovementsActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleVehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getDiverseProductTruckByPlateForVendor(licensePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleVehicle/GetDiverseProductTruckByPlateForVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductTruckByPlateForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductTruckByPlateForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetDiverseProductTruckByPlateForVendor(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param vendorId (optional) 
     * @return OK
     */
    getDiverseProductTruckByPlateForTransportVendor(licensePlate: string | undefined, vendorId: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleVehicle/GetDiverseProductTruckByPlateForTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductTruckByPlateForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductTruckByPlateForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetDiverseProductTruckByPlateForTransportVendor(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param vendorId (optional) 
     * @return OK
     */
    getInternalMovementTruckByPlateForTransportVendor(licensePlate: string | undefined, vendorId: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleVehicle/GetInternalMovementTruckByPlateForTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementTruckByPlateForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementTruckByPlateForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetInternalMovementTruckByPlateForTransportVendor(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getWoodTruckByPlateForTransportVendor(licensePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleVehicle/GetWoodTruckByPlateForTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodTruckByPlateForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodTruckByPlateForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetWoodTruckByPlateForTransportVendor(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getWoodTruckByPlateForVendor(licensePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleVehicle/GetWoodTruckByPlateForVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodTruckByPlateForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodTruckByPlateForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetWoodTruckByPlateForVendor(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleWoodPreActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the wood prereport of the given id if it belongs to the logged in vendor
     * @param reportId (optional) 
     * @return OK
     */
    obtainPreReportForViewOfVendor(reportId: number | undefined): Observable<WoodPreActivityReportFullDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ObtainPreReportForViewOfVendor?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtainPreReportForViewOfVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtainPreReportForViewOfVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportFullDto>;
        }));
    }

    protected processObtainPreReportForViewOfVendor(response: HttpResponseBase): Observable<WoodPreActivityReportFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportFullDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the wood prereport of the given id if it belongs to the logged in transport vendor
     * @param reportId (optional) 
     * @return OK
     */
    obtainPreReportForViewOfTransportVendor(reportId: number | undefined): Observable<WoodPreActivityReportFullDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ObtainPreReportForViewOfTransportVendor?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObtainPreReportForViewOfTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObtainPreReportForViewOfTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportFullDto>;
        }));
    }

    protected processObtainPreReportForViewOfTransportVendor(response: HttpResponseBase): Observable<WoodPreActivityReportFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportFullDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all available turns for wood prereport
     * @param reportId (optional) 
     * @return OK
     */
    getTurnsWithAvailableQuota(reportId: number | undefined): Observable<GetAvailableTurnsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/GetTurnsWithAvailableQuota?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnsWithAvailableQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnsWithAvailableQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableTurnsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableTurnsOutput>;
        }));
    }

    protected processGetTurnsWithAvailableQuota(response: HttpResponseBase): Observable<GetAvailableTurnsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableTurnsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Schedule a trip for the prereport of the given id with the given date
     * @param body (optional) 
     * @return OK
     */
    scheduleTrip(body: ProvidersModuleScheduleTripInput | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ScheduleTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processScheduleTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the scheduled trip of the prereport with the given id to the new given date
     * @param body (optional) 
     * @return OK
     */
    updateScheduledTrip(body: ProvidersModuleScheduleTripInput | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/UpdateScheduledTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduledTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduledTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processUpdateScheduledTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create wood prereport for logged in vendor with the given properties
     * @param body (optional) 
     * @return OK
     */
    createManualWoodPreReportForVendor(body: WoodPreActivityReportCreationDto | undefined): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/CreateManualWoodPreReportForVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualWoodPreReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualWoodPreReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
        }));
    }

    protected processCreateManualWoodPreReportForVendor(response: HttpResponseBase): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create wood prereport for the logged in transport vendor with the given properties
     * @param body (optional) 
     * @return OK
     */
    createManualWoodPreReportForTransportVendor(body: WoodPreActivityReportCreationDto | undefined): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/CreateManualWoodPreReportForTransportVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualWoodPreReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualWoodPreReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
        }));
    }

    protected processCreateManualWoodPreReportForTransportVendor(response: HttpResponseBase): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if a SmarTrip travel exists for the license plate of the given input
     * @param body (optional) 
     * @return OK
     */
    existSmartTripTrip(body: ExistSmartTripsTripInput | undefined): Observable<ExistSmartTripsTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ExistSmartTripTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistSmartTripTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistSmartTripTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistSmartTripsTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistSmartTripsTripOutput>;
        }));
    }

    protected processExistSmartTripTrip(response: HttpResponseBase): Observable<ExistSmartTripsTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistSmartTripsTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generate wood pre activity report with vehicle and driver information, using information provided external truck system and external wood system.
     * @param driverId (optional) 
     * @param truckPlate (optional) 
     * @param semisPlates (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getSmartLoadPreActivityReportInfo(driverId: number | undefined, truckPlate: string | undefined, semisPlates: string[] | undefined, destinationId: number | undefined): Observable<WoodPreActivityReportCreationDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/GetSmartLoadPreActivityReportInfo?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartLoadPreActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartLoadPreActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportCreationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportCreationDto>;
        }));
    }

    protected processGetSmartLoadPreActivityReportInfo(response: HttpResponseBase): Observable<WoodPreActivityReportCreationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportCreationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Receive qr string detected by camera and validate it to obtain the wood prereport creation dto.
     * @param qRCode (optional) 
     * @param driverId (optional) 
     * @param truckPlate (optional) 
     * @param semisPlates (optional) 
     * @param destinationId (optional) 
     * @param isTruckPlateDifferentConfirmed (optional) 
     * @param truckPlateParsedFromQR (optional) 
     * @return OK
     */
    getWoodTransportVendorQRPreActivityReportInfo(qRCode: string | undefined, driverId: number | undefined, truckPlate: string | undefined, semisPlates: string[] | undefined, destinationId: number | undefined, isTruckPlateDifferentConfirmed: boolean | undefined, truckPlateParsedFromQR: string | undefined): Observable<WoodPreActivityReportCreationDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/GetWoodTransportVendorQRPreActivityReportInfo?";
        if (qRCode === null)
            throw new Error("The parameter 'qRCode' cannot be null.");
        else if (qRCode !== undefined)
            url_ += "QRCode=" + encodeURIComponent("" + qRCode) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (isTruckPlateDifferentConfirmed === null)
            throw new Error("The parameter 'isTruckPlateDifferentConfirmed' cannot be null.");
        else if (isTruckPlateDifferentConfirmed !== undefined)
            url_ += "IsTruckPlateDifferentConfirmed=" + encodeURIComponent("" + isTruckPlateDifferentConfirmed) + "&";
        if (truckPlateParsedFromQR === null)
            throw new Error("The parameter 'truckPlateParsedFromQR' cannot be null.");
        else if (truckPlateParsedFromQR !== undefined)
            url_ += "TruckPlateParsedFromQR=" + encodeURIComponent("" + truckPlateParsedFromQR) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodTransportVendorQRPreActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodTransportVendorQRPreActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportCreationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportCreationDto>;
        }));
    }

    protected processGetWoodTransportVendorQRPreActivityReportInfo(response: HttpResponseBase): Observable<WoodPreActivityReportCreationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportCreationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Receive qr string detected by camera and validate it to obtain the wood prereport creation dto.
     * @param qRCode (optional) 
     * @param driverId (optional) 
     * @param truckPlate (optional) 
     * @param semisPlates (optional) 
     * @param destinationId (optional) 
     * @param isTruckPlateDifferentConfirmed (optional) 
     * @param truckPlateParsedFromQR (optional) 
     * @return OK
     */
    getWoodVendorQRPreActivityReportInfo(qRCode: string | undefined, driverId: number | undefined, truckPlate: string | undefined, semisPlates: string[] | undefined, destinationId: number | undefined, isTruckPlateDifferentConfirmed: boolean | undefined, truckPlateParsedFromQR: string | undefined): Observable<WoodPreActivityReportCreationDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/GetWoodVendorQRPreActivityReportInfo?";
        if (qRCode === null)
            throw new Error("The parameter 'qRCode' cannot be null.");
        else if (qRCode !== undefined)
            url_ += "QRCode=" + encodeURIComponent("" + qRCode) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (isTruckPlateDifferentConfirmed === null)
            throw new Error("The parameter 'isTruckPlateDifferentConfirmed' cannot be null.");
        else if (isTruckPlateDifferentConfirmed !== undefined)
            url_ += "IsTruckPlateDifferentConfirmed=" + encodeURIComponent("" + isTruckPlateDifferentConfirmed) + "&";
        if (truckPlateParsedFromQR === null)
            throw new Error("The parameter 'truckPlateParsedFromQR' cannot be null.");
        else if (truckPlateParsedFromQR !== undefined)
            url_ += "TruckPlateParsedFromQR=" + encodeURIComponent("" + truckPlateParsedFromQR) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodVendorQRPreActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodVendorQRPreActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportCreationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportCreationDto>;
        }));
    }

    protected processGetWoodVendorQRPreActivityReportInfo(response: HttpResponseBase): Observable<WoodPreActivityReportCreationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportCreationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create wood prereport from a transport vendor QR
     * @param body (optional) 
     * @return OK
     */
    confirmWoodTransportVendorQRPreActivityReport(body: QRWoodPreActivityReportInput | undefined): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ConfirmWoodTransportVendorQRPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmWoodTransportVendorQRPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmWoodTransportVendorQRPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
        }));
    }

    protected processConfirmWoodTransportVendorQRPreActivityReport(response: HttpResponseBase): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create wood prereport from a vendor QR
     * @param body (optional) 
     * @return OK
     */
    confirmWoodVendorQRPreActivityReport(body: VendorQRWoodPreActivityReportInput | undefined): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ConfirmWoodVendorQRPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmWoodVendorQRPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmWoodVendorQRPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
        }));
    }

    protected processConfirmWoodVendorQRPreActivityReport(response: HttpResponseBase): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create wood prereport from license plate with SmartLoad trip and its semitrailer plates and driver
     * @param body (optional) 
     * @return OK
     */
    confirmSmartLoadPreActivityReport(body: DriverAndTruckInput | undefined): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/ConfirmSmartLoadPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSmartLoadPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSmartLoadPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvidersModuleWoodPreReportCreationOutput>;
        }));
    }

    protected processConfirmSmartLoadPreActivityReport(response: HttpResponseBase): Observable<ProvidersModuleWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvidersModuleWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search all wood prereports with the given license plate, origin id, destination id, driver id and entrance status of the logged in vendor
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchWoodPreReportsForVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilterForVendor: PreActivityReportEntranceStatusFilterForVendor, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/SearchWoodPreReportsForVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilterForVendor === undefined || entranceStatusFilterForVendor === null)
            throw new Error("The parameter 'entranceStatusFilterForVendor' must be defined and cannot be null.");
        else
            url_ += "EntranceStatusFilterForVendor=" + encodeURIComponent("" + entranceStatusFilterForVendor) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodPreReportsForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodPreReportsForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchWoodPreReportsForVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search all wood prereports with the given license plate, origin id, destination id, driver id and entrance status of the logged in transport vendor
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchWoodPreReportsForTransportVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilterForTransportVendor: PreActivityReportEntranceStatusFilterForTransportVendor, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/SearchWoodPreReportsForTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilterForTransportVendor === undefined || entranceStatusFilterForTransportVendor === null)
            throw new Error("The parameter 'entranceStatusFilterForTransportVendor' must be defined and cannot be null.");
        else
            url_ += "EntranceStatusFilterForTransportVendor=" + encodeURIComponent("" + entranceStatusFilterForTransportVendor) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodPreReportsForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodPreReportsForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchWoodPreReportsForTransportVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate if the driver's vendor is valid for prereports of the logged in vendor
     * @param placeId (optional) 
     * @param driverVendorId (optional) 
     * @return OK
     */
    isValidDriverVendor(placeId: number | undefined, driverVendorId: number | undefined): Observable<ValidateDriverVendorOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/IsValidDriverVendor?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (driverVendorId === null)
            throw new Error("The parameter 'driverVendorId' cannot be null.");
        else if (driverVendorId !== undefined)
            url_ += "driverVendorId=" + encodeURIComponent("" + driverVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidDriverVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidDriverVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateDriverVendorOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateDriverVendorOutput>;
        }));
    }

    protected processIsValidDriverVendor(response: HttpResponseBase): Observable<ValidateDriverVendorOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateDriverVendorOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel the wood prereport of the given id with the given comment if it belongs to the logged in vendor
     * @param body (optional) 
     * @return OK
     */
    cancelWoodVendorPreReport(body: ProvidersModuleCancelPreActivityReportInputDto | undefined): Observable<CancelPreActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/CancelWoodVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelWoodVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelWoodVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutputDto>;
        }));
    }

    protected processCancelWoodVendorPreReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel the wood prereport of the given id with the given comment if it belongs to the logged in transport vendor
     * @param body (optional) 
     * @return OK
     */
    cancelWoodTransportVendorPreReport(body: ProvidersModuleCancelPreActivityReportInputDto | undefined): Observable<CancelPreActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/CancelWoodTransportVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelWoodTransportVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelWoodTransportVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutputDto>;
        }));
    }

    protected processCancelWoodTransportVendorPreReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the wood prereport of the given id with the given properties if it belongs to the logged in vendor
     * @param body (optional) 
     * @return OK
     */
    editWoodVendorPreReport(body: WoodPreActivityReportEditionInput | undefined): Observable<WoodPreActivityReportEditionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/EditWoodVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditWoodVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditWoodVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportEditionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportEditionOutput>;
        }));
    }

    protected processEditWoodVendorPreReport(response: HttpResponseBase): Observable<WoodPreActivityReportEditionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportEditionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the wood prereport of the given id with the given properties if it belongs to the logged in transport vendor
     * @param body (optional) 
     * @return OK
     */
    editWoodTransportVendorPreReport(body: WoodPreActivityReportEditionInput | undefined): Observable<WoodPreActivityReportEditionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodPreActivityReport/EditWoodTransportVendorPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditWoodTransportVendorPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditWoodTransportVendorPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportEditionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportEditionOutput>;
        }));
    }

    protected processEditWoodTransportVendorPreReport(response: HttpResponseBase): Observable<WoodPreActivityReportEditionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportEditionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvidersModuleWoodReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchWoodReportForVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodReport/SearchWoodReportForVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchWoodReportForVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationExternalId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchWoodReportForTransportVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationExternalId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodReport/SearchWoodReportForTransportVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchWoodReportForTransportVendor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return OK
     */
    getFORut(placeId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodReport/GetFORut?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFORut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFORut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFORut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    getWoodTransportVendorReportById(reportId: number | undefined): Observable<WoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodReport/GetWoodTransportVendorReportById?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodTransportVendorReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodTransportVendorReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportDto>;
        }));
    }

    protected processGetWoodTransportVendorReportById(response: HttpResponseBase): Observable<WoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    getWoodVendorReportById(reportId: number | undefined): Observable<WoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidersModuleWoodReport/GetWoodVendorReportById?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodVendorReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodVendorReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportDto>;
        }));
    }

    protected processGetWoodVendorReportById(response: HttpResponseBase): Observable<WoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RandomStatisticalSampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the random sample assignations
     * @param periodId (optional) 
     * @param modelId (optional) 
     * @param woodOriginExternalId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getRandomSampleAssignations(periodId: number | undefined, modelId: number | undefined, woodOriginExternalId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRandomSampleAssignationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSample/GetRandomSampleAssignations?";
        if (periodId === null)
            throw new Error("The parameter 'periodId' cannot be null.");
        else if (periodId !== undefined)
            url_ += "PeriodId=" + encodeURIComponent("" + periodId) + "&";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRandomSampleAssignations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRandomSampleAssignations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRandomSampleAssignationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRandomSampleAssignationOutputDto>;
        }));
    }

    protected processGetRandomSampleAssignations(response: HttpResponseBase): Observable<PagedResultDtoOfRandomSampleAssignationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRandomSampleAssignationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generate random sample assignations report
     * @param body (optional) 
     * @return OK
     */
    generateRandomSampleAssignationsReport(body: RandomSampleAssignationReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSample/GenerateRandomSampleAssignationsReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRandomSampleAssignationsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRandomSampleAssignationsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateRandomSampleAssignationsReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RandomStatisticalSampleQuotaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all random statistical sample quotas
     * @param placeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllRandomStatisticalSampleQuotas(placeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/GetAllRandomStatisticalSampleQuotas?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRandomStatisticalSampleQuotas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRandomStatisticalSampleQuotas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto>;
        }));
    }

    protected processGetAllRandomStatisticalSampleQuotas(response: HttpResponseBase): Observable<CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get sample quota by id
     * @param sampleQuotaId (optional) 
     * @return OK
     */
    getRandomStatisticalSampleQuotaById(sampleQuotaId: number | undefined): Observable<RandomStatisticalSampleQuotaDto> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/GetRandomStatisticalSampleQuotaById?";
        if (sampleQuotaId === null)
            throw new Error("The parameter 'sampleQuotaId' cannot be null.");
        else if (sampleQuotaId !== undefined)
            url_ += "sampleQuotaId=" + encodeURIComponent("" + sampleQuotaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRandomStatisticalSampleQuotaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRandomStatisticalSampleQuotaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RandomStatisticalSampleQuotaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RandomStatisticalSampleQuotaDto>;
        }));
    }

    protected processGetRandomStatisticalSampleQuotaById(response: HttpResponseBase): Observable<RandomStatisticalSampleQuotaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RandomStatisticalSampleQuotaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReceiptIndicatorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get's the indicator of Get Max Volume projection with in place
     * @param placeId (optional) 
     * @param hours (optional) 
     * @return OK
     */
    getVolumeProjection(placeId: number | undefined, hours: number | undefined): Observable<VolumeProjectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetVolumeProjection?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (hours === null)
            throw new Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVolumeProjection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVolumeProjection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VolumeProjectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VolumeProjectionOutputDto>;
        }));
    }

    protected processGetVolumeProjection(response: HttpResponseBase): Observable<VolumeProjectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VolumeProjectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's all the trucks not arrive trip in SmartAccess
     * @param placeId (optional) 
     * @return OK
     */
    getTrucksNotArriveToNextTrip(placeId: number | undefined): Observable<TrucksNextTripIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetTrucksNotArriveToNextTrip?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrucksNotArriveToNextTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrucksNotArriveToNextTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrucksNextTripIndicatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrucksNextTripIndicatorDto>;
        }));
    }

    protected processGetTrucksNotArriveToNextTrip(response: HttpResponseBase): Observable<TrucksNextTripIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrucksNextTripIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Enqueues the generation of a wood report for the input information
     * @param body (optional) 
     * @return OK
     */
    generateReport(body: WoodReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a samples report for the input information
     * @param body (optional) 
     * @return OK
     */
    generateReportForSamples(body: ArchimedesSamplesReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForSamples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForSamples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForSamples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForSamples(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a bark samples report for the input information
     * @param body (optional) 
     * @return OK
     */
    generateReportForBarkSamples(body: BarkSamplesReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForBarkSamples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForBarkSamples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForBarkSamples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForBarkSamples(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a diverse products
    report for the input information
     * @param body (optional) 
     * @return OK
     */
    generateReportForDiverseProducts(body: DiverseProductsReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForDiverseProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForDiverseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForDiverseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForDiverseProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a internal movements
     * @param body (optional) 
     * @return OK
     */
    generateReportForInternalMovements(body: InternalMovementsReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForInternalMovements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForInternalMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForInternalMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForInternalMovements(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a wood PreReports or 
    reports with PreReports information
     * @param body (optional) 
     * @return OK
     */
    generateReportForWoodPreActivityReport(body: ReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForWoodPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForWoodPreActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a pre-reports of diverse products reports
     * @param body (optional) 
     * @return OK
     */
    generateReportForPreReportOfDiverseProductReport(body: ReportInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForPreReportOfDiverseProductReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForPreReportOfDiverseProductReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForPreReportOfDiverseProductReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForPreReportOfDiverseProductReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enqueues the generation of a wood report logs for the input information
     * @param body (optional) 
     * @return OK
     */
    generateReportForWoodLogs(body: WoodActivityReportLogsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GenerateReportForWoodLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReportForWoodLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReportForWoodLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReportForWoodLogs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ResourceTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<ExternalResourceTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ResourceType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalResourceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalResourceTypeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ExternalResourceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalResourceTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RfidReaderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Receive a new rfid tag detection
     * @param body (optional) 
     * @return OK
     */
    detectNewTag(body: TagDetectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RfidReader/DetectNewTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetectNewTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetectNewTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDetectNewTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param roleId (optional) 
     * @return OK
     */
    refreshRolePermissions(roleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/RefreshRolePermissions?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshRolePermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    releaseSample(body: ReleaseSampleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ReleaseSample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseSample(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveSampleInstance(body: SaveSampleInput | undefined): Observable<SaveSampleOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sample/SaveSampleInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSampleInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSampleInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveSampleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveSampleOutput>;
        }));
    }

    protected processSaveSampleInstance(response: HttpResponseBase): Observable<SaveSampleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveSampleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportExternalId (optional) 
     * @return OK
     */
    deleteArchimedesSample(reportId: number, reportExternalId: number | undefined, comment: string, deletionReasonId: number): Observable<DeleteArchimedesSampleOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sample/DeleteArchimedesSample?";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined and cannot be null.");
        else
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (reportExternalId === null)
            throw new Error("The parameter 'reportExternalId' cannot be null.");
        else if (reportExternalId !== undefined)
            url_ += "ReportExternalId=" + encodeURIComponent("" + reportExternalId) + "&";
        if (comment === undefined || comment === null)
            throw new Error("The parameter 'comment' must be defined and cannot be null.");
        else
            url_ += "Comment=" + encodeURIComponent("" + comment) + "&";
        if (deletionReasonId === undefined || deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' must be defined and cannot be null.");
        else
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArchimedesSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArchimedesSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteArchimedesSampleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteArchimedesSampleOutput>;
        }));
    }

    protected processDeleteArchimedesSample(response: HttpResponseBase): Observable<DeleteArchimedesSampleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteArchimedesSampleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lockAndCommunicateSampleInitialization(body: SampleInitializationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/LockAndCommunicateSampleInitialization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockAndCommunicateSampleInitialization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockAndCommunicateSampleInitialization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLockAndCommunicateSampleInitialization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    communicateSampleManualWeight(body: CommunicateManualWeightInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/CommunicateSampleManualWeight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommunicateSampleManualWeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommunicateSampleManualWeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCommunicateSampleManualWeight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    calculateDensityForSampleAndCommunicate(body: CalculateDensityDtoInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Sample/CalculateDensityForSampleAndCommunicate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateDensityForSampleAndCommunicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateDensityForSampleAndCommunicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculateDensityForSampleAndCommunicate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagValue (optional) 
     * @param zoneId (optional) 
     * @param placeId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    startSampleDetectionByRfid(tagValue: number | undefined, zoneId: number | undefined, placeId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/StartSampleDetectionByRfid?";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSampleDetectionByRfid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSampleDetectionByRfid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartSampleDetectionByRfid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    shouldBeSampledAtLogyard(body: ShouldBeSampledAtLogyardInput | undefined): Observable<ShouldBeSampledAtLogyardOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ShouldBeSampledAtLogyard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldBeSampledAtLogyard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldBeSampledAtLogyard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShouldBeSampledAtLogyardOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShouldBeSampledAtLogyardOutput>;
        }));
    }

    protected processShouldBeSampledAtLogyard(response: HttpResponseBase): Observable<ShouldBeSampledAtLogyardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShouldBeSampledAtLogyardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSampleAssignmentsOnLogyardsManualCreation(body: LogyardsSampleRecoveryInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/UpdateSampleAssignmentsOnLogyardsManualCreation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSampleAssignmentsOnLogyardsManualCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSampleAssignmentsOnLogyardsManualCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSampleAssignmentsOnLogyardsManualCreation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    forceLogyardsSampleRecovery(body: LogyardsSampleRecoveryInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ForceLogyardsSampleRecovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceLogyardsSampleRecovery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceLogyardsSampleRecovery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceLogyardsSampleRecovery(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    recoverSamplesOnLogyardsReportEdition(body: RecoverSamplesOnLogyardsReportEditionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/RecoverSamplesOnLogyardsReportEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverSamplesOnLogyardsReportEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverSamplesOnLogyardsReportEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecoverSamplesOnLogyardsReportEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search all bark samples with the given search filters
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param cutServiceVendorId (optional) 
     * @param extractionServiceVendorId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchBarkSamplesForGrid(startDate: DateTime | undefined, endDate: DateTime | undefined, originId: number | undefined, standId: number | undefined, cutServiceVendorId: number | undefined, extractionServiceVendorId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfBarkSampleForGridDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/SearchBarkSamplesForGrid?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (cutServiceVendorId === null)
            throw new Error("The parameter 'cutServiceVendorId' cannot be null.");
        else if (cutServiceVendorId !== undefined)
            url_ += "CutServiceVendorId=" + encodeURIComponent("" + cutServiceVendorId) + "&";
        if (extractionServiceVendorId === null)
            throw new Error("The parameter 'extractionServiceVendorId' cannot be null.");
        else if (extractionServiceVendorId !== undefined)
            url_ += "ExtractionServiceVendorId=" + encodeURIComponent("" + extractionServiceVendorId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBarkSamplesForGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBarkSamplesForGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfBarkSampleForGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfBarkSampleForGridDto>;
        }));
    }

    protected processSearchBarkSamplesForGrid(response: HttpResponseBase): Observable<CustomPagedResultDtoOfBarkSampleForGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfBarkSampleForGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sampleType (optional) 
     * @param woodOriginExternalId (optional) 
     * @param standExternalId (optional) 
     * @param reportNumber (optional) 
     * @param reportSerial (optional) 
     * @param woodProviderExternalId (optional) 
     * @param articleExternalId (optional) 
     * @param placeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchArchimedesSamplesForGrid(reportId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, sampleType: SampleAssignmentType | undefined, woodOriginExternalId: number | undefined, standExternalId: number | undefined, reportNumber: number | undefined, reportSerial: string | undefined, woodProviderExternalId: number | undefined, articleExternalId: number | undefined, placeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfArchimedesSampleForGridDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/SearchArchimedesSamplesForGrid?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (sampleType === null)
            throw new Error("The parameter 'sampleType' cannot be null.");
        else if (sampleType !== undefined)
            url_ += "SampleType=" + encodeURIComponent("" + sampleType) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        if (standExternalId === null)
            throw new Error("The parameter 'standExternalId' cannot be null.");
        else if (standExternalId !== undefined)
            url_ += "StandExternalId=" + encodeURIComponent("" + standExternalId) + "&";
        if (reportNumber === null)
            throw new Error("The parameter 'reportNumber' cannot be null.");
        else if (reportNumber !== undefined)
            url_ += "ReportNumber=" + encodeURIComponent("" + reportNumber) + "&";
        if (reportSerial === null)
            throw new Error("The parameter 'reportSerial' cannot be null.");
        else if (reportSerial !== undefined)
            url_ += "ReportSerial=" + encodeURIComponent("" + reportSerial) + "&";
        if (woodProviderExternalId === null)
            throw new Error("The parameter 'woodProviderExternalId' cannot be null.");
        else if (woodProviderExternalId !== undefined)
            url_ += "WoodProviderExternalId=" + encodeURIComponent("" + woodProviderExternalId) + "&";
        if (articleExternalId === null)
            throw new Error("The parameter 'articleExternalId' cannot be null.");
        else if (articleExternalId !== undefined)
            url_ += "ArticleExternalId=" + encodeURIComponent("" + articleExternalId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchArchimedesSamplesForGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchArchimedesSamplesForGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfArchimedesSampleForGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfArchimedesSampleForGridDto>;
        }));
    }

    protected processSearchArchimedesSamplesForGrid(response: HttpResponseBase): Observable<CustomPagedResultDtoOfArchimedesSampleForGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfArchimedesSampleForGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScaleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get current scale weight by scaleId
     * @param scaleDeviceId (optional) 
     * @return OK
     */
    scaleWeightByScaleId(scaleDeviceId: number | undefined): Observable<ScaleOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Scale/ScaleWeightByScaleId?";
        if (scaleDeviceId === null)
            throw new Error("The parameter 'scaleDeviceId' cannot be null.");
        else if (scaleDeviceId !== undefined)
            url_ += "scaleDeviceId=" + encodeURIComponent("" + scaleDeviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScaleWeightByScaleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScaleWeightByScaleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleOutputDto>;
        }));
    }

    protected processScaleWeightByScaleId(response: HttpResponseBase): Observable<ScaleOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current scale weight by zoneId
     * @param zoneId (optional) 
     * @return OK
     */
    scaleWeightByZoneId(zoneId: number | undefined): Observable<ScaleOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Scale/ScaleWeightByZoneId?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScaleWeightByZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScaleWeightByZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleOutputDto>;
        }));
    }

    protected processScaleWeightByZoneId(response: HttpResponseBase): Observable<ScaleOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current scale weight by zoneTypeId and send notification to listeners about taked weight
     * @param receiptId (optional) 
     * @param zoneTypeId (optional) 
     * @param labelDescription (optional) 
     * @param attempt (optional) 
     * @return OK
     */
    getScaleWeightForSampling(receiptId: number | undefined, zoneTypeId: number | undefined, labelDescription: string | undefined, attempt: number | undefined, sampleTypeAssignment: SampleAssignmentType): Observable<ScaleOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Scale/GetScaleWeightForSampling?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "ReceiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (zoneTypeId === null)
            throw new Error("The parameter 'zoneTypeId' cannot be null.");
        else if (zoneTypeId !== undefined)
            url_ += "ZoneTypeId=" + encodeURIComponent("" + zoneTypeId) + "&";
        if (labelDescription === null)
            throw new Error("The parameter 'labelDescription' cannot be null.");
        else if (labelDescription !== undefined)
            url_ += "LabelDescription=" + encodeURIComponent("" + labelDescription) + "&";
        if (attempt === null)
            throw new Error("The parameter 'attempt' cannot be null.");
        else if (attempt !== undefined)
            url_ += "Attempt=" + encodeURIComponent("" + attempt) + "&";
        if (sampleTypeAssignment === undefined || sampleTypeAssignment === null)
            throw new Error("The parameter 'sampleTypeAssignment' must be defined and cannot be null.");
        else
            url_ += "SampleTypeAssignment=" + encodeURIComponent("" + sampleTypeAssignment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScaleWeightForSampling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScaleWeightForSampling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleOutputDto>;
        }));
    }

    protected processGetScaleWeightForSampling(response: HttpResponseBase): Observable<ScaleOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScannerExceptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllActiveScannerExceptions(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfScannerExceptionDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerException/GetAllActiveScannerExceptions?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveScannerExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveScannerExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfScannerExceptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfScannerExceptionDto>;
        }));
    }

    protected processGetAllActiveScannerExceptions(response: HttpResponseBase): Observable<CustomPagedResultDtoOfScannerExceptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfScannerExceptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScannerModelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfScannerModelDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerModel/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfScannerModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfScannerModelDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfScannerModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfScannerModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduledTurnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param receiptId (optional) 
     * @param truckPlate (optional) 
     * @param truckVendorId (optional) 
     * @param semisPlates (optional) 
     * @param hashValue (optional) 
     * @param truckExternalId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getTurnsWithAvailableQuotaForReportVendorId(receiptId: number | undefined, truckPlate: string | undefined, truckVendorId: number | undefined, semisPlates: string[] | undefined, hashValue: string | undefined, truckExternalId: number | undefined, locationId: number | undefined, locationType: LocationType): Observable<GetAvailableTurnsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledTurn/GetTurnsWithAvailableQuotaForReportVendorId?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "ReceiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (truckVendorId === null)
            throw new Error("The parameter 'truckVendorId' cannot be null.");
        else if (truckVendorId !== undefined)
            url_ += "TruckVendorId=" + encodeURIComponent("" + truckVendorId) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (hashValue === null)
            throw new Error("The parameter 'hashValue' cannot be null.");
        else if (hashValue !== undefined)
            url_ += "HashValue=" + encodeURIComponent("" + hashValue) + "&";
        if (truckExternalId === null)
            throw new Error("The parameter 'truckExternalId' cannot be null.");
        else if (truckExternalId !== undefined)
            url_ += "TruckExternalId=" + encodeURIComponent("" + truckExternalId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "LocationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnsWithAvailableQuotaForReportVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnsWithAvailableQuotaForReportVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableTurnsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableTurnsOutput>;
        }));
    }

    protected processGetTurnsWithAvailableQuotaForReportVendorId(response: HttpResponseBase): Observable<GetAvailableTurnsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableTurnsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scheduleTrip(body: ScheduleTripInput | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledTurn/ScheduleTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processScheduleTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateScheduledTrip(body: ScheduleTripInput | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledTurn/UpdateScheduledTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduledTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduledTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processUpdateScheduledTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getLoadServices(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfLoadStandServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetLoadServices?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfLoadStandServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfLoadStandServiceDto>;
        }));
    }

    protected processGetLoadServices(response: HttpResponseBase): Observable<CustomPagedResultDtoOfLoadStandServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfLoadStandServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getHarvestServices(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfHarvestStandServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetHarvestServices?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHarvestServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHarvestServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfHarvestStandServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfHarvestStandServiceDto>;
        }));
    }

    protected processGetHarvestServices(response: HttpResponseBase): Observable<CustomPagedResultDtoOfHarvestStandServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfHarvestStandServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getDownloadServices(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfDownloadStandServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetDownloadServices?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDownloadStandServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDownloadStandServiceDto>;
        }));
    }

    protected processGetDownloadServices(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDownloadStandServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDownloadStandServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param destinationId (optional) 
     * @return OK
     */
    getUnloadServicesByLocationId(destinationId: number | undefined): Observable<CustomPagedResultDtoOfDownloadStandServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetUnloadServicesByLocationId?";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnloadServicesByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnloadServicesByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfDownloadStandServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfDownloadStandServiceDto>;
        }));
    }

    protected processGetUnloadServicesByLocationId(response: HttpResponseBase): Observable<CustomPagedResultDtoOfDownloadStandServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfDownloadStandServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all service configurations for visualization.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param externalArticleId (optional) 
     * @param externalInvoiceServiceId (optional) 
     * @param originId (optional) 
     * @param externalDestinationId (optional) 
     * @param serviceType (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, externalArticleId: number | undefined, externalInvoiceServiceId: number | undefined, originId: number | undefined, externalDestinationId: number | undefined, serviceType: ServiceType | undefined): Observable<PagedResultDtoOfServiceConfigurationForVisualizationDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (externalArticleId === null)
            throw new Error("The parameter 'externalArticleId' cannot be null.");
        else if (externalArticleId !== undefined)
            url_ += "ExternalArticleId=" + encodeURIComponent("" + externalArticleId) + "&";
        if (externalInvoiceServiceId === null)
            throw new Error("The parameter 'externalInvoiceServiceId' cannot be null.");
        else if (externalInvoiceServiceId !== undefined)
            url_ += "ExternalInvoiceServiceId=" + encodeURIComponent("" + externalInvoiceServiceId) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (externalDestinationId === null)
            throw new Error("The parameter 'externalDestinationId' cannot be null.");
        else if (externalDestinationId !== undefined)
            url_ += "ExternalDestinationId=" + encodeURIComponent("" + externalDestinationId) + "&";
        if (serviceType === null)
            throw new Error("The parameter 'serviceType' cannot be null.");
        else if (serviceType !== undefined)
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfServiceConfigurationForVisualizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfServiceConfigurationForVisualizationDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfServiceConfigurationForVisualizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceConfigurationForVisualizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SicfeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param receiptId (optional) 
     * @return OK
     */
    generateCFE(receiptId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sicfe/GenerateCFE?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCFE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCFE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateCFE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SingleCustomDeclarationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a single custom declaration by an id
     * @param tenantId (optional) 
     * @param singleId (optional) 
     * @return OK
     */
    get(tenantId: number | undefined, singleId: number | undefined): Observable<SingleCustomDeclarationOutput> {
        let url_ = this.baseUrl + "/api/services/app/SingleCustomDeclaration/Get?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (singleId === null)
            throw new Error("The parameter 'singleId' cannot be null.");
        else if (singleId !== undefined)
            url_ += "SingleId=" + encodeURIComponent("" + singleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCustomDeclarationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCustomDeclarationOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SingleCustomDeclarationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SingleCustomDeclarationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a single custom declaration by vendor id, is wood log and date
     * @param isWoodLog (optional) 
     * @param vendorId (optional) 
     * @param dateTimeOffset (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getByIsWoodVendorMaterial(isWoodLog: boolean | undefined, vendorId: number | undefined, dateTimeOffset: DateTime | undefined, destinationId: number | undefined): Observable<SingleCustomDeclarationOutput> {
        let url_ = this.baseUrl + "/api/services/app/SingleCustomDeclaration/GetByIsWoodVendorMaterial?";
        if (isWoodLog === null)
            throw new Error("The parameter 'isWoodLog' cannot be null.");
        else if (isWoodLog !== undefined)
            url_ += "isWoodLog=" + encodeURIComponent("" + isWoodLog) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (dateTimeOffset === null)
            throw new Error("The parameter 'dateTimeOffset' cannot be null.");
        else if (dateTimeOffset !== undefined)
            url_ += "dateTimeOffset=" + encodeURIComponent(dateTimeOffset ? "" + dateTimeOffset.toString() : "") + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIsWoodVendorMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIsWoodVendorMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCustomDeclarationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCustomDeclarationOutput>;
        }));
    }

    protected processGetByIsWoodVendorMaterial(response: HttpResponseBase): Observable<SingleCustomDeclarationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SingleCustomDeclarationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a single custom declaration by number
     * @param number (optional) 
     * @return OK
     */
    getByNumber(number: string | undefined): Observable<SingleCustomDeclarationOutput> {
        let url_ = this.baseUrl + "/api/services/app/SingleCustomDeclaration/GetByNumber?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleCustomDeclarationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleCustomDeclarationOutput>;
        }));
    }

    protected processGetByNumber(response: HttpResponseBase): Observable<SingleCustomDeclarationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SingleCustomDeclarationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmartTruckServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param truckPlate (optional) 
     * @param truckVendorId (optional) 
     * @param semisPlates (optional) 
     * @param hashValue (optional) 
     * @param truckExternalId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getDriverAndTruckStatus(truckPlate: string | undefined, truckVendorId: number | undefined, semisPlates: string[] | undefined, hashValue: string | undefined, truckExternalId: number | undefined, locationId: number | undefined, locationType: LocationType): Observable<TruckAndDriverStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruck/GetDriverAndTruckStatus?";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (truckVendorId === null)
            throw new Error("The parameter 'truckVendorId' cannot be null.");
        else if (truckVendorId !== undefined)
            url_ += "TruckVendorId=" + encodeURIComponent("" + truckVendorId) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (hashValue === null)
            throw new Error("The parameter 'hashValue' cannot be null.");
        else if (hashValue !== undefined)
            url_ += "HashValue=" + encodeURIComponent("" + hashValue) + "&";
        if (truckExternalId === null)
            throw new Error("The parameter 'truckExternalId' cannot be null.");
        else if (truckExternalId !== undefined)
            url_ += "TruckExternalId=" + encodeURIComponent("" + truckExternalId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "LocationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDriverAndTruckStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDriverAndTruckStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckAndDriverStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckAndDriverStatusOutput>;
        }));
    }

    protected processGetDriverAndTruckStatus(response: HttpResponseBase): Observable<TruckAndDriverStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckAndDriverStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmTruck(body: SmartTruckConfirmTruckInputDto | undefined): Observable<SmartTruckConfirmTruckOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruck/ConfirmTruck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckConfirmTruckOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckConfirmTruckOutput>;
        }));
    }

    protected processConfirmTruck(response: HttpResponseBase): Observable<SmartTruckConfirmTruckOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTruckConfirmTruckOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmForestryTruck(body: SmartTruckConfirmTruckInputDto | undefined): Observable<SmartTruckConfirmTruckOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruck/ConfirmForestryTruck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmForestryTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmForestryTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckConfirmTruckOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckConfirmTruckOutput>;
        }));
    }

    protected processConfirmForestryTruck(response: HttpResponseBase): Observable<SmartTruckConfirmTruckOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTruckConfirmTruckOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmProductsTruck(body: SmartTruckConfirmTruckInputDto | undefined): Observable<SmartTruckConfirmTruckOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruck/ConfirmProductsTruck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmProductsTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmProductsTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckConfirmTruckOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckConfirmTruckOutput>;
        }));
    }

    protected processConfirmProductsTruck(response: HttpResponseBase): Observable<SmartTruckConfirmTruckOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTruckConfirmTruckOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    loadTruck(licensePlate: string | undefined): Observable<TruckOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruck/LoadTruck?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckOutputDto>;
        }));
    }

    protected processLoadTruck(response: HttpResponseBase): Observable<TruckOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get truck's type by license plate
     * @param licensePlate (optional) 
     * @return OK
     */
    getTruckType(licensePlate: string | undefined): Observable<SmartTruckTruckType> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruck/GetTruckType?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckTruckType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckTruckType>;
        }));
    }

    protected processGetTruckType(response: HttpResponseBase): Observable<SmartTruckTruckType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmartTruckActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param reportId (optional) 
     * @param truckPlate (optional) 
     * @param truckVendorId (optional) 
     * @param semisPlates (optional) 
     * @param hashValue (optional) 
     * @param truckExternalId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getPreActivityReportForActiveTrip(reportId: number | undefined, truckPlate: string | undefined, truckVendorId: number | undefined, semisPlates: string[] | undefined, hashValue: string | undefined, truckExternalId: number | undefined, locationId: number | undefined, locationType: LocationType): Observable<PreActivityReportForActiveTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckActivityReport/GetPreActivityReportForActiveTrip?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (truckVendorId === null)
            throw new Error("The parameter 'truckVendorId' cannot be null.");
        else if (truckVendorId !== undefined)
            url_ += "TruckVendorId=" + encodeURIComponent("" + truckVendorId) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (hashValue === null)
            throw new Error("The parameter 'hashValue' cannot be null.");
        else if (hashValue !== undefined)
            url_ += "HashValue=" + encodeURIComponent("" + hashValue) + "&";
        if (truckExternalId === null)
            throw new Error("The parameter 'truckExternalId' cannot be null.");
        else if (truckExternalId !== undefined)
            url_ += "TruckExternalId=" + encodeURIComponent("" + truckExternalId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "LocationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportForActiveTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportForActiveTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportForActiveTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportForActiveTripOutput>;
        }));
    }

    protected processGetPreActivityReportForActiveTrip(response: HttpResponseBase): Observable<PreActivityReportForActiveTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportForActiveTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    existsPreActivityReportByPlate(body: SmartTruckDto | undefined): Observable<ExistsPreActivityReportResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckActivityReport/ExistsPreActivityReportByPlate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsPreActivityReportByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsPreActivityReportByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistsPreActivityReportResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistsPreActivityReportResultOutput>;
        }));
    }

    protected processExistsPreActivityReportByPlate(response: HttpResponseBase): Observable<ExistsPreActivityReportResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistsPreActivityReportResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param truckPlate (optional) 
     * @return OK
     */
    existsPreActivityReportByTruckPlate(truckPlate: string | undefined): Observable<ExistsPreActivityReportResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckActivityReport/ExistsPreActivityReportByTruckPlate?";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "truckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsPreActivityReportByTruckPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsPreActivityReportByTruckPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistsPreActivityReportResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistsPreActivityReportResultOutput>;
        }));
    }

    protected processExistsPreActivityReportByTruckPlate(response: HttpResponseBase): Observable<ExistsPreActivityReportResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistsPreActivityReportResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelPreActivityReport(body: CancelPreActivityReportInputDto | undefined): Observable<CancelPreActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckActivityReport/CancelPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutputDto>;
        }));
    }

    protected processCancelPreActivityReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateTripDriver(placeId: number | undefined, body: SmartTruckDto | undefined): Observable<UpdateTripDriverOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckActivityReport/UpdateTripDriver?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTripDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTripDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTripDriverOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTripDriverOutput>;
        }));
    }

    protected processUpdateTripDriver(response: HttpResponseBase): Observable<UpdateTripDriverOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTripDriverOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmartTruckDiverseProductActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create SmartTruck diverse product prereport
     * @param body (optional) 
     * @return OK
     */
    createPreActivityReport(body: SmartTruckDiverseProductActivityReportInput | undefined): Observable<SmartTruckDiverseProductActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckDiverseProductActivityReport/CreatePreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckDiverseProductActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckDiverseProductActivityReportOutput>;
        }));
    }

    protected processCreatePreActivityReport(response: HttpResponseBase): Observable<SmartTruckDiverseProductActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTruckDiverseProductActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmartTruckInternalMovementActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create SmartTruck internal movement prereport
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateInternalMovementPreActivityReportInput | undefined): Observable<CreateInternalMovementPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckInternalMovementActivityReport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateInternalMovementPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateInternalMovementPreActivityReportOutput>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateInternalMovementPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateInternalMovementPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmartTruckWoodActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a manual wood pre activity report with the given properties
     * @param body (optional) 
     * @return OK
     */
    createManualWoodPreActivityReport(body: SmartTruckWoodPreActivityReportDto | undefined): Observable<CreateWoodPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckWoodActivityReport/CreateManualWoodPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodPreActivityReportOutput>;
        }));
    }

    protected processCreateManualWoodPreActivityReport(response: HttpResponseBase): Observable<CreateWoodPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get smartload pre activity report of the given truck plate, semis plates and driver
     * @param truckPlate (optional) 
     * @param truckVendorId (optional) 
     * @param semisPlates (optional) 
     * @param hashValue (optional) 
     * @param truckExternalId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getSmartLoadPreActivityReportInfo(truckPlate: string | undefined, truckVendorId: number | undefined, semisPlates: string[] | undefined, hashValue: string | undefined, truckExternalId: number | undefined, locationId: number | undefined, locationType: LocationType): Observable<SmartTruckWoodPreActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckWoodActivityReport/GetSmartLoadPreActivityReportInfo?";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (truckVendorId === null)
            throw new Error("The parameter 'truckVendorId' cannot be null.");
        else if (truckVendorId !== undefined)
            url_ += "TruckVendorId=" + encodeURIComponent("" + truckVendorId) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (hashValue === null)
            throw new Error("The parameter 'hashValue' cannot be null.");
        else if (hashValue !== undefined)
            url_ += "HashValue=" + encodeURIComponent("" + hashValue) + "&";
        if (truckExternalId === null)
            throw new Error("The parameter 'truckExternalId' cannot be null.");
        else if (truckExternalId !== undefined)
            url_ += "TruckExternalId=" + encodeURIComponent("" + truckExternalId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "LocationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartLoadPreActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartLoadPreActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckWoodPreActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckWoodPreActivityReportDto>;
        }));
    }

    protected processGetSmartLoadPreActivityReportInfo(response: HttpResponseBase): Observable<SmartTruckWoodPreActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTruckWoodPreActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm smartLoad pre activity report
     * @param body (optional) 
     * @return OK
     */
    confirmSmartLoadPreActivityReport(body: SmartTruckDto | undefined): Observable<CreateWoodPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckWoodActivityReport/ConfirmSmartLoadPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSmartLoadPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSmartLoadPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodPreActivityReportOutput>;
        }));
    }

    protected processConfirmSmartLoadPreActivityReport(response: HttpResponseBase): Observable<CreateWoodPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get QR pre activity report info of the given qr code
     * @param qRCode (optional) 
     * @param receiptPhotoToken (optional) 
     * @param truckPlateParsedFromQR (optional) 
     * @param isTruckPlateDifferentConfirmed (optional) 
     * @param truckPlate (optional) 
     * @param truckVendorId (optional) 
     * @param semisPlates (optional) 
     * @param hashValue (optional) 
     * @param truckExternalId (optional) 
     * @param locationId (optional) 
     * @return OK
     */
    getQRPreActivityReportInfo(qRCode: string | undefined, receiptPhotoToken: string | undefined, truckPlateParsedFromQR: string | undefined, isTruckPlateDifferentConfirmed: boolean | undefined, truckPlate: string | undefined, truckVendorId: number | undefined, semisPlates: string[] | undefined, hashValue: string | undefined, truckExternalId: number | undefined, locationId: number | undefined, locationType: LocationType): Observable<SmartTruckWoodPreActivityReportFromQRDto> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckWoodActivityReport/GetQRPreActivityReportInfo?";
        if (qRCode === null)
            throw new Error("The parameter 'qRCode' cannot be null.");
        else if (qRCode !== undefined)
            url_ += "QRCode=" + encodeURIComponent("" + qRCode) + "&";
        if (receiptPhotoToken === null)
            throw new Error("The parameter 'receiptPhotoToken' cannot be null.");
        else if (receiptPhotoToken !== undefined)
            url_ += "ReceiptPhotoToken=" + encodeURIComponent("" + receiptPhotoToken) + "&";
        if (truckPlateParsedFromQR === null)
            throw new Error("The parameter 'truckPlateParsedFromQR' cannot be null.");
        else if (truckPlateParsedFromQR !== undefined)
            url_ += "TruckPlateParsedFromQR=" + encodeURIComponent("" + truckPlateParsedFromQR) + "&";
        if (isTruckPlateDifferentConfirmed === null)
            throw new Error("The parameter 'isTruckPlateDifferentConfirmed' cannot be null.");
        else if (isTruckPlateDifferentConfirmed !== undefined)
            url_ += "IsTruckPlateDifferentConfirmed=" + encodeURIComponent("" + isTruckPlateDifferentConfirmed) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (truckVendorId === null)
            throw new Error("The parameter 'truckVendorId' cannot be null.");
        else if (truckVendorId !== undefined)
            url_ += "TruckVendorId=" + encodeURIComponent("" + truckVendorId) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (hashValue === null)
            throw new Error("The parameter 'hashValue' cannot be null.");
        else if (hashValue !== undefined)
            url_ += "HashValue=" + encodeURIComponent("" + hashValue) + "&";
        if (truckExternalId === null)
            throw new Error("The parameter 'truckExternalId' cannot be null.");
        else if (truckExternalId !== undefined)
            url_ += "TruckExternalId=" + encodeURIComponent("" + truckExternalId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "LocationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQRPreActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQRPreActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartTruckWoodPreActivityReportFromQRDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartTruckWoodPreActivityReportFromQRDto>;
        }));
    }

    protected processGetQRPreActivityReportInfo(response: HttpResponseBase): Observable<SmartTruckWoodPreActivityReportFromQRDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTruckWoodPreActivityReportFromQRDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirm qr pre activity report
     * @param body (optional) 
     * @return OK
     */
    confirmQRPreActivityReport(body: QRSmartTruckInput | undefined): Observable<CreateWoodPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckWoodActivityReport/ConfirmQRPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmQRPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmQRPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodPreActivityReportOutput>;
        }));
    }

    protected processConfirmQRPreActivityReport(response: HttpResponseBase): Observable<CreateWoodPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates a trip exists
     * @param body (optional) 
     * @return OK
     */
    existSmartTripsTrip(body: SmartTruckExistSmartTripsTripInput | undefined): Observable<ExistSmartTripsTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmartTruckWoodActivityReport/ExistSmartTripsTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistSmartTripsTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistSmartTripsTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistSmartTripsTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistSmartTripsTripOutput>;
        }));
    }

    protected processExistSmartTripsTrip(response: HttpResponseBase): Observable<ExistSmartTripsTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistSmartTripsTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SpeciesGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get species group by id
     * @param speciesGroupId (optional) 
     * @return OK
     */
    getSpeciesGroupById(speciesGroupId: number | undefined): Observable<SpeciesGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroup/GetSpeciesGroupById?";
        if (speciesGroupId === null)
            throw new Error("The parameter 'speciesGroupId' cannot be null.");
        else if (speciesGroupId !== undefined)
            url_ += "speciesGroupId=" + encodeURIComponent("" + speciesGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeciesGroupById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeciesGroupById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpeciesGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpeciesGroupDto>;
        }));
    }

    protected processGetSpeciesGroupById(response: HttpResponseBase): Observable<SpeciesGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpeciesGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get species groups by name
     * @param name (optional) 
     * @return OK
     */
    getAllSpeciesGroups(name: string | undefined): Observable<SpeciesGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SpeciesGroup/GetAllSpeciesGroups?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSpeciesGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpeciesGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpeciesGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpeciesGroupDto[]>;
        }));
    }

    protected processGetAllSpeciesGroups(response: HttpResponseBase): Observable<SpeciesGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpeciesGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StandServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the stand of the given id
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<StandOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StandOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StandOutputDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<StandOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StandOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the stand of the given name for the location of the given id and type
     * @param name (optional) 
     * @param locationId (optional) 
     * @param throwExceptionIfNotActive (optional) If true, throws an exception if the stand is not active
     * @return OK
     */
    getStandByName(name: string | undefined, locationType: LocationType, locationId: number | undefined, throwExceptionIfNotActive: boolean | undefined): Observable<StandOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetStandByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "locationType=" + encodeURIComponent("" + locationType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (throwExceptionIfNotActive === null)
            throw new Error("The parameter 'throwExceptionIfNotActive' cannot be null.");
        else if (throwExceptionIfNotActive !== undefined)
            url_ += "throwExceptionIfNotActive=" + encodeURIComponent("" + throwExceptionIfNotActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StandOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StandOutputDto>;
        }));
    }

    protected processGetStandByName(response: HttpResponseBase): Observable<StandOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StandOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the stand of the given name
     * @param name (optional) 
     * @return OK
     */
    getByName(name: string | undefined): Observable<StandOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StandOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StandOutputDto>;
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<StandOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StandOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all stands of the origin of the given id which contain the given string on their name
     * @param originId (optional) 
     * @param standName (optional) 
     * @return OK
     */
    getByOrigin(originId: number | undefined, standName: string | undefined): Observable<StandOutputCollectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetByOrigin?";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "originId=" + encodeURIComponent("" + originId) + "&";
        if (standName === null)
            throw new Error("The parameter 'standName' cannot be null.");
        else if (standName !== undefined)
            url_ += "standName=" + encodeURIComponent("" + standName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrigin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrigin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StandOutputCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StandOutputCollectionDto>;
        }));
    }

    protected processGetByOrigin(response: HttpResponseBase): Observable<StandOutputCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StandOutputCollectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all stands
     * @param skipCount (optional) Determines the starting position of the list to return (from the full list of stands)
     * @param maxResultCount (optional) Determines the size of the list to return
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfStandOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfStandOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfStandOutputDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfStandOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfStandOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getNotificationsPublicKey(): Observable<WebPushNotificationParametersOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/GetNotificationsPublicKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationsPublicKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationsPublicKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebPushNotificationParametersOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebPushNotificationParametersOutputDto>;
        }));
    }

    protected processGetNotificationsPublicKey(response: HttpResponseBase): Observable<WebPushNotificationParametersOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebPushNotificationParametersOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subscribeToPushNotification(body: PushSubscriptionDto | undefined): Observable<WebPushSubscriptionOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/SubscribeToPushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribeToPushNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeToPushNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebPushSubscriptionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebPushSubscriptionOutput>;
        }));
    }

    protected processSubscribeToPushNotification(response: HttpResponseBase): Observable<WebPushSubscriptionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebPushSubscriptionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param testTitle (optional) 
     * @param testBody (optional) 
     * @param userId (optional) 
     * @return OK
     */
    sendTestNotification(testTitle: string | undefined, testBody: string | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/SendTestNotification?";
        if (testTitle === null)
            throw new Error("The parameter 'testTitle' cannot be null.");
        else if (testTitle !== undefined)
            url_ += "testTitle=" + encodeURIComponent("" + testTitle) + "&";
        if (testBody === null)
            throw new Error("The parameter 'testBody' cannot be null.");
        else if (testBody !== undefined)
            url_ += "testBody=" + encodeURIComponent("" + testBody) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param browserUID (optional) 
     * @return OK
     */
    checkCurrentUserByBrowserWebSubscription(browserUID: string | undefined): Observable<CheckBrowserWebSubscriptionOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/CheckCurrentUserByBrowserWebSubscription?";
        if (browserUID === null)
            throw new Error("The parameter 'browserUID' cannot be null.");
        else if (browserUID !== undefined)
            url_ += "browserUID=" + encodeURIComponent("" + browserUID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserByBrowserWebSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserByBrowserWebSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckBrowserWebSubscriptionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckBrowserWebSubscriptionOutput>;
        }));
    }

    protected processCheckCurrentUserByBrowserWebSubscription(response: HttpResponseBase): Observable<CheckBrowserWebSubscriptionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckBrowserWebSubscriptionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param browserUID (optional) 
     * @return OK
     */
    disableCurrentUserByBrowserWebSubscription(browserUID: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableCurrentUserByBrowserWebSubscription?";
        if (browserUID === null)
            throw new Error("The parameter 'browserUID' cannot be null.");
        else if (browserUID !== undefined)
            url_ += "browserUID=" + encodeURIComponent("" + browserUID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableCurrentUserByBrowserWebSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableCurrentUserByBrowserWebSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableCurrentUserByBrowserWebSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pushSubscriptiOnChange(body: PushSubscriptionChangeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/PushSubscriptiOnChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushSubscriptiOnChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushSubscriptiOnChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPushSubscriptiOnChange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TotemDiverseProductPreReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPreReport(body: TotemDiverseProductPreReportCreationInput | undefined): Observable<TotemDiverseProductPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemDiverseProductPreReport/CreatePreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemDiverseProductPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemDiverseProductPreReportCreationOutput>;
        }));
    }

    protected processCreatePreReport(response: HttpResponseBase): Observable<TotemDiverseProductPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemDiverseProductPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TotemDriverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param driverIdentity (optional) 
     * @param canBeGeneric (optional) 
     * @return OK
     */
    getValidDriver(driverIdentity: string | undefined, canBeGeneric: boolean | undefined): Observable<DriverOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/TotemDriver/GetValidDriver?";
        if (driverIdentity === null)
            throw new Error("The parameter 'driverIdentity' cannot be null.");
        else if (driverIdentity !== undefined)
            url_ += "driverIdentity=" + encodeURIComponent("" + driverIdentity) + "&";
        if (canBeGeneric === null)
            throw new Error("The parameter 'canBeGeneric' cannot be null.");
        else if (canBeGeneric !== undefined)
            url_ += "canBeGeneric=" + encodeURIComponent("" + canBeGeneric) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DriverOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DriverOutputDto>;
        }));
    }

    protected processGetValidDriver(response: HttpResponseBase): Observable<DriverOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriverOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TotemPreActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param placeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updatePreActivityReportDriver(placeId: number | undefined, body: TotemUpdatePreReportDriverInput | undefined): Observable<TotemUpdatePreReportDriverOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemPreActivityReport/UpdatePreActivityReportDriver?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePreActivityReportDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePreActivityReportDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemUpdatePreReportDriverOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemUpdatePreReportDriverOutput>;
        }));
    }

    protected processUpdatePreActivityReportDriver(response: HttpResponseBase): Observable<TotemUpdatePreReportDriverOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemUpdatePreReportDriverOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TotemScheduledTurnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param receiptId (optional) 
     * @return OK
     */
    getTurnsWithAvailableQuotaForVendorByReportId(receiptId: number | undefined): Observable<GetAvailableTurnsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemScheduledTurn/GetTurnsWithAvailableQuotaForVendorByReportId?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnsWithAvailableQuotaForVendorByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnsWithAvailableQuotaForVendorByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableTurnsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableTurnsOutput>;
        }));
    }

    protected processGetTurnsWithAvailableQuotaForVendorByReportId(response: HttpResponseBase): Observable<GetAvailableTurnsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableTurnsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptId (optional) 
     * @param entryTime (optional) 
     * @return OK
     */
    scheduleTrip(receiptId: number | undefined, entryTime: DateTime | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemScheduledTurn/ScheduleTrip?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "ReceiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (entryTime === null)
            throw new Error("The parameter 'entryTime' cannot be null.");
        else if (entryTime !== undefined)
            url_ += "EntryTime=" + encodeURIComponent(entryTime ? "" + entryTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processScheduleTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptId (optional) 
     * @param entryTime (optional) 
     * @return OK
     */
    updateScheduledTrip(receiptId: number | undefined, entryTime: DateTime | undefined): Observable<ScheduleTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemScheduledTurn/UpdateScheduledTrip?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "ReceiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (entryTime === null)
            throw new Error("The parameter 'entryTime' cannot be null.");
        else if (entryTime !== undefined)
            url_ += "EntryTime=" + encodeURIComponent(entryTime ? "" + entryTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduledTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduledTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTripOutput>;
        }));
    }

    protected processUpdateScheduledTrip(response: HttpResponseBase): Observable<ScheduleTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TotemVehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param licensePlate (optional) 
     * @param driverVendorId (optional) 
     * @return OK
     */
    getPaysTransportWoodTruckByPlate(licensePlate: string | undefined, driverVendorId: number | undefined): Observable<TotemVehicleResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TotemVehicle/GetPaysTransportWoodTruckByPlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (driverVendorId === null)
            throw new Error("The parameter 'driverVendorId' cannot be null.");
        else if (driverVendorId !== undefined)
            url_ += "driverVendorId=" + encodeURIComponent("" + driverVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaysTransportWoodTruckByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaysTransportWoodTruckByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemVehicleResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemVehicleResultDto>;
        }));
    }

    protected processGetPaysTransportWoodTruckByPlate(response: HttpResponseBase): Observable<TotemVehicleResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemVehicleResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getNotPaysTransportWoodTruckByPlate(licensePlate: string | undefined): Observable<TotemVehicleResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TotemVehicle/GetNotPaysTransportWoodTruckByPlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotPaysTransportWoodTruckByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotPaysTransportWoodTruckByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemVehicleResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemVehicleResultDto>;
        }));
    }

    protected processGetNotPaysTransportWoodTruckByPlate(response: HttpResponseBase): Observable<TotemVehicleResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemVehicleResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param truckPlate (optional) 
     * @return OK
     */
    getDiverseProductTruckByPlate(truckPlate: string | undefined): Observable<TotemVehicleResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TotemVehicle/GetDiverseProductTruckByPlate?";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "truckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductTruckByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductTruckByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemVehicleResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemVehicleResultDto>;
        }));
    }

    protected processGetDiverseProductTruckByPlate(response: HttpResponseBase): Observable<TotemVehicleResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemVehicleResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Conflict", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TotemWoodPreActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createManualFOWoodPreReport(body: WoodPreActivityReportCreationDto | undefined): Observable<TotemWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/CreateManualFOWoodPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualFOWoodPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualFOWoodPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemWoodPreReportCreationOutput>;
        }));
    }

    protected processCreateManualFOWoodPreReport(response: HttpResponseBase): Observable<TotemWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createManualProviderWoodPreReport(body: WoodPreActivityReportCreationDto | undefined): Observable<TotemWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/CreateManualProviderWoodPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualProviderWoodPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualProviderWoodPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemWoodPreReportCreationOutput>;
        }));
    }

    protected processCreateManualProviderWoodPreReport(response: HttpResponseBase): Observable<TotemWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    existSmartTripTrip(body: ExistSmartTripsTripInput | undefined): Observable<ExistSmartTripsTripOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/ExistSmartTripTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistSmartTripTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistSmartTripTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistSmartTripsTripOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistSmartTripsTripOutput>;
        }));
    }

    protected processExistSmartTripTrip(response: HttpResponseBase): Observable<ExistSmartTripsTripOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistSmartTripsTripOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param driverId (optional) 
     * @param truckPlate (optional) 
     * @param semisPlates (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getSmartLoadPreActivityReportInfo(driverId: number | undefined, truckPlate: string | undefined, semisPlates: string[] | undefined, destinationId: number | undefined): Observable<WoodPreActivityReportCreationDto> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/GetSmartLoadPreActivityReportInfo?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartLoadPreActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartLoadPreActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportCreationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportCreationDto>;
        }));
    }

    protected processGetSmartLoadPreActivityReportInfo(response: HttpResponseBase): Observable<WoodPreActivityReportCreationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportCreationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmSmartLoadPreActivityReport(body: DriverAndTruckInput | undefined): Observable<TotemWoodPreReportCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/ConfirmSmartLoadPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSmartLoadPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSmartLoadPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotemWoodPreReportCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotemWoodPreReportCreationOutput>;
        }));
    }

    protected processConfirmSmartLoadPreActivityReport(response: HttpResponseBase): Observable<TotemWoodPreReportCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotemWoodPreReportCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param qRCode (optional) 
     * @param driverId (optional) 
     * @param truckPlate (optional) 
     * @param semisPlates (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    generatePreActivityReportInfoFromQR(qRCode: string | undefined, driverId: number | undefined, truckPlate: string | undefined, semisPlates: string[] | undefined, destinationId: number | undefined): Observable<WoodPreActivityReportQrCreationDto> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/GeneratePreActivityReportInfoFromQR?";
        if (qRCode === null)
            throw new Error("The parameter 'qRCode' cannot be null.");
        else if (qRCode !== undefined)
            url_ += "QRCode=" + encodeURIComponent("" + qRCode) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (truckPlate === null)
            throw new Error("The parameter 'truckPlate' cannot be null.");
        else if (truckPlate !== undefined)
            url_ += "TruckPlate=" + encodeURIComponent("" + truckPlate) + "&";
        if (semisPlates === null)
            throw new Error("The parameter 'semisPlates' cannot be null.");
        else if (semisPlates !== undefined)
            semisPlates && semisPlates.forEach(item => { url_ += "SemisPlates=" + encodeURIComponent("" + item) + "&"; });
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePreActivityReportInfoFromQR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePreActivityReportInfoFromQR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportQrCreationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportQrCreationDto>;
        }));
    }

    protected processGeneratePreActivityReportInfoFromQR(response: HttpResponseBase): Observable<WoodPreActivityReportQrCreationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportQrCreationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmQRFOPreActivityReport(body: QRConfirmationTotemInput | undefined): Observable<CreateWoodPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/ConfirmQRFOPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmQRFOPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmQRFOPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodPreActivityReportOutput>;
        }));
    }

    protected processConfirmQRFOPreActivityReport(response: HttpResponseBase): Observable<CreateWoodPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmQRProviderPreActivityReport(body: QRConfirmationTotemInput | undefined): Observable<CreateWoodPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/TotemWoodPreActivityReport/ConfirmQRProviderPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmQRProviderPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmQRProviderPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodPreActivityReportOutput>;
        }));
    }

    protected processConfirmQRProviderPreActivityReport(response: HttpResponseBase): Observable<CreateWoodPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TravelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the travel assignment of the given license plate and destination id
     * @param licensePlate (optional) 
     * @param destinationId (optional) 
     * @return OK
     */
    getTravelAssignmentByPlateAndDestination(licensePlate: string | undefined, destinationId: number | undefined): Observable<TravelAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/GetTravelAssignmentByPlateAndDestination?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelAssignmentByPlateAndDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelAssignmentByPlateAndDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TravelAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TravelAssignmentDto>;
        }));
    }

    protected processGetTravelAssignmentByPlateAndDestination(response: HttpResponseBase): Observable<TravelAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the travel assignment of the given license plate and origin id
     * @param licensePlate (optional) 
     * @param origin (optional) 
     * @return OK
     */
    getTravelAssignmentByPlateAndOrigin(licensePlate: string | undefined, origin: number | undefined): Observable<TravelAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/GetTravelAssignmentByPlateAndOrigin?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (origin === null)
            throw new Error("The parameter 'origin' cannot be null.");
        else if (origin !== undefined)
            url_ += "origin=" + encodeURIComponent("" + origin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelAssignmentByPlateAndOrigin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelAssignmentByPlateAndOrigin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TravelAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TravelAssignmentDto>;
        }));
    }

    protected processGetTravelAssignmentByPlateAndOrigin(response: HttpResponseBase): Observable<TravelAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get SmartLoad invoice by travel number
     * @param travelNumber (optional) 
     * @return OK
     */
    getInvoiceByTravelNumber(travelNumber: number | undefined): Observable<SmartLoadInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/GetInvoiceByTravelNumber?";
        if (travelNumber === null)
            throw new Error("The parameter 'travelNumber' cannot be null.");
        else if (travelNumber !== undefined)
            url_ += "travelNumber=" + encodeURIComponent("" + travelNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceByTravelNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceByTravelNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartLoadInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartLoadInvoiceDto>;
        }));
    }

    protected processGetInvoiceByTravelNumber(response: HttpResponseBase): Observable<SmartLoadInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartLoadInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all travel assignments between the given dates and belonging to the given locations
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param locationIds (optional) 
     * @return OK
     */
    getAllTravelAssignments(dateFrom: DateTime | undefined, dateTo: DateTime | undefined, locationIds: number[] | undefined): Observable<CustomPagedResultDtoOfTravelAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/GetAllTravelAssignments?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (locationIds === null)
            throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTravelAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTravelAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfTravelAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfTravelAssignmentDto>;
        }));
    }

    protected processGetAllTravelAssignments(response: HttpResponseBase): Observable<CustomPagedResultDtoOfTravelAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfTravelAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the next scheduled travel assignment of the given license plate
     * @param licensePlate (optional) 
     * @return OK
     */
    getNextTravelAssignment(licensePlate: string | undefined): Observable<TravelAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Travel/GetNextTravelAssignment?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextTravelAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextTravelAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TravelAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TravelAssignmentDto>;
        }));
    }

    protected processGetNextTravelAssignment(response: HttpResponseBase): Observable<TravelAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TripMonitorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets all the trips given a placeId
     * @param id (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMonitor(id: number | undefined, licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, reportType: ActivityReportType, articleId: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfMonitorActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/TripMonitor/GetAllMonitor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (reportType === undefined || reportType === null)
            throw new Error("The parameter 'reportType' must be defined and cannot be null.");
        else
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfMonitorActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfMonitorActivityDto>;
        }));
    }

    protected processGetAllMonitor(response: HttpResponseBase): Observable<CustomPagedResultDtoOfMonitorActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfMonitorActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    refreshCurrentUserPlace(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RefreshCurrentUserPlace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshCurrentUserPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshCurrentUserPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshCurrentUserPlace(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserVendorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getUserVendorInformation(userId: number | undefined): Observable<UserVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/GetUserVendorInformation?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserVendorInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserVendorInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVendorDto>;
        }));
    }

    protected processGetUserVendorInformation(response: HttpResponseBase): Observable<UserVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveUserVendor(body: UserVendorInput | undefined): Observable<SaveUserVendorResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/SaveUserVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveUserVendorResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveUserVendorResultOutput>;
        }));
    }

    protected processSaveUserVendor(response: HttpResponseBase): Observable<SaveUserVendorResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveUserVendorResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveUserVendorIdByEmail(body: UserVendorByEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/SaveUserVendorIdByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserVendorIdByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserVendorIdByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveUserVendorIdByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getList(sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined): Observable<CustomPagedResultDtoOfUserVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/GetList?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfUserVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfUserVendorDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<CustomPagedResultDtoOfUserVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfUserVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    deleteVendorFromUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/DeleteVendorFromUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVendorFromUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorFromUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteVendorFromUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param externalPlaceId (optional) 
     * @param placeId (optional) 
     * @param licensePlate (optional) 
     * @param paysTransport (optional) 
     * @param originVendorId (optional) 
     * @return OK
     */
    getWoodVendorAndVehicleWizardInfo(externalPlaceId: number | undefined, placeId: number | undefined, licensePlate: string | undefined, paysTransport: boolean | undefined, originVendorId: number | undefined): Observable<WizardInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetWoodVendorAndVehicleWizardInfo?";
        if (externalPlaceId === null)
            throw new Error("The parameter 'externalPlaceId' cannot be null.");
        else if (externalPlaceId !== undefined)
            url_ += "externalPlaceId=" + encodeURIComponent("" + externalPlaceId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (paysTransport === null)
            throw new Error("The parameter 'paysTransport' cannot be null.");
        else if (paysTransport !== undefined)
            url_ += "paysTransport=" + encodeURIComponent("" + paysTransport) + "&";
        if (originVendorId === null)
            throw new Error("The parameter 'originVendorId' cannot be null.");
        else if (originVendorId !== undefined)
            url_ += "originVendorId=" + encodeURIComponent("" + originVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodVendorAndVehicleWizardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodVendorAndVehicleWizardInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WizardInfoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WizardInfoOutputDto>;
        }));
    }

    protected processGetWoodVendorAndVehicleWizardInfo(response: HttpResponseBase): Observable<WizardInfoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WizardInfoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param externalPlaceId (optional) 
     * @param placeId (optional) 
     * @param licensePlate (optional) 
     * @param paysTransport (optional) 
     * @param originVendorId (optional) 
     * @return OK
     */
    getDiverseProductVendorAndVehicleWizardInfo(externalPlaceId: number | undefined, placeId: number | undefined, licensePlate: string | undefined, paysTransport: boolean | undefined, originVendorId: number | undefined): Observable<WizardInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetDiverseProductVendorAndVehicleWizardInfo?";
        if (externalPlaceId === null)
            throw new Error("The parameter 'externalPlaceId' cannot be null.");
        else if (externalPlaceId !== undefined)
            url_ += "externalPlaceId=" + encodeURIComponent("" + externalPlaceId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (paysTransport === null)
            throw new Error("The parameter 'paysTransport' cannot be null.");
        else if (paysTransport !== undefined)
            url_ += "paysTransport=" + encodeURIComponent("" + paysTransport) + "&";
        if (originVendorId === null)
            throw new Error("The parameter 'originVendorId' cannot be null.");
        else if (originVendorId !== undefined)
            url_ += "originVendorId=" + encodeURIComponent("" + originVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductVendorAndVehicleWizardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductVendorAndVehicleWizardInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WizardInfoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WizardInfoOutputDto>;
        }));
    }

    protected processGetDiverseProductVendorAndVehicleWizardInfo(response: HttpResponseBase): Observable<WizardInfoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WizardInfoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param externalPlaceId (optional) 
     * @param placeId (optional) 
     * @param licensePlate (optional) 
     * @return OK
     */
    getInternalMovementsVendorAndVehicleWizardInfo(externalPlaceId: number | undefined, placeId: number | undefined, licensePlate: string | undefined): Observable<WizardInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetInternalMovementsVendorAndVehicleWizardInfo?";
        if (externalPlaceId === null)
            throw new Error("The parameter 'externalPlaceId' cannot be null.");
        else if (externalPlaceId !== undefined)
            url_ += "externalPlaceId=" + encodeURIComponent("" + externalPlaceId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementsVendorAndVehicleWizardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementsVendorAndVehicleWizardInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WizardInfoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WizardInfoOutputDto>;
        }));
    }

    protected processGetInternalMovementsVendorAndVehicleWizardInfo(response: HttpResponseBase): Observable<WizardInfoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WizardInfoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getSemiTrailer(licensePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetSemiTrailer?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSemiTrailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSemiTrailer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetSemiTrailer(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getActiveOrInactiveSemiTrailer(licensePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetActiveOrInactiveSemiTrailer?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveOrInactiveSemiTrailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveOrInactiveSemiTrailer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetActiveOrInactiveSemiTrailer(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @return OK
     */
    getTruckByPlate(licensePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetTruckByPlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetTruckByPlate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param truckId (optional) 
     * @return OK
     */
    getTruckById(truckId: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetTruckById?";
        if (truckId === null)
            throw new Error("The parameter 'truckId' cannot be null.");
        else if (truckId !== undefined)
            url_ += "truckId=" + encodeURIComponent("" + truckId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetTruckById(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param semitrailerId (optional) 
     * @return OK
     */
    getSemitrailerById(semitrailerId: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetSemitrailerById?";
        if (semitrailerId === null)
            throw new Error("The parameter 'semitrailerId' cannot be null.");
        else if (semitrailerId !== undefined)
            url_ += "semitrailerId=" + encodeURIComponent("" + semitrailerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSemitrailerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSemitrailerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetSemitrailerById(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param truckId (optional) 
     * @return OK
     */
    getHistoricTare(truckId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetHistoricTare?";
        if (truckId === null)
            throw new Error("The parameter 'truckId' cannot be null.");
        else if (truckId !== undefined)
            url_ += "truckId=" + encodeURIComponent("" + truckId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricTare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricTare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetHistoricTare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getTrucks(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfVehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetTrucks?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrucks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrucks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfVehicleDto>;
        }));
    }

    protected processGetTrucks(response: HttpResponseBase): Observable<CustomPagedResultDtoOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfVehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param truckResourceTypeId (optional) 
     * @return OK
     */
    isTruckTritrainByResourceTypeId(truckResourceTypeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/IsTruckTritrainByResourceTypeId?";
        if (truckResourceTypeId === null)
            throw new Error("The parameter 'truckResourceTypeId' cannot be null.");
        else if (truckResourceTypeId !== undefined)
            url_ += "truckResourceTypeId=" + encodeURIComponent("" + truckResourceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTruckTritrainByResourceTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTruckTritrainByResourceTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTruckTritrainByResourceTypeId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VendorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param vendorId (optional) 
     * @return OK
     */
    get(vendorId: number | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/Get?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vendorsID (optional) 
     * @return OK
     */
    getVendorsById(vendorsID: number[] | undefined): Observable<CustomPagedResultDtoOfVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetVendorsById?";
        if (vendorsID === null)
            throw new Error("The parameter 'vendorsID' cannot be null.");
        else if (vendorsID !== undefined)
            vendorsID && vendorsID.forEach(item => { url_ += "vendorsID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfVendorDto>;
        }));
    }

    protected processGetVendorsById(response: HttpResponseBase): Observable<CustomPagedResultDtoOfVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vendorsID (optional) 
     * @return OK
     */
    getLoadVendorsByContract(vendorsID: number[] | undefined): Observable<CustomPagedResultDtoOfVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetLoadVendorsByContract?";
        if (vendorsID === null)
            throw new Error("The parameter 'vendorsID' cannot be null.");
        else if (vendorsID !== undefined)
            vendorsID && vendorsID.forEach(item => { url_ += "vendorsID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadVendorsByContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadVendorsByContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfVendorDto>;
        }));
    }

    protected processGetLoadVendorsByContract(response: HttpResponseBase): Observable<CustomPagedResultDtoOfVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param toSearch (optional) 
     * @return OK
     */
    getAllByName(toSearch: string | undefined): Observable<CustomPagedResultDtoOfVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetAllByName?";
        if (toSearch === null)
            throw new Error("The parameter 'toSearch' cannot be null.");
        else if (toSearch !== undefined)
            url_ += "toSearch=" + encodeURIComponent("" + toSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfVendorDto>;
        }));
    }

    protected processGetAllByName(response: HttpResponseBase): Observable<CustomPagedResultDtoOfVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfVendorDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomPagedResultDtoOfVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the last 100 web logs
     * @return OK
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download all web logs as a zip file
     * @return OK
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Edits an activity report according to the information passed
     * @param body (optional) 
     * @return OK
     */
    editWoodActivityReceipt(body: EditActivityReportInput | undefined): Observable<EditActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/EditWoodActivityReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditWoodActivityReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditWoodActivityReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditActivityReportOutput>;
        }));
    }

    protected processEditWoodActivityReceipt(response: HttpResponseBase): Observable<EditActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Complete wood semi automatic exit with the given properties
     * @param body (optional) 
     * @return OK
     */
    completeWoodSemiAutomaticExitProcess(body: EditActivityReportInput | undefined): Observable<CompleteWoodSemiAutomaticExitProcessOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/CompleteWoodSemiAutomaticExitProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteWoodSemiAutomaticExitProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteWoodSemiAutomaticExitProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteWoodSemiAutomaticExitProcessOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteWoodSemiAutomaticExitProcessOutput>;
        }));
    }

    protected processCompleteWoodSemiAutomaticExitProcess(response: HttpResponseBase): Observable<CompleteWoodSemiAutomaticExitProcessOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompleteWoodSemiAutomaticExitProcessOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Force wood activity report exit
     * @param body (optional) 
     * @return OK
     */
    forceWoodActivityReportExit(body: EditActivityReportInput | undefined): Observable<ForceWoodActivityReportExitOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/ForceWoodActivityReportExit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceWoodActivityReportExit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceWoodActivityReportExit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForceWoodActivityReportExitOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForceWoodActivityReportExitOutput>;
        }));
    }

    protected processForceWoodActivityReportExit(response: HttpResponseBase): Observable<ForceWoodActivityReportExitOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForceWoodActivityReportExitOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the wood activity report of the given id and a deletion reason
     * @return OK
     */
    deleteWoodActivityReport(activityReportId: number, deletionComment: string, deletionReasonId: number): Observable<ActivityReportDeletionResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/DeleteWoodActivityReport?";
        if (activityReportId === undefined || activityReportId === null)
            throw new Error("The parameter 'activityReportId' must be defined and cannot be null.");
        else
            url_ += "ActivityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (deletionComment === undefined || deletionComment === null)
            throw new Error("The parameter 'deletionComment' must be defined and cannot be null.");
        else
            url_ += "DeletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        if (deletionReasonId === undefined || deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' must be defined and cannot be null.");
        else
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityReportDeletionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityReportDeletionResultDto>;
        }));
    }

    protected processDeleteWoodActivityReport(response: HttpResponseBase): Observable<ActivityReportDeletionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityReportDeletionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a manual wood activity report with the given properties
     * @param body (optional) 
     * @return OK
     */
    createManualWoodActivityReport(body: CreateWoodActivityReportInput | undefined): Observable<CreateWoodActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/CreateManualWoodActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodActivityReportOutput>;
        }));
    }

    protected processCreateManualWoodActivityReport(response: HttpResponseBase): Observable<CreateWoodActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Complete wood semi automatic entrance with the given properties
     * @param body (optional) 
     * @return OK
     */
    completeWoodSemiAutomaticEntrance(body: CreateWoodActivityReportInput | undefined): Observable<CreateWoodActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/CompleteWoodSemiAutomaticEntrance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteWoodSemiAutomaticEntrance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteWoodSemiAutomaticEntrance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodActivityReportOutput>;
        }));
    }

    protected processCompleteWoodSemiAutomaticEntrance(response: HttpResponseBase): Observable<CreateWoodActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the wood activity report of the given id
     * @param id (optional) 
     * @return OK
     */
    getWoodActivityReport(id: number | undefined): Observable<WoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportDto>;
        }));
    }

    protected processGetWoodActivityReport(response: HttpResponseBase): Observable<WoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Indicates if the difference between exit activity report gross weight and the current one is greater than tolerance
     * @param body (optional) 
     * @return OK
     */
    isValidEntryWithGrossWeightOutsideTolerance(body: GrossWeightOutsideToleranceInput | undefined): Observable<GrossWeightOutsideToleranceOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/IsValidEntryWithGrossWeightOutsideTolerance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidEntryWithGrossWeightOutsideTolerance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidEntryWithGrossWeightOutsideTolerance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrossWeightOutsideToleranceOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrossWeightOutsideToleranceOutput>;
        }));
    }

    protected processIsValidEntryWithGrossWeightOutsideTolerance(response: HttpResponseBase): Observable<GrossWeightOutsideToleranceOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrossWeightOutsideToleranceOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood activity report state
     * @param reportId (optional) 
     * @return OK
     */
    getActivityReportState(reportId: number | undefined): Observable<ActivityReportState> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetActivityReportState?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityReportState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityReportState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityReportState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityReportState>;
        }));
    }

    protected processGetActivityReportState(response: HttpResponseBase): Observable<ActivityReportState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether the user should be prompted to confirm 
    deletion of scanner measurement data when the article changes.
     * @param oldArticleExternalId (optional) The external ID of the previous article.
     * @param newArticleExternalId (optional) The external ID of the new article.
     * @return OK
     */
    shouldConfirmDeleteScannerMeasurementData(oldArticleExternalId: number | undefined, newArticleExternalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/ShouldConfirmDeleteScannerMeasurementData?";
        if (oldArticleExternalId === null)
            throw new Error("The parameter 'oldArticleExternalId' cannot be null.");
        else if (oldArticleExternalId !== undefined)
            url_ += "oldArticleExternalId=" + encodeURIComponent("" + oldArticleExternalId) + "&";
        if (newArticleExternalId === null)
            throw new Error("The parameter 'newArticleExternalId' cannot be null.");
        else if (newArticleExternalId !== undefined)
            url_ += "newArticleExternalId=" + encodeURIComponent("" + newArticleExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldConfirmDeleteScannerMeasurementData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldConfirmDeleteScannerMeasurementData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processShouldConfirmDeleteScannerMeasurementData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodPileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a pile with the given properties
     * @param body (optional) 
     * @return OK
     */
    createPile(body: WoodPileCreationInput | undefined): Observable<WoodPileCreationOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodPile/CreatePile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPileCreationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPileCreationOutput>;
        }));
    }

    protected processCreatePile(response: HttpResponseBase): Observable<WoodPileCreationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPileCreationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get pile with the given id
     * @param pileId (optional) 
     * @return OK
     */
    getPileById(pileId: number | undefined): Observable<PileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodPile/GetPileById?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PileForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PileForViewDto>;
        }));
    }

    protected processGetPileById(response: HttpResponseBase): Observable<PileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PileForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit a pile with the given id, by changing the specified properties
     * @param body (optional) 
     * @return OK
     */
    editPile(body: WoodPileEditionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodPile/EditPile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditPile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditPile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditPile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change the status of the pile with the given SmartAccess and BioForest ids to the given one
     * @param pileId (optional) Id needed to change the status on SmartAccess
     * @param pileExternalId (optional) Id needed to change the status on BioForest
     * @param isActive (optional) 
     * @return OK
     */
    changePileStatus(pileId: number | undefined, pileExternalId: number | undefined, isActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodPile/ChangePileStatus?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        if (pileExternalId === null)
            throw new Error("The parameter 'pileExternalId' cannot be null.");
        else if (pileExternalId !== undefined)
            url_ += "pileExternalId=" + encodeURIComponent("" + pileExternalId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePileStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePileStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePileStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active and inactive piles
     * @param logyardExternalId (optional) Logyard external id.
     * @return OK
     */
    getActiveAndInactivePilesByLogyardExternalId(logyardExternalId: number | undefined): Observable<BasicPileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WoodPile/GetActiveAndInactivePilesByLogyardExternalId?";
        if (logyardExternalId === null)
            throw new Error("The parameter 'logyardExternalId' cannot be null.");
        else if (logyardExternalId !== undefined)
            url_ += "logyardExternalId=" + encodeURIComponent("" + logyardExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveAndInactivePilesByLogyardExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveAndInactivePilesByLogyardExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicPileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicPileDto[]>;
        }));
    }

    protected processGetActiveAndInactivePilesByLogyardExternalId(response: HttpResponseBase): Observable<BasicPileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicPileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the active pile (if any) for the specified wood origin and article.
     * @param woodOriginId (optional) Wood origin identifier.
     * @param locationType Location type
     * @param articleId (optional) Article identifier.
     * @return OK
     */
    getActivePileByWoodOriginAndArticle(woodOriginId: number | undefined, locationType: LocationType, articleId: number | undefined): Observable<BasicPileDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodPile/GetActivePileByWoodOriginAndArticle?";
        if (woodOriginId === null)
            throw new Error("The parameter 'woodOriginId' cannot be null.");
        else if (woodOriginId !== undefined)
            url_ += "woodOriginId=" + encodeURIComponent("" + woodOriginId) + "&";
        if (locationType === undefined || locationType === null)
            throw new Error("The parameter 'locationType' must be defined and cannot be null.");
        else
            url_ += "locationType=" + encodeURIComponent("" + locationType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivePileByWoodOriginAndArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivePileByWoodOriginAndArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicPileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicPileDto>;
        }));
    }

    protected processGetActivePileByWoodOriginAndArticle(response: HttpResponseBase): Observable<BasicPileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicPileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodScannerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Notification successful
     */
    notifyResult(body: ScannerNotificationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/NotifyResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Report not found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Validation error", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes the deletion of the scanner sample
     * @param reportId (optional) 
     * @param externalReportId (optional) 
     * @return OK
     */
    deleteScannerResult(reportId: number | undefined, externalReportId: number | undefined): Observable<DeleteScannerResultsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/DeleteScannerResult?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (externalReportId === null)
            throw new Error("The parameter 'externalReportId' cannot be null.");
        else if (externalReportId !== undefined)
            url_ += "ExternalReportId=" + encodeURIComponent("" + externalReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScannerResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScannerResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteScannerResultsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteScannerResultsOutputDto>;
        }));
    }

    protected processDeleteScannerResult(response: HttpResponseBase): Observable<DeleteScannerResultsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteScannerResultsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send signal for scanner calibration
     * @param body (optional) 
     * @return OK
     */
    sendSignalForScannerCalibration(body: SendSignalForScannerCalibrationInputDto | undefined): Observable<ScannerCalibrationEventDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/SendSignalForScannerCalibration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSignalForScannerCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSignalForScannerCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCalibrationEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCalibrationEventDto>;
        }));
    }

    protected processSendSignalForScannerCalibration(response: HttpResponseBase): Observable<ScannerCalibrationEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCalibrationEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get send signal input for scanner calibration
     * @return OK
     */
    getSendSignalInputForScannerCalibration(): Observable<SendSignalInputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/GetSendSignalInputForScannerCalibration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSendSignalInputForScannerCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSendSignalInputForScannerCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendSignalInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendSignalInputDto>;
        }));
    }

    protected processGetSendSignalInputForScannerCalibration(response: HttpResponseBase): Observable<SendSignalInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendSignalInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodTruckTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodTruckType/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodTruckTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWoodTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<WoodTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodTruckType/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodTruckTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<WoodTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodVendorQuotaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchWoodVendorQuotas(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/SearchWoodVendorQuotas?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodVendorQuotas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodVendorQuotas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto>;
        }));
    }

    protected processSearchWoodVendorQuotas(response: HttpResponseBase): Observable<CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createWoodVendorQuota(body: CreateWoodVendorQuotaDto | undefined): Observable<CreateWoodVendorQuotaOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/CreateWoodVendorQuota";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodVendorQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodVendorQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodVendorQuotaOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodVendorQuotaOutputDto>;
        }));
    }

    protected processCreateWoodVendorQuota(response: HttpResponseBase): Observable<CreateWoodVendorQuotaOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodVendorQuotaOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param woodVendorId (optional) 
     * @return OK
     */
    getWoodVendorQuotaById(woodVendorId: number | undefined): Observable<WoodVendorQuotaDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/GetWoodVendorQuotaById?";
        if (woodVendorId === null)
            throw new Error("The parameter 'woodVendorId' cannot be null.");
        else if (woodVendorId !== undefined)
            url_ += "woodVendorId=" + encodeURIComponent("" + woodVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodVendorQuotaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodVendorQuotaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodVendorQuotaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodVendorQuotaDto>;
        }));
    }

    protected processGetWoodVendorQuotaById(response: HttpResponseBase): Observable<WoodVendorQuotaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodVendorQuotaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class YardSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROCESSAPI_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get wood pre reports to arrive
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getWoodPreReportsToArrive(hours: number, destinationId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWoodPreReportToArriveOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/YardSystem/GetWoodPreReportsToArrive?";
        if (hours === undefined || hours === null)
            throw new Error("The parameter 'hours' must be defined and cannot be null.");
        else
            url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
        if (destinationId === undefined || destinationId === null)
            throw new Error("The parameter 'destinationId' must be defined and cannot be null.");
        else
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreReportsToArrive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreReportsToArrive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetWoodPreReportToArriveOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetWoodPreReportToArriveOutputDto>;
        }));
    }

    protected processGetWoodPreReportsToArrive(response: HttpResponseBase): Observable<PagedResultDtoOfGetWoodPreReportToArriveOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWoodPreReportToArriveOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessCardDetectionInputDto implements IAccessCardDetectionInputDto {
    accessCardDeviceId!: number;
    tenantId!: number;
    identityCardNumber!: string | undefined;
    isWildcard!: boolean;
    hasAccessCardError!: boolean;
    accessCardMessageError!: string | undefined;
    scaleDeviceId!: number;
    scaleWeight!: number;
    hasScaleError!: boolean;
    scaleMessageError!: string | undefined;
    systemType!: DeviceSystemType;
    accessCardNumber!: string | undefined;

    constructor(data?: IAccessCardDetectionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessCardDeviceId = _data["accessCardDeviceId"];
            this.tenantId = _data["tenantId"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.isWildcard = _data["isWildcard"];
            this.hasAccessCardError = _data["hasAccessCardError"];
            this.accessCardMessageError = _data["accessCardMessageError"];
            this.scaleDeviceId = _data["scaleDeviceId"];
            this.scaleWeight = _data["scaleWeight"];
            this.hasScaleError = _data["hasScaleError"];
            this.scaleMessageError = _data["scaleMessageError"];
            this.systemType = _data["systemType"];
            this.accessCardNumber = _data["accessCardNumber"];
        }
    }

    static fromJS(data: any): AccessCardDetectionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessCardDetectionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessCardDeviceId"] = this.accessCardDeviceId;
        data["tenantId"] = this.tenantId;
        data["identityCardNumber"] = this.identityCardNumber;
        data["isWildcard"] = this.isWildcard;
        data["hasAccessCardError"] = this.hasAccessCardError;
        data["accessCardMessageError"] = this.accessCardMessageError;
        data["scaleDeviceId"] = this.scaleDeviceId;
        data["scaleWeight"] = this.scaleWeight;
        data["hasScaleError"] = this.hasScaleError;
        data["scaleMessageError"] = this.scaleMessageError;
        data["systemType"] = this.systemType;
        data["accessCardNumber"] = this.accessCardNumber;
        return data;
    }
}

export interface IAccessCardDetectionInputDto {
    accessCardDeviceId: number;
    tenantId: number;
    identityCardNumber: string | undefined;
    isWildcard: boolean;
    hasAccessCardError: boolean;
    accessCardMessageError: string | undefined;
    scaleDeviceId: number;
    scaleWeight: number;
    hasScaleError: boolean;
    scaleMessageError: string | undefined;
    systemType: DeviceSystemType;
    accessCardNumber: string | undefined;
}

export class AccessCardDetectionOutputDto implements IAccessCardDetectionOutputDto {
    success!: boolean;
    message!: string | undefined;
    driverSuccess!: boolean;
    driverMessage!: string | undefined;
    scaleSuccess!: boolean;
    scaleMessage!: string | undefined;

    constructor(data?: IAccessCardDetectionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.driverSuccess = _data["driverSuccess"];
            this.driverMessage = _data["driverMessage"];
            this.scaleSuccess = _data["scaleSuccess"];
            this.scaleMessage = _data["scaleMessage"];
        }
    }

    static fromJS(data: any): AccessCardDetectionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessCardDetectionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["driverSuccess"] = this.driverSuccess;
        data["driverMessage"] = this.driverMessage;
        data["scaleSuccess"] = this.scaleSuccess;
        data["scaleMessage"] = this.scaleMessage;
        return data;
    }
}

export interface IAccessCardDetectionOutputDto {
    success: boolean;
    message: string | undefined;
    driverSuccess: boolean;
    driverMessage: string | undefined;
    scaleSuccess: boolean;
    scaleMessage: string | undefined;
}

export enum ActivityReportCreationSystem {
    SmartAccess = 0,
    SmartTruck = 1,
    ProvidersModule = 2,
    Api = 3,
    Totem = 4,
}

export class ActivityReportDeletionResultDto implements IActivityReportDeletionResultDto {
    success!: boolean;
    reason!: string | undefined;

    constructor(data?: IActivityReportDeletionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ActivityReportDeletionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReportDeletionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IActivityReportDeletionResultDto {
    success: boolean;
    reason: string | undefined;
}

export class ActivityReportDto implements IActivityReportDto {
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    tripNumber!: number;
    tenantId!: number;
    transport!: VehicleDto;
    driver!: DriverDto;
    origin!: LocationWithPaysTransportDto;
    destination!: LocationDto;
    activityReportDate!: DateTime;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    customsDeclaration!: SingleCustomDeclarationOutput;
    comment!: string | undefined;
    placeId!: number;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    id!: number;

    constructor(data?: IActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.tripNumber = _data["tripNumber"];
            this.tenantId = _data["tenantId"];
            this.transport = _data["transport"] ? VehicleDto.fromJS(_data["transport"]) : <any>undefined;
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationWithPaysTransportDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.customsDeclaration = _data["customsDeclaration"] ? SingleCustomDeclarationOutput.fromJS(_data["customsDeclaration"]) : <any>undefined;
            this.comment = _data["comment"];
            this.placeId = _data["placeId"];
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["tripNumber"] = this.tripNumber;
        data["tenantId"] = this.tenantId;
        data["transport"] = this.transport ? this.transport.toJSON() : <any>undefined;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["customsDeclaration"] = this.customsDeclaration ? this.customsDeclaration.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["placeId"] = this.placeId;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["id"] = this.id;
        return data;
    }
}

export interface IActivityReportDto {
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    tripNumber: number;
    tenantId: number;
    transport: VehicleDto;
    driver: DriverDto;
    origin: LocationWithPaysTransportDto;
    destination: LocationDto;
    activityReportDate: DateTime;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    customsDeclaration: SingleCustomDeclarationOutput;
    comment: string | undefined;
    placeId: number;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    id: number;
}

export enum ActivityReportOperationMode {
    Entrance = 0,
    Exit = 1,
}

export enum ActivityReportState {
    PreActivityReport = 0,
    Entering = 1,
    InPlace = 2,
    Leaving = 3,
    Finished = 99,
    Rejected = 100,
}

export enum ActivityReportStateCondition {
    InError = 0,
    OK = 1,
    ConditionalProcess = 2,
    ConditionalExit = 3,
}

export enum ActivityReportSynchronizationResult {
    Error = 0,
    Ok = 1,
}

export enum ActivityReportType {
    None = 0,
    WoodActivityReport = 1,
    DiverseProductActivityReport = 2,
    InternalMovementsActivityReport = 3,
    Pulp = 4,
    Chemical = 5,
}

export class ArchimedesSampleForGridDto implements IArchimedesSampleForGridDto {
    sampleDate!: DateTime;
    sampleType!: SampleAssignmentType;
    reportId!: number;
    originName!: string | undefined;
    standName!: string | undefined;
    sampleDensity!: number;

    constructor(data?: IArchimedesSampleForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : <any>undefined;
            this.sampleType = _data["sampleType"];
            this.reportId = _data["reportId"];
            this.originName = _data["originName"];
            this.standName = _data["standName"];
            this.sampleDensity = _data["sampleDensity"];
        }
    }

    static fromJS(data: any): ArchimedesSampleForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSampleForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : <any>undefined;
        data["sampleType"] = this.sampleType;
        data["reportId"] = this.reportId;
        data["originName"] = this.originName;
        data["standName"] = this.standName;
        data["sampleDensity"] = this.sampleDensity;
        return data;
    }
}

export interface IArchimedesSampleForGridDto {
    sampleDate: DateTime;
    sampleType: SampleAssignmentType;
    reportId: number;
    originName: string | undefined;
    standName: string | undefined;
    sampleDensity: number;
}

export class ArchimedesSampleInstanceDto implements IArchimedesSampleInstanceDto {
    machineTare!: WeightDto;
    machineTareAttempts!: number;
    withoutSubmerging!: WeightDto;
    withoutSubmergingAttempts!: number;
    withSubmerging!: WeightDto;
    withSubmergingAttempts!: number;
    baleWeight!: number;
    density!: number;
    densityAttempts!: number;
    historicalDensity!: number;
    isManual!: boolean;
    woodVolume!: number;
    archimedesSampleId!: number;
    deletionCommentary!: string | undefined;
    loaderMachineId!: number;
    activityReportId!: number;
    packageNumber!: number | undefined;

    constructor(data?: IArchimedesSampleInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineTare = _data["machineTare"] ? WeightDto.fromJS(_data["machineTare"]) : <any>undefined;
            this.machineTareAttempts = _data["machineTareAttempts"];
            this.withoutSubmerging = _data["withoutSubmerging"] ? WeightDto.fromJS(_data["withoutSubmerging"]) : <any>undefined;
            this.withoutSubmergingAttempts = _data["withoutSubmergingAttempts"];
            this.withSubmerging = _data["withSubmerging"] ? WeightDto.fromJS(_data["withSubmerging"]) : <any>undefined;
            this.withSubmergingAttempts = _data["withSubmergingAttempts"];
            this.baleWeight = _data["baleWeight"];
            this.density = _data["density"];
            this.densityAttempts = _data["densityAttempts"];
            this.historicalDensity = _data["historicalDensity"];
            this.isManual = _data["isManual"];
            this.woodVolume = _data["woodVolume"];
            this.archimedesSampleId = _data["archimedesSampleId"];
            this.deletionCommentary = _data["deletionCommentary"];
            this.loaderMachineId = _data["loaderMachineId"];
            this.activityReportId = _data["activityReportId"];
            this.packageNumber = _data["packageNumber"];
        }
    }

    static fromJS(data: any): ArchimedesSampleInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSampleInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineTare"] = this.machineTare ? this.machineTare.toJSON() : <any>undefined;
        data["machineTareAttempts"] = this.machineTareAttempts;
        data["withoutSubmerging"] = this.withoutSubmerging ? this.withoutSubmerging.toJSON() : <any>undefined;
        data["withoutSubmergingAttempts"] = this.withoutSubmergingAttempts;
        data["withSubmerging"] = this.withSubmerging ? this.withSubmerging.toJSON() : <any>undefined;
        data["withSubmergingAttempts"] = this.withSubmergingAttempts;
        data["baleWeight"] = this.baleWeight;
        data["density"] = this.density;
        data["densityAttempts"] = this.densityAttempts;
        data["historicalDensity"] = this.historicalDensity;
        data["isManual"] = this.isManual;
        data["woodVolume"] = this.woodVolume;
        data["archimedesSampleId"] = this.archimedesSampleId;
        data["deletionCommentary"] = this.deletionCommentary;
        data["loaderMachineId"] = this.loaderMachineId;
        data["activityReportId"] = this.activityReportId;
        data["packageNumber"] = this.packageNumber;
        return data;
    }
}

export interface IArchimedesSampleInstanceDto {
    machineTare: WeightDto;
    machineTareAttempts: number;
    withoutSubmerging: WeightDto;
    withoutSubmergingAttempts: number;
    withSubmerging: WeightDto;
    withSubmergingAttempts: number;
    baleWeight: number;
    density: number;
    densityAttempts: number;
    historicalDensity: number;
    isManual: boolean;
    woodVolume: number;
    archimedesSampleId: number;
    deletionCommentary: string | undefined;
    loaderMachineId: number;
    activityReportId: number;
    packageNumber: number | undefined;
}

export class ArchimedesSamplesReportInputDto implements IArchimedesSamplesReportInputDto {
    reportId!: number | undefined;
    reportNumber!: number | undefined;
    reportSerial!: string | undefined;
    assignmentSampleType!: SampleAssignmentType;
    providerVendorExternalId!: number | undefined;
    articleExternalId!: number | undefined;
    includeDeletedOnes!: boolean;
    operationMode!: ActivityReportOperationMode;
    originExternalId!: number | undefined;
    standExternalId!: number | undefined;
    destinationExternalId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IArchimedesSamplesReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportNumber = _data["reportNumber"];
            this.reportSerial = _data["reportSerial"];
            this.assignmentSampleType = _data["assignmentSampleType"];
            this.providerVendorExternalId = _data["providerVendorExternalId"];
            this.articleExternalId = _data["articleExternalId"];
            this.includeDeletedOnes = _data["includeDeletedOnes"];
            this.operationMode = _data["operationMode"];
            this.originExternalId = _data["originExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ArchimedesSamplesReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSamplesReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportNumber"] = this.reportNumber;
        data["reportSerial"] = this.reportSerial;
        data["assignmentSampleType"] = this.assignmentSampleType;
        data["providerVendorExternalId"] = this.providerVendorExternalId;
        data["articleExternalId"] = this.articleExternalId;
        data["includeDeletedOnes"] = this.includeDeletedOnes;
        data["operationMode"] = this.operationMode;
        data["originExternalId"] = this.originExternalId;
        data["standExternalId"] = this.standExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IArchimedesSamplesReportInputDto {
    reportId: number | undefined;
    reportNumber: number | undefined;
    reportSerial: string | undefined;
    assignmentSampleType: SampleAssignmentType;
    providerVendorExternalId: number | undefined;
    articleExternalId: number | undefined;
    includeDeletedOnes: boolean;
    operationMode: ActivityReportOperationMode;
    originExternalId: number | undefined;
    standExternalId: number | undefined;
    destinationExternalId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class ArchimedesStandMonitorDtoOutput implements IArchimedesStandMonitorDtoOutput {
    locationName!: string | undefined;
    article!: string | undefined;
    percentage!: number;

    constructor(data?: IArchimedesStandMonitorDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationName = _data["locationName"];
            this.article = _data["article"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): ArchimedesStandMonitorDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesStandMonitorDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["article"] = this.article;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IArchimedesStandMonitorDtoOutput {
    locationName: string | undefined;
    article: string | undefined;
    percentage: number;
}

export class ArticleByLocationOutput implements IArticleByLocationOutput {
    locationId!: number;
    articles!: number[] | undefined;

    constructor(data?: IArticleByLocationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleByLocationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleByLocationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item);
        }
        return data;
    }
}

export interface IArticleByLocationOutput {
    locationId: number;
    articles: number[] | undefined;
}

export class ArticleDiverseProductsDto implements IArticleDiverseProductsDto {
    id!: number;
    name!: string | undefined;
    resourceTypeId!: number | undefined;
    isActive!: boolean | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IArticleDiverseProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleDiverseProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDiverseProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["resourceTypeId"] = this.resourceTypeId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IArticleDiverseProductsDto {
    id: number;
    name: string | undefined;
    resourceTypeId: number | undefined;
    isActive: boolean | undefined;
    errorList: string[] | undefined;
}

export class ArticleDtoOutput implements IArticleDtoOutput {
    id!: number;
    resourceName!: string | undefined;
    resourceId!: number;
    speciesId!: number;
    isWoodLog!: boolean;
    isFscCertified!: boolean;
    errorList!: string[] | undefined;
    lengthId!: number;
    bdmtMcsFactor!: number;

    constructor(data?: IArticleDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceName = _data["resourceName"];
            this.resourceId = _data["resourceId"];
            this.speciesId = _data["speciesId"];
            this.isWoodLog = _data["isWoodLog"];
            this.isFscCertified = _data["isFscCertified"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.lengthId = _data["lengthId"];
            this.bdmtMcsFactor = _data["bdmtMcsFactor"];
        }
    }

    static fromJS(data: any): ArticleDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceName"] = this.resourceName;
        data["resourceId"] = this.resourceId;
        data["speciesId"] = this.speciesId;
        data["isWoodLog"] = this.isWoodLog;
        data["isFscCertified"] = this.isFscCertified;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["lengthId"] = this.lengthId;
        data["bdmtMcsFactor"] = this.bdmtMcsFactor;
        return data;
    }
}

export interface IArticleDtoOutput {
    id: number;
    resourceName: string | undefined;
    resourceId: number;
    speciesId: number;
    isWoodLog: boolean;
    isFscCertified: boolean;
    errorList: string[] | undefined;
    lengthId: number;
    bdmtMcsFactor: number;
}

export class ArticleInternalMovementDto implements IArticleInternalMovementDto {
    id!: number;
    name!: string | undefined;
    resourceTypeId!: number | undefined;
    isActive!: boolean | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IArticleInternalMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleInternalMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleInternalMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["resourceTypeId"] = this.resourceTypeId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IArticleInternalMovementDto {
    id: number;
    name: string | undefined;
    resourceTypeId: number | undefined;
    isActive: boolean | undefined;
    errorList: string[] | undefined;
}

export class ArticleInternalMovementsDto implements IArticleInternalMovementsDto {
    id!: number;
    name!: string | undefined;
    resourceTypeId!: number | undefined;
    isActive!: boolean | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IArticleInternalMovementsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleInternalMovementsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleInternalMovementsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["resourceTypeId"] = this.resourceTypeId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IArticleInternalMovementsDto {
    id: number;
    name: string | undefined;
    resourceTypeId: number | undefined;
    isActive: boolean | undefined;
    errorList: string[] | undefined;
}

export class Assembly implements IAssembly {
    readonly definedTypes!: string[] | undefined;
    readonly exportedTypes!: string[] | undefined;
    readonly codeBase!: string | undefined;
    entryPoint!: MethodInfo;
    readonly fullName!: string | undefined;
    readonly imageRuntimeVersion!: string | undefined;
    readonly isDynamic!: boolean;
    readonly location!: string | undefined;
    readonly reflectionOnly!: boolean;
    readonly isCollectible!: boolean;
    readonly isFullyTrusted!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly escapedCodeBase!: string | undefined;
    manifestModule!: Module;
    readonly modules!: Module[] | undefined;
    readonly globalAssemblyCache!: boolean;
    readonly hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(item);
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes: string[] | undefined;
    exportedTypes: string[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class AvailableTurnTimeDto implements IAvailableTurnTimeDto {
    date!: DateTime;
    conditional!: boolean;

    constructor(data?: IAvailableTurnTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.conditional = _data["conditional"];
        }
    }

    static fromJS(data: any): AvailableTurnTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableTurnTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["conditional"] = this.conditional;
        return data;
    }
}

export interface IAvailableTurnTimeDto {
    date: DateTime;
    conditional: boolean;
}

export class BarkSampleEditionDto implements IBarkSampleEditionDto {
    mode!: BarkSampleMode;
    packageSelected!: number | undefined;
    volume!: number;
    adheredBarkWeight!: number;
    sweptBarkWeight!: number;

    constructor(data?: IBarkSampleEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.packageSelected = _data["packageSelected"];
            this.volume = _data["volume"];
            this.adheredBarkWeight = _data["adheredBarkWeight"];
            this.sweptBarkWeight = _data["sweptBarkWeight"];
        }
    }

    static fromJS(data: any): BarkSampleEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSampleEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["packageSelected"] = this.packageSelected;
        data["volume"] = this.volume;
        data["adheredBarkWeight"] = this.adheredBarkWeight;
        data["sweptBarkWeight"] = this.sweptBarkWeight;
        return data;
    }
}

export interface IBarkSampleEditionDto {
    mode: BarkSampleMode;
    packageSelected: number | undefined;
    volume: number;
    adheredBarkWeight: number;
    sweptBarkWeight: number;
}

export class BarkSampleForGridDto implements IBarkSampleForGridDto {
    reportId!: number;
    originName!: string | undefined;
    standName!: string | undefined;
    cutVendorName!: string | undefined;
    extractionVendorName!: string | undefined;
    receiptEntryDate!: DateTime;
    totalBarkDensity!: number;

    constructor(data?: IBarkSampleForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.originName = _data["originName"];
            this.standName = _data["standName"];
            this.cutVendorName = _data["cutVendorName"];
            this.extractionVendorName = _data["extractionVendorName"];
            this.receiptEntryDate = _data["receiptEntryDate"] ? DateTime.fromISO(_data["receiptEntryDate"].toString()) : <any>undefined;
            this.totalBarkDensity = _data["totalBarkDensity"];
        }
    }

    static fromJS(data: any): BarkSampleForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSampleForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["originName"] = this.originName;
        data["standName"] = this.standName;
        data["cutVendorName"] = this.cutVendorName;
        data["extractionVendorName"] = this.extractionVendorName;
        data["receiptEntryDate"] = this.receiptEntryDate ? this.receiptEntryDate.toString() : <any>undefined;
        data["totalBarkDensity"] = this.totalBarkDensity;
        return data;
    }
}

export interface IBarkSampleForGridDto {
    reportId: number;
    originName: string | undefined;
    standName: string | undefined;
    cutVendorName: string | undefined;
    extractionVendorName: string | undefined;
    receiptEntryDate: DateTime;
    totalBarkDensity: number;
}

export enum BarkSampleMode {
    CompleteTruck = 0,
    SelectPackage = 1,
}

export class BarkSamplesReportInputDto implements IBarkSamplesReportInputDto {
    cutServiceId!: number | undefined;
    extractionServiceId!: number | undefined;
    includeDeletedOnes!: boolean;
    operationMode!: ActivityReportOperationMode;
    originExternalId!: number | undefined;
    standExternalId!: number | undefined;
    destinationExternalId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IBarkSamplesReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cutServiceId = _data["cutServiceId"];
            this.extractionServiceId = _data["extractionServiceId"];
            this.includeDeletedOnes = _data["includeDeletedOnes"];
            this.operationMode = _data["operationMode"];
            this.originExternalId = _data["originExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): BarkSamplesReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSamplesReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cutServiceId"] = this.cutServiceId;
        data["extractionServiceId"] = this.extractionServiceId;
        data["includeDeletedOnes"] = this.includeDeletedOnes;
        data["operationMode"] = this.operationMode;
        data["originExternalId"] = this.originExternalId;
        data["standExternalId"] = this.standExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IBarkSamplesReportInputDto {
    cutServiceId: number | undefined;
    extractionServiceId: number | undefined;
    includeDeletedOnes: boolean;
    operationMode: ActivityReportOperationMode;
    originExternalId: number | undefined;
    standExternalId: number | undefined;
    destinationExternalId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class BasicContractForPolygonContractCreationDto implements IBasicContractForPolygonContractCreationDto {
    contractId!: number;
    contractVendorName!: string | undefined;

    constructor(data?: IBasicContractForPolygonContractCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractVendorName = _data["contractVendorName"];
        }
    }

    static fromJS(data: any): BasicContractForPolygonContractCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicContractForPolygonContractCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractVendorName"] = this.contractVendorName;
        return data;
    }
}

export interface IBasicContractForPolygonContractCreationDto {
    contractId: number;
    contractVendorName: string | undefined;
}

export class BasicDriverDto implements IBasicDriverDto {
    name!: string | undefined;
    carrier!: string | undefined;
    isActive!: boolean;
    vendorId!: number | undefined;
    identityNumber!: string | undefined;
    isBlockingError!: boolean;
    resourceTypeId!: number;
    id!: number;

    constructor(data?: IBasicDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.carrier = _data["carrier"];
            this.isActive = _data["isActive"];
            this.vendorId = _data["vendorId"];
            this.identityNumber = _data["identityNumber"];
            this.isBlockingError = _data["isBlockingError"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicDriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicDriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["carrier"] = this.carrier;
        data["isActive"] = this.isActive;
        data["vendorId"] = this.vendorId;
        data["identityNumber"] = this.identityNumber;
        data["isBlockingError"] = this.isBlockingError;
        data["resourceTypeId"] = this.resourceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicDriverDto {
    name: string | undefined;
    carrier: string | undefined;
    isActive: boolean;
    vendorId: number | undefined;
    identityNumber: string | undefined;
    isBlockingError: boolean;
    resourceTypeId: number;
    id: number;
}

export class BasicLocationDto implements IBasicLocationDto {
    name!: string | undefined;
    readonly locationTypeId!: number;
    locationType!: LocationType;
    contractId!: number;
    vendorId!: number;
    ownerId!: number;
    id!: number;

    constructor(data?: IBasicLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            (<any>this).locationTypeId = _data["locationTypeId"];
            this.locationType = _data["locationType"];
            this.contractId = _data["contractId"];
            this.vendorId = _data["vendorId"];
            this.ownerId = _data["ownerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationType"] = this.locationType;
        data["contractId"] = this.contractId;
        data["vendorId"] = this.vendorId;
        data["ownerId"] = this.ownerId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicLocationDto {
    name: string | undefined;
    locationTypeId: number;
    locationType: LocationType;
    contractId: number;
    vendorId: number;
    ownerId: number;
    id: number;
}

export class BasicPileDto implements IBasicPileDto {
    id!: number;
    name!: string | undefined;
    externalId!: number;
    articleExternalId!: number;
    pileStatus!: PileStatus;

    constructor(data?: IBasicPileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.articleExternalId = _data["articleExternalId"];
            this.pileStatus = _data["pileStatus"];
        }
    }

    static fromJS(data: any): BasicPileDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicPileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["articleExternalId"] = this.articleExternalId;
        data["pileStatus"] = this.pileStatus;
        return data;
    }
}

export interface IBasicPileDto {
    id: number;
    name: string | undefined;
    externalId: number;
    articleExternalId: number;
    pileStatus: PileStatus;
}

export class BasicVendorDto implements IBasicVendorDto {
    fantasyName!: string | undefined;
    id!: number;

    constructor(data?: IBasicVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fantasyName = _data["fantasyName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fantasyName"] = this.fantasyName;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicVendorDto {
    fantasyName: string | undefined;
    id: number;
}

export class BeginEntryProcessWithLicensePlateInput implements IBeginEntryProcessWithLicensePlateInput {
    entrySystemApiZoneId!: number;
    entryProductsZoneId!: number;
    licensePlate!: string | undefined;
    placeId!: number;
    systemType!: DeviceSystemType;

    constructor(data?: IBeginEntryProcessWithLicensePlateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entrySystemApiZoneId = _data["entrySystemApiZoneId"];
            this.entryProductsZoneId = _data["entryProductsZoneId"];
            this.licensePlate = _data["licensePlate"];
            this.placeId = _data["placeId"];
            this.systemType = _data["systemType"];
        }
    }

    static fromJS(data: any): BeginEntryProcessWithLicensePlateInput {
        data = typeof data === 'object' ? data : {};
        let result = new BeginEntryProcessWithLicensePlateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entrySystemApiZoneId"] = this.entrySystemApiZoneId;
        data["entryProductsZoneId"] = this.entryProductsZoneId;
        data["licensePlate"] = this.licensePlate;
        data["placeId"] = this.placeId;
        data["systemType"] = this.systemType;
        return data;
    }
}

export interface IBeginEntryProcessWithLicensePlateInput {
    entrySystemApiZoneId: number;
    entryProductsZoneId: number;
    licensePlate: string | undefined;
    placeId: number;
    systemType: DeviceSystemType;
}

export class BeginExitProcessWithLicensePlateInput implements IBeginExitProcessWithLicensePlateInput {
    exitSystemApiZoneId!: number;
    exitProductsZoneId!: number;
    licensePlate!: string | undefined;
    placeId!: number;
    systemType!: DeviceSystemType;

    constructor(data?: IBeginExitProcessWithLicensePlateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exitSystemApiZoneId = _data["exitSystemApiZoneId"];
            this.exitProductsZoneId = _data["exitProductsZoneId"];
            this.licensePlate = _data["licensePlate"];
            this.placeId = _data["placeId"];
            this.systemType = _data["systemType"];
        }
    }

    static fromJS(data: any): BeginExitProcessWithLicensePlateInput {
        data = typeof data === 'object' ? data : {};
        let result = new BeginExitProcessWithLicensePlateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exitSystemApiZoneId"] = this.exitSystemApiZoneId;
        data["exitProductsZoneId"] = this.exitProductsZoneId;
        data["licensePlate"] = this.licensePlate;
        data["placeId"] = this.placeId;
        data["systemType"] = this.systemType;
        return data;
    }
}

export interface IBeginExitProcessWithLicensePlateInput {
    exitSystemApiZoneId: number;
    exitProductsZoneId: number;
    licensePlate: string | undefined;
    placeId: number;
    systemType: DeviceSystemType;
}

export class CalculateDensityDtoInput implements ICalculateDensityDtoInput {
    machineTareValue!: number;
    withoutSubmergedValue!: number;
    withSubmergedValue!: number;
    stapleVolumeValue!: number;
    waterDensityValue!: number;
    historicalDensity!: number;
    sampleVariationParameter!: number;
    calculateDensityAttempt!: number;
    receiptId!: number;
    sampleAssignmentType!: SampleAssignmentType;

    constructor(data?: ICalculateDensityDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineTareValue = _data["machineTareValue"];
            this.withoutSubmergedValue = _data["withoutSubmergedValue"];
            this.withSubmergedValue = _data["withSubmergedValue"];
            this.stapleVolumeValue = _data["stapleVolumeValue"];
            this.waterDensityValue = _data["waterDensityValue"];
            this.historicalDensity = _data["historicalDensity"];
            this.sampleVariationParameter = _data["sampleVariationParameter"];
            this.calculateDensityAttempt = _data["calculateDensityAttempt"];
            this.receiptId = _data["receiptId"];
            this.sampleAssignmentType = _data["sampleAssignmentType"];
        }
    }

    static fromJS(data: any): CalculateDensityDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateDensityDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineTareValue"] = this.machineTareValue;
        data["withoutSubmergedValue"] = this.withoutSubmergedValue;
        data["withSubmergedValue"] = this.withSubmergedValue;
        data["stapleVolumeValue"] = this.stapleVolumeValue;
        data["waterDensityValue"] = this.waterDensityValue;
        data["historicalDensity"] = this.historicalDensity;
        data["sampleVariationParameter"] = this.sampleVariationParameter;
        data["calculateDensityAttempt"] = this.calculateDensityAttempt;
        data["receiptId"] = this.receiptId;
        data["sampleAssignmentType"] = this.sampleAssignmentType;
        return data;
    }
}

export interface ICalculateDensityDtoInput {
    machineTareValue: number;
    withoutSubmergedValue: number;
    withSubmergedValue: number;
    stapleVolumeValue: number;
    waterDensityValue: number;
    historicalDensity: number;
    sampleVariationParameter: number;
    calculateDensityAttempt: number;
    receiptId: number;
    sampleAssignmentType: SampleAssignmentType;
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class CanEditDiverseProductsOutput implements ICanEditDiverseProductsOutput {
    canEditDestination!: boolean;
    canEditLicensePlate!: boolean;
    canEditDriver!: boolean;
    canEditArticle!: boolean;
    activityReportExternalId!: number | undefined;
    errorMessage!: string | undefined;

    constructor(data?: ICanEditDiverseProductsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEditDestination = _data["canEditDestination"];
            this.canEditLicensePlate = _data["canEditLicensePlate"];
            this.canEditDriver = _data["canEditDriver"];
            this.canEditArticle = _data["canEditArticle"];
            this.activityReportExternalId = _data["activityReportExternalId"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CanEditDiverseProductsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CanEditDiverseProductsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEditDestination"] = this.canEditDestination;
        data["canEditLicensePlate"] = this.canEditLicensePlate;
        data["canEditDriver"] = this.canEditDriver;
        data["canEditArticle"] = this.canEditArticle;
        data["activityReportExternalId"] = this.activityReportExternalId;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICanEditDiverseProductsOutput {
    canEditDestination: boolean;
    canEditLicensePlate: boolean;
    canEditDriver: boolean;
    canEditArticle: boolean;
    activityReportExternalId: number | undefined;
    errorMessage: string | undefined;
}

export class CanEditReceiptOutput implements ICanEditReceiptOutput {
    canEdit!: boolean;
    description!: string | undefined;

    constructor(data?: ICanEditReceiptOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEdit = _data["canEdit"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CanEditReceiptOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CanEditReceiptOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEdit"] = this.canEdit;
        data["description"] = this.description;
        return data;
    }
}

export interface ICanEditReceiptOutput {
    canEdit: boolean;
    description: string | undefined;
}

export class CanEditReportOutput implements ICanEditReportOutput {
    canEditOrigin!: boolean;
    canEditStand!: boolean;
    canEditDriver!: boolean;
    canEditChipHumidity!: boolean;
    canEditChipHumidityAlways!: boolean;
    canEditBarkSample!: boolean;
    canEditTripInfo!: boolean;
    canEditTareWeight!: boolean;
    canEditNoSamplingReason!: boolean;
    canEditInternalDestination!: boolean;
    canEditSerialAndNumber!: boolean;
    canEditLicensePlate!: boolean;
    canEditArticle!: boolean;
    message!: string | undefined;

    constructor(data?: ICanEditReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEditOrigin = _data["canEditOrigin"];
            this.canEditStand = _data["canEditStand"];
            this.canEditDriver = _data["canEditDriver"];
            this.canEditChipHumidity = _data["canEditChipHumidity"];
            this.canEditChipHumidityAlways = _data["canEditChipHumidityAlways"];
            this.canEditBarkSample = _data["canEditBarkSample"];
            this.canEditTripInfo = _data["canEditTripInfo"];
            this.canEditTareWeight = _data["canEditTareWeight"];
            this.canEditNoSamplingReason = _data["canEditNoSamplingReason"];
            this.canEditInternalDestination = _data["canEditInternalDestination"];
            this.canEditSerialAndNumber = _data["canEditSerialAndNumber"];
            this.canEditLicensePlate = _data["canEditLicensePlate"];
            this.canEditArticle = _data["canEditArticle"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CanEditReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CanEditReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEditOrigin"] = this.canEditOrigin;
        data["canEditStand"] = this.canEditStand;
        data["canEditDriver"] = this.canEditDriver;
        data["canEditChipHumidity"] = this.canEditChipHumidity;
        data["canEditChipHumidityAlways"] = this.canEditChipHumidityAlways;
        data["canEditBarkSample"] = this.canEditBarkSample;
        data["canEditTripInfo"] = this.canEditTripInfo;
        data["canEditTareWeight"] = this.canEditTareWeight;
        data["canEditNoSamplingReason"] = this.canEditNoSamplingReason;
        data["canEditInternalDestination"] = this.canEditInternalDestination;
        data["canEditSerialAndNumber"] = this.canEditSerialAndNumber;
        data["canEditLicensePlate"] = this.canEditLicensePlate;
        data["canEditArticle"] = this.canEditArticle;
        data["message"] = this.message;
        return data;
    }
}

export interface ICanEditReportOutput {
    canEditOrigin: boolean;
    canEditStand: boolean;
    canEditDriver: boolean;
    canEditChipHumidity: boolean;
    canEditChipHumidityAlways: boolean;
    canEditBarkSample: boolean;
    canEditTripInfo: boolean;
    canEditTareWeight: boolean;
    canEditNoSamplingReason: boolean;
    canEditInternalDestination: boolean;
    canEditSerialAndNumber: boolean;
    canEditLicensePlate: boolean;
    canEditArticle: boolean;
    message: string | undefined;
}

export class CancelPreActivityReportInputDto implements ICancelPreActivityReportInputDto {
    reportId!: number;
    cancelComment!: string;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ICancelPreActivityReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.cancelComment = _data["cancelComment"];
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): CancelPreActivityReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPreActivityReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["cancelComment"] = this.cancelComment;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ICancelPreActivityReportInputDto {
    reportId: number;
    cancelComment: string;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class CancelPreActivityReportOutputDto implements ICancelPreActivityReportOutputDto {
    hasError!: boolean;
    errorList!: string[] | undefined;

    constructor(data?: ICancelPreActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasError = _data["hasError"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): CancelPreActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPreActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasError"] = this.hasError;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface ICancelPreActivityReportOutputDto {
    hasError: boolean;
    errorList: string[] | undefined;
}

export class CenterControlDiverseProductPreActivityReportSearchOutputDto implements ICenterControlDiverseProductPreActivityReportSearchOutputDto {
    id!: number;
    licensePlate!: string | undefined;
    origin!: string | undefined;
    destination!: string | undefined;
    validationResult!: PreActivityReportValidation;
    creationSystem!: ActivityReportCreationSystem;
    vehicleVendorName!: string | undefined;

    constructor(data?: ICenterControlDiverseProductPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.validationResult = _data["validationResult"];
            this.creationSystem = _data["creationSystem"];
            this.vehicleVendorName = _data["vehicleVendorName"];
        }
    }

    static fromJS(data: any): CenterControlDiverseProductPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenterControlDiverseProductPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["validationResult"] = this.validationResult;
        data["creationSystem"] = this.creationSystem;
        data["vehicleVendorName"] = this.vehicleVendorName;
        return data;
    }
}

export interface ICenterControlDiverseProductPreActivityReportSearchOutputDto {
    id: number;
    licensePlate: string | undefined;
    origin: string | undefined;
    destination: string | undefined;
    validationResult: PreActivityReportValidation;
    creationSystem: ActivityReportCreationSystem;
    vehicleVendorName: string | undefined;
}

export class CenterControlInternalMovementPreActivityReportSearchOutputDto implements ICenterControlInternalMovementPreActivityReportSearchOutputDto {
    id!: number;
    licensePlate!: string | undefined;
    origin!: string | undefined;
    destination!: string | undefined;
    article!: string | undefined;
    validationResult!: PreActivityReportValidation;
    creationSystem!: ActivityReportCreationSystem;

    constructor(data?: ICenterControlInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.article = _data["article"];
            this.validationResult = _data["validationResult"];
            this.creationSystem = _data["creationSystem"];
        }
    }

    static fromJS(data: any): CenterControlInternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenterControlInternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["article"] = this.article;
        data["validationResult"] = this.validationResult;
        data["creationSystem"] = this.creationSystem;
        return data;
    }
}

export interface ICenterControlInternalMovementPreActivityReportSearchOutputDto {
    id: number;
    licensePlate: string | undefined;
    origin: string | undefined;
    destination: string | undefined;
    article: string | undefined;
    validationResult: PreActivityReportValidation;
    creationSystem: ActivityReportCreationSystem;
}

export class CenterControlWoodPreActivityReportSearchOutputDto implements ICenterControlWoodPreActivityReportSearchOutputDto {
    vehicleVendorName!: string | undefined;
    creationSystem!: ActivityReportCreationSystem;
    id!: number;
    date!: DateTime;
    origin!: string | undefined;
    destination!: string | undefined;
    licensePlate!: string | undefined;
    scheduledEntryTime!: DateTime | undefined;
    validationResult!: PreActivityReportValidation;
    isApproved!: boolean;
    creationMode!: PreActivityReportCreationMode;
    paysTransport!: boolean;
    tripNumber!: number | undefined;
    isChip!: boolean;
    serial!: string | undefined;
    number!: number | undefined;
    articleResourceName!: string | undefined;

    constructor(data?: ICenterControlWoodPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleVendorName = _data["vehicleVendorName"];
            this.creationSystem = _data["creationSystem"];
            this.id = _data["id"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.licensePlate = _data["licensePlate"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.isApproved = _data["isApproved"];
            this.creationMode = _data["creationMode"];
            this.paysTransport = _data["paysTransport"];
            this.tripNumber = _data["tripNumber"];
            this.isChip = _data["isChip"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.articleResourceName = _data["articleResourceName"];
        }
    }

    static fromJS(data: any): CenterControlWoodPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenterControlWoodPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleVendorName"] = this.vehicleVendorName;
        data["creationSystem"] = this.creationSystem;
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["licensePlate"] = this.licensePlate;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["isApproved"] = this.isApproved;
        data["creationMode"] = this.creationMode;
        data["paysTransport"] = this.paysTransport;
        data["tripNumber"] = this.tripNumber;
        data["isChip"] = this.isChip;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["articleResourceName"] = this.articleResourceName;
        return data;
    }
}

export interface ICenterControlWoodPreActivityReportSearchOutputDto {
    vehicleVendorName: string | undefined;
    creationSystem: ActivityReportCreationSystem;
    id: number;
    date: DateTime;
    origin: string | undefined;
    destination: string | undefined;
    licensePlate: string | undefined;
    scheduledEntryTime: DateTime | undefined;
    validationResult: PreActivityReportValidation;
    isApproved: boolean;
    creationMode: PreActivityReportCreationMode;
    paysTransport: boolean;
    tripNumber: number | undefined;
    isChip: boolean;
    serial: string | undefined;
    number: number | undefined;
    articleResourceName: string | undefined;
}

export class CheckBrowserWebSubscriptionOutput implements ICheckBrowserWebSubscriptionOutput {
    anErrorOcurred!: boolean;
    errorDescription!: string | undefined;

    constructor(data?: ICheckBrowserWebSubscriptionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anErrorOcurred = _data["anErrorOcurred"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): CheckBrowserWebSubscriptionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckBrowserWebSubscriptionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anErrorOcurred"] = this.anErrorOcurred;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface ICheckBrowserWebSubscriptionOutput {
    anErrorOcurred: boolean;
    errorDescription: string | undefined;
}

export class CommunicateManualWeightInputDto implements ICommunicateManualWeightInputDto {
    receiptId!: number;
    label!: string | undefined;
    value!: number;
    manualWeightReason!: string | undefined;
    manualWeightComment!: string | undefined;
    attempt!: number;
    sampleAssignmentType!: SampleAssignmentType;

    constructor(data?: ICommunicateManualWeightInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.manualWeightReason = _data["manualWeightReason"];
            this.manualWeightComment = _data["manualWeightComment"];
            this.attempt = _data["attempt"];
            this.sampleAssignmentType = _data["sampleAssignmentType"];
        }
    }

    static fromJS(data: any): CommunicateManualWeightInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicateManualWeightInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["label"] = this.label;
        data["value"] = this.value;
        data["manualWeightReason"] = this.manualWeightReason;
        data["manualWeightComment"] = this.manualWeightComment;
        data["attempt"] = this.attempt;
        data["sampleAssignmentType"] = this.sampleAssignmentType;
        return data;
    }
}

export interface ICommunicateManualWeightInputDto {
    receiptId: number;
    label: string | undefined;
    value: number;
    manualWeightReason: string | undefined;
    manualWeightComment: string | undefined;
    attempt: number;
    sampleAssignmentType: SampleAssignmentType;
}

export class CompleteWoodSemiAutomaticExitProcessOutput implements ICompleteWoodSemiAutomaticExitProcessOutput {
    editionSuccessfull!: boolean;
    integrationsSuccessfull!: boolean;
    errors!: string | undefined;

    constructor(data?: ICompleteWoodSemiAutomaticExitProcessOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionSuccessfull = _data["editionSuccessfull"];
            this.integrationsSuccessfull = _data["integrationsSuccessfull"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): CompleteWoodSemiAutomaticExitProcessOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteWoodSemiAutomaticExitProcessOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionSuccessfull"] = this.editionSuccessfull;
        data["integrationsSuccessfull"] = this.integrationsSuccessfull;
        data["errors"] = this.errors;
        return data;
    }
}

export interface ICompleteWoodSemiAutomaticExitProcessOutput {
    editionSuccessfull: boolean;
    integrationsSuccessfull: boolean;
    errors: string | undefined;
}

export class ConfirmEntryInputDto implements IConfirmEntryInputDto {
    tagValue!: string | undefined;
    licensePlate!: string | undefined;
    zoneId!: number;
    enteringActivityReportId!: number;
    type!: ConfirmEntryType;

    constructor(data?: IConfirmEntryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagValue = _data["tagValue"];
            this.licensePlate = _data["licensePlate"];
            this.zoneId = _data["zoneId"];
            this.enteringActivityReportId = _data["enteringActivityReportId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ConfirmEntryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEntryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagValue"] = this.tagValue;
        data["licensePlate"] = this.licensePlate;
        data["zoneId"] = this.zoneId;
        data["enteringActivityReportId"] = this.enteringActivityReportId;
        data["type"] = this.type;
        return data;
    }
}

export interface IConfirmEntryInputDto {
    tagValue: string | undefined;
    licensePlate: string | undefined;
    zoneId: number;
    enteringActivityReportId: number;
    type: ConfirmEntryType;
}

export enum ConfirmEntryType {
    PreReportProcessing = 0,
    SampleAssignment = 1,
}

export class ConfirmTruckTypeSelection implements IConfirmTruckTypeSelection {
    truckFlowType!: TruckFlowType;
    tagNumber!: string | undefined;
    licensePlate!: string | undefined;
    woodZoneId!: number;
    productsZoneId!: number;

    constructor(data?: IConfirmTruckTypeSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckFlowType = _data["truckFlowType"];
            this.tagNumber = _data["tagNumber"];
            this.licensePlate = _data["licensePlate"];
            this.woodZoneId = _data["woodZoneId"];
            this.productsZoneId = _data["productsZoneId"];
        }
    }

    static fromJS(data: any): ConfirmTruckTypeSelection {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTruckTypeSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckFlowType"] = this.truckFlowType;
        data["tagNumber"] = this.tagNumber;
        data["licensePlate"] = this.licensePlate;
        data["woodZoneId"] = this.woodZoneId;
        data["productsZoneId"] = this.productsZoneId;
        return data;
    }
}

export interface IConfirmTruckTypeSelection {
    truckFlowType: TruckFlowType;
    tagNumber: string | undefined;
    licensePlate: string | undefined;
    woodZoneId: number;
    productsZoneId: number;
}

export class ConstructorInfo implements IConstructorInfo {
    memberType!: MemberTypes;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IConstructorInfo {
    memberType: MemberTypes;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class ContractDto implements IContractDto {
    contractTypeId!: number;
    contractType!: ContractTypeDto;
    vendorId!: number;
    number!: string | undefined;
    startDate!: DateTime | undefined;
    dueDate!: DateTime | undefined;
    services!: ServiceActivityDto[] | undefined;
    isActive!: boolean;
    contractDestinationId!: number | undefined;
    id!: number;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractTypeId = _data["contractTypeId"];
            this.contractType = _data["contractType"] ? ContractTypeDto.fromJS(_data["contractType"]) : <any>undefined;
            this.vendorId = _data["vendorId"];
            this.number = _data["number"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceActivityDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.contractDestinationId = _data["contractDestinationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractTypeId"] = this.contractTypeId;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["number"] = this.number;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["contractDestinationId"] = this.contractDestinationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IContractDto {
    contractTypeId: number;
    contractType: ContractTypeDto;
    vendorId: number;
    number: string | undefined;
    startDate: DateTime | undefined;
    dueDate: DateTime | undefined;
    services: ServiceActivityDto[] | undefined;
    isActive: boolean;
    contractDestinationId: number | undefined;
    id: number;
}

export class ContractDtoOutput implements IContractDtoOutput {
    contract!: ContractDto;
    contractType!: ContractTypeDto;
    errorList!: string[] | undefined;

    constructor(data?: IContractDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.contractType = _data["contractType"] ? ContractTypeDto.fromJS(_data["contractType"]) : <any>undefined;
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IContractDtoOutput {
    contract: ContractDto;
    contractType: ContractTypeDto;
    errorList: string[] | undefined;
}

export class ContractTypeDto implements IContractTypeDto {
    id!: number;
    name!: string | undefined;
    paysTransport!: boolean;
    services!: ServiceActivityDto[] | undefined;
    contractTypeGroupId!: number;
    contractTypeGroup!: ContractTypeGroupDto;

    constructor(data?: IContractTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.paysTransport = _data["paysTransport"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceActivityDto.fromJS(item));
            }
            this.contractTypeGroupId = _data["contractTypeGroupId"];
            this.contractTypeGroup = _data["contractTypeGroup"] ? ContractTypeGroupDto.fromJS(_data["contractTypeGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["paysTransport"] = this.paysTransport;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["contractTypeGroupId"] = this.contractTypeGroupId;
        data["contractTypeGroup"] = this.contractTypeGroup ? this.contractTypeGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContractTypeDto {
    id: number;
    name: string | undefined;
    paysTransport: boolean;
    services: ServiceActivityDto[] | undefined;
    contractTypeGroupId: number;
    contractTypeGroup: ContractTypeGroupDto;
}

export class ContractTypeGroupDto implements IContractTypeGroupDto {
    id!: number;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IContractTypeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ContractTypeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IContractTypeGroupDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class ContractTypeUsageDto implements IContractTypeUsageDto {
    name!: string | undefined;
    code!: string | undefined;
    id!: number;

    constructor(data?: IContractTypeUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContractTypeUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IContractTypeUsageDto {
    name: string | undefined;
    code: string | undefined;
    id: number;
}

export class CreateInternalMovementPreActivityReportInput implements ICreateInternalMovementPreActivityReportInput {
    originAndDestinationId!: number;
    date!: DateTime;
    articleId!: number;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ICreateInternalMovementPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originAndDestinationId = _data["originAndDestinationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.articleId = _data["articleId"];
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): CreateInternalMovementPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInternalMovementPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originAndDestinationId"] = this.originAndDestinationId;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["articleId"] = this.articleId;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ICreateInternalMovementPreActivityReportInput {
    originAndDestinationId: number;
    date: DateTime;
    articleId: number;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class CreateInternalMovementPreActivityReportOutput implements ICreateInternalMovementPreActivityReportOutput {
    result!: boolean;
    errorList!: string[] | undefined;
    internalMovementActivityReportId!: number;

    constructor(data?: ICreateInternalMovementPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.internalMovementActivityReportId = _data["internalMovementActivityReportId"];
        }
    }

    static fromJS(data: any): CreateInternalMovementPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInternalMovementPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["internalMovementActivityReportId"] = this.internalMovementActivityReportId;
        return data;
    }
}

export interface ICreateInternalMovementPreActivityReportOutput {
    result: boolean;
    errorList: string[] | undefined;
    internalMovementActivityReportId: number;
}

export class CreateManualDiverseProductActivityReportInput implements ICreateManualDiverseProductActivityReportInput {
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    vehicleId!: number;
    vendorId!: number;
    driver!: DriverInputDto;
    articleId!: number;
    netWeight!: number;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    singleCustomDeclarationId!: number;
    comment!: string | undefined;
    enteringStockAreaId!: number;

    constructor(data?: ICreateManualDiverseProductActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vendorId = _data["vendorId"];
            this.driver = _data["driver"] ? DriverInputDto.fromJS(_data["driver"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.singleCustomDeclarationId = _data["singleCustomDeclarationId"];
            this.comment = _data["comment"];
            this.enteringStockAreaId = _data["enteringStockAreaId"];
        }
    }

    static fromJS(data: any): CreateManualDiverseProductActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualDiverseProductActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vendorId"] = this.vendorId;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["singleCustomDeclarationId"] = this.singleCustomDeclarationId;
        data["comment"] = this.comment;
        data["enteringStockAreaId"] = this.enteringStockAreaId;
        return data;
    }
}

export interface ICreateManualDiverseProductActivityReportInput {
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    vehicleId: number;
    vendorId: number;
    driver: DriverInputDto;
    articleId: number;
    netWeight: number;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    singleCustomDeclarationId: number;
    comment: string | undefined;
    enteringStockAreaId: number;
}

export class CreateManualDiverseProductActivityReportOutput implements ICreateManualDiverseProductActivityReportOutput {
    result!: boolean;
    diverseProductActivityReportId!: number;
    errorList!: string[] | undefined;
    integrationsResult!: boolean;

    constructor(data?: ICreateManualDiverseProductActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.diverseProductActivityReportId = _data["diverseProductActivityReportId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.integrationsResult = _data["integrationsResult"];
        }
    }

    static fromJS(data: any): CreateManualDiverseProductActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualDiverseProductActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["diverseProductActivityReportId"] = this.diverseProductActivityReportId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["integrationsResult"] = this.integrationsResult;
        return data;
    }
}

export interface ICreateManualDiverseProductActivityReportOutput {
    result: boolean;
    diverseProductActivityReportId: number;
    errorList: string[] | undefined;
    integrationsResult: boolean;
}

export class CreateManualInternalMovementActivityReportInput implements ICreateManualInternalMovementActivityReportInput {
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    vehicleId!: number;
    vendorId!: number;
    driver!: DriverInputDto;
    articleId!: number;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    netWeight!: number;
    comment!: string | undefined;

    constructor(data?: ICreateManualInternalMovementActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vendorId = _data["vendorId"];
            this.driver = _data["driver"] ? DriverInputDto.fromJS(_data["driver"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateManualInternalMovementActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualInternalMovementActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vendorId"] = this.vendorId;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateManualInternalMovementActivityReportInput {
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    vehicleId: number;
    vendorId: number;
    driver: DriverInputDto;
    articleId: number;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    netWeight: number;
    comment: string | undefined;
}

export class CreateManualInternalMovementActivityReportOutput implements ICreateManualInternalMovementActivityReportOutput {
    result!: boolean;
    internalMovementActivityReport!: number;
    errorList!: string[] | undefined;

    constructor(data?: ICreateManualInternalMovementActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.internalMovementActivityReport = _data["internalMovementActivityReport"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateManualInternalMovementActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualInternalMovementActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["internalMovementActivityReport"] = this.internalMovementActivityReport;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface ICreateManualInternalMovementActivityReportOutput {
    result: boolean;
    internalMovementActivityReport: number;
    errorList: string[] | undefined;
}

export class CreatePolygonContractInputDto implements ICreatePolygonContractInputDto {
    contractId!: number;
    isActive!: boolean;
    emails!: string[] | undefined;

    constructor(data?: ICreatePolygonContractInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePolygonContractInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePolygonContractInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface ICreatePolygonContractInputDto {
    contractId: number;
    isActive: boolean;
    emails: string[] | undefined;
}

export class CreateWoodActivityReportInput implements ICreateWoodActivityReportInput {
    origin!: LocationDto;
    destination!: LocationDto;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    vehicle!: VehicleDto;
    tripNumber!: number | undefined;
    driver!: DriverDto;
    lines!: WoodControlActivityReportLineDto[] | undefined;
    netWeight!: number;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    singleCustomDeclaration!: SingleCustomDeclarationOutput;
    internalDestination!: ZoneDto;
    isChip!: boolean;
    comment!: string | undefined;
    cycle!: number | undefined;
    loadDateTime!: DateTime | undefined;
    sampleAlgorithmExecuted!: boolean;
    enteringStockAreaId!: number;
    isWithGrossWeightOutsideTolerance!: boolean;
    isMissingActivityReportExit!: boolean;
    exitActivityReportGrossWeight!: number;
    exitActivityReportPlaceId!: number | undefined;
    isConfirmedSampleEntrance!: boolean;
    id!: number;

    constructor(data?: ICreateWoodActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineDto.fromJS(item));
            }
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.singleCustomDeclaration = _data["singleCustomDeclaration"] ? SingleCustomDeclarationOutput.fromJS(_data["singleCustomDeclaration"]) : <any>undefined;
            this.internalDestination = _data["internalDestination"] ? ZoneDto.fromJS(_data["internalDestination"]) : <any>undefined;
            this.isChip = _data["isChip"];
            this.comment = _data["comment"];
            this.cycle = _data["cycle"];
            this.loadDateTime = _data["loadDateTime"] ? DateTime.fromISO(_data["loadDateTime"].toString()) : <any>undefined;
            this.sampleAlgorithmExecuted = _data["sampleAlgorithmExecuted"];
            this.enteringStockAreaId = _data["enteringStockAreaId"];
            this.isWithGrossWeightOutsideTolerance = _data["isWithGrossWeightOutsideTolerance"];
            this.isMissingActivityReportExit = _data["isMissingActivityReportExit"];
            this.exitActivityReportGrossWeight = _data["exitActivityReportGrossWeight"];
            this.exitActivityReportPlaceId = _data["exitActivityReportPlaceId"];
            this.isConfirmedSampleEntrance = _data["isConfirmedSampleEntrance"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWoodActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["singleCustomDeclaration"] = this.singleCustomDeclaration ? this.singleCustomDeclaration.toJSON() : <any>undefined;
        data["internalDestination"] = this.internalDestination ? this.internalDestination.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["comment"] = this.comment;
        data["cycle"] = this.cycle;
        data["loadDateTime"] = this.loadDateTime ? this.loadDateTime.toString() : <any>undefined;
        data["sampleAlgorithmExecuted"] = this.sampleAlgorithmExecuted;
        data["enteringStockAreaId"] = this.enteringStockAreaId;
        data["isWithGrossWeightOutsideTolerance"] = this.isWithGrossWeightOutsideTolerance;
        data["isMissingActivityReportExit"] = this.isMissingActivityReportExit;
        data["exitActivityReportGrossWeight"] = this.exitActivityReportGrossWeight;
        data["exitActivityReportPlaceId"] = this.exitActivityReportPlaceId;
        data["isConfirmedSampleEntrance"] = this.isConfirmedSampleEntrance;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateWoodActivityReportInput {
    origin: LocationDto;
    destination: LocationDto;
    serial: string | undefined;
    number: number;
    date: DateTime;
    vehicle: VehicleDto;
    tripNumber: number | undefined;
    driver: DriverDto;
    lines: WoodControlActivityReportLineDto[] | undefined;
    netWeight: number;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    singleCustomDeclaration: SingleCustomDeclarationOutput;
    internalDestination: ZoneDto;
    isChip: boolean;
    comment: string | undefined;
    cycle: number | undefined;
    loadDateTime: DateTime | undefined;
    sampleAlgorithmExecuted: boolean;
    enteringStockAreaId: number;
    isWithGrossWeightOutsideTolerance: boolean;
    isMissingActivityReportExit: boolean;
    exitActivityReportGrossWeight: number;
    exitActivityReportPlaceId: number | undefined;
    isConfirmedSampleEntrance: boolean;
    id: number;
}

export class CreateWoodActivityReportOutput implements ICreateWoodActivityReportOutput {
    result!: boolean;
    errorList!: string[] | undefined;
    woodActivityReportId!: number;
    shouldBeSampled!: boolean;
    integrationResult!: boolean;
    shouldConfirmEntrance!: boolean;
    confirmationMessage!: string | undefined;

    constructor(data?: ICreateWoodActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.woodActivityReportId = _data["woodActivityReportId"];
            this.shouldBeSampled = _data["shouldBeSampled"];
            this.integrationResult = _data["integrationResult"];
            this.shouldConfirmEntrance = _data["shouldConfirmEntrance"];
            this.confirmationMessage = _data["confirmationMessage"];
        }
    }

    static fromJS(data: any): CreateWoodActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["woodActivityReportId"] = this.woodActivityReportId;
        data["shouldBeSampled"] = this.shouldBeSampled;
        data["integrationResult"] = this.integrationResult;
        data["shouldConfirmEntrance"] = this.shouldConfirmEntrance;
        data["confirmationMessage"] = this.confirmationMessage;
        return data;
    }
}

export interface ICreateWoodActivityReportOutput {
    result: boolean;
    errorList: string[] | undefined;
    woodActivityReportId: number;
    shouldBeSampled: boolean;
    integrationResult: boolean;
    shouldConfirmEntrance: boolean;
    confirmationMessage: string | undefined;
}

export class CreateWoodPreActivityReportOutput implements ICreateWoodPreActivityReportOutput {
    result!: boolean;
    errorList!: string[] | undefined;
    woodActivityReportId!: number;
    originType!: LocationType;
    imageExpired!: boolean;

    constructor(data?: ICreateWoodPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.woodActivityReportId = _data["woodActivityReportId"];
            this.originType = _data["originType"];
            this.imageExpired = _data["imageExpired"];
        }
    }

    static fromJS(data: any): CreateWoodPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["woodActivityReportId"] = this.woodActivityReportId;
        data["originType"] = this.originType;
        data["imageExpired"] = this.imageExpired;
        return data;
    }
}

export interface ICreateWoodPreActivityReportOutput {
    result: boolean;
    errorList: string[] | undefined;
    woodActivityReportId: number;
    originType: LocationType;
    imageExpired: boolean;
}

export class CreateWoodProvidersPreActivityReportOutput implements ICreateWoodProvidersPreActivityReportOutput {
    result!: boolean;
    errorList!: string[] | undefined;
    woodActivityReportId!: number;

    constructor(data?: ICreateWoodProvidersPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.woodActivityReportId = _data["woodActivityReportId"];
        }
    }

    static fromJS(data: any): CreateWoodProvidersPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodProvidersPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["woodActivityReportId"] = this.woodActivityReportId;
        return data;
    }
}

export interface ICreateWoodProvidersPreActivityReportOutput {
    result: boolean;
    errorList: string[] | undefined;
    woodActivityReportId: number;
}

export class CreateWoodVendorQuotaDto implements ICreateWoodVendorQuotaDto {
    vendorExternalIds!: number[];
    hourlyQuota!: number;
    tolerance!: number;
    volumeDailyTolerance!: number;

    constructor(data?: ICreateWoodVendorQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vendorExternalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendorExternalIds"])) {
                this.vendorExternalIds = [] as any;
                for (let item of _data["vendorExternalIds"])
                    this.vendorExternalIds!.push(item);
            }
            this.hourlyQuota = _data["hourlyQuota"];
            this.tolerance = _data["tolerance"];
            this.volumeDailyTolerance = _data["volumeDailyTolerance"];
        }
    }

    static fromJS(data: any): CreateWoodVendorQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodVendorQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorExternalIds)) {
            data["vendorExternalIds"] = [];
            for (let item of this.vendorExternalIds)
                data["vendorExternalIds"].push(item);
        }
        data["hourlyQuota"] = this.hourlyQuota;
        data["tolerance"] = this.tolerance;
        data["volumeDailyTolerance"] = this.volumeDailyTolerance;
        return data;
    }
}

export interface ICreateWoodVendorQuotaDto {
    vendorExternalIds: number[];
    hourlyQuota: number;
    tolerance: number;
    volumeDailyTolerance: number;
}

export class CreateWoodVendorQuotaOutputDto implements ICreateWoodVendorQuotaOutputDto {
    hasError!: boolean;
    errorList!: string[] | undefined;

    constructor(data?: ICreateWoodVendorQuotaOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasError = _data["hasError"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateWoodVendorQuotaOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodVendorQuotaOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasError"] = this.hasError;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface ICreateWoodVendorQuotaOutputDto {
    hasError: boolean;
    errorList: string[] | undefined;
}

export class CustodyChainDto implements ICustodyChainDto {
    id!: number;
    name!: string | undefined;
    certificationType!: string | undefined;
    isCertified!: boolean;
    validSinceDate!: DateTime;

    constructor(data?: ICustodyChainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.certificationType = _data["certificationType"];
            this.isCertified = _data["isCertified"];
            this.validSinceDate = _data["validSinceDate"] ? DateTime.fromISO(_data["validSinceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustodyChainDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustodyChainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["certificationType"] = this.certificationType;
        data["isCertified"] = this.isCertified;
        data["validSinceDate"] = this.validSinceDate ? this.validSinceDate.toString() : <any>undefined;
        return data;
    }
}

export interface ICustodyChainDto {
    id: number;
    name: string | undefined;
    certificationType: string | undefined;
    isCertified: boolean;
    validSinceDate: DateTime;
}

export class CustomAttributeData implements ICustomAttributeData {
    readonly attributeType!: string | undefined;
    constructor_!: ConstructorInfo;
    readonly constructorArguments!: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments!: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).attributeType = _data["attributeType"];
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType: string | undefined;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo!: MemberInfo;
    typedValue!: CustomAttributeTypedArgument;
    readonly memberName!: string | undefined;
    readonly isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType!: string | undefined;
    value!: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: string | undefined;
    value: any | undefined;
}

export class CustomPagedResultDtoOfArchimedesSampleForGridDto implements ICustomPagedResultDtoOfArchimedesSampleForGridDto {
    errorList!: string[] | undefined;
    items!: ArchimedesSampleForGridDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfArchimedesSampleForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArchimedesSampleForGridDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfArchimedesSampleForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfArchimedesSampleForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfArchimedesSampleForGridDto {
    errorList: string[] | undefined;
    items: ArchimedesSampleForGridDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfArticleByLocationOutput implements ICustomPagedResultDtoOfArticleByLocationOutput {
    errorList!: string[] | undefined;
    items!: ArticleByLocationOutput[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfArticleByLocationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleByLocationOutput.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfArticleByLocationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfArticleByLocationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfArticleByLocationOutput {
    errorList: string[] | undefined;
    items: ArticleByLocationOutput[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfArticleDiverseProductsDto implements ICustomPagedResultDtoOfArticleDiverseProductsDto {
    errorList!: string[] | undefined;
    items!: ArticleDiverseProductsDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfArticleDiverseProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleDiverseProductsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfArticleDiverseProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfArticleDiverseProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfArticleDiverseProductsDto {
    errorList: string[] | undefined;
    items: ArticleDiverseProductsDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfArticleDtoOutput implements ICustomPagedResultDtoOfArticleDtoOutput {
    errorList!: string[] | undefined;
    items!: ArticleDtoOutput[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfArticleDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleDtoOutput.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfArticleDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfArticleDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfArticleDtoOutput {
    errorList: string[] | undefined;
    items: ArticleDtoOutput[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfArticleInternalMovementDto implements ICustomPagedResultDtoOfArticleInternalMovementDto {
    errorList!: string[] | undefined;
    items!: ArticleInternalMovementDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfArticleInternalMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleInternalMovementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfArticleInternalMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfArticleInternalMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfArticleInternalMovementDto {
    errorList: string[] | undefined;
    items: ArticleInternalMovementDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfBarkSampleForGridDto implements ICustomPagedResultDtoOfBarkSampleForGridDto {
    errorList!: string[] | undefined;
    items!: BarkSampleForGridDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfBarkSampleForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BarkSampleForGridDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfBarkSampleForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfBarkSampleForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfBarkSampleForGridDto {
    errorList: string[] | undefined;
    items: BarkSampleForGridDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto implements ICustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto {
    errorList!: string[] | undefined;
    items!: CenterControlDiverseProductPreActivityReportSearchOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CenterControlDiverseProductPreActivityReportSearchOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto {
    errorList: string[] | undefined;
    items: CenterControlDiverseProductPreActivityReportSearchOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto implements ICustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto {
    errorList!: string[] | undefined;
    items!: CenterControlInternalMovementPreActivityReportSearchOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CenterControlInternalMovementPreActivityReportSearchOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto {
    errorList: string[] | undefined;
    items: CenterControlInternalMovementPreActivityReportSearchOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto implements ICustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto {
    errorList!: string[] | undefined;
    items!: CenterControlWoodPreActivityReportSearchOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CenterControlWoodPreActivityReportSearchOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto {
    errorList: string[] | undefined;
    items: CenterControlWoodPreActivityReportSearchOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfContractDto implements ICustomPagedResultDtoOfContractDto {
    errorList!: string[] | undefined;
    items!: ContractDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfContractDto {
    errorList: string[] | undefined;
    items: ContractDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfContractTypeDto implements ICustomPagedResultDtoOfContractTypeDto {
    errorList!: string[] | undefined;
    items!: ContractTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfContractTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfContractTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfContractTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfContractTypeDto {
    errorList: string[] | undefined;
    items: ContractTypeDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfContractTypeUsageDto implements ICustomPagedResultDtoOfContractTypeUsageDto {
    errorList!: string[] | undefined;
    items!: ContractTypeUsageDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfContractTypeUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractTypeUsageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfContractTypeUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfContractTypeUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfContractTypeUsageDto {
    errorList: string[] | undefined;
    items: ContractTypeUsageDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfCustodyChainDto implements ICustomPagedResultDtoOfCustodyChainDto {
    errorList!: string[] | undefined;
    items!: CustodyChainDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfCustodyChainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustodyChainDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfCustodyChainDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfCustodyChainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfCustodyChainDto {
    errorList: string[] | undefined;
    items: CustodyChainDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto implements ICustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto {
    errorList!: string[] | undefined;
    items!: DiverseProductPreActivityReportForProviderSearchOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiverseProductPreActivityReportForProviderSearchOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto {
    errorList: string[] | undefined;
    items: DiverseProductPreActivityReportForProviderSearchOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfDownloadStandServiceDto implements ICustomPagedResultDtoOfDownloadStandServiceDto {
    errorList!: string[] | undefined;
    items!: DownloadStandServiceDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfDownloadStandServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DownloadStandServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfDownloadStandServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfDownloadStandServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfDownloadStandServiceDto {
    errorList: string[] | undefined;
    items: DownloadStandServiceDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfDriverDto implements ICustomPagedResultDtoOfDriverDto {
    errorList!: string[] | undefined;
    items!: DriverDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DriverDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfDriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfDriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfDriverDto {
    errorList: string[] | undefined;
    items: DriverDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfGetAllPaysTransportOutputDto implements ICustomPagedResultDtoOfGetAllPaysTransportOutputDto {
    errorList!: string[] | undefined;
    items!: GetAllPaysTransportOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfGetAllPaysTransportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllPaysTransportOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfGetAllPaysTransportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfGetAllPaysTransportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfGetAllPaysTransportOutputDto {
    errorList: string[] | undefined;
    items: GetAllPaysTransportOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfHarvestStandServiceDto implements ICustomPagedResultDtoOfHarvestStandServiceDto {
    errorList!: string[] | undefined;
    items!: HarvestStandServiceDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfHarvestStandServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HarvestStandServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfHarvestStandServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfHarvestStandServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfHarvestStandServiceDto {
    errorList: string[] | undefined;
    items: HarvestStandServiceDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto implements ICustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto {
    errorList!: string[] | undefined;
    items!: InternalMovementPreActivityReportSearchOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InternalMovementPreActivityReportSearchOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto {
    errorList: string[] | undefined;
    items: InternalMovementPreActivityReportSearchOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfLengthDto implements ICustomPagedResultDtoOfLengthDto {
    errorList!: string[] | undefined;
    items!: LengthDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfLengthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LengthDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfLengthDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfLengthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfLengthDto {
    errorList: string[] | undefined;
    items: LengthDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfLoadStandServiceDto implements ICustomPagedResultDtoOfLoadStandServiceDto {
    errorList!: string[] | undefined;
    items!: LoadStandServiceDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfLoadStandServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LoadStandServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfLoadStandServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfLoadStandServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfLoadStandServiceDto {
    errorList: string[] | undefined;
    items: LoadStandServiceDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfLocationDto implements ICustomPagedResultDtoOfLocationDto {
    errorList!: string[] | undefined;
    items!: LocationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfLocationDto {
    errorList: string[] | undefined;
    items: LocationDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfLocationWithAcceptedOriginsDto implements ICustomPagedResultDtoOfLocationWithAcceptedOriginsDto {
    errorList!: string[] | undefined;
    items!: LocationWithAcceptedOriginsDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfLocationWithAcceptedOriginsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationWithAcceptedOriginsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfLocationWithAcceptedOriginsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfLocationWithAcceptedOriginsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfLocationWithAcceptedOriginsDto {
    errorList: string[] | undefined;
    items: LocationWithAcceptedOriginsDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfLogyardWithSpeciesDto implements ICustomPagedResultDtoOfLogyardWithSpeciesDto {
    errorList!: string[] | undefined;
    items!: LogyardWithSpeciesDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfLogyardWithSpeciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LogyardWithSpeciesDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfLogyardWithSpeciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfLogyardWithSpeciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfLogyardWithSpeciesDto {
    errorList: string[] | undefined;
    items: LogyardWithSpeciesDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfMeasurementTypeDto implements ICustomPagedResultDtoOfMeasurementTypeDto {
    errorList!: string[] | undefined;
    items!: MeasurementTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfMeasurementTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfMeasurementTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfMeasurementTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfMeasurementTypeDto {
    errorList: string[] | undefined;
    items: MeasurementTypeDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfMeasurementTypePerOriginDto implements ICustomPagedResultDtoOfMeasurementTypePerOriginDto {
    errorList!: string[] | undefined;
    items!: MeasurementTypePerOriginDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfMeasurementTypePerOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeasurementTypePerOriginDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfMeasurementTypePerOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfMeasurementTypePerOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfMeasurementTypePerOriginDto {
    errorList: string[] | undefined;
    items: MeasurementTypePerOriginDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfMonitorActivityDto implements ICustomPagedResultDtoOfMonitorActivityDto {
    errorList!: string[] | undefined;
    items!: MonitorActivityDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfMonitorActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MonitorActivityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfMonitorActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfMonitorActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfMonitorActivityDto {
    errorList: string[] | undefined;
    items: MonitorActivityDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfPeriodDto implements ICustomPagedResultDtoOfPeriodDto {
    errorList!: string[] | undefined;
    items!: PeriodDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PeriodDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfPeriodDto {
    errorList: string[] | undefined;
    items: PeriodDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto implements ICustomPagedResultDtoOfRandomStatisticalSampleQuotaDto {
    errorList!: string[] | undefined;
    items!: RandomStatisticalSampleQuotaDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfRandomStatisticalSampleQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RandomStatisticalSampleQuotaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfRandomStatisticalSampleQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfRandomStatisticalSampleQuotaDto {
    errorList: string[] | undefined;
    items: RandomStatisticalSampleQuotaDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfReportByProviderOutputPagedDto implements ICustomPagedResultDtoOfReportByProviderOutputPagedDto {
    errorList!: string[] | undefined;
    items!: ReportByProviderOutputPagedDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfReportByProviderOutputPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportByProviderOutputPagedDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfReportByProviderOutputPagedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfReportByProviderOutputPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfReportByProviderOutputPagedDto {
    errorList: string[] | undefined;
    items: ReportByProviderOutputPagedDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfScannerExceptionDto implements ICustomPagedResultDtoOfScannerExceptionDto {
    errorList!: string[] | undefined;
    items!: ScannerExceptionDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfScannerExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScannerExceptionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfScannerExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfScannerExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfScannerExceptionDto {
    errorList: string[] | undefined;
    items: ScannerExceptionDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfScannerModelDto implements ICustomPagedResultDtoOfScannerModelDto {
    errorList!: string[] | undefined;
    items!: ScannerModelDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfScannerModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScannerModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfScannerModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfScannerModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfScannerModelDto {
    errorList: string[] | undefined;
    items: ScannerModelDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfSearchReportOutputDto implements ICustomPagedResultDtoOfSearchReportOutputDto {
    errorList!: string[] | undefined;
    items!: SearchReportOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfSearchReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchReportOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfSearchReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfSearchReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfSearchReportOutputDto {
    errorList: string[] | undefined;
    items: SearchReportOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto implements ICustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto {
    errorList!: string[] | undefined;
    items!: SearchWoodVendorQuotaOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchWoodVendorQuotaOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfSearchWoodVendorQuotaOutputDto {
    errorList: string[] | undefined;
    items: SearchWoodVendorQuotaOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfSimpleLocationDto implements ICustomPagedResultDtoOfSimpleLocationDto {
    errorList!: string[] | undefined;
    items!: SimpleLocationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfSimpleLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleLocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfSimpleLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfSimpleLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfSimpleLocationDto {
    errorList: string[] | undefined;
    items: SimpleLocationDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfSpeciesDto implements ICustomPagedResultDtoOfSpeciesDto {
    errorList!: string[] | undefined;
    items!: SpeciesDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfSpeciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpeciesDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfSpeciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfSpeciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfSpeciesDto {
    errorList: string[] | undefined;
    items: SpeciesDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfStandOutputDto implements ICustomPagedResultDtoOfStandOutputDto {
    errorList!: string[] | undefined;
    items!: StandOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfStandOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StandOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfStandOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfStandOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfStandOutputDto {
    errorList: string[] | undefined;
    items: StandOutputDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfTravelAssignmentDto implements ICustomPagedResultDtoOfTravelAssignmentDto {
    errorList!: string[] | undefined;
    items!: TravelAssignmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfTravelAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TravelAssignmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfTravelAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfTravelAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfTravelAssignmentDto {
    errorList: string[] | undefined;
    items: TravelAssignmentDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfTritrainDriverDto implements ICustomPagedResultDtoOfTritrainDriverDto {
    errorList!: string[] | undefined;
    items!: TritrainDriverDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfTritrainDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TritrainDriverDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfTritrainDriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfTritrainDriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfTritrainDriverDto {
    errorList: string[] | undefined;
    items: TritrainDriverDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfUserVendorDto implements ICustomPagedResultDtoOfUserVendorDto {
    errorList!: string[] | undefined;
    items!: UserVendorDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfUserVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserVendorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfUserVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfUserVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfUserVendorDto {
    errorList: string[] | undefined;
    items: UserVendorDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfVehicleDto implements ICustomPagedResultDtoOfVehicleDto {
    errorList!: string[] | undefined;
    items!: VehicleDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VehicleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfVehicleDto {
    errorList: string[] | undefined;
    items: VehicleDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfVendorDto implements ICustomPagedResultDtoOfVendorDto {
    errorList!: string[] | undefined;
    items!: VendorDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VendorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfVendorDto {
    errorList: string[] | undefined;
    items: VendorDto[] | undefined;
    totalCount: number;
}

export class CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto implements ICustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto {
    errorList!: string[] | undefined;
    items!: WoodPreActivityReportForProviderSearchOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodPreActivityReportForProviderSearchOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICustomPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto {
    errorList: string[] | undefined;
    items: WoodPreActivityReportForProviderSearchOutputDto[] | undefined;
    totalCount: number;
}

export class DeleteArchimedesSampleOutput implements IDeleteArchimedesSampleOutput {
    success!: boolean;
    errorMessage!: string | undefined;

    constructor(data?: IDeleteArchimedesSampleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DeleteArchimedesSampleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteArchimedesSampleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDeleteArchimedesSampleOutput {
    success: boolean;
    errorMessage: string | undefined;
}

export class DeleteScannerResultsOutputDto implements IDeleteScannerResultsOutputDto {
    success!: boolean;
    message!: string | undefined;

    constructor(data?: IDeleteScannerResultsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeleteScannerResultsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScannerResultsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IDeleteScannerResultsOutputDto {
    success: boolean;
    message: string | undefined;
}

export class DensityPerSpeciesGroupDto implements IDensityPerSpeciesGroupDto {
    id!: number;
    speciesGroup!: SpeciesGroupDto;
    minDensity!: number;
    maxDensity!: number;

    constructor(data?: IDensityPerSpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.speciesGroup = _data["speciesGroup"] ? SpeciesGroupDto.fromJS(_data["speciesGroup"]) : <any>undefined;
            this.minDensity = _data["minDensity"];
            this.maxDensity = _data["maxDensity"];
        }
    }

    static fromJS(data: any): DensityPerSpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DensityPerSpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["speciesGroup"] = this.speciesGroup ? this.speciesGroup.toJSON() : <any>undefined;
        data["minDensity"] = this.minDensity;
        data["maxDensity"] = this.maxDensity;
        return data;
    }
}

export interface IDensityPerSpeciesGroupDto {
    id: number;
    speciesGroup: SpeciesGroupDto;
    minDensity: number;
    maxDensity: number;
}

export enum DeviceSystemType {
    SmartAccessWood = 0,
    SmartAccessProducts = 1,
}

export enum DiverseProductActivityReportCreationSystemFilter {
    All = 0,
    SmartTruck = 1,
    ProvidersModule = 2,
    Totem = 3,
}

export class DiverseProductActivityReportDto implements IDiverseProductActivityReportDto {
    origin!: LocationDto;
    destination!: LocationDto;
    activityReportLines!: DiverseProductsActivityReportLineDto[] | undefined;
    serial!: string | undefined;
    customsDeclaration!: SingleCustomDeclarationOutput;
    tareWeight!: WeightDto;
    grossWeight!: WeightDto;
    netWeight!: number;
    activityReportDate!: DateTime;
    entryDate!: DateTime | undefined;
    driver!: DriverDto;
    transport!: VehicleDto;
    vendor!: VendorDto;
    state!: ActivityReportState;
    externalActivityReportId!: number | undefined;
    comment!: string | undefined;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    id!: number;

    constructor(data?: IDiverseProductActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(DiverseProductsActivityReportLineDto.fromJS(item));
            }
            this.serial = _data["serial"];
            this.customsDeclaration = _data["customsDeclaration"] ? SingleCustomDeclarationOutput.fromJS(_data["customsDeclaration"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.transport = _data["transport"] ? VehicleDto.fromJS(_data["transport"]) : <any>undefined;
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.state = _data["state"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.comment = _data["comment"];
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiverseProductActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["serial"] = this.serial;
        data["customsDeclaration"] = this.customsDeclaration ? this.customsDeclaration.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["transport"] = this.transport ? this.transport.toJSON() : <any>undefined;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["comment"] = this.comment;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiverseProductActivityReportDto {
    origin: LocationDto;
    destination: LocationDto;
    activityReportLines: DiverseProductsActivityReportLineDto[] | undefined;
    serial: string | undefined;
    customsDeclaration: SingleCustomDeclarationOutput;
    tareWeight: WeightDto;
    grossWeight: WeightDto;
    netWeight: number;
    activityReportDate: DateTime;
    entryDate: DateTime | undefined;
    driver: DriverDto;
    transport: VehicleDto;
    vendor: VendorDto;
    state: ActivityReportState;
    externalActivityReportId: number | undefined;
    comment: string | undefined;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    id: number;
}

export class DiverseProductPreActivityReportEditionInput implements IDiverseProductPreActivityReportEditionInput {
    newDestination!: LocationDto;
    newDriver!: DriverDto;
    newArticle!: ArticleDiverseProductsDto;
    newDate!: DateTime;
    originExternalId!: number;
    originLocationType!: LocationType;
    id!: number;

    constructor(data?: IDiverseProductPreActivityReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newDestination = _data["newDestination"] ? LocationDto.fromJS(_data["newDestination"]) : <any>undefined;
            this.newDriver = _data["newDriver"] ? DriverDto.fromJS(_data["newDriver"]) : <any>undefined;
            this.newArticle = _data["newArticle"] ? ArticleDiverseProductsDto.fromJS(_data["newArticle"]) : <any>undefined;
            this.newDate = _data["newDate"] ? DateTime.fromISO(_data["newDate"].toString()) : <any>undefined;
            this.originExternalId = _data["originExternalId"];
            this.originLocationType = _data["originLocationType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiverseProductPreActivityReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreActivityReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newDestination"] = this.newDestination ? this.newDestination.toJSON() : <any>undefined;
        data["newDriver"] = this.newDriver ? this.newDriver.toJSON() : <any>undefined;
        data["newArticle"] = this.newArticle ? this.newArticle.toJSON() : <any>undefined;
        data["newDate"] = this.newDate ? this.newDate.toString() : <any>undefined;
        data["originExternalId"] = this.originExternalId;
        data["originLocationType"] = this.originLocationType;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiverseProductPreActivityReportEditionInput {
    newDestination: LocationDto;
    newDriver: DriverDto;
    newArticle: ArticleDiverseProductsDto;
    newDate: DateTime;
    originExternalId: number;
    originLocationType: LocationType;
    id: number;
}

export class DiverseProductPreActivityReportForProviderSearchOutputDto implements IDiverseProductPreActivityReportForProviderSearchOutputDto {
    id!: number;
    driver!: string | undefined;
    licensePlate!: string | undefined;
    origin!: string | undefined;
    destination!: string | undefined;
    validationResult!: PreActivityReportValidation;

    constructor(data?: IDiverseProductPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.driver = _data["driver"];
            this.licensePlate = _data["licensePlate"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.validationResult = _data["validationResult"];
        }
    }

    static fromJS(data: any): DiverseProductPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["driver"] = this.driver;
        data["licensePlate"] = this.licensePlate;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["validationResult"] = this.validationResult;
        return data;
    }
}

export interface IDiverseProductPreActivityReportForProviderSearchOutputDto {
    id: number;
    driver: string | undefined;
    licensePlate: string | undefined;
    origin: string | undefined;
    destination: string | undefined;
    validationResult: PreActivityReportValidation;
}

export class DiverseProductPreReportEntranceRequiredInfoDto implements IDiverseProductPreReportEntranceRequiredInfoDto {
    id!: number;
    validationResult!: PreActivityReportValidation;
    isApproved!: boolean;

    constructor(data?: IDiverseProductPreReportEntranceRequiredInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationResult = _data["validationResult"];
            this.isApproved = _data["isApproved"];
        }
    }

    static fromJS(data: any): DiverseProductPreReportEntranceRequiredInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreReportEntranceRequiredInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationResult"] = this.validationResult;
        data["isApproved"] = this.isApproved;
        return data;
    }
}

export interface IDiverseProductPreReportEntranceRequiredInfoDto {
    id: number;
    validationResult: PreActivityReportValidation;
    isApproved: boolean;
}

export class DiverseProductsActivityReportLineDto implements IDiverseProductsActivityReportLineDto {
    articleDiverseProducts!: ArticleDiverseProductsDto;
    contract!: ContractDto;

    constructor(data?: IDiverseProductsActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleDiverseProducts = _data["articleDiverseProducts"] ? ArticleDiverseProductsDto.fromJS(_data["articleDiverseProducts"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiverseProductsActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductsActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleDiverseProducts"] = this.articleDiverseProducts ? this.articleDiverseProducts.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDiverseProductsActivityReportLineDto {
    articleDiverseProducts: ArticleDiverseProductsDto;
    contract: ContractDto;
}

export class DiverseProductsReportInputDto implements IDiverseProductsReportInputDto {
    destinationId!: number | undefined;
    transportVendorId!: number | undefined;
    driverId!: number | undefined;
    singleCustomsDeclarationExternalId!: number | undefined;
    contractUsageExternalId!: number | undefined;
    includeDeletedOnes!: boolean;
    operationMode!: ActivityReportOperationMode;
    originExternalId!: number | undefined;
    standExternalId!: number | undefined;
    destinationExternalId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IDiverseProductsReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationId = _data["destinationId"];
            this.transportVendorId = _data["transportVendorId"];
            this.driverId = _data["driverId"];
            this.singleCustomsDeclarationExternalId = _data["singleCustomsDeclarationExternalId"];
            this.contractUsageExternalId = _data["contractUsageExternalId"];
            this.includeDeletedOnes = _data["includeDeletedOnes"];
            this.operationMode = _data["operationMode"];
            this.originExternalId = _data["originExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): DiverseProductsReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductsReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationId"] = this.destinationId;
        data["transportVendorId"] = this.transportVendorId;
        data["driverId"] = this.driverId;
        data["singleCustomsDeclarationExternalId"] = this.singleCustomsDeclarationExternalId;
        data["contractUsageExternalId"] = this.contractUsageExternalId;
        data["includeDeletedOnes"] = this.includeDeletedOnes;
        data["operationMode"] = this.operationMode;
        data["originExternalId"] = this.originExternalId;
        data["standExternalId"] = this.standExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IDiverseProductsReportInputDto {
    destinationId: number | undefined;
    transportVendorId: number | undefined;
    driverId: number | undefined;
    singleCustomsDeclarationExternalId: number | undefined;
    contractUsageExternalId: number | undefined;
    includeDeletedOnes: boolean;
    operationMode: ActivityReportOperationMode;
    originExternalId: number | undefined;
    standExternalId: number | undefined;
    destinationExternalId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class DiverseProductsTruckTypeDto implements IDiverseProductsTruckTypeDto {
    maxTonsAllowed!: number;
    resourceType!: ExternalResourceTypeDto;
    id!: number;

    constructor(data?: IDiverseProductsTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxTonsAllowed = _data["maxTonsAllowed"];
            this.resourceType = _data["resourceType"] ? ExternalResourceTypeDto.fromJS(_data["resourceType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiverseProductsTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductsTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxTonsAllowed"] = this.maxTonsAllowed;
        data["resourceType"] = this.resourceType ? this.resourceType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiverseProductsTruckTypeDto {
    maxTonsAllowed: number;
    resourceType: ExternalResourceTypeDto;
    id: number;
}

export class DocumentDto implements IDocumentDto {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IDocumentDto {
    code: string | undefined;
    name: string | undefined;
}

export class DownloadStandServiceDto implements IDownloadStandServiceDto {
    activityId!: number;
    name!: string | undefined;
    vendorId!: number;
    locationId!: number;

    constructor(data?: IDownloadStandServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.name = _data["name"];
            this.vendorId = _data["vendorId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): DownloadStandServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadStandServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["name"] = this.name;
        data["vendorId"] = this.vendorId;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IDownloadStandServiceDto {
    activityId: number;
    name: string | undefined;
    vendorId: number;
    locationId: number;
}

export class DriverAndTruckInput implements IDriverAndTruckInput {
    driverId!: number;
    truckPlate!: string | undefined;
    semisPlates!: string[] | undefined;
    destinationId!: number;

    constructor(data?: IDriverAndTruckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverId = _data["driverId"];
            this.truckPlate = _data["truckPlate"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): DriverAndTruckInput {
        data = typeof data === 'object' ? data : {};
        let result = new DriverAndTruckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverId"] = this.driverId;
        data["truckPlate"] = this.truckPlate;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IDriverAndTruckInput {
    driverId: number;
    truckPlate: string | undefined;
    semisPlates: string[] | undefined;
    destinationId: number;
}

export class DriverDto implements IDriverDto {
    driverLicenseDueDate!: DateTime;
    name!: string | undefined;
    carrier!: string | undefined;
    isActive!: boolean;
    vendorId!: number | undefined;
    identityNumber!: string | undefined;
    isBlockingError!: boolean;
    resourceTypeId!: number;
    id!: number;

    constructor(data?: IDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverLicenseDueDate = _data["driverLicenseDueDate"] ? DateTime.fromISO(_data["driverLicenseDueDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.carrier = _data["carrier"];
            this.isActive = _data["isActive"];
            this.vendorId = _data["vendorId"];
            this.identityNumber = _data["identityNumber"];
            this.isBlockingError = _data["isBlockingError"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new DriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverLicenseDueDate"] = this.driverLicenseDueDate ? this.driverLicenseDueDate.toString() : <any>undefined;
        data["name"] = this.name;
        data["carrier"] = this.carrier;
        data["isActive"] = this.isActive;
        data["vendorId"] = this.vendorId;
        data["identityNumber"] = this.identityNumber;
        data["isBlockingError"] = this.isBlockingError;
        data["resourceTypeId"] = this.resourceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDriverDto {
    driverLicenseDueDate: DateTime;
    name: string | undefined;
    carrier: string | undefined;
    isActive: boolean;
    vendorId: number | undefined;
    identityNumber: string | undefined;
    isBlockingError: boolean;
    resourceTypeId: number;
    id: number;
}

export class DriverInputDto implements IDriverInputDto {
    id!: number;
    name!: string | undefined;
    isActive!: boolean;
    vendorId!: number | undefined;
    identityNumber!: string | undefined;

    constructor(data?: IDriverInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.vendorId = _data["vendorId"];
            this.identityNumber = _data["identityNumber"];
        }
    }

    static fromJS(data: any): DriverInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DriverInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["vendorId"] = this.vendorId;
        data["identityNumber"] = this.identityNumber;
        return data;
    }
}

export interface IDriverInputDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
    vendorId: number | undefined;
    identityNumber: string | undefined;
}

export class DriverOutputDto implements IDriverOutputDto {
    errorList!: string[] | undefined;
    isBlockingError!: boolean;
    driver!: DriverDto;

    constructor(data?: IDriverOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.isBlockingError = _data["isBlockingError"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DriverOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DriverOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["isBlockingError"] = this.isBlockingError;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDriverOutputDto {
    errorList: string[] | undefined;
    isBlockingError: boolean;
    driver: DriverDto;
}

export class DriverStatusOutput implements IDriverStatusOutput {
    isValid!: boolean;
    reason!: string | undefined;

    constructor(data?: IDriverStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DriverStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DriverStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IDriverStatusOutput {
    isValid: boolean;
    reason: string | undefined;
}

export class EditActivityReportInput implements IEditActivityReportInput {
    reportId!: number;
    destinationId!: number;
    destinationType!: LocationType;
    externalActivityReportId!: number | undefined;
    newOriginId!: number | undefined;
    newOriginType!: LocationType;
    newLines!: EditActivityReportLineInput[] | undefined;
    newDriver!: number | undefined;
    chipHumidity!: number | undefined;
    manualChipSampleAssignmentComment!: string | undefined;
    chipSampleDeletionComment!: string | undefined;
    newBarkSample!: BarkSampleEditionDto;
    isNullifyingBarkSample!: boolean;
    newTransport!: VehicleDto;
    newTripNumber!: number | undefined;
    newTareWeight!: WeightDto;
    noSamplingReasonId!: number | undefined;
    noSamplingReasonComment!: string | undefined;
    newInternalDestination!: number | undefined;
    newComment!: string | undefined;
    newSerial!: string | undefined;
    newNumber!: number | undefined;
    scannerAbortedSpeedResultReasonId!: number | undefined;
    scannerAbortedSpeedResultReasonComment!: string | undefined;
    shouldDeleteScannerMeasurementData!: boolean;

    constructor(data?: IEditActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.newOriginId = _data["newOriginId"];
            this.newOriginType = _data["newOriginType"];
            if (Array.isArray(_data["newLines"])) {
                this.newLines = [] as any;
                for (let item of _data["newLines"])
                    this.newLines!.push(EditActivityReportLineInput.fromJS(item));
            }
            this.newDriver = _data["newDriver"];
            this.chipHumidity = _data["chipHumidity"];
            this.manualChipSampleAssignmentComment = _data["manualChipSampleAssignmentComment"];
            this.chipSampleDeletionComment = _data["chipSampleDeletionComment"];
            this.newBarkSample = _data["newBarkSample"] ? BarkSampleEditionDto.fromJS(_data["newBarkSample"]) : <any>undefined;
            this.isNullifyingBarkSample = _data["isNullifyingBarkSample"];
            this.newTransport = _data["newTransport"] ? VehicleDto.fromJS(_data["newTransport"]) : <any>undefined;
            this.newTripNumber = _data["newTripNumber"];
            this.newTareWeight = _data["newTareWeight"] ? WeightDto.fromJS(_data["newTareWeight"]) : <any>undefined;
            this.noSamplingReasonId = _data["noSamplingReasonId"];
            this.noSamplingReasonComment = _data["noSamplingReasonComment"];
            this.newInternalDestination = _data["newInternalDestination"];
            this.newComment = _data["newComment"];
            this.newSerial = _data["newSerial"];
            this.newNumber = _data["newNumber"];
            this.scannerAbortedSpeedResultReasonId = _data["scannerAbortedSpeedResultReasonId"];
            this.scannerAbortedSpeedResultReasonComment = _data["scannerAbortedSpeedResultReasonComment"];
            this.shouldDeleteScannerMeasurementData = _data["shouldDeleteScannerMeasurementData"];
        }
    }

    static fromJS(data: any): EditActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["newOriginId"] = this.newOriginId;
        data["newOriginType"] = this.newOriginType;
        if (Array.isArray(this.newLines)) {
            data["newLines"] = [];
            for (let item of this.newLines)
                data["newLines"].push(item.toJSON());
        }
        data["newDriver"] = this.newDriver;
        data["chipHumidity"] = this.chipHumidity;
        data["manualChipSampleAssignmentComment"] = this.manualChipSampleAssignmentComment;
        data["chipSampleDeletionComment"] = this.chipSampleDeletionComment;
        data["newBarkSample"] = this.newBarkSample ? this.newBarkSample.toJSON() : <any>undefined;
        data["isNullifyingBarkSample"] = this.isNullifyingBarkSample;
        data["newTransport"] = this.newTransport ? this.newTransport.toJSON() : <any>undefined;
        data["newTripNumber"] = this.newTripNumber;
        data["newTareWeight"] = this.newTareWeight ? this.newTareWeight.toJSON() : <any>undefined;
        data["noSamplingReasonId"] = this.noSamplingReasonId;
        data["noSamplingReasonComment"] = this.noSamplingReasonComment;
        data["newInternalDestination"] = this.newInternalDestination;
        data["newComment"] = this.newComment;
        data["newSerial"] = this.newSerial;
        data["newNumber"] = this.newNumber;
        data["scannerAbortedSpeedResultReasonId"] = this.scannerAbortedSpeedResultReasonId;
        data["scannerAbortedSpeedResultReasonComment"] = this.scannerAbortedSpeedResultReasonComment;
        data["shouldDeleteScannerMeasurementData"] = this.shouldDeleteScannerMeasurementData;
        return data;
    }
}

export interface IEditActivityReportInput {
    reportId: number;
    destinationId: number;
    destinationType: LocationType;
    externalActivityReportId: number | undefined;
    newOriginId: number | undefined;
    newOriginType: LocationType;
    newLines: EditActivityReportLineInput[] | undefined;
    newDriver: number | undefined;
    chipHumidity: number | undefined;
    manualChipSampleAssignmentComment: string | undefined;
    chipSampleDeletionComment: string | undefined;
    newBarkSample: BarkSampleEditionDto;
    isNullifyingBarkSample: boolean;
    newTransport: VehicleDto;
    newTripNumber: number | undefined;
    newTareWeight: WeightDto;
    noSamplingReasonId: number | undefined;
    noSamplingReasonComment: string | undefined;
    newInternalDestination: number | undefined;
    newComment: string | undefined;
    newSerial: string | undefined;
    newNumber: number | undefined;
    scannerAbortedSpeedResultReasonId: number | undefined;
    scannerAbortedSpeedResultReasonComment: string | undefined;
    shouldDeleteScannerMeasurementData: boolean;
}

export class EditActivityReportLineInput implements IEditActivityReportLineInput {
    lineId!: number;
    newStandId!: number | undefined;
    newLoadingServiceVendor!: number | undefined;
    newCutServiceVendor!: number | undefined;
    newExtractionServiceVendor!: number | undefined;
    newPefcCertification!: boolean | undefined;
    newArticleId!: number | undefined;
    newPileId!: number | undefined;

    constructor(data?: IEditActivityReportLineInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.newStandId = _data["newStandId"];
            this.newLoadingServiceVendor = _data["newLoadingServiceVendor"];
            this.newCutServiceVendor = _data["newCutServiceVendor"];
            this.newExtractionServiceVendor = _data["newExtractionServiceVendor"];
            this.newPefcCertification = _data["newPefcCertification"];
            this.newArticleId = _data["newArticleId"];
            this.newPileId = _data["newPileId"];
        }
    }

    static fromJS(data: any): EditActivityReportLineInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityReportLineInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["newStandId"] = this.newStandId;
        data["newLoadingServiceVendor"] = this.newLoadingServiceVendor;
        data["newCutServiceVendor"] = this.newCutServiceVendor;
        data["newExtractionServiceVendor"] = this.newExtractionServiceVendor;
        data["newPefcCertification"] = this.newPefcCertification;
        data["newArticleId"] = this.newArticleId;
        data["newPileId"] = this.newPileId;
        return data;
    }
}

export interface IEditActivityReportLineInput {
    lineId: number;
    newStandId: number | undefined;
    newLoadingServiceVendor: number | undefined;
    newCutServiceVendor: number | undefined;
    newExtractionServiceVendor: number | undefined;
    newPefcCertification: boolean | undefined;
    newArticleId: number | undefined;
    newPileId: number | undefined;
}

export class EditActivityReportOutput implements IEditActivityReportOutput {
    isSuccess!: boolean;
    errors!: string | undefined;
    stateChanged!: boolean;

    constructor(data?: IEditActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.errors = _data["errors"];
            this.stateChanged = _data["stateChanged"];
        }
    }

    static fromJS(data: any): EditActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["errors"] = this.errors;
        data["stateChanged"] = this.stateChanged;
        return data;
    }
}

export interface IEditActivityReportOutput {
    isSuccess: boolean;
    errors: string | undefined;
    stateChanged: boolean;
}

export class EditDiverseProductsInput implements IEditDiverseProductsInput {
    reportId!: number;
    newDestinationId!: number | undefined;
    newDestinationType!: LocationType;
    newArticleId!: number | undefined;
    newSingleCustomDeclaration!: number | undefined;
    date!: DateTime | undefined;
    newVehicleId!: number | undefined;
    newVendorId!: number | undefined;
    newDriverId!: number | undefined;
    externalActivityReportId!: number | undefined;
    licensePlate!: string | undefined;
    grossWeight!: WeightDto;
    comment!: string | undefined;

    constructor(data?: IEditDiverseProductsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.newDestinationId = _data["newDestinationId"];
            this.newDestinationType = _data["newDestinationType"];
            this.newArticleId = _data["newArticleId"];
            this.newSingleCustomDeclaration = _data["newSingleCustomDeclaration"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.newVehicleId = _data["newVehicleId"];
            this.newVendorId = _data["newVendorId"];
            this.newDriverId = _data["newDriverId"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.licensePlate = _data["licensePlate"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): EditDiverseProductsInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditDiverseProductsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["newDestinationId"] = this.newDestinationId;
        data["newDestinationType"] = this.newDestinationType;
        data["newArticleId"] = this.newArticleId;
        data["newSingleCustomDeclaration"] = this.newSingleCustomDeclaration;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["newVehicleId"] = this.newVehicleId;
        data["newVendorId"] = this.newVendorId;
        data["newDriverId"] = this.newDriverId;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["licensePlate"] = this.licensePlate;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IEditDiverseProductsInput {
    reportId: number;
    newDestinationId: number | undefined;
    newDestinationType: LocationType;
    newArticleId: number | undefined;
    newSingleCustomDeclaration: number | undefined;
    date: DateTime | undefined;
    newVehicleId: number | undefined;
    newVendorId: number | undefined;
    newDriverId: number | undefined;
    externalActivityReportId: number | undefined;
    licensePlate: string | undefined;
    grossWeight: WeightDto;
    comment: string | undefined;
}

export class EditPolygonContractInputDto implements IEditPolygonContractInputDto {
    polygonContractId!: number;
    isActive!: boolean;
    emails!: string[] | undefined;

    constructor(data?: IEditPolygonContractInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polygonContractId = _data["polygonContractId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): EditPolygonContractInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPolygonContractInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polygonContractId"] = this.polygonContractId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IEditPolygonContractInputDto {
    polygonContractId: number;
    isActive: boolean;
    emails: string[] | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class ExecuteEntryProcessByRfidInputDto implements IExecuteEntryProcessByRfidInputDto {
    tagValueDetected!: number;
    rfidDeviceId!: number;
    zoneId!: number;
    placeId!: number;
    externalPlaceId!: number;
    tenantId!: number;
    flowType!: TruckFlowType;
    deviceSystemType!: DeviceSystemType;
    isLandfillEntry!: boolean;

    constructor(data?: IExecuteEntryProcessByRfidInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagValueDetected = _data["tagValueDetected"];
            this.rfidDeviceId = _data["rfidDeviceId"];
            this.zoneId = _data["zoneId"];
            this.placeId = _data["placeId"];
            this.externalPlaceId = _data["externalPlaceId"];
            this.tenantId = _data["tenantId"];
            this.flowType = _data["flowType"];
            this.deviceSystemType = _data["deviceSystemType"];
            this.isLandfillEntry = _data["isLandfillEntry"];
        }
    }

    static fromJS(data: any): ExecuteEntryProcessByRfidInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteEntryProcessByRfidInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagValueDetected"] = this.tagValueDetected;
        data["rfidDeviceId"] = this.rfidDeviceId;
        data["zoneId"] = this.zoneId;
        data["placeId"] = this.placeId;
        data["externalPlaceId"] = this.externalPlaceId;
        data["tenantId"] = this.tenantId;
        data["flowType"] = this.flowType;
        data["deviceSystemType"] = this.deviceSystemType;
        data["isLandfillEntry"] = this.isLandfillEntry;
        return data;
    }
}

export interface IExecuteEntryProcessByRfidInputDto {
    tagValueDetected: number;
    rfidDeviceId: number;
    zoneId: number;
    placeId: number;
    externalPlaceId: number;
    tenantId: number;
    flowType: TruckFlowType;
    deviceSystemType: DeviceSystemType;
    isLandfillEntry: boolean;
}

export class ExecuteMassEditInputDto implements IExecuteMassEditInputDto {
    reportIds!: number[] | undefined;
    newOriginId!: number | undefined;
    newOriginType!: LocationType;
    newStandId!: number | undefined;
    newArticleId!: number | undefined;
    newPefcCertification!: boolean | undefined;
    newLoaderId!: number | undefined;
    newCutId!: number | undefined;
    newExtractionId!: number | undefined;
    oldOriginId!: number;
    oldOriginType!: LocationType;
    oldStandId!: number;
    oldArticleId!: number;
    reason!: string | undefined;
    destinationId!: number;
    oldPileId!: number | undefined;
    newPileId!: number | undefined;
    newPileName!: string | undefined;

    constructor(data?: IExecuteMassEditInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds!.push(item);
            }
            this.newOriginId = _data["newOriginId"];
            this.newOriginType = _data["newOriginType"];
            this.newStandId = _data["newStandId"];
            this.newArticleId = _data["newArticleId"];
            this.newPefcCertification = _data["newPefcCertification"];
            this.newLoaderId = _data["newLoaderId"];
            this.newCutId = _data["newCutId"];
            this.newExtractionId = _data["newExtractionId"];
            this.oldOriginId = _data["oldOriginId"];
            this.oldOriginType = _data["oldOriginType"];
            this.oldStandId = _data["oldStandId"];
            this.oldArticleId = _data["oldArticleId"];
            this.reason = _data["reason"];
            this.destinationId = _data["destinationId"];
            this.oldPileId = _data["oldPileId"];
            this.newPileId = _data["newPileId"];
            this.newPileName = _data["newPileName"];
        }
    }

    static fromJS(data: any): ExecuteMassEditInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteMassEditInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        data["newOriginId"] = this.newOriginId;
        data["newOriginType"] = this.newOriginType;
        data["newStandId"] = this.newStandId;
        data["newArticleId"] = this.newArticleId;
        data["newPefcCertification"] = this.newPefcCertification;
        data["newLoaderId"] = this.newLoaderId;
        data["newCutId"] = this.newCutId;
        data["newExtractionId"] = this.newExtractionId;
        data["oldOriginId"] = this.oldOriginId;
        data["oldOriginType"] = this.oldOriginType;
        data["oldStandId"] = this.oldStandId;
        data["oldArticleId"] = this.oldArticleId;
        data["reason"] = this.reason;
        data["destinationId"] = this.destinationId;
        data["oldPileId"] = this.oldPileId;
        data["newPileId"] = this.newPileId;
        data["newPileName"] = this.newPileName;
        return data;
    }
}

export interface IExecuteMassEditInputDto {
    reportIds: number[] | undefined;
    newOriginId: number | undefined;
    newOriginType: LocationType;
    newStandId: number | undefined;
    newArticleId: number | undefined;
    newPefcCertification: boolean | undefined;
    newLoaderId: number | undefined;
    newCutId: number | undefined;
    newExtractionId: number | undefined;
    oldOriginId: number;
    oldOriginType: LocationType;
    oldStandId: number;
    oldArticleId: number;
    reason: string | undefined;
    destinationId: number;
    oldPileId: number | undefined;
    newPileId: number | undefined;
    newPileName: string | undefined;
}

export class ExecuteMassEditOutputDto implements IExecuteMassEditOutputDto {
    succeeded!: boolean;
    errorMessage!: string | undefined;
    massEditId!: string;

    constructor(data?: IExecuteMassEditOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.errorMessage = _data["errorMessage"];
            this.massEditId = _data["massEditId"];
        }
    }

    static fromJS(data: any): ExecuteMassEditOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteMassEditOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["errorMessage"] = this.errorMessage;
        data["massEditId"] = this.massEditId;
        return data;
    }
}

export interface IExecuteMassEditOutputDto {
    succeeded: boolean;
    errorMessage: string | undefined;
    massEditId: string;
}

export class ExistSmartTripsTripInput implements IExistSmartTripsTripInput {
    truckPlate!: string | undefined;
    destinationId!: number;

    constructor(data?: IExistSmartTripsTripInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlate = _data["truckPlate"];
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): ExistSmartTripsTripInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExistSmartTripsTripInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlate"] = this.truckPlate;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IExistSmartTripsTripInput {
    truckPlate: string | undefined;
    destinationId: number;
}

export class ExistSmartTripsTripOutput implements IExistSmartTripsTripOutput {
    tripFound!: boolean;
    travelNumber!: number;
    origin!: LocationDto;
    destination!: LocationDto;

    constructor(data?: IExistSmartTripsTripOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripFound = _data["tripFound"];
            this.travelNumber = _data["travelNumber"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExistSmartTripsTripOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExistSmartTripsTripOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripFound"] = this.tripFound;
        data["travelNumber"] = this.travelNumber;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExistSmartTripsTripOutput {
    tripFound: boolean;
    travelNumber: number;
    origin: LocationDto;
    destination: LocationDto;
}

export class ExistsPreActivityReportResultOutput implements IExistsPreActivityReportResultOutput {
    exists!: boolean;
    activityReportId!: number;
    belongsToUser!: boolean;
    activityReportPlaceId!: number;
    originDestinationExternalId!: number;
    originDestinationType!: LocationType;
    originDestinationName!: string | undefined;
    isProductsFlow!: boolean;

    constructor(data?: IExistsPreActivityReportResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.activityReportId = _data["activityReportId"];
            this.belongsToUser = _data["belongsToUser"];
            this.activityReportPlaceId = _data["activityReportPlaceId"];
            this.originDestinationExternalId = _data["originDestinationExternalId"];
            this.originDestinationType = _data["originDestinationType"];
            this.originDestinationName = _data["originDestinationName"];
            this.isProductsFlow = _data["isProductsFlow"];
        }
    }

    static fromJS(data: any): ExistsPreActivityReportResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExistsPreActivityReportResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["activityReportId"] = this.activityReportId;
        data["belongsToUser"] = this.belongsToUser;
        data["activityReportPlaceId"] = this.activityReportPlaceId;
        data["originDestinationExternalId"] = this.originDestinationExternalId;
        data["originDestinationType"] = this.originDestinationType;
        data["originDestinationName"] = this.originDestinationName;
        data["isProductsFlow"] = this.isProductsFlow;
        return data;
    }
}

export interface IExistsPreActivityReportResultOutput {
    exists: boolean;
    activityReportId: number;
    belongsToUser: boolean;
    activityReportPlaceId: number;
    originDestinationExternalId: number;
    originDestinationType: LocationType;
    originDestinationName: string | undefined;
    isProductsFlow: boolean;
}

export class ExternalResourceTypeDto implements IExternalResourceTypeDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IExternalResourceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExternalResourceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalResourceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IExternalResourceTypeDto {
    name: string | undefined;
    id: number;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class ForceWoodActivityReportExitOutput implements IForceWoodActivityReportExitOutput {
    editionSuccessfull!: boolean;
    integrationsSuccessfull!: boolean;
    errors!: string | undefined;

    constructor(data?: IForceWoodActivityReportExitOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionSuccessfull = _data["editionSuccessfull"];
            this.integrationsSuccessfull = _data["integrationsSuccessfull"];
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): ForceWoodActivityReportExitOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ForceWoodActivityReportExitOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionSuccessfull"] = this.editionSuccessfull;
        data["integrationsSuccessfull"] = this.integrationsSuccessfull;
        data["errors"] = this.errors;
        return data;
    }
}

export interface IForceWoodActivityReportExitOutput {
    editionSuccessfull: boolean;
    integrationsSuccessfull: boolean;
    errors: string | undefined;
}

export class FullWoodPreActivityReportLineDto implements IFullWoodPreActivityReportLineDto {
    contract!: ContractDto;
    vendor!: VendorDto;
    isPefcCertified!: boolean | undefined;
    loaderServiceVendor!: VendorDto;
    stand!: StandOutputDto;
    article!: ArticleDtoOutput;
    origin!: LocationDto;
    readonly isChip!: boolean;
    pileName!: string | undefined;

    constructor(data?: IFullWoodPreActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.isPefcCertified = _data["isPefcCertified"];
            this.loaderServiceVendor = _data["loaderServiceVendor"] ? VendorDto.fromJS(_data["loaderServiceVendor"]) : <any>undefined;
            this.stand = _data["stand"] ? StandOutputDto.fromJS(_data["stand"]) : <any>undefined;
            this.article = _data["article"] ? ArticleDtoOutput.fromJS(_data["article"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            (<any>this).isChip = _data["isChip"];
            this.pileName = _data["pileName"];
        }
    }

    static fromJS(data: any): FullWoodPreActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullWoodPreActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["isPefcCertified"] = this.isPefcCertified;
        data["loaderServiceVendor"] = this.loaderServiceVendor ? this.loaderServiceVendor.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["pileName"] = this.pileName;
        return data;
    }
}

export interface IFullWoodPreActivityReportLineDto {
    contract: ContractDto;
    vendor: VendorDto;
    isPefcCertified: boolean | undefined;
    loaderServiceVendor: VendorDto;
    stand: StandOutputDto;
    article: ArticleDtoOutput;
    origin: LocationDto;
    isChip: boolean;
    pileName: string | undefined;
}

export class FuncOfIServiceProviderIHealthCheck implements IFuncOfIServiceProviderIHealthCheck {
    readonly hasSingleTarget!: boolean;
    readonly target!: any | undefined;
    method!: MethodInfo;

    constructor(data?: IFuncOfIServiceProviderIHealthCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).hasSingleTarget = _data["hasSingleTarget"];
            (<any>this).target = _data["target"];
            this.method = _data["method"] ? MethodInfo.fromJS(_data["method"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FuncOfIServiceProviderIHealthCheck {
        data = typeof data === 'object' ? data : {};
        let result = new FuncOfIServiceProviderIHealthCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSingleTarget"] = this.hasSingleTarget;
        data["target"] = this.target;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFuncOfIServiceProviderIHealthCheck {
    hasSingleTarget: boolean;
    target: any | undefined;
    method: MethodInfo;
}

export class GeneticMaterialTypeDto implements IGeneticMaterialTypeDto {
    id!: number;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IGeneticMaterialTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GeneticMaterialTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneticMaterialTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IGeneticMaterialTypeDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class GetAllPaysTransportOutputDto implements IGetAllPaysTransportOutputDto {
    locationId!: number;
    paysTransport!: boolean;

    constructor(data?: IGetAllPaysTransportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.paysTransport = _data["paysTransport"];
        }
    }

    static fromJS(data: any): GetAllPaysTransportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaysTransportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["paysTransport"] = this.paysTransport;
        return data;
    }
}

export interface IGetAllPaysTransportOutputDto {
    locationId: number;
    paysTransport: boolean;
}

export class GetAvailableTurnsOutput implements IGetAvailableTurnsOutput {
    availableTurns!: AvailableTurnTimeDto[] | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IGetAvailableTurnsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableTurns"])) {
                this.availableTurns = [] as any;
                for (let item of _data["availableTurns"])
                    this.availableTurns!.push(AvailableTurnTimeDto.fromJS(item));
            }
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAvailableTurnsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableTurnsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableTurns)) {
            data["availableTurns"] = [];
            for (let item of this.availableTurns)
                data["availableTurns"].push(item.toJSON());
        }
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IGetAvailableTurnsOutput {
    availableTurns: AvailableTurnTimeDto[] | undefined;
    errorList: string[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetLoaderVendorsForStandsOutput implements IGetLoaderVendorsForStandsOutput {
    loaderVendors!: VendorDto[] | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IGetLoaderVendorsForStandsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["loaderVendors"])) {
                this.loaderVendors = [] as any;
                for (let item of _data["loaderVendors"])
                    this.loaderVendors!.push(VendorDto.fromJS(item));
            }
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLoaderVendorsForStandsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoaderVendorsForStandsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.loaderVendors)) {
            data["loaderVendors"] = [];
            for (let item of this.loaderVendors)
                data["loaderVendors"].push(item.toJSON());
        }
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IGetLoaderVendorsForStandsOutput {
    loaderVendors: VendorDto[] | undefined;
    errorList: string[] | undefined;
}

export class GetWoodPreReportToArriveOutputDto implements IGetWoodPreReportToArriveOutputDto {
    travelNumber!: number;
    reportId!: number;
    driverName!: string | undefined;
    truckPlate!: string | undefined;
    typeOfTruck!: string | undefined;
    transportCompanyName!: string | undefined;
    volume!: number;
    species!: string | undefined;
    destinationId!: number;
    destinationName!: string | undefined;
    lengthId!: number;
    readonly estimatedTimeCharge!: number;
    arrivedDateTime!: DateTime;
    originId!: number;
    volumePerTree!: number;
    originLocationType!: LocationType;
    speciesId!: number;
    speciesCode!: string | undefined;
    isTritrain!: boolean;
    standName!: string | undefined;
    standId!: number;

    constructor(data?: IGetWoodPreReportToArriveOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.travelNumber = _data["travelNumber"];
            this.reportId = _data["reportId"];
            this.driverName = _data["driverName"];
            this.truckPlate = _data["truckPlate"];
            this.typeOfTruck = _data["typeOfTruck"];
            this.transportCompanyName = _data["transportCompanyName"];
            this.volume = _data["volume"];
            this.species = _data["species"];
            this.destinationId = _data["destinationId"];
            this.destinationName = _data["destinationName"];
            this.lengthId = _data["lengthId"];
            (<any>this).estimatedTimeCharge = _data["estimatedTimeCharge"];
            this.arrivedDateTime = _data["arrivedDateTime"] ? DateTime.fromISO(_data["arrivedDateTime"].toString()) : <any>undefined;
            this.originId = _data["originId"];
            this.volumePerTree = _data["volumePerTree"];
            this.originLocationType = _data["originLocationType"];
            this.speciesId = _data["speciesId"];
            this.speciesCode = _data["speciesCode"];
            this.isTritrain = _data["isTritrain"];
            this.standName = _data["standName"];
            this.standId = _data["standId"];
        }
    }

    static fromJS(data: any): GetWoodPreReportToArriveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWoodPreReportToArriveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelNumber"] = this.travelNumber;
        data["reportId"] = this.reportId;
        data["driverName"] = this.driverName;
        data["truckPlate"] = this.truckPlate;
        data["typeOfTruck"] = this.typeOfTruck;
        data["transportCompanyName"] = this.transportCompanyName;
        data["volume"] = this.volume;
        data["species"] = this.species;
        data["destinationId"] = this.destinationId;
        data["destinationName"] = this.destinationName;
        data["lengthId"] = this.lengthId;
        data["estimatedTimeCharge"] = this.estimatedTimeCharge;
        data["arrivedDateTime"] = this.arrivedDateTime ? this.arrivedDateTime.toString() : <any>undefined;
        data["originId"] = this.originId;
        data["volumePerTree"] = this.volumePerTree;
        data["originLocationType"] = this.originLocationType;
        data["speciesId"] = this.speciesId;
        data["speciesCode"] = this.speciesCode;
        data["isTritrain"] = this.isTritrain;
        data["standName"] = this.standName;
        data["standId"] = this.standId;
        return data;
    }
}

export interface IGetWoodPreReportToArriveOutputDto {
    travelNumber: number;
    reportId: number;
    driverName: string | undefined;
    truckPlate: string | undefined;
    typeOfTruck: string | undefined;
    transportCompanyName: string | undefined;
    volume: number;
    species: string | undefined;
    destinationId: number;
    destinationName: string | undefined;
    lengthId: number;
    estimatedTimeCharge: number;
    arrivedDateTime: DateTime;
    originId: number;
    volumePerTree: number;
    originLocationType: LocationType;
    speciesId: number;
    speciesCode: string | undefined;
    isTritrain: boolean;
    standName: string | undefined;
    standId: number;
}

export class GrossWeightOutsideToleranceInput implements IGrossWeightOutsideToleranceInput {
    tripNumber!: number | undefined;
    currentGrossWeight!: number;
    currentPlaceId!: number;
    licensePlate!: string | undefined;
    originId!: number;

    constructor(data?: IGrossWeightOutsideToleranceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripNumber = _data["tripNumber"];
            this.currentGrossWeight = _data["currentGrossWeight"];
            this.currentPlaceId = _data["currentPlaceId"];
            this.licensePlate = _data["licensePlate"];
            this.originId = _data["originId"];
        }
    }

    static fromJS(data: any): GrossWeightOutsideToleranceInput {
        data = typeof data === 'object' ? data : {};
        let result = new GrossWeightOutsideToleranceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripNumber"] = this.tripNumber;
        data["currentGrossWeight"] = this.currentGrossWeight;
        data["currentPlaceId"] = this.currentPlaceId;
        data["licensePlate"] = this.licensePlate;
        data["originId"] = this.originId;
        return data;
    }
}

export interface IGrossWeightOutsideToleranceInput {
    tripNumber: number | undefined;
    currentGrossWeight: number;
    currentPlaceId: number;
    licensePlate: string | undefined;
    originId: number;
}

export class GrossWeightOutsideToleranceOutput implements IGrossWeightOutsideToleranceOutput {
    isValid!: boolean;
    errorMessage!: string | undefined;
    isMissingActivityReportExit!: boolean;
    exitActivityReportGrossWeight!: number;
    exitActivityReportPlaceId!: number;

    constructor(data?: IGrossWeightOutsideToleranceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.errorMessage = _data["errorMessage"];
            this.isMissingActivityReportExit = _data["isMissingActivityReportExit"];
            this.exitActivityReportGrossWeight = _data["exitActivityReportGrossWeight"];
            this.exitActivityReportPlaceId = _data["exitActivityReportPlaceId"];
        }
    }

    static fromJS(data: any): GrossWeightOutsideToleranceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GrossWeightOutsideToleranceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        data["isMissingActivityReportExit"] = this.isMissingActivityReportExit;
        data["exitActivityReportGrossWeight"] = this.exitActivityReportGrossWeight;
        data["exitActivityReportPlaceId"] = this.exitActivityReportPlaceId;
        return data;
    }
}

export interface IGrossWeightOutsideToleranceOutput {
    isValid: boolean;
    errorMessage: string | undefined;
    isMissingActivityReportExit: boolean;
    exitActivityReportGrossWeight: number;
    exitActivityReportPlaceId: number;
}

export class HarvestStandServiceDto implements IHarvestStandServiceDto {
    activityId!: number;
    name!: string | undefined;
    vendorId!: number;
    standId!: number;

    constructor(data?: IHarvestStandServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.name = _data["name"];
            this.vendorId = _data["vendorId"];
            this.standId = _data["standId"];
        }
    }

    static fromJS(data: any): HarvestStandServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HarvestStandServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["name"] = this.name;
        data["vendorId"] = this.vendorId;
        data["standId"] = this.standId;
        return data;
    }
}

export interface IHarvestStandServiceDto {
    activityId: number;
    name: string | undefined;
    vendorId: number;
    standId: number;
}

export class HealthCheckContext implements IHealthCheckContext {
    registration!: HealthCheckRegistration;

    constructor(data?: IHealthCheckContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registration = _data["registration"] ? HealthCheckRegistration.fromJS(_data["registration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthCheckContext {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthCheckContext {
    registration: HealthCheckRegistration;
}

export class HealthCheckRegistration implements IHealthCheckRegistration {
    factory!: FuncOfIServiceProviderIHealthCheck;
    failureStatus!: HealthStatus;
    timeout!: string;
    delay!: string | undefined;
    period!: string | undefined;
    name!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IHealthCheckRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? FuncOfIServiceProviderIHealthCheck.fromJS(_data["factory"]) : <any>undefined;
            this.failureStatus = _data["failureStatus"];
            this.timeout = _data["timeout"];
            this.delay = _data["delay"];
            this.period = _data["period"];
            this.name = _data["name"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): HealthCheckRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["failureStatus"] = this.failureStatus;
        data["timeout"] = this.timeout;
        data["delay"] = this.delay;
        data["period"] = this.period;
        data["name"] = this.name;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IHealthCheckRegistration {
    factory: FuncOfIServiceProviderIHealthCheck;
    failureStatus: HealthStatus;
    timeout: string;
    delay: string | undefined;
    period: string | undefined;
    name: string | undefined;
    tags: string[] | undefined;
}

export class HealthCheckResult implements IHealthCheckResult {
    data!: { [key: string]: any; } | undefined;
    description!: string | undefined;
    exception!: any | undefined;
    status!: HealthStatus;

    constructor(data?: IHealthCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.description = _data["description"];
            this.exception = _data["exception"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HealthCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["description"] = this.description;
        data["exception"] = this.exception;
        data["status"] = this.status;
        return data;
    }
}

export interface IHealthCheckResult {
    data: { [key: string]: any; } | undefined;
    description: string | undefined;
    exception: any | undefined;
    status: HealthStatus;
}

export enum HealthStatus {
    Unhealthy = 0,
    Degraded = 1,
    Healthy = 2,
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class IntegrationLogOutputDto implements IIntegrationLogOutputDto {
    exceptionAnOcurred!: boolean;
    integrationName!: string | undefined;
    activityReportId!: number;
    dateSent!: DateTime;
    objectSent!: string | undefined;
    dateReceived!: DateTime;
    objectReceived!: string | undefined;

    constructor(data?: IIntegrationLogOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exceptionAnOcurred = _data["exceptionAnOcurred"];
            this.integrationName = _data["integrationName"];
            this.activityReportId = _data["activityReportId"];
            this.dateSent = _data["dateSent"] ? DateTime.fromISO(_data["dateSent"].toString()) : <any>undefined;
            this.objectSent = _data["objectSent"];
            this.dateReceived = _data["dateReceived"] ? DateTime.fromISO(_data["dateReceived"].toString()) : <any>undefined;
            this.objectReceived = _data["objectReceived"];
        }
    }

    static fromJS(data: any): IntegrationLogOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationLogOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionAnOcurred"] = this.exceptionAnOcurred;
        data["integrationName"] = this.integrationName;
        data["activityReportId"] = this.activityReportId;
        data["dateSent"] = this.dateSent ? this.dateSent.toString() : <any>undefined;
        data["objectSent"] = this.objectSent;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toString() : <any>undefined;
        data["objectReceived"] = this.objectReceived;
        return data;
    }
}

export interface IIntegrationLogOutputDto {
    exceptionAnOcurred: boolean;
    integrationName: string | undefined;
    activityReportId: number;
    dateSent: DateTime;
    objectSent: string | undefined;
    dateReceived: DateTime;
    objectReceived: string | undefined;
}

export class IntegrationResultOutputDto implements IIntegrationResultOutputDto {
    message!: string | undefined;
    integrationId!: number;
    executed!: boolean;
    success!: boolean;

    constructor(data?: IIntegrationResultOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.integrationId = _data["integrationId"];
            this.executed = _data["executed"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): IntegrationResultOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationResultOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["integrationId"] = this.integrationId;
        data["executed"] = this.executed;
        data["success"] = this.success;
        return data;
    }
}

export interface IIntegrationResultOutputDto {
    message: string | undefined;
    integrationId: number;
    executed: boolean;
    success: boolean;
}

export class InternalMovementPreActivityReportEditionInput implements IInternalMovementPreActivityReportEditionInput {
    id!: number;
    newDriver!: DriverDto;
    newArticle!: ArticleInternalMovementDto;
    newDate!: DateTime;

    constructor(data?: IInternalMovementPreActivityReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newDriver = _data["newDriver"] ? DriverDto.fromJS(_data["newDriver"]) : <any>undefined;
            this.newArticle = _data["newArticle"] ? ArticleInternalMovementDto.fromJS(_data["newArticle"]) : <any>undefined;
            this.newDate = _data["newDate"] ? DateTime.fromISO(_data["newDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalMovementPreActivityReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementPreActivityReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newDriver"] = this.newDriver ? this.newDriver.toJSON() : <any>undefined;
        data["newArticle"] = this.newArticle ? this.newArticle.toJSON() : <any>undefined;
        data["newDate"] = this.newDate ? this.newDate.toString() : <any>undefined;
        return data;
    }
}

export interface IInternalMovementPreActivityReportEditionInput {
    id: number;
    newDriver: DriverDto;
    newArticle: ArticleInternalMovementDto;
    newDate: DateTime;
}

export class InternalMovementPreActivityReportSearchOutputDto implements IInternalMovementPreActivityReportSearchOutputDto {
    id!: number;
    driver!: string | undefined;
    licensePlate!: string | undefined;
    origin!: string | undefined;
    destination!: string | undefined;
    article!: string | undefined;
    validationResult!: PreActivityReportValidation;

    constructor(data?: IInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.driver = _data["driver"];
            this.licensePlate = _data["licensePlate"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.article = _data["article"];
            this.validationResult = _data["validationResult"];
        }
    }

    static fromJS(data: any): InternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["driver"] = this.driver;
        data["licensePlate"] = this.licensePlate;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["article"] = this.article;
        data["validationResult"] = this.validationResult;
        return data;
    }
}

export interface IInternalMovementPreActivityReportSearchOutputDto {
    id: number;
    driver: string | undefined;
    licensePlate: string | undefined;
    origin: string | undefined;
    destination: string | undefined;
    article: string | undefined;
    validationResult: PreActivityReportValidation;
}

export class InternalMovementsActivityReportDto implements IInternalMovementsActivityReportDto {
    origin!: LocationDto;
    destination!: LocationDto;
    activityReportLines!: InternalMovementsActivityReportLineDto[] | undefined;
    serial!: string | undefined;
    tareWeight!: WeightDto;
    grossWeight!: WeightDto;
    netWeight!: number;
    activityReportDate!: DateTime;
    entryDate!: DateTime | undefined;
    driver!: DriverDto;
    transport!: VehicleDto;
    vendor!: VendorDto;
    state!: ActivityReportState;
    isAutomatic!: boolean;
    comment!: string | undefined;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    placeId!: number;
    id!: number;

    constructor(data?: IInternalMovementsActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(InternalMovementsActivityReportLineDto.fromJS(item));
            }
            this.serial = _data["serial"];
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.transport = _data["transport"] ? VehicleDto.fromJS(_data["transport"]) : <any>undefined;
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.state = _data["state"];
            this.isAutomatic = _data["isAutomatic"];
            this.comment = _data["comment"];
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InternalMovementsActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementsActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["serial"] = this.serial;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["transport"] = this.transport ? this.transport.toJSON() : <any>undefined;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["isAutomatic"] = this.isAutomatic;
        data["comment"] = this.comment;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IInternalMovementsActivityReportDto {
    origin: LocationDto;
    destination: LocationDto;
    activityReportLines: InternalMovementsActivityReportLineDto[] | undefined;
    serial: string | undefined;
    tareWeight: WeightDto;
    grossWeight: WeightDto;
    netWeight: number;
    activityReportDate: DateTime;
    entryDate: DateTime | undefined;
    driver: DriverDto;
    transport: VehicleDto;
    vendor: VendorDto;
    state: ActivityReportState;
    isAutomatic: boolean;
    comment: string | undefined;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    placeId: number;
    id: number;
}

export class InternalMovementsActivityReportLineDto implements IInternalMovementsActivityReportLineDto {
    articleInternalMovements!: ArticleInternalMovementsDto;

    constructor(data?: IInternalMovementsActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleInternalMovements = _data["articleInternalMovements"] ? ArticleInternalMovementsDto.fromJS(_data["articleInternalMovements"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalMovementsActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementsActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleInternalMovements"] = this.articleInternalMovements ? this.articleInternalMovements.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInternalMovementsActivityReportLineDto {
    articleInternalMovements: ArticleInternalMovementsDto;
}

export class InternalMovementsReportInputDto implements IInternalMovementsReportInputDto {
    transportVendorId!: number | undefined;
    driverId!: number | undefined;
    includeDeletedOnes!: boolean;
    operationMode!: ActivityReportOperationMode;
    originExternalId!: number | undefined;
    standExternalId!: number | undefined;
    destinationExternalId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IInternalMovementsReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transportVendorId = _data["transportVendorId"];
            this.driverId = _data["driverId"];
            this.includeDeletedOnes = _data["includeDeletedOnes"];
            this.operationMode = _data["operationMode"];
            this.originExternalId = _data["originExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): InternalMovementsReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementsReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportVendorId"] = this.transportVendorId;
        data["driverId"] = this.driverId;
        data["includeDeletedOnes"] = this.includeDeletedOnes;
        data["operationMode"] = this.operationMode;
        data["originExternalId"] = this.originExternalId;
        data["standExternalId"] = this.standExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IInternalMovementsReportInputDto {
    transportVendorId: number | undefined;
    driverId: number | undefined;
    includeDeletedOnes: boolean;
    operationMode: ActivityReportOperationMode;
    originExternalId: number | undefined;
    standExternalId: number | undefined;
    destinationExternalId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class InvoiceServiceDto implements IInvoiceServiceDto {
    name!: string | undefined;
    description!: string | undefined;
    vendorCode!: string | undefined;
    code!: number;
    id!: number;

    constructor(data?: IInvoiceServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.vendorCode = _data["vendorCode"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InvoiceServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["vendorCode"] = this.vendorCode;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface IInvoiceServiceDto {
    name: string | undefined;
    description: string | undefined;
    vendorCode: string | undefined;
    code: number;
    id: number;
}

export class LengthDto implements ILengthDto {
    id!: number;
    lengthValue!: number;

    constructor(data?: ILengthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lengthValue = _data["lengthValue"];
        }
    }

    static fromJS(data: any): LengthDto {
        data = typeof data === 'object' ? data : {};
        let result = new LengthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lengthValue"] = this.lengthValue;
        return data;
    }
}

export interface ILengthDto {
    id: number;
    lengthValue: number;
}

export class LengthWithTreeVolumeDto implements ILengthWithTreeVolumeDto {
    lengthId!: number;
    treeVolume!: number;

    constructor(data?: ILengthWithTreeVolumeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lengthId = _data["lengthId"];
            this.treeVolume = _data["treeVolume"];
        }
    }

    static fromJS(data: any): LengthWithTreeVolumeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LengthWithTreeVolumeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lengthId"] = this.lengthId;
        data["treeVolume"] = this.treeVolume;
        return data;
    }
}

export interface ILengthWithTreeVolumeDto {
    lengthId: number;
    treeVolume: number;
}

export class ListResultDtoOfProcessCacheDto implements IListResultDtoOfProcessCacheDto {
    items!: ProcessCacheDto[] | undefined;

    constructor(data?: IListResultDtoOfProcessCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProcessCacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProcessCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfProcessCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfProcessCacheDto {
    items: ProcessCacheDto[] | undefined;
}

export class LoadStandServiceDto implements ILoadStandServiceDto {
    activityId!: number;
    name!: string | undefined;
    vendorId!: number;
    locationId!: number;

    constructor(data?: ILoadStandServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.name = _data["name"];
            this.vendorId = _data["vendorId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): LoadStandServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadStandServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["name"] = this.name;
        data["vendorId"] = this.vendorId;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface ILoadStandServiceDto {
    activityId: number;
    name: string | undefined;
    vendorId: number;
    locationId: number;
}

export class Location implements ILocation {
    id!: number;
    name!: string | undefined;
    readonly locationTypeId!: number;
    locationType!: LocationType;
    isOrigin!: boolean;
    isDestination!: boolean;
    contractId!: number;
    vendorId!: number;
    exporterId!: number;
    ownerId!: number;
    measurementTypeId!: number;
    thirdPropertyCategoryId!: number;
    isFscCertified!: boolean;
    isPefCertified!: boolean;
    treeVolume!: number;
    mgsCode!: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).locationTypeId = _data["locationTypeId"];
            this.locationType = _data["locationType"];
            this.isOrigin = _data["isOrigin"];
            this.isDestination = _data["isDestination"];
            this.contractId = _data["contractId"];
            this.vendorId = _data["vendorId"];
            this.exporterId = _data["exporterId"];
            this.ownerId = _data["ownerId"];
            this.measurementTypeId = _data["measurementTypeId"];
            this.thirdPropertyCategoryId = _data["thirdPropertyCategoryId"];
            this.isFscCertified = _data["isFscCertified"];
            this.isPefCertified = _data["isPefCertified"];
            this.treeVolume = _data["treeVolume"];
            this.mgsCode = _data["mgsCode"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationType"] = this.locationType;
        data["isOrigin"] = this.isOrigin;
        data["isDestination"] = this.isDestination;
        data["contractId"] = this.contractId;
        data["vendorId"] = this.vendorId;
        data["exporterId"] = this.exporterId;
        data["ownerId"] = this.ownerId;
        data["measurementTypeId"] = this.measurementTypeId;
        data["thirdPropertyCategoryId"] = this.thirdPropertyCategoryId;
        data["isFscCertified"] = this.isFscCertified;
        data["isPefCertified"] = this.isPefCertified;
        data["treeVolume"] = this.treeVolume;
        data["mgsCode"] = this.mgsCode;
        return data;
    }
}

export interface ILocation {
    id: number;
    name: string | undefined;
    locationTypeId: number;
    locationType: LocationType;
    isOrigin: boolean;
    isDestination: boolean;
    contractId: number;
    vendorId: number;
    exporterId: number;
    ownerId: number;
    measurementTypeId: number;
    thirdPropertyCategoryId: number;
    isFscCertified: boolean;
    isPefCertified: boolean;
    treeVolume: number;
    mgsCode: string | undefined;
}

export class LocationDto implements ILocationDto {
    id!: number;
    name!: string | undefined;
    readonly locationTypeId!: number;
    locationType!: LocationType;
    contractId!: number;
    vendorId!: number;
    ownerId!: number;
    errorList!: string[] | undefined;
    exporterId!: number;
    measurementTypeId!: number;
    thirdPropertyCategoryId!: number;
    isFscCertified!: boolean;
    isPefCertified!: boolean;
    treeVolume!: number;
    mgsCode!: string | undefined;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).locationTypeId = _data["locationTypeId"];
            this.locationType = _data["locationType"];
            this.contractId = _data["contractId"];
            this.vendorId = _data["vendorId"];
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.exporterId = _data["exporterId"];
            this.measurementTypeId = _data["measurementTypeId"];
            this.thirdPropertyCategoryId = _data["thirdPropertyCategoryId"];
            this.isFscCertified = _data["isFscCertified"];
            this.isPefCertified = _data["isPefCertified"];
            this.treeVolume = _data["treeVolume"];
            this.mgsCode = _data["mgsCode"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationType"] = this.locationType;
        data["contractId"] = this.contractId;
        data["vendorId"] = this.vendorId;
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["exporterId"] = this.exporterId;
        data["measurementTypeId"] = this.measurementTypeId;
        data["thirdPropertyCategoryId"] = this.thirdPropertyCategoryId;
        data["isFscCertified"] = this.isFscCertified;
        data["isPefCertified"] = this.isPefCertified;
        data["treeVolume"] = this.treeVolume;
        data["mgsCode"] = this.mgsCode;
        return data;
    }
}

export interface ILocationDto {
    id: number;
    name: string | undefined;
    locationTypeId: number;
    locationType: LocationType;
    contractId: number;
    vendorId: number;
    ownerId: number;
    errorList: string[] | undefined;
    exporterId: number;
    measurementTypeId: number;
    thirdPropertyCategoryId: number;
    isFscCertified: boolean;
    isPefCertified: boolean;
    treeVolume: number;
    mgsCode: string | undefined;
}

export class LocationInputDto implements ILocationInputDto {
    id!: number;
    locationType!: LocationType;

    constructor(data?: ILocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): LocationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ILocationInputDto {
    id: number;
    locationType: LocationType;
}

export enum LocationType {
    None = 0,
    Stand = 1,
    Plant = 2,
    Logyard = 3,
    IntermediateLogyard = 4,
    Property = 5,
    ThirdProperty = 7,
}

export class LocationWithAcceptedOriginsDto implements ILocationWithAcceptedOriginsDto {
    id!: number;
    locationType!: LocationType;
    acceptedOrigins!: SimpleLocationDto[] | undefined;

    constructor(data?: ILocationWithAcceptedOriginsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationType = _data["locationType"];
            if (Array.isArray(_data["acceptedOrigins"])) {
                this.acceptedOrigins = [] as any;
                for (let item of _data["acceptedOrigins"])
                    this.acceptedOrigins!.push(SimpleLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationWithAcceptedOriginsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationWithAcceptedOriginsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationType"] = this.locationType;
        if (Array.isArray(this.acceptedOrigins)) {
            data["acceptedOrigins"] = [];
            for (let item of this.acceptedOrigins)
                data["acceptedOrigins"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationWithAcceptedOriginsDto {
    id: number;
    locationType: LocationType;
    acceptedOrigins: SimpleLocationDto[] | undefined;
}

export class LocationWithPaysTransportDto implements ILocationWithPaysTransportDto {
    paysTransport!: boolean;
    id!: number;
    name!: string | undefined;
    readonly locationTypeId!: number;
    locationType!: LocationType;
    contractId!: number;
    vendorId!: number;
    ownerId!: number;
    errorList!: string[] | undefined;
    exporterId!: number;
    measurementTypeId!: number;
    thirdPropertyCategoryId!: number;
    isFscCertified!: boolean;
    isPefCertified!: boolean;
    treeVolume!: number;
    mgsCode!: string | undefined;

    constructor(data?: ILocationWithPaysTransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paysTransport = _data["paysTransport"];
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).locationTypeId = _data["locationTypeId"];
            this.locationType = _data["locationType"];
            this.contractId = _data["contractId"];
            this.vendorId = _data["vendorId"];
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.exporterId = _data["exporterId"];
            this.measurementTypeId = _data["measurementTypeId"];
            this.thirdPropertyCategoryId = _data["thirdPropertyCategoryId"];
            this.isFscCertified = _data["isFscCertified"];
            this.isPefCertified = _data["isPefCertified"];
            this.treeVolume = _data["treeVolume"];
            this.mgsCode = _data["mgsCode"];
        }
    }

    static fromJS(data: any): LocationWithPaysTransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationWithPaysTransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paysTransport"] = this.paysTransport;
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationType"] = this.locationType;
        data["contractId"] = this.contractId;
        data["vendorId"] = this.vendorId;
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["exporterId"] = this.exporterId;
        data["measurementTypeId"] = this.measurementTypeId;
        data["thirdPropertyCategoryId"] = this.thirdPropertyCategoryId;
        data["isFscCertified"] = this.isFscCertified;
        data["isPefCertified"] = this.isPefCertified;
        data["treeVolume"] = this.treeVolume;
        data["mgsCode"] = this.mgsCode;
        return data;
    }
}

export interface ILocationWithPaysTransportDto {
    paysTransport: boolean;
    id: number;
    name: string | undefined;
    locationTypeId: number;
    locationType: LocationType;
    contractId: number;
    vendorId: number;
    ownerId: number;
    errorList: string[] | undefined;
    exporterId: number;
    measurementTypeId: number;
    thirdPropertyCategoryId: number;
    isFscCertified: boolean;
    isPefCertified: boolean;
    treeVolume: number;
    mgsCode: string | undefined;
}

export enum LogyardReportExceptionType {
    Driver = 0,
    Truck = 1,
    Semis = 2,
    Origin = 3,
    Article = 4,
    Stand = 5,
    Contract = 6,
    ContractType = 7,
    ServiceLoad = 8,
    TripNumber = 9,
    Certification = 10,
    Period = 11,
    Weight = 12,
    Line = 13,
    ServiceDownload = 14,
    State = 15,
    Destination = 16,
    ReceiptIsSynchronizedWithFinishState = 17,
    Pile = 18,
    ExternalSystems = 19,
    OperationMode = 20,
}

export class LogyardWithSpeciesDto implements ILogyardWithSpeciesDto {
    logyardId!: number;
    species!: SpeciesWithLengthsDto[] | undefined;

    constructor(data?: ILogyardWithSpeciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logyardId = _data["logyardId"];
            if (Array.isArray(_data["species"])) {
                this.species = [] as any;
                for (let item of _data["species"])
                    this.species!.push(SpeciesWithLengthsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogyardWithSpeciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardWithSpeciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logyardId"] = this.logyardId;
        if (Array.isArray(this.species)) {
            data["species"] = [];
            for (let item of this.species)
                data["species"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILogyardWithSpeciesDto {
    logyardId: number;
    species: SpeciesWithLengthsDto[] | undefined;
}

export class LogyardWoodActivityReportEditionOutput implements ILogyardWoodActivityReportEditionOutput {
    reportId!: number;
    synchronizationResult!: ActivityReportSynchronizationResult;
    errors!: LogyardWoodActivityReportErrorDto[] | undefined;

    constructor(data?: ILogyardWoodActivityReportEditionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.synchronizationResult = _data["synchronizationResult"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(LogyardWoodActivityReportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogyardWoodActivityReportEditionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardWoodActivityReportEditionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["synchronizationResult"] = this.synchronizationResult;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILogyardWoodActivityReportEditionOutput {
    reportId: number;
    synchronizationResult: ActivityReportSynchronizationResult;
    errors: LogyardWoodActivityReportErrorDto[] | undefined;
}

export class LogyardWoodActivityReportErrorDto implements ILogyardWoodActivityReportErrorDto {
    reason!: string | undefined;
    errorType!: LogyardReportExceptionType;

    constructor(data?: ILogyardWoodActivityReportErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.errorType = _data["errorType"];
        }
    }

    static fromJS(data: any): LogyardWoodActivityReportErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardWoodActivityReportErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["errorType"] = this.errorType;
        return data;
    }
}

export interface ILogyardWoodActivityReportErrorDto {
    reason: string | undefined;
    errorType: LogyardReportExceptionType;
}

export class LogyardWoodActivityReportInput implements ILogyardWoodActivityReportInput {
    localId!: number;
    userId!: number;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationLocationType!: LocationType;
    truckExternalId!: number;
    truckVendorExternalId!: number;
    driverExternalId!: number;
    semis!: number[] | undefined;
    tripNumber!: number;
    paysTransport!: boolean;
    date!: DateTime;
    exitDate!: DateTime | undefined;
    loadDate!: DateTime;
    arrivalDate!: DateTime;
    serial!: string | undefined;
    number!: number;
    woodActivityReportLines!: WoodActivityReportLineInput[] | undefined;
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    netWeight!: number;
    operationMode!: ActivityReportOperationMode;
    isSemiAutomatic!: boolean;
    placeId!: number;
    comment!: string | undefined;
    hasLoadActivityReport!: boolean;
    noSamplingReasonId!: number | undefined;
    noSamplingReasonComment!: string | undefined;
    scannerAbortedSpeedResultReason!: WoodActivityReportAbortedScannerReasonDto;
    woodActivityReportGeoLocationInformation!: WoodActivityReportGeoLocationInformationDto;
    shouldDeleteScannerMeasurementData!: boolean;

    constructor(data?: ILogyardWoodActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localId = _data["localId"];
            this.userId = _data["userId"];
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationLocationType = _data["destinationLocationType"];
            this.truckExternalId = _data["truckExternalId"];
            this.truckVendorExternalId = _data["truckVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(item);
            }
            this.tripNumber = _data["tripNumber"];
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
            this.arrivalDate = _data["arrivalDate"] ? DateTime.fromISO(_data["arrivalDate"].toString()) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            if (Array.isArray(_data["woodActivityReportLines"])) {
                this.woodActivityReportLines = [] as any;
                for (let item of _data["woodActivityReportLines"])
                    this.woodActivityReportLines!.push(WoodActivityReportLineInput.fromJS(item));
            }
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.operationMode = _data["operationMode"];
            this.isSemiAutomatic = _data["isSemiAutomatic"];
            this.placeId = _data["placeId"];
            this.comment = _data["comment"];
            this.hasLoadActivityReport = _data["hasLoadActivityReport"];
            this.noSamplingReasonId = _data["noSamplingReasonId"];
            this.noSamplingReasonComment = _data["noSamplingReasonComment"];
            this.scannerAbortedSpeedResultReason = _data["scannerAbortedSpeedResultReason"] ? WoodActivityReportAbortedScannerReasonDto.fromJS(_data["scannerAbortedSpeedResultReason"]) : <any>undefined;
            this.woodActivityReportGeoLocationInformation = _data["woodActivityReportGeoLocationInformation"] ? WoodActivityReportGeoLocationInformationDto.fromJS(_data["woodActivityReportGeoLocationInformation"]) : <any>undefined;
            this.shouldDeleteScannerMeasurementData = _data["shouldDeleteScannerMeasurementData"];
        }
    }

    static fromJS(data: any): LogyardWoodActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardWoodActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localId"] = this.localId;
        data["userId"] = this.userId;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationLocationType"] = this.destinationLocationType;
        data["truckExternalId"] = this.truckExternalId;
        data["truckVendorExternalId"] = this.truckVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item);
        }
        data["tripNumber"] = this.tripNumber;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toString() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        if (Array.isArray(this.woodActivityReportLines)) {
            data["woodActivityReportLines"] = [];
            for (let item of this.woodActivityReportLines)
                data["woodActivityReportLines"].push(item.toJSON());
        }
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["operationMode"] = this.operationMode;
        data["isSemiAutomatic"] = this.isSemiAutomatic;
        data["placeId"] = this.placeId;
        data["comment"] = this.comment;
        data["hasLoadActivityReport"] = this.hasLoadActivityReport;
        data["noSamplingReasonId"] = this.noSamplingReasonId;
        data["noSamplingReasonComment"] = this.noSamplingReasonComment;
        data["scannerAbortedSpeedResultReason"] = this.scannerAbortedSpeedResultReason ? this.scannerAbortedSpeedResultReason.toJSON() : <any>undefined;
        data["woodActivityReportGeoLocationInformation"] = this.woodActivityReportGeoLocationInformation ? this.woodActivityReportGeoLocationInformation.toJSON() : <any>undefined;
        data["shouldDeleteScannerMeasurementData"] = this.shouldDeleteScannerMeasurementData;
        return data;
    }
}

export interface ILogyardWoodActivityReportInput {
    localId: number;
    userId: number;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationLocationType: LocationType;
    truckExternalId: number;
    truckVendorExternalId: number;
    driverExternalId: number;
    semis: number[] | undefined;
    tripNumber: number;
    paysTransport: boolean;
    date: DateTime;
    exitDate: DateTime | undefined;
    loadDate: DateTime;
    arrivalDate: DateTime;
    serial: string | undefined;
    number: number;
    woodActivityReportLines: WoodActivityReportLineInput[] | undefined;
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    netWeight: number;
    operationMode: ActivityReportOperationMode;
    isSemiAutomatic: boolean;
    placeId: number;
    comment: string | undefined;
    hasLoadActivityReport: boolean;
    noSamplingReasonId: number | undefined;
    noSamplingReasonComment: string | undefined;
    scannerAbortedSpeedResultReason: WoodActivityReportAbortedScannerReasonDto;
    woodActivityReportGeoLocationInformation: WoodActivityReportGeoLocationInformationDto;
    shouldDeleteScannerMeasurementData: boolean;
}

export class LogyardWoodActivityReportSynchronizeOutput implements ILogyardWoodActivityReportSynchronizeOutput {
    isSyncronizedToSmartTrip!: boolean;
    isSynchronizationDuplicated!: boolean;
    reportId!: number;
    synchronizationResult!: ActivityReportSynchronizationResult;
    errors!: LogyardWoodActivityReportErrorDto[] | undefined;

    constructor(data?: ILogyardWoodActivityReportSynchronizeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSyncronizedToSmartTrip = _data["isSyncronizedToSmartTrip"];
            this.isSynchronizationDuplicated = _data["isSynchronizationDuplicated"];
            this.reportId = _data["reportId"];
            this.synchronizationResult = _data["synchronizationResult"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(LogyardWoodActivityReportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogyardWoodActivityReportSynchronizeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardWoodActivityReportSynchronizeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSyncronizedToSmartTrip"] = this.isSyncronizedToSmartTrip;
        data["isSynchronizationDuplicated"] = this.isSynchronizationDuplicated;
        data["reportId"] = this.reportId;
        data["synchronizationResult"] = this.synchronizationResult;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILogyardWoodActivityReportSynchronizeOutput {
    isSyncronizedToSmartTrip: boolean;
    isSynchronizationDuplicated: boolean;
    reportId: number;
    synchronizationResult: ActivityReportSynchronizationResult;
    errors: LogyardWoodActivityReportErrorDto[] | undefined;
}

export class LogyardWoodActivityReportUpdateInput implements ILogyardWoodActivityReportUpdateInput {
    activityReportId!: number;
    localId!: number;
    userId!: number;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationLocationType!: LocationType;
    truckExternalId!: number;
    truckVendorExternalId!: number;
    driverExternalId!: number;
    semis!: number[] | undefined;
    tripNumber!: number;
    paysTransport!: boolean;
    date!: DateTime;
    exitDate!: DateTime | undefined;
    loadDate!: DateTime;
    arrivalDate!: DateTime;
    serial!: string | undefined;
    number!: number;
    woodActivityReportLines!: WoodActivityReportLineInput[] | undefined;
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    netWeight!: number;
    operationMode!: ActivityReportOperationMode;
    isSemiAutomatic!: boolean;
    placeId!: number;
    comment!: string | undefined;
    hasLoadActivityReport!: boolean;
    noSamplingReasonId!: number | undefined;
    noSamplingReasonComment!: string | undefined;
    scannerAbortedSpeedResultReason!: WoodActivityReportAbortedScannerReasonDto;
    woodActivityReportGeoLocationInformation!: WoodActivityReportGeoLocationInformationDto;
    shouldDeleteScannerMeasurementData!: boolean;

    constructor(data?: ILogyardWoodActivityReportUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.localId = _data["localId"];
            this.userId = _data["userId"];
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationLocationType = _data["destinationLocationType"];
            this.truckExternalId = _data["truckExternalId"];
            this.truckVendorExternalId = _data["truckVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(item);
            }
            this.tripNumber = _data["tripNumber"];
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
            this.arrivalDate = _data["arrivalDate"] ? DateTime.fromISO(_data["arrivalDate"].toString()) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            if (Array.isArray(_data["woodActivityReportLines"])) {
                this.woodActivityReportLines = [] as any;
                for (let item of _data["woodActivityReportLines"])
                    this.woodActivityReportLines!.push(WoodActivityReportLineInput.fromJS(item));
            }
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.operationMode = _data["operationMode"];
            this.isSemiAutomatic = _data["isSemiAutomatic"];
            this.placeId = _data["placeId"];
            this.comment = _data["comment"];
            this.hasLoadActivityReport = _data["hasLoadActivityReport"];
            this.noSamplingReasonId = _data["noSamplingReasonId"];
            this.noSamplingReasonComment = _data["noSamplingReasonComment"];
            this.scannerAbortedSpeedResultReason = _data["scannerAbortedSpeedResultReason"] ? WoodActivityReportAbortedScannerReasonDto.fromJS(_data["scannerAbortedSpeedResultReason"]) : <any>undefined;
            this.woodActivityReportGeoLocationInformation = _data["woodActivityReportGeoLocationInformation"] ? WoodActivityReportGeoLocationInformationDto.fromJS(_data["woodActivityReportGeoLocationInformation"]) : <any>undefined;
            this.shouldDeleteScannerMeasurementData = _data["shouldDeleteScannerMeasurementData"];
        }
    }

    static fromJS(data: any): LogyardWoodActivityReportUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardWoodActivityReportUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["localId"] = this.localId;
        data["userId"] = this.userId;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationLocationType"] = this.destinationLocationType;
        data["truckExternalId"] = this.truckExternalId;
        data["truckVendorExternalId"] = this.truckVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item);
        }
        data["tripNumber"] = this.tripNumber;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toString() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        if (Array.isArray(this.woodActivityReportLines)) {
            data["woodActivityReportLines"] = [];
            for (let item of this.woodActivityReportLines)
                data["woodActivityReportLines"].push(item.toJSON());
        }
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["operationMode"] = this.operationMode;
        data["isSemiAutomatic"] = this.isSemiAutomatic;
        data["placeId"] = this.placeId;
        data["comment"] = this.comment;
        data["hasLoadActivityReport"] = this.hasLoadActivityReport;
        data["noSamplingReasonId"] = this.noSamplingReasonId;
        data["noSamplingReasonComment"] = this.noSamplingReasonComment;
        data["scannerAbortedSpeedResultReason"] = this.scannerAbortedSpeedResultReason ? this.scannerAbortedSpeedResultReason.toJSON() : <any>undefined;
        data["woodActivityReportGeoLocationInformation"] = this.woodActivityReportGeoLocationInformation ? this.woodActivityReportGeoLocationInformation.toJSON() : <any>undefined;
        data["shouldDeleteScannerMeasurementData"] = this.shouldDeleteScannerMeasurementData;
        return data;
    }
}

export interface ILogyardWoodActivityReportUpdateInput {
    activityReportId: number;
    localId: number;
    userId: number;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationLocationType: LocationType;
    truckExternalId: number;
    truckVendorExternalId: number;
    driverExternalId: number;
    semis: number[] | undefined;
    tripNumber: number;
    paysTransport: boolean;
    date: DateTime;
    exitDate: DateTime | undefined;
    loadDate: DateTime;
    arrivalDate: DateTime;
    serial: string | undefined;
    number: number;
    woodActivityReportLines: WoodActivityReportLineInput[] | undefined;
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    netWeight: number;
    operationMode: ActivityReportOperationMode;
    isSemiAutomatic: boolean;
    placeId: number;
    comment: string | undefined;
    hasLoadActivityReport: boolean;
    noSamplingReasonId: number | undefined;
    noSamplingReasonComment: string | undefined;
    scannerAbortedSpeedResultReason: WoodActivityReportAbortedScannerReasonDto;
    woodActivityReportGeoLocationInformation: WoodActivityReportGeoLocationInformationDto;
    shouldDeleteScannerMeasurementData: boolean;
}

export class LogyardsLineSamplingInputDto implements ILogyardsLineSamplingInputDto {
    standOriginId!: number;
    articleId!: number;
    notSyncedReportsCount!: number;
    notSyncedSkippedSamplesCount!: number;
    usesScanner!: boolean;

    constructor(data?: ILogyardsLineSamplingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standOriginId = _data["standOriginId"];
            this.articleId = _data["articleId"];
            this.notSyncedReportsCount = _data["notSyncedReportsCount"];
            this.notSyncedSkippedSamplesCount = _data["notSyncedSkippedSamplesCount"];
            this.usesScanner = _data["usesScanner"];
        }
    }

    static fromJS(data: any): LogyardsLineSamplingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardsLineSamplingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standOriginId"] = this.standOriginId;
        data["articleId"] = this.articleId;
        data["notSyncedReportsCount"] = this.notSyncedReportsCount;
        data["notSyncedSkippedSamplesCount"] = this.notSyncedSkippedSamplesCount;
        data["usesScanner"] = this.usesScanner;
        return data;
    }
}

export interface ILogyardsLineSamplingInputDto {
    standOriginId: number;
    articleId: number;
    notSyncedReportsCount: number;
    notSyncedSkippedSamplesCount: number;
    usesScanner: boolean;
}

export class LogyardsSampleRecoveryInput implements ILogyardsSampleRecoveryInput {
    reportId!: number;
    logyardsLinesSamplingInput!: LogyardsLineSamplingInputDto[] | undefined;

    constructor(data?: ILogyardsSampleRecoveryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            if (Array.isArray(_data["logyardsLinesSamplingInput"])) {
                this.logyardsLinesSamplingInput = [] as any;
                for (let item of _data["logyardsLinesSamplingInput"])
                    this.logyardsLinesSamplingInput!.push(LogyardsLineSamplingInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogyardsSampleRecoveryInput {
        data = typeof data === 'object' ? data : {};
        let result = new LogyardsSampleRecoveryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        if (Array.isArray(this.logyardsLinesSamplingInput)) {
            data["logyardsLinesSamplingInput"] = [];
            for (let item of this.logyardsLinesSamplingInput)
                data["logyardsLinesSamplingInput"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILogyardsSampleRecoveryInput {
    reportId: number;
    logyardsLinesSamplingInput: LogyardsLineSamplingInputDto[] | undefined;
}

export class MeasurementTypeDto implements IMeasurementTypeDto {
    id!: number;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IMeasurementTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): MeasurementTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IMeasurementTypeDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class MeasurementTypePerOriginDto implements IMeasurementTypePerOriginDto {
    locationId!: number | undefined;
    locationTypeId!: number | undefined;
    articleResourceId!: number | undefined;
    articles!: MeasurementTypeWithArticleDto[] | undefined;
    loadVendors!: MeasurementTypeWithVendorDto[] | undefined;
    measurementTypeId!: number | undefined;

    constructor(data?: IMeasurementTypePerOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationTypeId = _data["locationTypeId"];
            this.articleResourceId = _data["articleResourceId"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(MeasurementTypeWithArticleDto.fromJS(item));
            }
            if (Array.isArray(_data["loadVendors"])) {
                this.loadVendors = [] as any;
                for (let item of _data["loadVendors"])
                    this.loadVendors!.push(MeasurementTypeWithVendorDto.fromJS(item));
            }
            this.measurementTypeId = _data["measurementTypeId"];
        }
    }

    static fromJS(data: any): MeasurementTypePerOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementTypePerOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationTypeId"] = this.locationTypeId;
        data["articleResourceId"] = this.articleResourceId;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        if (Array.isArray(this.loadVendors)) {
            data["loadVendors"] = [];
            for (let item of this.loadVendors)
                data["loadVendors"].push(item.toJSON());
        }
        data["measurementTypeId"] = this.measurementTypeId;
        return data;
    }
}

export interface IMeasurementTypePerOriginDto {
    locationId: number | undefined;
    locationTypeId: number | undefined;
    articleResourceId: number | undefined;
    articles: MeasurementTypeWithArticleDto[] | undefined;
    loadVendors: MeasurementTypeWithVendorDto[] | undefined;
    measurementTypeId: number | undefined;
}

export class MeasurementTypeWithArticleDto implements IMeasurementTypeWithArticleDto {
    articleId!: number | undefined;
    measurementTypeId!: number | undefined;

    constructor(data?: IMeasurementTypeWithArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.measurementTypeId = _data["measurementTypeId"];
        }
    }

    static fromJS(data: any): MeasurementTypeWithArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementTypeWithArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["measurementTypeId"] = this.measurementTypeId;
        return data;
    }
}

export interface IMeasurementTypeWithArticleDto {
    articleId: number | undefined;
    measurementTypeId: number | undefined;
}

export class MeasurementTypeWithVendorDto implements IMeasurementTypeWithVendorDto {
    vendorId!: number | undefined;
    measurementTypeId!: number | undefined;

    constructor(data?: IMeasurementTypeWithVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorId = _data["vendorId"];
            this.measurementTypeId = _data["measurementTypeId"];
        }
    }

    static fromJS(data: any): MeasurementTypeWithVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementTypeWithVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorId"] = this.vendorId;
        data["measurementTypeId"] = this.measurementTypeId;
        return data;
    }
}

export interface IMeasurementTypeWithVendorDto {
    vendorId: number | undefined;
    measurementTypeId: number | undefined;
}

export class MemberInfo implements IMemberInfo {
    memberType!: MemberTypes;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 1,
    Private = 2,
    FamANDAssem = 3,
    Assembly = 4,
    Family = 5,
    FamORAssem = 6,
    Public = 7,
    MemberAccessMask = 8,
    UnmanagedExport = 16,
    Static = 32,
    Final = 64,
    Virtual = 128,
    HideBySig = 256,
    NewSlot = 512,
    VtableLayoutMask = 1024,
    CheckAccessOnOverride = 2048,
    Abstract = 4096,
    SpecialName = 8192,
    RTSpecialName = 16384,
    PinvokeImpl = 32768,
    HasSecurity = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 1,
    Native = 2,
    OPTIL = 3,
    CodeTypeMask = 4,
    Runtime = 8,
    ManagedMask = 16,
    Unmanaged = 32,
    NoInlining = 64,
    ForwardRef = 128,
    Synchronized = 256,
    NoOptimization = 512,
    PreserveSig = 4096,
    AggressiveInlining = 8192,
    AggressiveOptimization = 65535,
}

export class MethodInfo implements IMethodInfo {
    memberType!: MemberTypes;
    returnParameter!: ParameterInfo;
    readonly returnType!: string | undefined;
    returnTypeCustomAttributes!: ICustomAttributeProvider;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            (<any>this).returnType = _data["returnType"];
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMethodInfo {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string | undefined;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class Module implements IModule {
    assembly!: Assembly;
    readonly fullyQualifiedName!: string | undefined;
    readonly name!: string | undefined;
    readonly mdStreamVersion!: number;
    readonly moduleVersionId!: string;
    readonly scopeName!: string | undefined;
    moduleHandle!: ModuleHandle;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class MonitorActivityDto implements IMonitorActivityDto {
    id!: number;
    truckPlate!: string | undefined;
    vendorVehicleName!: string | undefined;
    driverName!: string | undefined;
    origin!: string | undefined;
    destination!: string | undefined;
    state!: ActivityReportState;
    stand!: string | undefined;
    article!: string | undefined;
    isChip!: boolean;
    sampleAssigned!: boolean;
    isTritrain!: boolean;

    constructor(data?: IMonitorActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.truckPlate = _data["truckPlate"];
            this.vendorVehicleName = _data["vendorVehicleName"];
            this.driverName = _data["driverName"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.state = _data["state"];
            this.stand = _data["stand"];
            this.article = _data["article"];
            this.isChip = _data["isChip"];
            this.sampleAssigned = _data["sampleAssigned"];
            this.isTritrain = _data["isTritrain"];
        }
    }

    static fromJS(data: any): MonitorActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["truckPlate"] = this.truckPlate;
        data["vendorVehicleName"] = this.vendorVehicleName;
        data["driverName"] = this.driverName;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["state"] = this.state;
        data["stand"] = this.stand;
        data["article"] = this.article;
        data["isChip"] = this.isChip;
        data["sampleAssigned"] = this.sampleAssigned;
        data["isTritrain"] = this.isTritrain;
        return data;
    }
}

export interface IMonitorActivityDto {
    id: number;
    truckPlate: string | undefined;
    vendorVehicleName: string | undefined;
    driverName: string | undefined;
    origin: string | undefined;
    destination: string | undefined;
    state: ActivityReportState;
    stand: string | undefined;
    article: string | undefined;
    isChip: boolean;
    sampleAssigned: boolean;
    isTritrain: boolean;
}

export class MonitorZonesOutputDto implements IMonitorZonesOutputDto {
    woodAndDiverseProductsZones!: TruckAvailableZoneDto[] | undefined;
    productsZones!: TruckAvailableZoneDto[] | undefined;

    constructor(data?: IMonitorZonesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["woodAndDiverseProductsZones"])) {
                this.woodAndDiverseProductsZones = [] as any;
                for (let item of _data["woodAndDiverseProductsZones"])
                    this.woodAndDiverseProductsZones!.push(TruckAvailableZoneDto.fromJS(item));
            }
            if (Array.isArray(_data["productsZones"])) {
                this.productsZones = [] as any;
                for (let item of _data["productsZones"])
                    this.productsZones!.push(TruckAvailableZoneDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonitorZonesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitorZonesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.woodAndDiverseProductsZones)) {
            data["woodAndDiverseProductsZones"] = [];
            for (let item of this.woodAndDiverseProductsZones)
                data["woodAndDiverseProductsZones"].push(item.toJSON());
        }
        if (Array.isArray(this.productsZones)) {
            data["productsZones"] = [];
            for (let item of this.productsZones)
                data["productsZones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonitorZonesOutputDto {
    woodAndDiverseProductsZones: TruckAvailableZoneDto[] | undefined;
    productsZones: TruckAvailableZoneDto[] | undefined;
}

export class NetworkMeditionDto implements INetworkMeditionDto {
    userId!: number;
    placeId!: number;
    responseTime!: number;
    dateOfMedition!: DateTime;

    constructor(data?: INetworkMeditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.placeId = _data["placeId"];
            this.responseTime = _data["responseTime"];
            this.dateOfMedition = _data["dateOfMedition"] ? DateTime.fromISO(_data["dateOfMedition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NetworkMeditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkMeditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["placeId"] = this.placeId;
        data["responseTime"] = this.responseTime;
        data["dateOfMedition"] = this.dateOfMedition ? this.dateOfMedition.toString() : <any>undefined;
        return data;
    }
}

export interface INetworkMeditionDto {
    userId: number;
    placeId: number;
    responseTime: number;
    dateOfMedition: DateTime;
}

export class PagedResultDtoOfDensityPerSpeciesGroupDto implements IPagedResultDtoOfDensityPerSpeciesGroupDto {
    totalCount!: number;
    items!: DensityPerSpeciesGroupDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDensityPerSpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DensityPerSpeciesGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDensityPerSpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDensityPerSpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDensityPerSpeciesGroupDto {
    totalCount: number;
    items: DensityPerSpeciesGroupDto[] | undefined;
}

export class PagedResultDtoOfDiverseProductsTruckTypeDto implements IPagedResultDtoOfDiverseProductsTruckTypeDto {
    totalCount!: number;
    items!: DiverseProductsTruckTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDiverseProductsTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiverseProductsTruckTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDiverseProductsTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDiverseProductsTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDiverseProductsTruckTypeDto {
    totalCount: number;
    items: DiverseProductsTruckTypeDto[] | undefined;
}

export class PagedResultDtoOfGetWoodPreReportToArriveOutputDto implements IPagedResultDtoOfGetWoodPreReportToArriveOutputDto {
    totalCount!: number;
    items!: GetWoodPreReportToArriveOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWoodPreReportToArriveOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetWoodPreReportToArriveOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWoodPreReportToArriveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWoodPreReportToArriveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWoodPreReportToArriveOutputDto {
    totalCount: number;
    items: GetWoodPreReportToArriveOutputDto[] | undefined;
}

export class PagedResultDtoOfPolygonContractDto implements IPagedResultDtoOfPolygonContractDto {
    totalCount!: number;
    items!: PolygonContractDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolygonContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolygonContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolygonContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolygonContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolygonContractDto {
    totalCount: number;
    items: PolygonContractDto[] | undefined;
}

export class PagedResultDtoOfProcessAuditLogListDto implements IPagedResultDtoOfProcessAuditLogListDto {
    totalCount!: number;
    items!: ProcessAuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProcessAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProcessAuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProcessAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProcessAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfProcessAuditLogListDto {
    totalCount: number;
    items: ProcessAuditLogListDto[] | undefined;
}

export class PagedResultDtoOfRandomSampleAssignationOutputDto implements IPagedResultDtoOfRandomSampleAssignationOutputDto {
    totalCount!: number;
    items!: RandomSampleAssignationOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRandomSampleAssignationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RandomSampleAssignationOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRandomSampleAssignationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRandomSampleAssignationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRandomSampleAssignationOutputDto {
    totalCount: number;
    items: RandomSampleAssignationOutputDto[] | undefined;
}

export class PagedResultDtoOfServiceConfigurationForVisualizationDto implements IPagedResultDtoOfServiceConfigurationForVisualizationDto {
    totalCount!: number;
    items!: ServiceConfigurationForVisualizationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceConfigurationForVisualizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceConfigurationForVisualizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceConfigurationForVisualizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceConfigurationForVisualizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfServiceConfigurationForVisualizationDto {
    totalCount: number;
    items: ServiceConfigurationForVisualizationDto[] | undefined;
}

export class PagedResultDtoOfWoodActivityReportForMassEditGridDto implements IPagedResultDtoOfWoodActivityReportForMassEditGridDto {
    totalCount!: number;
    items!: WoodActivityReportForMassEditGridDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodActivityReportForMassEditGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportForMassEditGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodActivityReportForMassEditGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodActivityReportForMassEditGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodActivityReportForMassEditGridDto {
    totalCount: number;
    items: WoodActivityReportForMassEditGridDto[] | undefined;
}

export class PagedResultDtoOfWoodActivityReportForSamplesGridDto implements IPagedResultDtoOfWoodActivityReportForSamplesGridDto {
    totalCount!: number;
    items!: WoodActivityReportForSamplesGridDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodActivityReportForSamplesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportForSamplesGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodActivityReportForSamplesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodActivityReportForSamplesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodActivityReportForSamplesGridDto {
    totalCount: number;
    items: WoodActivityReportForSamplesGridDto[] | undefined;
}

export class PagedResultDtoOfWoodTruckTypeDto implements IPagedResultDtoOfWoodTruckTypeDto {
    totalCount!: number;
    items!: WoodTruckTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodTruckTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodTruckTypeDto {
    totalCount: number;
    items: WoodTruckTypeDto[] | undefined;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export class ParameterInfo implements IParameterInfo {
    attributes!: ParameterAttributes;
    member!: MemberInfo;
    readonly name!: string | undefined;
    readonly parameterType!: string | undefined;
    readonly position!: number;
    readonly isIn!: boolean;
    readonly isLcid!: boolean;
    readonly isOptional!: boolean;
    readonly isOut!: boolean;
    readonly isRetval!: boolean;
    readonly defaultValue!: any | undefined;
    readonly rawDefaultValue!: any | undefined;
    readonly hasDefaultValue!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).parameterType = _data["parameterType"];
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | undefined;
    parameterType: string | undefined;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class PeriodDto implements IPeriodDto {
    id!: number;
    startDatePeriod!: DateTime;
    endDatePeriod!: DateTime;
    name!: string | undefined;

    constructor(data?: IPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDatePeriod = _data["startDatePeriod"] ? DateTime.fromISO(_data["startDatePeriod"].toString()) : <any>undefined;
            this.endDatePeriod = _data["endDatePeriod"] ? DateTime.fromISO(_data["endDatePeriod"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDatePeriod"] = this.startDatePeriod ? this.startDatePeriod.toString() : <any>undefined;
        data["endDatePeriod"] = this.endDatePeriod ? this.endDatePeriod.toString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IPeriodDto {
    id: number;
    startDatePeriod: DateTime;
    endDatePeriod: DateTime;
    name: string | undefined;
}

export class PileForViewDto implements IPileForViewDto {
    id!: number;
    externalId!: number;
    pileType!: PileType;
    pileStatus!: PileStatus;
    name!: string | undefined;
    number!: number;
    logyardExternalId!: number;
    isPefcCertified!: boolean;
    isFscCertified!: boolean;
    article!: ArticleDtoOutput;
    locations!: PileOriginDto[] | undefined;
    allowsEntry!: boolean;
    allowsExit!: boolean;
    geneticMaterialType!: GeneticMaterialTypeDto;
    contractTypeGroup!: ContractTypeGroupDto;

    constructor(data?: IPileForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.pileType = _data["pileType"];
            this.pileStatus = _data["pileStatus"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.logyardExternalId = _data["logyardExternalId"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.isFscCertified = _data["isFscCertified"];
            this.article = _data["article"] ? ArticleDtoOutput.fromJS(_data["article"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(PileOriginDto.fromJS(item));
            }
            this.allowsEntry = _data["allowsEntry"];
            this.allowsExit = _data["allowsExit"];
            this.geneticMaterialType = _data["geneticMaterialType"] ? GeneticMaterialTypeDto.fromJS(_data["geneticMaterialType"]) : <any>undefined;
            this.contractTypeGroup = _data["contractTypeGroup"] ? ContractTypeGroupDto.fromJS(_data["contractTypeGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PileForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PileForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["pileType"] = this.pileType;
        data["pileStatus"] = this.pileStatus;
        data["name"] = this.name;
        data["number"] = this.number;
        data["logyardExternalId"] = this.logyardExternalId;
        data["isPefcCertified"] = this.isPefcCertified;
        data["isFscCertified"] = this.isFscCertified;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["allowsEntry"] = this.allowsEntry;
        data["allowsExit"] = this.allowsExit;
        data["geneticMaterialType"] = this.geneticMaterialType ? this.geneticMaterialType.toJSON() : <any>undefined;
        data["contractTypeGroup"] = this.contractTypeGroup ? this.contractTypeGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPileForViewDto {
    id: number;
    externalId: number;
    pileType: PileType;
    pileStatus: PileStatus;
    name: string | undefined;
    number: number;
    logyardExternalId: number;
    isPefcCertified: boolean;
    isFscCertified: boolean;
    article: ArticleDtoOutput;
    locations: PileOriginDto[] | undefined;
    allowsEntry: boolean;
    allowsExit: boolean;
    geneticMaterialType: GeneticMaterialTypeDto;
    contractTypeGroup: ContractTypeGroupDto;
}

export class PileOriginDto implements IPileOriginDto {
    id!: number;
    originType!: PileOriginType;
    standOrigin!: StandOutputDto;
    thirdPropertyOrLogyardOrigin!: LocationWithPaysTransportDto;

    constructor(data?: IPileOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originType = _data["originType"];
            this.standOrigin = _data["standOrigin"] ? StandOutputDto.fromJS(_data["standOrigin"]) : <any>undefined;
            this.thirdPropertyOrLogyardOrigin = _data["thirdPropertyOrLogyardOrigin"] ? LocationWithPaysTransportDto.fromJS(_data["thirdPropertyOrLogyardOrigin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PileOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new PileOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originType"] = this.originType;
        data["standOrigin"] = this.standOrigin ? this.standOrigin.toJSON() : <any>undefined;
        data["thirdPropertyOrLogyardOrigin"] = this.thirdPropertyOrLogyardOrigin ? this.thirdPropertyOrLogyardOrigin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPileOriginDto {
    id: number;
    originType: PileOriginType;
    standOrigin: StandOutputDto;
    thirdPropertyOrLogyardOrigin: LocationWithPaysTransportDto;
}

export class PileOriginInput implements IPileOriginInput {
    id!: number;
    originType!: PileOriginType;

    constructor(data?: IPileOriginInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originType = _data["originType"];
        }
    }

    static fromJS(data: any): PileOriginInput {
        data = typeof data === 'object' ? data : {};
        let result = new PileOriginInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originType"] = this.originType;
        return data;
    }
}

export interface IPileOriginInput {
    id: number;
    originType: PileOriginType;
}

export enum PileOriginType {
    Stand = 0,
    ThirdProperty = 1,
    Logyard = 2,
}

export enum PileStatus {
    Active = 0,
    Inactive = 1,
    Closed = 2,
}

export enum PileType {
    Simple = 1,
    Mix = 2,
}

export class PolygonContractDto implements IPolygonContractDto {
    contractId!: number;
    contractVendorName!: string | undefined;
    isActive!: boolean;
    emails!: string[] | undefined;
    id!: number;

    constructor(data?: IPolygonContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.contractVendorName = _data["contractVendorName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PolygonContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolygonContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["contractVendorName"] = this.contractVendorName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPolygonContractDto {
    contractId: number;
    contractVendorName: string | undefined;
    isActive: boolean;
    emails: string[] | undefined;
    id: number;
}

export enum PreActivityReportCreationMode {
    Automatic = 0,
    QR = 1,
    Manual = 2,
    ThirdPartyQR = 3,
    ProvidersApi = 4,
}

export enum PreActivityReportEntranceStatusFilter {
    None = 0,
    EnabledEntrance = 1,
    ConditionalEntrance = 2,
}

export enum PreActivityReportEntranceStatusFilterForTransportVendor {
    None = 0,
    EnabledEntrance = 1,
    ConditionalEntrance = 2,
    UPMReview = 3,
    ProviderErrors = 4,
}

export enum PreActivityReportEntranceStatusFilterForVendor {
    None = 0,
    EnabledEntrance = 1,
    ConditionalEntrance = 2,
    UPMReview = 3,
    ProviderErrors = 4,
    WithoutTurn = 5,
}

export class PreActivityReportErrorDto implements IPreActivityReportErrorDto {
    errorType!: PreActivityReportErrorType;
    isProvidersResponsibility!: boolean;
    errorMessages!: string[] | undefined;
    syncUp!: boolean;
    deleteOnReceiptVerification!: boolean;

    constructor(data?: IPreActivityReportErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorType = _data["errorType"];
            this.isProvidersResponsibility = _data["isProvidersResponsibility"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.syncUp = _data["syncUp"];
            this.deleteOnReceiptVerification = _data["deleteOnReceiptVerification"];
        }
    }

    static fromJS(data: any): PreActivityReportErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorType"] = this.errorType;
        data["isProvidersResponsibility"] = this.isProvidersResponsibility;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["syncUp"] = this.syncUp;
        data["deleteOnReceiptVerification"] = this.deleteOnReceiptVerification;
        return data;
    }
}

export interface IPreActivityReportErrorDto {
    errorType: PreActivityReportErrorType;
    isProvidersResponsibility: boolean;
    errorMessages: string[] | undefined;
    syncUp: boolean;
    deleteOnReceiptVerification: boolean;
}

export enum PreActivityReportErrorType {
    Driver = 0,
    Truck = 1,
    Semitrailer = 2,
    Stand = 3,
    Contract = 4,
    DUA = 5,
    TripNumber = 6,
    QRCertification = 7,
    Sample = 8,
    Destination = 9,
    LoadingService = 10,
    Origin = 11,
    Article = 12,
    ValidatePhoto = 13,
    ValidateQRCode = 14,
}

export class PreActivityReportForActiveTripOutput implements IPreActivityReportForActiveTripOutput {
    reportId!: number;
    reportType!: ActivityReportType;
    state!: ActivityReportState;
    article!: ArticleDiverseProductsDto;
    origin!: LocationDto;
    destination!: LocationDto;
    scheduledEntryTime!: DateTime | undefined;
    tripNumber!: number | undefined;
    serialNumber!: string | undefined;
    errorList!: string[] | undefined;
    takenByOtherDriver!: boolean;
    paysTransport!: boolean;
    validationStatus!: PreActivityReportValidation;
    creationMode!: PreActivityReportCreationMode;
    isApproved!: boolean;
    prereportByIdNotFound!: boolean;
    isDriverActive!: boolean;
    areTruckAndSemisActive!: boolean;
    isChip!: boolean;

    constructor(data?: IPreActivityReportForActiveTripOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportType = _data["reportType"];
            this.state = _data["state"];
            this.article = _data["article"] ? ArticleDiverseProductsDto.fromJS(_data["article"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            this.serialNumber = _data["serialNumber"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.takenByOtherDriver = _data["takenByOtherDriver"];
            this.paysTransport = _data["paysTransport"];
            this.validationStatus = _data["validationStatus"];
            this.creationMode = _data["creationMode"];
            this.isApproved = _data["isApproved"];
            this.prereportByIdNotFound = _data["prereportByIdNotFound"];
            this.isDriverActive = _data["isDriverActive"];
            this.areTruckAndSemisActive = _data["areTruckAndSemisActive"];
            this.isChip = _data["isChip"];
        }
    }

    static fromJS(data: any): PreActivityReportForActiveTripOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportForActiveTripOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportType"] = this.reportType;
        data["state"] = this.state;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        data["serialNumber"] = this.serialNumber;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["takenByOtherDriver"] = this.takenByOtherDriver;
        data["paysTransport"] = this.paysTransport;
        data["validationStatus"] = this.validationStatus;
        data["creationMode"] = this.creationMode;
        data["isApproved"] = this.isApproved;
        data["prereportByIdNotFound"] = this.prereportByIdNotFound;
        data["isDriverActive"] = this.isDriverActive;
        data["areTruckAndSemisActive"] = this.areTruckAndSemisActive;
        data["isChip"] = this.isChip;
        return data;
    }
}

export interface IPreActivityReportForActiveTripOutput {
    reportId: number;
    reportType: ActivityReportType;
    state: ActivityReportState;
    article: ArticleDiverseProductsDto;
    origin: LocationDto;
    destination: LocationDto;
    scheduledEntryTime: DateTime | undefined;
    tripNumber: number | undefined;
    serialNumber: string | undefined;
    errorList: string[] | undefined;
    takenByOtherDriver: boolean;
    paysTransport: boolean;
    validationStatus: PreActivityReportValidation;
    creationMode: PreActivityReportCreationMode;
    isApproved: boolean;
    prereportByIdNotFound: boolean;
    isDriverActive: boolean;
    areTruckAndSemisActive: boolean;
    isChip: boolean;
}

export class PreActivityReportStatusOutput implements IPreActivityReportStatusOutput {
    status!: string | undefined;
    message!: string | undefined;

    constructor(data?: IPreActivityReportStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PreActivityReportStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IPreActivityReportStatusOutput {
    status: string | undefined;
    message: string | undefined;
}

export enum PreActivityReportValidation {
    NoErrorsDetected = 0,
    HasUpmErrors = 1,
    HasProviderErrors = 2,
    HasUpmAndProviderErrors = 3,
    Rejected = 4,
}

export class PreReportMonitorCardInfoDto implements IPreReportMonitorCardInfoDto {
    total!: number;
    providerErrorCount!: number;
    upmErrorCount!: number;

    constructor(data?: IPreReportMonitorCardInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.providerErrorCount = _data["providerErrorCount"];
            this.upmErrorCount = _data["upmErrorCount"];
        }
    }

    static fromJS(data: any): PreReportMonitorCardInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreReportMonitorCardInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["providerErrorCount"] = this.providerErrorCount;
        data["upmErrorCount"] = this.upmErrorCount;
        return data;
    }
}

export interface IPreReportMonitorCardInfoDto {
    total: number;
    providerErrorCount: number;
    upmErrorCount: number;
}

export class PreReportMonitorInfoOutput implements IPreReportMonitorInfoOutput {
    woodTotemNotValidated!: PreReportMonitorCardInfoDto;
    woodNotTotemActualAndNextTurnNotValidated!: PreReportMonitorCardInfoDto;
    woodNotValidated!: PreReportMonitorCardInfoDto;
    diverseProductNotValidated!: PreReportMonitorCardInfoDto;
    woodTotalCount!: number;
    diverseProductTotalCount!: number;
    internalMovementTotalCount!: number;

    constructor(data?: IPreReportMonitorInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodTotemNotValidated = _data["woodTotemNotValidated"] ? PreReportMonitorCardInfoDto.fromJS(_data["woodTotemNotValidated"]) : <any>undefined;
            this.woodNotTotemActualAndNextTurnNotValidated = _data["woodNotTotemActualAndNextTurnNotValidated"] ? PreReportMonitorCardInfoDto.fromJS(_data["woodNotTotemActualAndNextTurnNotValidated"]) : <any>undefined;
            this.woodNotValidated = _data["woodNotValidated"] ? PreReportMonitorCardInfoDto.fromJS(_data["woodNotValidated"]) : <any>undefined;
            this.diverseProductNotValidated = _data["diverseProductNotValidated"] ? PreReportMonitorCardInfoDto.fromJS(_data["diverseProductNotValidated"]) : <any>undefined;
            this.woodTotalCount = _data["woodTotalCount"];
            this.diverseProductTotalCount = _data["diverseProductTotalCount"];
            this.internalMovementTotalCount = _data["internalMovementTotalCount"];
        }
    }

    static fromJS(data: any): PreReportMonitorInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreReportMonitorInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodTotemNotValidated"] = this.woodTotemNotValidated ? this.woodTotemNotValidated.toJSON() : <any>undefined;
        data["woodNotTotemActualAndNextTurnNotValidated"] = this.woodNotTotemActualAndNextTurnNotValidated ? this.woodNotTotemActualAndNextTurnNotValidated.toJSON() : <any>undefined;
        data["woodNotValidated"] = this.woodNotValidated ? this.woodNotValidated.toJSON() : <any>undefined;
        data["diverseProductNotValidated"] = this.diverseProductNotValidated ? this.diverseProductNotValidated.toJSON() : <any>undefined;
        data["woodTotalCount"] = this.woodTotalCount;
        data["diverseProductTotalCount"] = this.diverseProductTotalCount;
        data["internalMovementTotalCount"] = this.internalMovementTotalCount;
        return data;
    }
}

export interface IPreReportMonitorInfoOutput {
    woodTotemNotValidated: PreReportMonitorCardInfoDto;
    woodNotTotemActualAndNextTurnNotValidated: PreReportMonitorCardInfoDto;
    woodNotValidated: PreReportMonitorCardInfoDto;
    diverseProductNotValidated: PreReportMonitorCardInfoDto;
    woodTotalCount: number;
    diverseProductTotalCount: number;
    internalMovementTotalCount: number;
}

export class PreReportRejectionInput implements IPreReportRejectionInput {
    reportId!: number;
    rejectingUserComment!: string | undefined;

    constructor(data?: IPreReportRejectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.rejectingUserComment = _data["rejectingUserComment"];
        }
    }

    static fromJS(data: any): PreReportRejectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new PreReportRejectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["rejectingUserComment"] = this.rejectingUserComment;
        return data;
    }
}

export interface IPreReportRejectionInput {
    reportId: number;
    rejectingUserComment: string | undefined;
}

export class PrintResultDto implements IPrintResultDto {
    succeeded!: boolean;
    reason!: string | undefined;

    constructor(data?: IPrintResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PrintResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrintResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IPrintResultDto {
    succeeded: boolean;
    reason: string | undefined;
}

export class ProcessAuditLogListDto implements IProcessAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    returnValue!: string | undefined;

    constructor(data?: IProcessAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.returnValue = _data["returnValue"];
        }
    }

    static fromJS(data: any): ProcessAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["returnValue"] = this.returnValue;
        return data;
    }
}

export interface IProcessAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    returnValue: string | undefined;
}

export class ProcessCacheDto implements IProcessCacheDto {
    name!: string | undefined;

    constructor(data?: IProcessCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IProcessCacheDto {
    name: string | undefined;
}

export class ProcessWithLicensePlateOutputDto implements IProcessWithLicensePlateOutputDto {
    success!: boolean;
    errors!: string[] | undefined;

    constructor(data?: IProcessWithLicensePlateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessWithLicensePlateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWithLicensePlateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IProcessWithLicensePlateOutputDto {
    success: boolean;
    errors: string[] | undefined;
}

export class ProvidersModuleCancelPreActivityReportInputDto implements IProvidersModuleCancelPreActivityReportInputDto {
    reportId!: number;
    cancelationComment!: string;

    constructor(data?: IProvidersModuleCancelPreActivityReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.cancelationComment = _data["cancelationComment"];
        }
    }

    static fromJS(data: any): ProvidersModuleCancelPreActivityReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleCancelPreActivityReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["cancelationComment"] = this.cancelationComment;
        return data;
    }
}

export interface IProvidersModuleCancelPreActivityReportInputDto {
    reportId: number;
    cancelationComment: string;
}

export class ProvidersModuleDiverseProductPreReportCreationInput implements IProvidersModuleDiverseProductPreReportCreationInput {
    driver!: DriverDto;
    truck!: VehicleDto;
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    article!: ArticleDiverseProductsDto;

    constructor(data?: IProvidersModuleDiverseProductPreReportCreationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.truck = _data["truck"] ? VehicleDto.fromJS(_data["truck"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.article = _data["article"] ? ArticleDiverseProductsDto.fromJS(_data["article"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvidersModuleDiverseProductPreReportCreationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleDiverseProductPreReportCreationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["truck"] = this.truck ? this.truck.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProvidersModuleDiverseProductPreReportCreationInput {
    driver: DriverDto;
    truck: VehicleDto;
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    article: ArticleDiverseProductsDto;
}

export class ProvidersModuleDiverseProductPreReportCreationOutput implements IProvidersModuleDiverseProductPreReportCreationOutput {
    creationResult!: boolean;
    preReportId!: number;
    errorList!: string[] | undefined;

    constructor(data?: IProvidersModuleDiverseProductPreReportCreationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationResult = _data["creationResult"];
            this.preReportId = _data["preReportId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProvidersModuleDiverseProductPreReportCreationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleDiverseProductPreReportCreationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationResult"] = this.creationResult;
        data["preReportId"] = this.preReportId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IProvidersModuleDiverseProductPreReportCreationOutput {
    creationResult: boolean;
    preReportId: number;
    errorList: string[] | undefined;
}

export class ProvidersModuleInternalMovementPreReportCreationOutput implements IProvidersModuleInternalMovementPreReportCreationOutput {
    creationResult!: boolean;
    preReportId!: number;
    errorList!: string[] | undefined;

    constructor(data?: IProvidersModuleInternalMovementPreReportCreationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationResult = _data["creationResult"];
            this.preReportId = _data["preReportId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ProvidersModuleInternalMovementPreReportCreationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleInternalMovementPreReportCreationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationResult"] = this.creationResult;
        data["preReportId"] = this.preReportId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IProvidersModuleInternalMovementPreReportCreationOutput {
    creationResult: boolean;
    preReportId: number;
    errorList: string[] | undefined;
}

export class ProvidersModuleInternalMovementsPreReportCreationInput implements IProvidersModuleInternalMovementsPreReportCreationInput {
    driver!: DriverDto;
    truck!: VehicleDto;
    date!: DateTime;
    article!: ArticleInternalMovementsDto;
    destinationId!: number;
    destinationType!: LocationType;

    constructor(data?: IProvidersModuleInternalMovementsPreReportCreationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.truck = _data["truck"] ? VehicleDto.fromJS(_data["truck"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.article = _data["article"] ? ArticleInternalMovementsDto.fromJS(_data["article"]) : <any>undefined;
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
        }
    }

    static fromJS(data: any): ProvidersModuleInternalMovementsPreReportCreationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleInternalMovementsPreReportCreationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["truck"] = this.truck ? this.truck.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        return data;
    }
}

export interface IProvidersModuleInternalMovementsPreReportCreationInput {
    driver: DriverDto;
    truck: VehicleDto;
    date: DateTime;
    article: ArticleInternalMovementsDto;
    destinationId: number;
    destinationType: LocationType;
}

export class ProvidersModuleScheduleTripInput implements IProvidersModuleScheduleTripInput {
    receiptId!: number;
    entryTime!: DateTime;

    constructor(data?: IProvidersModuleScheduleTripInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.entryTime = _data["entryTime"] ? DateTime.fromISO(_data["entryTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvidersModuleScheduleTripInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleScheduleTripInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["entryTime"] = this.entryTime ? this.entryTime.toString() : <any>undefined;
        return data;
    }
}

export interface IProvidersModuleScheduleTripInput {
    receiptId: number;
    entryTime: DateTime;
}

export class ProvidersModuleWoodPreReportCreationOutput implements IProvidersModuleWoodPreReportCreationOutput {
    creationResult!: boolean;
    preReportId!: number;
    errorList!: string[] | undefined;
    imageExpired!: boolean;

    constructor(data?: IProvidersModuleWoodPreReportCreationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationResult = _data["creationResult"];
            this.preReportId = _data["preReportId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.imageExpired = _data["imageExpired"];
        }
    }

    static fromJS(data: any): ProvidersModuleWoodPreReportCreationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersModuleWoodPreReportCreationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationResult"] = this.creationResult;
        data["preReportId"] = this.preReportId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["imageExpired"] = this.imageExpired;
        return data;
    }
}

export interface IProvidersModuleWoodPreReportCreationOutput {
    creationResult: boolean;
    preReportId: number;
    errorList: string[] | undefined;
    imageExpired: boolean;
}

export class ProvidersPreActivityReportCreationInput implements IProvidersPreActivityReportCreationInput {
    dateCreated!: DateTime;
    lengthId!: number | undefined;
    speciesCode!: string | undefined;
    truckPlate!: string | undefined;
    semiTrailerPlates!: string[] | undefined;
    receiptSerial!: string | undefined;
    receiptNumber!: number;
    propertyCode!: string | undefined;
    isFscCertified!: boolean;
    driverIdentityCard!: string | undefined;
    receiptPhoto!: string | undefined;
    isWoodLog!: boolean;
    propertyCategory!: number | undefined;
    destinationId!: number | undefined;

    constructor(data?: IProvidersPreActivityReportCreationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.lengthId = _data["lengthId"];
            this.speciesCode = _data["speciesCode"];
            this.truckPlate = _data["truckPlate"];
            if (Array.isArray(_data["semiTrailerPlates"])) {
                this.semiTrailerPlates = [] as any;
                for (let item of _data["semiTrailerPlates"])
                    this.semiTrailerPlates!.push(item);
            }
            this.receiptSerial = _data["receiptSerial"];
            this.receiptNumber = _data["receiptNumber"];
            this.propertyCode = _data["propertyCode"];
            this.isFscCertified = _data["isFscCertified"];
            this.driverIdentityCard = _data["driverIdentityCard"];
            this.receiptPhoto = _data["receiptPhoto"];
            this.isWoodLog = _data["isWoodLog"];
            this.propertyCategory = _data["propertyCategory"];
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): ProvidersPreActivityReportCreationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersPreActivityReportCreationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["lengthId"] = this.lengthId;
        data["speciesCode"] = this.speciesCode;
        data["truckPlate"] = this.truckPlate;
        if (Array.isArray(this.semiTrailerPlates)) {
            data["semiTrailerPlates"] = [];
            for (let item of this.semiTrailerPlates)
                data["semiTrailerPlates"].push(item);
        }
        data["receiptSerial"] = this.receiptSerial;
        data["receiptNumber"] = this.receiptNumber;
        data["propertyCode"] = this.propertyCode;
        data["isFscCertified"] = this.isFscCertified;
        data["driverIdentityCard"] = this.driverIdentityCard;
        data["receiptPhoto"] = this.receiptPhoto;
        data["isWoodLog"] = this.isWoodLog;
        data["propertyCategory"] = this.propertyCategory;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IProvidersPreActivityReportCreationInput {
    dateCreated: DateTime;
    lengthId: number | undefined;
    speciesCode: string | undefined;
    truckPlate: string | undefined;
    semiTrailerPlates: string[] | undefined;
    receiptSerial: string | undefined;
    receiptNumber: number;
    propertyCode: string | undefined;
    isFscCertified: boolean;
    driverIdentityCard: string | undefined;
    receiptPhoto: string | undefined;
    isWoodLog: boolean;
    propertyCategory: number | undefined;
    destinationId: number | undefined;
}

export class PushSubscriptionChangeInputDto implements IPushSubscriptionChangeInputDto {
    oldEndpoint!: string | undefined;
    newEndpoint!: string | undefined;
    newP256dh!: string | undefined;
    newAuth!: string | undefined;

    constructor(data?: IPushSubscriptionChangeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldEndpoint = _data["oldEndpoint"];
            this.newEndpoint = _data["newEndpoint"];
            this.newP256dh = _data["newP256dh"];
            this.newAuth = _data["newAuth"];
        }
    }

    static fromJS(data: any): PushSubscriptionChangeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushSubscriptionChangeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldEndpoint"] = this.oldEndpoint;
        data["newEndpoint"] = this.newEndpoint;
        data["newP256dh"] = this.newP256dh;
        data["newAuth"] = this.newAuth;
        return data;
    }
}

export interface IPushSubscriptionChangeInputDto {
    oldEndpoint: string | undefined;
    newEndpoint: string | undefined;
    newP256dh: string | undefined;
    newAuth: string | undefined;
}

export class PushSubscriptionDto implements IPushSubscriptionDto {
    endpoint!: string | undefined;
    expirationTime!: number | undefined;
    auth!: string | undefined;
    p256dh!: string | undefined;

    constructor(data?: IPushSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.expirationTime = _data["expirationTime"];
            this.auth = _data["auth"];
            this.p256dh = _data["p256dh"];
        }
    }

    static fromJS(data: any): PushSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["expirationTime"] = this.expirationTime;
        data["auth"] = this.auth;
        data["p256dh"] = this.p256dh;
        return data;
    }
}

export interface IPushSubscriptionDto {
    endpoint: string | undefined;
    expirationTime: number | undefined;
    auth: string | undefined;
    p256dh: string | undefined;
}

export class QRConfirmationTotemInput implements IQRConfirmationTotemInput {
    qrCode!: string | undefined;
    receiptPhotoToken!: string | undefined;
    truckPlate!: string | undefined;
    semisPlates!: string[] | undefined;
    driverId!: number;
    destinationId!: number;
    isTruckPlateDifferentConfirmed!: boolean;
    truckPlateParsedFromQR!: string | undefined;

    constructor(data?: IQRConfirmationTotemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCode = _data["qrCode"];
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.truckPlate = _data["truckPlate"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.driverId = _data["driverId"];
            this.destinationId = _data["destinationId"];
            this.isTruckPlateDifferentConfirmed = _data["isTruckPlateDifferentConfirmed"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
        }
    }

    static fromJS(data: any): QRConfirmationTotemInput {
        data = typeof data === 'object' ? data : {};
        let result = new QRConfirmationTotemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["truckPlate"] = this.truckPlate;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["driverId"] = this.driverId;
        data["destinationId"] = this.destinationId;
        data["isTruckPlateDifferentConfirmed"] = this.isTruckPlateDifferentConfirmed;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        return data;
    }
}

export interface IQRConfirmationTotemInput {
    qrCode: string | undefined;
    receiptPhotoToken: string | undefined;
    truckPlate: string | undefined;
    semisPlates: string[] | undefined;
    driverId: number;
    destinationId: number;
    isTruckPlateDifferentConfirmed: boolean;
    truckPlateParsedFromQR: string | undefined;
}

export class QRReceivedDto implements IQRReceivedDto {
    reportId!: number;
    isProcessing!: boolean;
    isQrReadCorrectly!: boolean;
    message!: string | undefined;
    generationTime!: DateTime;
    zoneId!: number;

    constructor(data?: IQRReceivedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.isProcessing = _data["isProcessing"];
            this.isQrReadCorrectly = _data["isQrReadCorrectly"];
            this.message = _data["message"];
            this.generationTime = _data["generationTime"] ? DateTime.fromISO(_data["generationTime"].toString()) : <any>undefined;
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): QRReceivedDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRReceivedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["isProcessing"] = this.isProcessing;
        data["isQrReadCorrectly"] = this.isQrReadCorrectly;
        data["message"] = this.message;
        data["generationTime"] = this.generationTime ? this.generationTime.toString() : <any>undefined;
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IQRReceivedDto {
    reportId: number;
    isProcessing: boolean;
    isQrReadCorrectly: boolean;
    message: string | undefined;
    generationTime: DateTime;
    zoneId: number;
}

export class QRSmartTruckInput implements IQRSmartTruckInput {
    qrCode!: string | undefined;
    receiptPhotoToken!: string | undefined;
    truckPlateParsedFromQR!: string | undefined;
    isTruckPlateDifferentConfirmed!: boolean;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: IQRSmartTruckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCode = _data["qrCode"];
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
            this.isTruckPlateDifferentConfirmed = _data["isTruckPlateDifferentConfirmed"];
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): QRSmartTruckInput {
        data = typeof data === 'object' ? data : {};
        let result = new QRSmartTruckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        data["isTruckPlateDifferentConfirmed"] = this.isTruckPlateDifferentConfirmed;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface IQRSmartTruckInput {
    qrCode: string | undefined;
    receiptPhotoToken: string | undefined;
    truckPlateParsedFromQR: string | undefined;
    isTruckPlateDifferentConfirmed: boolean;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class QRWoodPreActivityReportInput implements IQRWoodPreActivityReportInput {
    qrCode!: string | undefined;
    driverId!: number;
    truckPlate!: string | undefined;
    semisPlates!: string[] | undefined;
    destinationId!: number;
    isTruckPlateDifferentConfirmed!: boolean;
    truckPlateParsedFromQR!: string | undefined;

    constructor(data?: IQRWoodPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCode = _data["qrCode"];
            this.driverId = _data["driverId"];
            this.truckPlate = _data["truckPlate"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.destinationId = _data["destinationId"];
            this.isTruckPlateDifferentConfirmed = _data["isTruckPlateDifferentConfirmed"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
        }
    }

    static fromJS(data: any): QRWoodPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new QRWoodPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["driverId"] = this.driverId;
        data["truckPlate"] = this.truckPlate;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["destinationId"] = this.destinationId;
        data["isTruckPlateDifferentConfirmed"] = this.isTruckPlateDifferentConfirmed;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        return data;
    }
}

export interface IQRWoodPreActivityReportInput {
    qrCode: string | undefined;
    driverId: number;
    truckPlate: string | undefined;
    semisPlates: string[] | undefined;
    destinationId: number;
    isTruckPlateDifferentConfirmed: boolean;
    truckPlateParsedFromQR: string | undefined;
}

export class RandomSampleAssignationOutputDto implements IRandomSampleAssignationOutputDto {
    originName!: string | undefined;
    standName!: string | undefined;
    periodDescription!: string | undefined;
    speciesGroupName!: string | undefined;
    modelId!: number;
    randomSampleCount!: number;
    reportCount!: number;

    constructor(data?: IRandomSampleAssignationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originName = _data["originName"];
            this.standName = _data["standName"];
            this.periodDescription = _data["periodDescription"];
            this.speciesGroupName = _data["speciesGroupName"];
            this.modelId = _data["modelId"];
            this.randomSampleCount = _data["randomSampleCount"];
            this.reportCount = _data["reportCount"];
        }
    }

    static fromJS(data: any): RandomSampleAssignationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RandomSampleAssignationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originName"] = this.originName;
        data["standName"] = this.standName;
        data["periodDescription"] = this.periodDescription;
        data["speciesGroupName"] = this.speciesGroupName;
        data["modelId"] = this.modelId;
        data["randomSampleCount"] = this.randomSampleCount;
        data["reportCount"] = this.reportCount;
        return data;
    }
}

export interface IRandomSampleAssignationOutputDto {
    originName: string | undefined;
    standName: string | undefined;
    periodDescription: string | undefined;
    speciesGroupName: string | undefined;
    modelId: number;
    randomSampleCount: number;
    reportCount: number;
}

export class RandomSampleAssignationReportInputDto implements IRandomSampleAssignationReportInputDto {
    placeId!: number;
    placeName!: string | undefined;
    periodId!: number;
    modelId!: number | undefined;
    woodOriginExternalId!: number | undefined;

    constructor(data?: IRandomSampleAssignationReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.placeName = _data["placeName"];
            this.periodId = _data["periodId"];
            this.modelId = _data["modelId"];
            this.woodOriginExternalId = _data["woodOriginExternalId"];
        }
    }

    static fromJS(data: any): RandomSampleAssignationReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RandomSampleAssignationReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["placeName"] = this.placeName;
        data["periodId"] = this.periodId;
        data["modelId"] = this.modelId;
        data["woodOriginExternalId"] = this.woodOriginExternalId;
        return data;
    }
}

export interface IRandomSampleAssignationReportInputDto {
    placeId: number;
    placeName: string | undefined;
    periodId: number;
    modelId: number | undefined;
    woodOriginExternalId: number | undefined;
}

export class RandomStatisticalSampleQuotaDto implements IRandomStatisticalSampleQuotaDto {
    modelId!: number;
    speciesGroup!: SpeciesGroupDto;
    woodOriginType!: LocationType;
    amount!: number;
    samplePercentage!: number;
    placeId!: number;
    id!: number;

    constructor(data?: IRandomStatisticalSampleQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.speciesGroup = _data["speciesGroup"] ? SpeciesGroupDto.fromJS(_data["speciesGroup"]) : <any>undefined;
            this.woodOriginType = _data["woodOriginType"];
            this.amount = _data["amount"];
            this.samplePercentage = _data["samplePercentage"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RandomStatisticalSampleQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RandomStatisticalSampleQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["speciesGroup"] = this.speciesGroup ? this.speciesGroup.toJSON() : <any>undefined;
        data["woodOriginType"] = this.woodOriginType;
        data["amount"] = this.amount;
        data["samplePercentage"] = this.samplePercentage;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRandomStatisticalSampleQuotaDto {
    modelId: number;
    speciesGroup: SpeciesGroupDto;
    woodOriginType: LocationType;
    amount: number;
    samplePercentage: number;
    placeId: number;
    id: number;
}

export class RecoverSamplesOnLogyardsReportEditionInput implements IRecoverSamplesOnLogyardsReportEditionInput {
    originId!: number;
    originType!: LocationType;
    placeId!: number;
    entryDate!: DateTime;
    reportThirdPropertyCategoryId!: number | undefined;
    logyardsLinesSamplingInput!: LogyardsLineSamplingInputDto[] | undefined;
    destinationId!: number;

    constructor(data?: IRecoverSamplesOnLogyardsReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originId = _data["originId"];
            this.originType = _data["originType"];
            this.placeId = _data["placeId"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.reportThirdPropertyCategoryId = _data["reportThirdPropertyCategoryId"];
            if (Array.isArray(_data["logyardsLinesSamplingInput"])) {
                this.logyardsLinesSamplingInput = [] as any;
                for (let item of _data["logyardsLinesSamplingInput"])
                    this.logyardsLinesSamplingInput!.push(LogyardsLineSamplingInputDto.fromJS(item));
            }
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): RecoverSamplesOnLogyardsReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new RecoverSamplesOnLogyardsReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originId"] = this.originId;
        data["originType"] = this.originType;
        data["placeId"] = this.placeId;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["reportThirdPropertyCategoryId"] = this.reportThirdPropertyCategoryId;
        if (Array.isArray(this.logyardsLinesSamplingInput)) {
            data["logyardsLinesSamplingInput"] = [];
            for (let item of this.logyardsLinesSamplingInput)
                data["logyardsLinesSamplingInput"].push(item.toJSON());
        }
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IRecoverSamplesOnLogyardsReportEditionInput {
    originId: number;
    originType: LocationType;
    placeId: number;
    entryDate: DateTime;
    reportThirdPropertyCategoryId: number | undefined;
    logyardsLinesSamplingInput: LogyardsLineSamplingInputDto[] | undefined;
    destinationId: number;
}

export class ReleaseSampleInput implements IReleaseSampleInput {
    activityReportId!: number;
    loadActivityReportId!: number;
    sampleAssignment!: SampleAssignmentType;
    sampleIsCompleted!: boolean;

    constructor(data?: IReleaseSampleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.loadActivityReportId = _data["loadActivityReportId"];
            this.sampleAssignment = _data["sampleAssignment"];
            this.sampleIsCompleted = _data["sampleIsCompleted"];
        }
    }

    static fromJS(data: any): ReleaseSampleInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseSampleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["loadActivityReportId"] = this.loadActivityReportId;
        data["sampleAssignment"] = this.sampleAssignment;
        data["sampleIsCompleted"] = this.sampleIsCompleted;
        return data;
    }
}

export interface IReleaseSampleInput {
    activityReportId: number;
    loadActivityReportId: number;
    sampleAssignment: SampleAssignmentType;
    sampleIsCompleted: boolean;
}

export class ReportByProviderOutputPagedDto implements IReportByProviderOutputPagedDto {
    reportId!: number;
    reportNumber!: number;
    reportSerial!: string | undefined;
    articleName!: string | undefined;
    species!: string | undefined;
    length!: number;
    driverName!: string | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    origin!: string | undefined;
    destination!: string | undefined;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    tripNumber!: number | undefined;
    licensePlate!: string | undefined;
    truckType!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IReportByProviderOutputPagedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportNumber = _data["reportNumber"];
            this.reportSerial = _data["reportSerial"];
            this.articleName = _data["articleName"];
            this.species = _data["species"];
            this.length = _data["length"];
            this.driverName = _data["driverName"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            this.licensePlate = _data["licensePlate"];
            this.truckType = _data["truckType"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): ReportByProviderOutputPagedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportByProviderOutputPagedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportNumber"] = this.reportNumber;
        data["reportSerial"] = this.reportSerial;
        data["articleName"] = this.articleName;
        data["species"] = this.species;
        data["length"] = this.length;
        data["driverName"] = this.driverName;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        data["licensePlate"] = this.licensePlate;
        data["truckType"] = this.truckType;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IReportByProviderOutputPagedDto {
    reportId: number;
    reportNumber: number;
    reportSerial: string | undefined;
    articleName: string | undefined;
    species: string | undefined;
    length: number;
    driverName: string | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    origin: string | undefined;
    destination: string | undefined;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    tripNumber: number | undefined;
    licensePlate: string | undefined;
    truckType: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class ReportInputDto implements IReportInputDto {
    includeDeletedOnes!: boolean;
    operationMode!: ActivityReportOperationMode;
    originExternalId!: number | undefined;
    standExternalId!: number | undefined;
    destinationExternalId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeDeletedOnes = _data["includeDeletedOnes"];
            this.operationMode = _data["operationMode"];
            this.originExternalId = _data["originExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeDeletedOnes"] = this.includeDeletedOnes;
        data["operationMode"] = this.operationMode;
        data["originExternalId"] = this.originExternalId;
        data["standExternalId"] = this.standExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IReportInputDto {
    includeDeletedOnes: boolean;
    operationMode: ActivityReportOperationMode;
    originExternalId: number | undefined;
    standExternalId: number | undefined;
    destinationExternalId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class ResponseContent implements IResponseContent {
    readonly version!: string | undefined;
    action!: string | undefined;
    userMessage!: string | undefined;
    status!: number | undefined;
    extension_DriverId!: string | undefined;
    extension_IdentityCard!: string | undefined;
    surname!: string | undefined;
    givenName!: string | undefined;

    constructor(data?: IResponseContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).version = _data["version"];
            this.action = _data["action"];
            this.userMessage = _data["userMessage"];
            this.status = _data["status"];
            this.extension_DriverId = _data["extension_DriverId"];
            this.extension_IdentityCard = _data["extension_IdentityCard"];
            this.surname = _data["surname"];
            this.givenName = _data["givenName"];
        }
    }

    static fromJS(data: any): ResponseContent {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["action"] = this.action;
        data["userMessage"] = this.userMessage;
        data["status"] = this.status;
        data["extension_DriverId"] = this.extension_DriverId;
        data["extension_IdentityCard"] = this.extension_IdentityCard;
        data["surname"] = this.surname;
        data["givenName"] = this.givenName;
        return data;
    }
}

export interface IResponseContent {
    version: string | undefined;
    action: string | undefined;
    userMessage: string | undefined;
    status: number | undefined;
    extension_DriverId: string | undefined;
    extension_IdentityCard: string | undefined;
    surname: string | undefined;
    givenName: string | undefined;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    readonly value!: any;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value: any;
}

export enum SampleAssignmentType {
    None = 0,
    SimpleSample = 1,
    CalibrationSample = 2,
    ManualSample = 3,
    RandomStatisticalSample = 4,
}

export class SampleInitializationInputDto implements ISampleInitializationInputDto {
    reportId!: number;
    articleName!: string | undefined;
    standName!: string | undefined;
    licensePlate!: string | undefined;
    transportVendorName!: string | undefined;
    samplingMeditionType!: string | undefined;
    driverName!: string | undefined;
    grossWeight!: number;
    historicalDensity!: number;

    constructor(data?: ISampleInitializationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.articleName = _data["articleName"];
            this.standName = _data["standName"];
            this.licensePlate = _data["licensePlate"];
            this.transportVendorName = _data["transportVendorName"];
            this.samplingMeditionType = _data["samplingMeditionType"];
            this.driverName = _data["driverName"];
            this.grossWeight = _data["grossWeight"];
            this.historicalDensity = _data["historicalDensity"];
        }
    }

    static fromJS(data: any): SampleInitializationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SampleInitializationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["articleName"] = this.articleName;
        data["standName"] = this.standName;
        data["licensePlate"] = this.licensePlate;
        data["transportVendorName"] = this.transportVendorName;
        data["samplingMeditionType"] = this.samplingMeditionType;
        data["driverName"] = this.driverName;
        data["grossWeight"] = this.grossWeight;
        data["historicalDensity"] = this.historicalDensity;
        return data;
    }
}

export interface ISampleInitializationInputDto {
    reportId: number;
    articleName: string | undefined;
    standName: string | undefined;
    licensePlate: string | undefined;
    transportVendorName: string | undefined;
    samplingMeditionType: string | undefined;
    driverName: string | undefined;
    grossWeight: number;
    historicalDensity: number;
}

export enum SampleTypeOfRead {
    Tag = 0,
    Manual = 1,
}

export class SaveSampleInput implements ISaveSampleInput {
    sample!: ArchimedesSampleInstanceDto;
    isManual!: boolean;
    reasonForManualAssignment!: string | undefined;
    activityReportExternalId!: number | undefined;
    loadActivityReportId!: number;
    sampleAssignment!: SampleAssignmentType;
    sampleTypeOfRead!: SampleTypeOfRead;

    constructor(data?: ISaveSampleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sample = _data["sample"] ? ArchimedesSampleInstanceDto.fromJS(_data["sample"]) : <any>undefined;
            this.isManual = _data["isManual"];
            this.reasonForManualAssignment = _data["reasonForManualAssignment"];
            this.activityReportExternalId = _data["activityReportExternalId"];
            this.loadActivityReportId = _data["loadActivityReportId"];
            this.sampleAssignment = _data["sampleAssignment"];
            this.sampleTypeOfRead = _data["sampleTypeOfRead"];
        }
    }

    static fromJS(data: any): SaveSampleInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSampleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sample"] = this.sample ? this.sample.toJSON() : <any>undefined;
        data["isManual"] = this.isManual;
        data["reasonForManualAssignment"] = this.reasonForManualAssignment;
        data["activityReportExternalId"] = this.activityReportExternalId;
        data["loadActivityReportId"] = this.loadActivityReportId;
        data["sampleAssignment"] = this.sampleAssignment;
        data["sampleTypeOfRead"] = this.sampleTypeOfRead;
        return data;
    }
}

export interface ISaveSampleInput {
    sample: ArchimedesSampleInstanceDto;
    isManual: boolean;
    reasonForManualAssignment: string | undefined;
    activityReportExternalId: number | undefined;
    loadActivityReportId: number;
    sampleAssignment: SampleAssignmentType;
    sampleTypeOfRead: SampleTypeOfRead;
}

export class SaveSampleOutput implements ISaveSampleOutput {
    success!: boolean;
    error!: string | undefined;

    constructor(data?: ISaveSampleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): SaveSampleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSampleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface ISaveSampleOutput {
    success: boolean;
    error: string | undefined;
}

export class SaveUserVendorResultOutput implements ISaveUserVendorResultOutput {
    result!: boolean;
    errorList!: string[] | undefined;

    constructor(data?: ISaveUserVendorResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveUserVendorResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserVendorResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface ISaveUserVendorResultOutput {
    result: boolean;
    errorList: string[] | undefined;
}

export class ScaleOutputDto implements IScaleOutputDto {
    deviceId!: number;
    errorList!: string[] | undefined;
    scaleWeight!: number;

    constructor(data?: IScaleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.scaleWeight = _data["scaleWeight"];
        }
    }

    static fromJS(data: any): ScaleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["scaleWeight"] = this.scaleWeight;
        return data;
    }
}

export interface IScaleOutputDto {
    deviceId: number;
    errorList: string[] | undefined;
    scaleWeight: number;
}

export class ScannerCalibrationEventDto implements IScannerCalibrationEventDto {
    ordinal!: number;
    isSuccess!: boolean;
    creationUserName!: string | undefined;
    creationDate!: DateTime;
    id!: number;

    constructor(data?: IScannerCalibrationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinal = _data["ordinal"];
            this.isSuccess = _data["isSuccess"];
            this.creationUserName = _data["creationUserName"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScannerCalibrationEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCalibrationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinal"] = this.ordinal;
        data["isSuccess"] = this.isSuccess;
        data["creationUserName"] = this.creationUserName;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IScannerCalibrationEventDto {
    ordinal: number;
    isSuccess: boolean;
    creationUserName: string | undefined;
    creationDate: DateTime;
    id: number;
}

export class ScannerExceptionDto implements IScannerExceptionDto {
    id!: number;
    originId!: number;
    destinationId!: number;
    periodId!: number;
    startDate!: DateTime;
    endDate!: DateTime;

    constructor(data?: IScannerExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originId = _data["originId"];
            this.destinationId = _data["destinationId"];
            this.periodId = _data["periodId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScannerExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originId"] = this.originId;
        data["destinationId"] = this.destinationId;
        data["periodId"] = this.periodId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface IScannerExceptionDto {
    id: number;
    originId: number;
    destinationId: number;
    periodId: number;
    startDate: DateTime;
    endDate: DateTime;
}

export class ScannerModelDto implements IScannerModelDto {
    id!: number;
    code!: string | undefined;
    measurementPercent!: number;
    thirdPropertyCategoryId!: number;
    minimumTreeVolume!: number;
    maximumTreeVolume!: number;
    specieGroupId!: number;
    lengthId!: number;

    constructor(data?: IScannerModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.measurementPercent = _data["measurementPercent"];
            this.thirdPropertyCategoryId = _data["thirdPropertyCategoryId"];
            this.minimumTreeVolume = _data["minimumTreeVolume"];
            this.maximumTreeVolume = _data["maximumTreeVolume"];
            this.specieGroupId = _data["specieGroupId"];
            this.lengthId = _data["lengthId"];
        }
    }

    static fromJS(data: any): ScannerModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["measurementPercent"] = this.measurementPercent;
        data["thirdPropertyCategoryId"] = this.thirdPropertyCategoryId;
        data["minimumTreeVolume"] = this.minimumTreeVolume;
        data["maximumTreeVolume"] = this.maximumTreeVolume;
        data["specieGroupId"] = this.specieGroupId;
        data["lengthId"] = this.lengthId;
        return data;
    }
}

export interface IScannerModelDto {
    id: number;
    code: string | undefined;
    measurementPercent: number;
    thirdPropertyCategoryId: number;
    minimumTreeVolume: number;
    maximumTreeVolume: number;
    specieGroupId: number;
    lengthId: number;
}

export class ScannerNotificationInputDto implements IScannerNotificationInputDto {
    eventId!: string | undefined;
    activityReportId!: number;
    executionDateTime!: string | undefined;
    averageTotalDiameters!: number;
    solidTotalVolume!: number;
    stereoTotalVolume!: number;
    averageLenghtFixed!: number;
    averageLenghtVisible!: number;
    fullIndicator!: string | undefined;
    averageHeight!: number;
    isDiameterExcesiveAlarm!: boolean;
    interventionState!: string | undefined;
    isRecalculation!: boolean;
    stereoBankVolume!: number[] | undefined;
    averageBankDiameters!: number[] | undefined;
    solidTotalBank!: number[] | undefined;
    superiorUnevennessBank!: number[] | undefined;
    rightSlopeBank!: number[] | undefined;
    leftSlopeBank!: number[] | undefined;
    rightProfileBankPoints!: number[] | undefined;
    leftProfileBankPoints!: number[] | undefined;
    modelId!: number;
    height_Banco!: number[] | undefined;
    bar_Height_Banco!: number[] | undefined;
    length_Classification!: string[] | undefined;
    average_Length_Classification!: string[] | undefined;
    width_Banco!: number[] | undefined;

    constructor(data?: IScannerNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.activityReportId = _data["activityReportId"];
            this.executionDateTime = _data["executionDateTime"];
            this.averageTotalDiameters = _data["averageTotalDiameters"];
            this.solidTotalVolume = _data["solidTotalVolume"];
            this.stereoTotalVolume = _data["stereoTotalVolume"];
            this.averageLenghtFixed = _data["averageLenghtFixed"];
            this.averageLenghtVisible = _data["averageLenghtVisible"];
            this.fullIndicator = _data["fullIndicator"];
            this.averageHeight = _data["averageHeight"];
            this.isDiameterExcesiveAlarm = _data["isDiameterExcesiveAlarm"];
            this.interventionState = _data["interventionState"];
            this.isRecalculation = _data["isRecalculation"];
            if (Array.isArray(_data["stereoBankVolume"])) {
                this.stereoBankVolume = [] as any;
                for (let item of _data["stereoBankVolume"])
                    this.stereoBankVolume!.push(item);
            }
            if (Array.isArray(_data["averageBankDiameters"])) {
                this.averageBankDiameters = [] as any;
                for (let item of _data["averageBankDiameters"])
                    this.averageBankDiameters!.push(item);
            }
            if (Array.isArray(_data["solidTotalBank"])) {
                this.solidTotalBank = [] as any;
                for (let item of _data["solidTotalBank"])
                    this.solidTotalBank!.push(item);
            }
            if (Array.isArray(_data["superiorUnevennessBank"])) {
                this.superiorUnevennessBank = [] as any;
                for (let item of _data["superiorUnevennessBank"])
                    this.superiorUnevennessBank!.push(item);
            }
            if (Array.isArray(_data["rightSlopeBank"])) {
                this.rightSlopeBank = [] as any;
                for (let item of _data["rightSlopeBank"])
                    this.rightSlopeBank!.push(item);
            }
            if (Array.isArray(_data["leftSlopeBank"])) {
                this.leftSlopeBank = [] as any;
                for (let item of _data["leftSlopeBank"])
                    this.leftSlopeBank!.push(item);
            }
            if (Array.isArray(_data["rightProfileBankPoints"])) {
                this.rightProfileBankPoints = [] as any;
                for (let item of _data["rightProfileBankPoints"])
                    this.rightProfileBankPoints!.push(item);
            }
            if (Array.isArray(_data["leftProfileBankPoints"])) {
                this.leftProfileBankPoints = [] as any;
                for (let item of _data["leftProfileBankPoints"])
                    this.leftProfileBankPoints!.push(item);
            }
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["height_Banco"])) {
                this.height_Banco = [] as any;
                for (let item of _data["height_Banco"])
                    this.height_Banco!.push(item);
            }
            if (Array.isArray(_data["bar_Height_Banco"])) {
                this.bar_Height_Banco = [] as any;
                for (let item of _data["bar_Height_Banco"])
                    this.bar_Height_Banco!.push(item);
            }
            if (Array.isArray(_data["length_Classification"])) {
                this.length_Classification = [] as any;
                for (let item of _data["length_Classification"])
                    this.length_Classification!.push(item);
            }
            if (Array.isArray(_data["average_Length_Classification"])) {
                this.average_Length_Classification = [] as any;
                for (let item of _data["average_Length_Classification"])
                    this.average_Length_Classification!.push(item);
            }
            if (Array.isArray(_data["width_Banco"])) {
                this.width_Banco = [] as any;
                for (let item of _data["width_Banco"])
                    this.width_Banco!.push(item);
            }
        }
    }

    static fromJS(data: any): ScannerNotificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["activityReportId"] = this.activityReportId;
        data["executionDateTime"] = this.executionDateTime;
        data["averageTotalDiameters"] = this.averageTotalDiameters;
        data["solidTotalVolume"] = this.solidTotalVolume;
        data["stereoTotalVolume"] = this.stereoTotalVolume;
        data["averageLenghtFixed"] = this.averageLenghtFixed;
        data["averageLenghtVisible"] = this.averageLenghtVisible;
        data["fullIndicator"] = this.fullIndicator;
        data["averageHeight"] = this.averageHeight;
        data["isDiameterExcesiveAlarm"] = this.isDiameterExcesiveAlarm;
        data["interventionState"] = this.interventionState;
        data["isRecalculation"] = this.isRecalculation;
        if (Array.isArray(this.stereoBankVolume)) {
            data["stereoBankVolume"] = [];
            for (let item of this.stereoBankVolume)
                data["stereoBankVolume"].push(item);
        }
        if (Array.isArray(this.averageBankDiameters)) {
            data["averageBankDiameters"] = [];
            for (let item of this.averageBankDiameters)
                data["averageBankDiameters"].push(item);
        }
        if (Array.isArray(this.solidTotalBank)) {
            data["solidTotalBank"] = [];
            for (let item of this.solidTotalBank)
                data["solidTotalBank"].push(item);
        }
        if (Array.isArray(this.superiorUnevennessBank)) {
            data["superiorUnevennessBank"] = [];
            for (let item of this.superiorUnevennessBank)
                data["superiorUnevennessBank"].push(item);
        }
        if (Array.isArray(this.rightSlopeBank)) {
            data["rightSlopeBank"] = [];
            for (let item of this.rightSlopeBank)
                data["rightSlopeBank"].push(item);
        }
        if (Array.isArray(this.leftSlopeBank)) {
            data["leftSlopeBank"] = [];
            for (let item of this.leftSlopeBank)
                data["leftSlopeBank"].push(item);
        }
        if (Array.isArray(this.rightProfileBankPoints)) {
            data["rightProfileBankPoints"] = [];
            for (let item of this.rightProfileBankPoints)
                data["rightProfileBankPoints"].push(item);
        }
        if (Array.isArray(this.leftProfileBankPoints)) {
            data["leftProfileBankPoints"] = [];
            for (let item of this.leftProfileBankPoints)
                data["leftProfileBankPoints"].push(item);
        }
        data["modelId"] = this.modelId;
        if (Array.isArray(this.height_Banco)) {
            data["height_Banco"] = [];
            for (let item of this.height_Banco)
                data["height_Banco"].push(item);
        }
        if (Array.isArray(this.bar_Height_Banco)) {
            data["bar_Height_Banco"] = [];
            for (let item of this.bar_Height_Banco)
                data["bar_Height_Banco"].push(item);
        }
        if (Array.isArray(this.length_Classification)) {
            data["length_Classification"] = [];
            for (let item of this.length_Classification)
                data["length_Classification"].push(item);
        }
        if (Array.isArray(this.average_Length_Classification)) {
            data["average_Length_Classification"] = [];
            for (let item of this.average_Length_Classification)
                data["average_Length_Classification"].push(item);
        }
        if (Array.isArray(this.width_Banco)) {
            data["width_Banco"] = [];
            for (let item of this.width_Banco)
                data["width_Banco"].push(item);
        }
        return data;
    }
}

export interface IScannerNotificationInputDto {
    eventId: string | undefined;
    activityReportId: number;
    executionDateTime: string | undefined;
    averageTotalDiameters: number;
    solidTotalVolume: number;
    stereoTotalVolume: number;
    averageLenghtFixed: number;
    averageLenghtVisible: number;
    fullIndicator: string | undefined;
    averageHeight: number;
    isDiameterExcesiveAlarm: boolean;
    interventionState: string | undefined;
    isRecalculation: boolean;
    stereoBankVolume: number[] | undefined;
    averageBankDiameters: number[] | undefined;
    solidTotalBank: number[] | undefined;
    superiorUnevennessBank: number[] | undefined;
    rightSlopeBank: number[] | undefined;
    leftSlopeBank: number[] | undefined;
    rightProfileBankPoints: number[] | undefined;
    leftProfileBankPoints: number[] | undefined;
    modelId: number;
    height_Banco: number[] | undefined;
    bar_Height_Banco: number[] | undefined;
    length_Classification: string[] | undefined;
    average_Length_Classification: string[] | undefined;
    width_Banco: number[] | undefined;
}

export class ScheduleTripInput implements IScheduleTripInput {
    receiptId!: number;
    entryTime!: DateTime;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: IScheduleTripInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.entryTime = _data["entryTime"] ? DateTime.fromISO(_data["entryTime"].toString()) : <any>undefined;
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): ScheduleTripInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTripInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["entryTime"] = this.entryTime ? this.entryTime.toString() : <any>undefined;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface IScheduleTripInput {
    receiptId: number;
    entryTime: DateTime;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class ScheduleTripOutput implements IScheduleTripOutput {
    result!: boolean;
    scheduledEntryTime!: DateTime;
    receiptId!: number;
    errorList!: string[] | undefined;

    constructor(data?: IScheduleTripOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.receiptId = _data["receiptId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ScheduleTripOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTripOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["receiptId"] = this.receiptId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IScheduleTripOutput {
    result: boolean;
    scheduledEntryTime: DateTime;
    receiptId: number;
    errorList: string[] | undefined;
}

export class SearchReportOutputDto implements ISearchReportOutputDto {
    id!: number;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    exitDate!: DateTime | undefined;
    originType!: LocationType;
    origin!: string | undefined;
    destination!: string | undefined;
    licensePlate!: string | undefined;
    state!: ActivityReportState;
    operationMode!: ActivityReportOperationMode;
    localId!: number;
    standName!: string | undefined;
    pileName!: string | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;

    constructor(data?: ISearchReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.originType = _data["originType"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.licensePlate = _data["licensePlate"];
            this.state = _data["state"];
            this.operationMode = _data["operationMode"];
            this.localId = _data["localId"];
            this.standName = _data["standName"];
            this.pileName = _data["pileName"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
        }
    }

    static fromJS(data: any): SearchReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["originType"] = this.originType;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["licensePlate"] = this.licensePlate;
        data["state"] = this.state;
        data["operationMode"] = this.operationMode;
        data["localId"] = this.localId;
        data["standName"] = this.standName;
        data["pileName"] = this.pileName;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        return data;
    }
}

export interface ISearchReportOutputDto {
    id: number;
    serial: string | undefined;
    number: number;
    date: DateTime;
    exitDate: DateTime | undefined;
    originType: LocationType;
    origin: string | undefined;
    destination: string | undefined;
    licensePlate: string | undefined;
    state: ActivityReportState;
    operationMode: ActivityReportOperationMode;
    localId: number;
    standName: string | undefined;
    pileName: string | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
}

export class SearchWoodVendorQuotaOutputDto implements ISearchWoodVendorQuotaOutputDto {
    woodVendorNames!: string[] | undefined;
    hourlyQuota!: number;
    tolerance!: number;
    woodVendorQuotaId!: number;
    volumeDailyTolerance!: number;

    constructor(data?: ISearchWoodVendorQuotaOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["woodVendorNames"])) {
                this.woodVendorNames = [] as any;
                for (let item of _data["woodVendorNames"])
                    this.woodVendorNames!.push(item);
            }
            this.hourlyQuota = _data["hourlyQuota"];
            this.tolerance = _data["tolerance"];
            this.woodVendorQuotaId = _data["woodVendorQuotaId"];
            this.volumeDailyTolerance = _data["volumeDailyTolerance"];
        }
    }

    static fromJS(data: any): SearchWoodVendorQuotaOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWoodVendorQuotaOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.woodVendorNames)) {
            data["woodVendorNames"] = [];
            for (let item of this.woodVendorNames)
                data["woodVendorNames"].push(item);
        }
        data["hourlyQuota"] = this.hourlyQuota;
        data["tolerance"] = this.tolerance;
        data["woodVendorQuotaId"] = this.woodVendorQuotaId;
        data["volumeDailyTolerance"] = this.volumeDailyTolerance;
        return data;
    }
}

export interface ISearchWoodVendorQuotaOutputDto {
    woodVendorNames: string[] | undefined;
    hourlyQuota: number;
    tolerance: number;
    woodVendorQuotaId: number;
    volumeDailyTolerance: number;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class SemiTrailerDto implements ISemiTrailerDto {
    id!: number;
    name!: string | undefined;
    licensePlate!: string | undefined;
    isActive!: boolean;
    vendorId!: number;
    errorList!: string[] | undefined;

    constructor(data?: ISemiTrailerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.licensePlate = _data["licensePlate"];
            this.isActive = _data["isActive"];
            this.vendorId = _data["vendorId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): SemiTrailerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SemiTrailerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["licensePlate"] = this.licensePlate;
        data["isActive"] = this.isActive;
        data["vendorId"] = this.vendorId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface ISemiTrailerDto {
    id: number;
    name: string | undefined;
    licensePlate: string | undefined;
    isActive: boolean;
    vendorId: number;
    errorList: string[] | undefined;
}

export class SendSignalForScannerCalibrationInputDto implements ISendSignalForScannerCalibrationInputDto {
    scannerCalibrationId!: number;
    ordinal!: number;
    scannerId!: number;

    constructor(data?: ISendSignalForScannerCalibrationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scannerCalibrationId = _data["scannerCalibrationId"];
            this.ordinal = _data["ordinal"];
            this.scannerId = _data["scannerId"];
        }
    }

    static fromJS(data: any): SendSignalForScannerCalibrationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendSignalForScannerCalibrationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scannerCalibrationId"] = this.scannerCalibrationId;
        data["ordinal"] = this.ordinal;
        data["scannerId"] = this.scannerId;
        return data;
    }
}

export interface ISendSignalForScannerCalibrationInputDto {
    scannerCalibrationId: number;
    ordinal: number;
    scannerId: number;
}

export class SendSignalInputDto implements ISendSignalInputDto {
    reportId!: number;
    date!: DateTime;
    species!: number;
    length!: string | undefined;
    treeVolume!: number;
    category!: number;
    truckType!: string | undefined;
    bankQuantity!: number;
    vehicleQuantity!: number;
    netWeight!: number;
    grossWeight!: number;
    maxHeight!: number;
    provider!: string | undefined;
    modelId!: number;
    plate!: string | undefined;
    woodOrigin!: string | undefined;
    deviceId!: number;
    minDensity!: number;
    maxDensity!: number;

    constructor(data?: ISendSignalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.species = _data["species"];
            this.length = _data["length"];
            this.treeVolume = _data["treeVolume"];
            this.category = _data["category"];
            this.truckType = _data["truckType"];
            this.bankQuantity = _data["bankQuantity"];
            this.vehicleQuantity = _data["vehicleQuantity"];
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"];
            this.maxHeight = _data["maxHeight"];
            this.provider = _data["provider"];
            this.modelId = _data["modelId"];
            this.plate = _data["plate"];
            this.woodOrigin = _data["woodOrigin"];
            this.deviceId = _data["deviceId"];
            this.minDensity = _data["minDensity"];
            this.maxDensity = _data["maxDensity"];
        }
    }

    static fromJS(data: any): SendSignalInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendSignalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["species"] = this.species;
        data["length"] = this.length;
        data["treeVolume"] = this.treeVolume;
        data["category"] = this.category;
        data["truckType"] = this.truckType;
        data["bankQuantity"] = this.bankQuantity;
        data["vehicleQuantity"] = this.vehicleQuantity;
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight;
        data["maxHeight"] = this.maxHeight;
        data["provider"] = this.provider;
        data["modelId"] = this.modelId;
        data["plate"] = this.plate;
        data["woodOrigin"] = this.woodOrigin;
        data["deviceId"] = this.deviceId;
        data["minDensity"] = this.minDensity;
        data["maxDensity"] = this.maxDensity;
        return data;
    }
}

export interface ISendSignalInputDto {
    reportId: number;
    date: DateTime;
    species: number;
    length: string | undefined;
    treeVolume: number;
    category: number;
    truckType: string | undefined;
    bankQuantity: number;
    vehicleQuantity: number;
    netWeight: number;
    grossWeight: number;
    maxHeight: number;
    provider: string | undefined;
    modelId: number;
    plate: string | undefined;
    woodOrigin: string | undefined;
    deviceId: number;
    minDensity: number;
    maxDensity: number;
}

export class ServiceActivityDto implements IServiceActivityDto {
    id!: number;
    name!: string | undefined;
    vendorId!: number;

    constructor(data?: IServiceActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vendorId = _data["vendorId"];
        }
    }

    static fromJS(data: any): ServiceActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vendorId"] = this.vendorId;
        return data;
    }
}

export interface IServiceActivityDto {
    id: number;
    name: string | undefined;
    vendorId: number;
}

export class ServiceConfigurationForVisualizationDto implements IServiceConfigurationForVisualizationDto {
    id!: number;
    destinationName!: string | undefined;
    articleName!: string | undefined;
    originName!: string | undefined;
    serviceType!: ServiceType;
    serviceDisplayName!: string | undefined;

    constructor(data?: IServiceConfigurationForVisualizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.destinationName = _data["destinationName"];
            this.articleName = _data["articleName"];
            this.originName = _data["originName"];
            this.serviceType = _data["serviceType"];
            this.serviceDisplayName = _data["serviceDisplayName"];
        }
    }

    static fromJS(data: any): ServiceConfigurationForVisualizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConfigurationForVisualizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["destinationName"] = this.destinationName;
        data["articleName"] = this.articleName;
        data["originName"] = this.originName;
        data["serviceType"] = this.serviceType;
        data["serviceDisplayName"] = this.serviceDisplayName;
        return data;
    }
}

export interface IServiceConfigurationForVisualizationDto {
    id: number;
    destinationName: string | undefined;
    articleName: string | undefined;
    originName: string | undefined;
    serviceType: ServiceType;
    serviceDisplayName: string | undefined;
}

export class ServiceEntrySheetInformationDto implements IServiceEntrySheetInformationDto {
    serviceEntrySheetNumber!: number;
    serviceName!: string | undefined;
    isReversed!: boolean;
    generatedDate!: DateTime;
    reversedDate!: DateTime | undefined;

    constructor(data?: IServiceEntrySheetInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceEntrySheetNumber = _data["serviceEntrySheetNumber"];
            this.serviceName = _data["serviceName"];
            this.isReversed = _data["isReversed"];
            this.generatedDate = _data["generatedDate"] ? DateTime.fromISO(_data["generatedDate"].toString()) : <any>undefined;
            this.reversedDate = _data["reversedDate"] ? DateTime.fromISO(_data["reversedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceEntrySheetInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEntrySheetInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceEntrySheetNumber"] = this.serviceEntrySheetNumber;
        data["serviceName"] = this.serviceName;
        data["isReversed"] = this.isReversed;
        data["generatedDate"] = this.generatedDate ? this.generatedDate.toString() : <any>undefined;
        data["reversedDate"] = this.reversedDate ? this.reversedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IServiceEntrySheetInformationDto {
    serviceEntrySheetNumber: number;
    serviceName: string | undefined;
    isReversed: boolean;
    generatedDate: DateTime;
    reversedDate: DateTime | undefined;
}

export enum ServiceType {
    Transport = 0,
    Load = 1,
}

export class ShouldBeSampledAtLogyardInput implements IShouldBeSampledAtLogyardInput {
    reportId!: number;
    destinationId!: number;
    date!: DateTime;
    logyardsLinesSamplingInput!: LogyardsLineSamplingInputDto[] | undefined;

    constructor(data?: IShouldBeSampledAtLogyardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.destinationId = _data["destinationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["logyardsLinesSamplingInput"])) {
                this.logyardsLinesSamplingInput = [] as any;
                for (let item of _data["logyardsLinesSamplingInput"])
                    this.logyardsLinesSamplingInput!.push(LogyardsLineSamplingInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShouldBeSampledAtLogyardInput {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldBeSampledAtLogyardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["destinationId"] = this.destinationId;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.logyardsLinesSamplingInput)) {
            data["logyardsLinesSamplingInput"] = [];
            for (let item of this.logyardsLinesSamplingInput)
                data["logyardsLinesSamplingInput"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShouldBeSampledAtLogyardInput {
    reportId: number;
    destinationId: number;
    date: DateTime;
    logyardsLinesSamplingInput: LogyardsLineSamplingInputDto[] | undefined;
}

export class ShouldBeSampledAtLogyardOutput implements IShouldBeSampledAtLogyardOutput {
    shouldBeSampled!: boolean;
    wasAssignedSample!: boolean;
    message!: string | undefined;

    constructor(data?: IShouldBeSampledAtLogyardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldBeSampled = _data["shouldBeSampled"];
            this.wasAssignedSample = _data["wasAssignedSample"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ShouldBeSampledAtLogyardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldBeSampledAtLogyardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldBeSampled"] = this.shouldBeSampled;
        data["wasAssignedSample"] = this.wasAssignedSample;
        data["message"] = this.message;
        return data;
    }
}

export interface IShouldBeSampledAtLogyardOutput {
    shouldBeSampled: boolean;
    wasAssignedSample: boolean;
    message: string | undefined;
}

export class SimpleLocationDto implements ISimpleLocationDto {
    id!: number;
    name!: string | undefined;
    readonly locationTypeId!: number;
    locationType!: LocationType;
    paysTransport!: boolean | undefined;

    constructor(data?: ISimpleLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).locationTypeId = _data["locationTypeId"];
            this.locationType = _data["locationType"];
            this.paysTransport = _data["paysTransport"];
        }
    }

    static fromJS(data: any): SimpleLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationTypeId"] = this.locationTypeId;
        data["locationType"] = this.locationType;
        data["paysTransport"] = this.paysTransport;
        return data;
    }
}

export interface ISimpleLocationDto {
    id: number;
    name: string | undefined;
    locationTypeId: number;
    locationType: LocationType;
    paysTransport: boolean | undefined;
}

export class SingleCustomDeclarationOutput implements ISingleCustomDeclarationOutput {
    id!: number;
    number!: string | undefined;
    vendorId!: number;
    ncmName!: string | undefined;
    errorList!: string[] | undefined;
    tons!: number;
    tonsWarning!: number;

    constructor(data?: ISingleCustomDeclarationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.vendorId = _data["vendorId"];
            this.ncmName = _data["ncmName"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.tons = _data["tons"];
            this.tonsWarning = _data["tonsWarning"];
        }
    }

    static fromJS(data: any): SingleCustomDeclarationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SingleCustomDeclarationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["vendorId"] = this.vendorId;
        data["ncmName"] = this.ncmName;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["tons"] = this.tons;
        data["tonsWarning"] = this.tonsWarning;
        return data;
    }
}

export interface ISingleCustomDeclarationOutput {
    id: number;
    number: string | undefined;
    vendorId: number;
    ncmName: string | undefined;
    errorList: string[] | undefined;
    tons: number;
    tonsWarning: number;
}

export class SmartLoadInvoiceArticleDto implements ISmartLoadInvoiceArticleDto {
    externalId!: number;
    resourceName!: string | undefined;
    speciesId!: number;
    lengthId!: number;
    isFscCertified!: boolean;
    specieName!: string | undefined;

    constructor(data?: ISmartLoadInvoiceArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.resourceName = _data["resourceName"];
            this.speciesId = _data["speciesId"];
            this.lengthId = _data["lengthId"];
            this.isFscCertified = _data["isFscCertified"];
            this.specieName = _data["specieName"];
        }
    }

    static fromJS(data: any): SmartLoadInvoiceArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartLoadInvoiceArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["resourceName"] = this.resourceName;
        data["speciesId"] = this.speciesId;
        data["lengthId"] = this.lengthId;
        data["isFscCertified"] = this.isFscCertified;
        data["specieName"] = this.specieName;
        return data;
    }
}

export interface ISmartLoadInvoiceArticleDto {
    externalId: number;
    resourceName: string | undefined;
    speciesId: number;
    lengthId: number;
    isFscCertified: boolean;
    specieName: string | undefined;
}

export class SmartLoadInvoiceDto implements ISmartLoadInvoiceDto {
    serial!: string | undefined;
    number!: number | undefined;
    stands!: SmartLoadInvoiceStandDto[] | undefined;
    articles!: SmartLoadInvoiceArticleDto[] | undefined;
    originId!: number;
    destinationId!: number;
    originType!: LocationType;
    loaderVendorId!: number;
    licensePlate!: string | undefined;

    constructor(data?: ISmartLoadInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            this.number = _data["number"];
            if (Array.isArray(_data["stands"])) {
                this.stands = [] as any;
                for (let item of _data["stands"])
                    this.stands!.push(SmartLoadInvoiceStandDto.fromJS(item));
            }
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(SmartLoadInvoiceArticleDto.fromJS(item));
            }
            this.originId = _data["originId"];
            this.destinationId = _data["destinationId"];
            this.originType = _data["originType"];
            this.loaderVendorId = _data["loaderVendorId"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): SmartLoadInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartLoadInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["number"] = this.number;
        if (Array.isArray(this.stands)) {
            data["stands"] = [];
            for (let item of this.stands)
                data["stands"].push(item.toJSON());
        }
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        data["originId"] = this.originId;
        data["destinationId"] = this.destinationId;
        data["originType"] = this.originType;
        data["loaderVendorId"] = this.loaderVendorId;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface ISmartLoadInvoiceDto {
    serial: string | undefined;
    number: number | undefined;
    stands: SmartLoadInvoiceStandDto[] | undefined;
    articles: SmartLoadInvoiceArticleDto[] | undefined;
    originId: number;
    destinationId: number;
    originType: LocationType;
    loaderVendorId: number;
    licensePlate: string | undefined;
}

export class SmartLoadInvoiceStandDto implements ISmartLoadInvoiceStandDto {
    externalId!: number;
    standName!: string | undefined;
    active!: boolean;
    isPefcCertified!: boolean;

    constructor(data?: ISmartLoadInvoiceStandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.standName = _data["standName"];
            this.active = _data["active"];
            this.isPefcCertified = _data["isPefcCertified"];
        }
    }

    static fromJS(data: any): SmartLoadInvoiceStandDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartLoadInvoiceStandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["standName"] = this.standName;
        data["active"] = this.active;
        data["isPefcCertified"] = this.isPefcCertified;
        return data;
    }
}

export interface ISmartLoadInvoiceStandDto {
    externalId: number;
    standName: string | undefined;
    active: boolean;
    isPefcCertified: boolean;
}

export class SmartTruckConfirmTruckInputDto implements ISmartTruckConfirmTruckInputDto {
    placeId!: number;
    truck!: VehicleDto;

    constructor(data?: ISmartTruckConfirmTruckInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.truck = _data["truck"] ? VehicleDto.fromJS(_data["truck"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SmartTruckConfirmTruckInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckConfirmTruckInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["truck"] = this.truck ? this.truck.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISmartTruckConfirmTruckInputDto {
    placeId: number;
    truck: VehicleDto;
}

export class SmartTruckConfirmTruckOutput implements ISmartTruckConfirmTruckOutput {
    truckPlate!: string | undefined;
    truckType!: SmartTruckTruckType;
    hashValue!: string | undefined;
    hasTagError!: boolean;
    truckAndSemiTrailersNonBlockingErrors!: string[] | undefined;
    driverNonBlockingErrors!: string[] | undefined;
    areTruckAndSemiTrailersActive!: boolean;
    isDriverActive!: boolean;
    semis!: SemiTrailerDto[] | undefined;
    blockingTruckErrorList!: string[] | undefined;
    isBlockingError!: boolean;
    truckVendorId!: number;
    driverName!: string | undefined;
    truckExternalId!: number;
    hasSemiTrailersErrors!: boolean;
    semiTrailersErrors!: { [key: string]: string[]; } | undefined;
    shouldSelectFlow!: boolean;

    constructor(data?: ISmartTruckConfirmTruckOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlate = _data["truckPlate"];
            this.truckType = _data["truckType"];
            this.hashValue = _data["hashValue"];
            this.hasTagError = _data["hasTagError"];
            if (Array.isArray(_data["truckAndSemiTrailersNonBlockingErrors"])) {
                this.truckAndSemiTrailersNonBlockingErrors = [] as any;
                for (let item of _data["truckAndSemiTrailersNonBlockingErrors"])
                    this.truckAndSemiTrailersNonBlockingErrors!.push(item);
            }
            if (Array.isArray(_data["driverNonBlockingErrors"])) {
                this.driverNonBlockingErrors = [] as any;
                for (let item of _data["driverNonBlockingErrors"])
                    this.driverNonBlockingErrors!.push(item);
            }
            this.areTruckAndSemiTrailersActive = _data["areTruckAndSemiTrailersActive"];
            this.isDriverActive = _data["isDriverActive"];
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(SemiTrailerDto.fromJS(item));
            }
            if (Array.isArray(_data["blockingTruckErrorList"])) {
                this.blockingTruckErrorList = [] as any;
                for (let item of _data["blockingTruckErrorList"])
                    this.blockingTruckErrorList!.push(item);
            }
            this.isBlockingError = _data["isBlockingError"];
            this.truckVendorId = _data["truckVendorId"];
            this.driverName = _data["driverName"];
            this.truckExternalId = _data["truckExternalId"];
            this.hasSemiTrailersErrors = _data["hasSemiTrailersErrors"];
            if (_data["semiTrailersErrors"]) {
                this.semiTrailersErrors = {} as any;
                for (let key in _data["semiTrailersErrors"]) {
                    if (_data["semiTrailersErrors"].hasOwnProperty(key))
                        (<any>this.semiTrailersErrors)![key] = _data["semiTrailersErrors"][key];
                }
            }
            this.shouldSelectFlow = _data["shouldSelectFlow"];
        }
    }

    static fromJS(data: any): SmartTruckConfirmTruckOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckConfirmTruckOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlate"] = this.truckPlate;
        data["truckType"] = this.truckType;
        data["hashValue"] = this.hashValue;
        data["hasTagError"] = this.hasTagError;
        if (Array.isArray(this.truckAndSemiTrailersNonBlockingErrors)) {
            data["truckAndSemiTrailersNonBlockingErrors"] = [];
            for (let item of this.truckAndSemiTrailersNonBlockingErrors)
                data["truckAndSemiTrailersNonBlockingErrors"].push(item);
        }
        if (Array.isArray(this.driverNonBlockingErrors)) {
            data["driverNonBlockingErrors"] = [];
            for (let item of this.driverNonBlockingErrors)
                data["driverNonBlockingErrors"].push(item);
        }
        data["areTruckAndSemiTrailersActive"] = this.areTruckAndSemiTrailersActive;
        data["isDriverActive"] = this.isDriverActive;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item.toJSON());
        }
        if (Array.isArray(this.blockingTruckErrorList)) {
            data["blockingTruckErrorList"] = [];
            for (let item of this.blockingTruckErrorList)
                data["blockingTruckErrorList"].push(item);
        }
        data["isBlockingError"] = this.isBlockingError;
        data["truckVendorId"] = this.truckVendorId;
        data["driverName"] = this.driverName;
        data["truckExternalId"] = this.truckExternalId;
        data["hasSemiTrailersErrors"] = this.hasSemiTrailersErrors;
        if (this.semiTrailersErrors) {
            data["semiTrailersErrors"] = {};
            for (let key in this.semiTrailersErrors) {
                if (this.semiTrailersErrors.hasOwnProperty(key))
                    (<any>data["semiTrailersErrors"])[key] = (<any>this.semiTrailersErrors)[key];
            }
        }
        data["shouldSelectFlow"] = this.shouldSelectFlow;
        return data;
    }
}

export interface ISmartTruckConfirmTruckOutput {
    truckPlate: string | undefined;
    truckType: SmartTruckTruckType;
    hashValue: string | undefined;
    hasTagError: boolean;
    truckAndSemiTrailersNonBlockingErrors: string[] | undefined;
    driverNonBlockingErrors: string[] | undefined;
    areTruckAndSemiTrailersActive: boolean;
    isDriverActive: boolean;
    semis: SemiTrailerDto[] | undefined;
    blockingTruckErrorList: string[] | undefined;
    isBlockingError: boolean;
    truckVendorId: number;
    driverName: string | undefined;
    truckExternalId: number;
    hasSemiTrailersErrors: boolean;
    semiTrailersErrors: { [key: string]: string[]; } | undefined;
    shouldSelectFlow: boolean;
}

export class SmartTruckDiverseProductActivityReportInput implements ISmartTruckDiverseProductActivityReportInput {
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    articleId!: number;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ISmartTruckDiverseProductActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.articleId = _data["articleId"];
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): SmartTruckDiverseProductActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckDiverseProductActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["articleId"] = this.articleId;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ISmartTruckDiverseProductActivityReportInput {
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    articleId: number;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class SmartTruckDiverseProductActivityReportOutput implements ISmartTruckDiverseProductActivityReportOutput {
    creationResult!: boolean;
    diverseProductActivityReportId!: number;
    errorMessages!: string[] | undefined;

    constructor(data?: ISmartTruckDiverseProductActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationResult = _data["creationResult"];
            this.diverseProductActivityReportId = _data["diverseProductActivityReportId"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): SmartTruckDiverseProductActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckDiverseProductActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationResult"] = this.creationResult;
        data["diverseProductActivityReportId"] = this.diverseProductActivityReportId;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}

export interface ISmartTruckDiverseProductActivityReportOutput {
    creationResult: boolean;
    diverseProductActivityReportId: number;
    errorMessages: string[] | undefined;
}

export class SmartTruckDto implements ISmartTruckDto {
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ISmartTruckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): SmartTruckDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ISmartTruckDto {
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class SmartTruckExistSmartTripsTripInput implements ISmartTruckExistSmartTripsTripInput {
    rut!: string | undefined;
    placeId!: number;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ISmartTruckExistSmartTripsTripInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rut = _data["rut"];
            this.placeId = _data["placeId"];
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): SmartTruckExistSmartTripsTripInput {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckExistSmartTripsTripInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rut"] = this.rut;
        data["placeId"] = this.placeId;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ISmartTruckExistSmartTripsTripInput {
    rut: string | undefined;
    placeId: number;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export enum SmartTruckTruckType {
    Wood = 0,
    DiverseProducts = 1,
    InternalMovement = 2,
    FinalDisposition = 3,
}

export class SmartTruckWoodPreActivityReportDto implements ISmartTruckWoodPreActivityReportDto {
    serial!: string | undefined;
    number!: number;
    origin!: LocationDto;
    destination!: LocationDto;
    date!: DateTime;
    lines!: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken!: string | undefined;
    tripNumber!: number | undefined;
    certification!: WoodPreActivityCertificationDTO;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ISmartTruckWoodPreActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineDto.fromJS(item));
            }
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.tripNumber = _data["tripNumber"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): SmartTruckWoodPreActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckWoodPreActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["tripNumber"] = this.tripNumber;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ISmartTruckWoodPreActivityReportDto {
    serial: string | undefined;
    number: number;
    origin: LocationDto;
    destination: LocationDto;
    date: DateTime;
    lines: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken: string | undefined;
    tripNumber: number | undefined;
    certification: WoodPreActivityCertificationDTO;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class SmartTruckWoodPreActivityReportFromQRDto implements ISmartTruckWoodPreActivityReportFromQRDto {
    truckPlateIsSame!: boolean;
    truckPlateParsedFromQR!: string | undefined;
    isThirdPartyQR!: boolean;
    errorList!: string[] | undefined;
    originVendorRut!: string | undefined;
    serial!: string | undefined;
    number!: number;
    origin!: LocationDto;
    destination!: LocationDto;
    date!: DateTime;
    lines!: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken!: string | undefined;
    tripNumber!: number | undefined;
    certification!: WoodPreActivityCertificationDTO;
    truckPlate!: string | undefined;
    truckVendorId!: number;
    semisPlates!: string[] | undefined;
    hashValue!: string | undefined;
    truckExternalId!: number;
    locationId!: number;
    locationType!: LocationType;

    constructor(data?: ISmartTruckWoodPreActivityReportFromQRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlateIsSame = _data["truckPlateIsSame"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
            this.isThirdPartyQR = _data["isThirdPartyQR"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.originVendorRut = _data["originVendorRut"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineDto.fromJS(item));
            }
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.tripNumber = _data["tripNumber"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.truckPlate = _data["truckPlate"];
            this.truckVendorId = _data["truckVendorId"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckExternalId = _data["truckExternalId"];
            this.locationId = _data["locationId"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): SmartTruckWoodPreActivityReportFromQRDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTruckWoodPreActivityReportFromQRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlateIsSame"] = this.truckPlateIsSame;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        data["isThirdPartyQR"] = this.isThirdPartyQR;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["originVendorRut"] = this.originVendorRut;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["tripNumber"] = this.tripNumber;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorId"] = this.truckVendorId;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckExternalId"] = this.truckExternalId;
        data["locationId"] = this.locationId;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ISmartTruckWoodPreActivityReportFromQRDto {
    truckPlateIsSame: boolean;
    truckPlateParsedFromQR: string | undefined;
    isThirdPartyQR: boolean;
    errorList: string[] | undefined;
    originVendorRut: string | undefined;
    serial: string | undefined;
    number: number;
    origin: LocationDto;
    destination: LocationDto;
    date: DateTime;
    lines: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken: string | undefined;
    tripNumber: number | undefined;
    certification: WoodPreActivityCertificationDTO;
    truckPlate: string | undefined;
    truckVendorId: number;
    semisPlates: string[] | undefined;
    hashValue: string | undefined;
    truckExternalId: number;
    locationId: number;
    locationType: LocationType;
}

export class SpeciesDto implements ISpeciesDto {
    id!: number;
    name!: string | undefined;
    specieGroupName!: string | undefined;
    specieGroupCode!: string | undefined;
    speciesGroupId!: number;
    density!: number;

    constructor(data?: ISpeciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.specieGroupName = _data["specieGroupName"];
            this.specieGroupCode = _data["specieGroupCode"];
            this.speciesGroupId = _data["speciesGroupId"];
            this.density = _data["density"];
        }
    }

    static fromJS(data: any): SpeciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["specieGroupName"] = this.specieGroupName;
        data["specieGroupCode"] = this.specieGroupCode;
        data["speciesGroupId"] = this.speciesGroupId;
        data["density"] = this.density;
        return data;
    }
}

export interface ISpeciesDto {
    id: number;
    name: string | undefined;
    specieGroupName: string | undefined;
    specieGroupCode: string | undefined;
    speciesGroupId: number;
    density: number;
}

export class SpeciesGroupDto implements ISpeciesGroupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISpeciesGroupDto {
    id: number;
    name: string | undefined;
}

export class SpeciesWithLengthsDto implements ISpeciesWithLengthsDto {
    speciesId!: number;
    lengths!: LengthWithTreeVolumeDto[] | undefined;

    constructor(data?: ISpeciesWithLengthsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speciesId = _data["speciesId"];
            if (Array.isArray(_data["lengths"])) {
                this.lengths = [] as any;
                for (let item of _data["lengths"])
                    this.lengths!.push(LengthWithTreeVolumeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpeciesWithLengthsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeciesWithLengthsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciesId"] = this.speciesId;
        if (Array.isArray(this.lengths)) {
            data["lengths"] = [];
            for (let item of this.lengths)
                data["lengths"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISpeciesWithLengthsDto {
    speciesId: number;
    lengths: LengthWithTreeVolumeDto[] | undefined;
}

export class StandOutputCollectionDto implements IStandOutputCollectionDto {
    stands!: StandOutputDto[] | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IStandOutputCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stands"])) {
                this.stands = [] as any;
                for (let item of _data["stands"])
                    this.stands!.push(StandOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): StandOutputCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandOutputCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stands)) {
            data["stands"] = [];
            for (let item of this.stands)
                data["stands"].push(item.toJSON());
        }
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IStandOutputCollectionDto {
    stands: StandOutputDto[] | undefined;
    errorList: string[] | undefined;
}

export class StandOutputDto implements IStandOutputDto {
    id!: number;
    standNumber!: number;
    name!: string | undefined;
    errorList!: string[] | undefined;
    locationTypeId!: number;
    isFscCertified!: boolean;
    isPefcCertified!: boolean;
    isActive!: boolean;
    originId!: number;
    area!: number;
    speciesId!: number;
    geneticMaterialTypeId!: number;
    treeVolume!: number;
    contractId!: number;

    constructor(data?: IStandOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.standNumber = _data["standNumber"];
            this.name = _data["name"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.locationTypeId = _data["locationTypeId"];
            this.isFscCertified = _data["isFscCertified"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.isActive = _data["isActive"];
            this.originId = _data["originId"];
            this.area = _data["area"];
            this.speciesId = _data["speciesId"];
            this.geneticMaterialTypeId = _data["geneticMaterialTypeId"];
            this.treeVolume = _data["treeVolume"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): StandOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["standNumber"] = this.standNumber;
        data["name"] = this.name;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["locationTypeId"] = this.locationTypeId;
        data["isFscCertified"] = this.isFscCertified;
        data["isPefcCertified"] = this.isPefcCertified;
        data["isActive"] = this.isActive;
        data["originId"] = this.originId;
        data["area"] = this.area;
        data["speciesId"] = this.speciesId;
        data["geneticMaterialTypeId"] = this.geneticMaterialTypeId;
        data["treeVolume"] = this.treeVolume;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface IStandOutputDto {
    id: number;
    standNumber: number;
    name: string | undefined;
    errorList: string[] | undefined;
    locationTypeId: number;
    isFscCertified: boolean;
    isPefcCertified: boolean;
    isActive: boolean;
    originId: number;
    area: number;
    speciesId: number;
    geneticMaterialTypeId: number;
    treeVolume: number;
    contractId: number;
}

export class TagDetectionInput implements ITagDetectionInput {
    tagValue!: number;
    deviceId!: number;
    tenantId!: number;
    systemType!: DeviceSystemType;

    constructor(data?: ITagDetectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagValue = _data["tagValue"];
            this.deviceId = _data["deviceId"];
            this.tenantId = _data["tenantId"];
            this.systemType = _data["systemType"];
        }
    }

    static fromJS(data: any): TagDetectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new TagDetectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagValue"] = this.tagValue;
        data["deviceId"] = this.deviceId;
        data["tenantId"] = this.tenantId;
        data["systemType"] = this.systemType;
        return data;
    }
}

export interface ITagDetectionInput {
    tagValue: number;
    deviceId: number;
    tenantId: number;
    systemType: DeviceSystemType;
}

export class TotemDiverseProductPreReportCreationInput implements ITotemDiverseProductPreReportCreationInput {
    driver!: DriverDto;
    truck!: VehicleDto;
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    article!: ArticleDiverseProductsDto;

    constructor(data?: ITotemDiverseProductPreReportCreationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.truck = _data["truck"] ? VehicleDto.fromJS(_data["truck"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.article = _data["article"] ? ArticleDiverseProductsDto.fromJS(_data["article"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TotemDiverseProductPreReportCreationInput {
        data = typeof data === 'object' ? data : {};
        let result = new TotemDiverseProductPreReportCreationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["truck"] = this.truck ? this.truck.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITotemDiverseProductPreReportCreationInput {
    driver: DriverDto;
    truck: VehicleDto;
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    article: ArticleDiverseProductsDto;
}

export class TotemDiverseProductPreReportCreationOutput implements ITotemDiverseProductPreReportCreationOutput {
    preReportId!: number;

    constructor(data?: ITotemDiverseProductPreReportCreationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
        }
    }

    static fromJS(data: any): TotemDiverseProductPreReportCreationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TotemDiverseProductPreReportCreationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        return data;
    }
}

export interface ITotemDiverseProductPreReportCreationOutput {
    preReportId: number;
}

export class TotemUpdatePreReportDriverInput implements ITotemUpdatePreReportDriverInput {
    truckPlate!: string | undefined;
    driverId!: number;

    constructor(data?: ITotemUpdatePreReportDriverInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlate = _data["truckPlate"];
            this.driverId = _data["driverId"];
        }
    }

    static fromJS(data: any): TotemUpdatePreReportDriverInput {
        data = typeof data === 'object' ? data : {};
        let result = new TotemUpdatePreReportDriverInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlate"] = this.truckPlate;
        data["driverId"] = this.driverId;
        return data;
    }
}

export interface ITotemUpdatePreReportDriverInput {
    truckPlate: string | undefined;
    driverId: number;
}

export class TotemUpdatePreReportDriverOutput implements ITotemUpdatePreReportDriverOutput {
    preReportId!: number;

    constructor(data?: ITotemUpdatePreReportDriverOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
        }
    }

    static fromJS(data: any): TotemUpdatePreReportDriverOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TotemUpdatePreReportDriverOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        return data;
    }
}

export interface ITotemUpdatePreReportDriverOutput {
    preReportId: number;
}

export class TotemVehicleResultDto implements ITotemVehicleResultDto {
    vehicle!: VehicleDto;
    existingPreReportId!: number | undefined;
    existingPreReportDriverExternalId!: number | undefined;
    existingPreReportPlaceId!: number | undefined;

    constructor(data?: ITotemVehicleResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.existingPreReportId = _data["existingPreReportId"];
            this.existingPreReportDriverExternalId = _data["existingPreReportDriverExternalId"];
            this.existingPreReportPlaceId = _data["existingPreReportPlaceId"];
        }
    }

    static fromJS(data: any): TotemVehicleResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotemVehicleResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["existingPreReportId"] = this.existingPreReportId;
        data["existingPreReportDriverExternalId"] = this.existingPreReportDriverExternalId;
        data["existingPreReportPlaceId"] = this.existingPreReportPlaceId;
        return data;
    }
}

export interface ITotemVehicleResultDto {
    vehicle: VehicleDto;
    existingPreReportId: number | undefined;
    existingPreReportDriverExternalId: number | undefined;
    existingPreReportPlaceId: number | undefined;
}

export class TotemWoodPreReportCreationOutput implements ITotemWoodPreReportCreationOutput {
    creationResult!: boolean;
    preReportId!: number;
    errorList!: string[] | undefined;
    imageExpired!: boolean;

    constructor(data?: ITotemWoodPreReportCreationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationResult = _data["creationResult"];
            this.preReportId = _data["preReportId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.imageExpired = _data["imageExpired"];
        }
    }

    static fromJS(data: any): TotemWoodPreReportCreationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TotemWoodPreReportCreationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationResult"] = this.creationResult;
        data["preReportId"] = this.preReportId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["imageExpired"] = this.imageExpired;
        return data;
    }
}

export interface ITotemWoodPreReportCreationOutput {
    creationResult: boolean;
    preReportId: number;
    errorList: string[] | undefined;
    imageExpired: boolean;
}

export class TravelAssignmentDto implements ITravelAssignmentDto {
    travelNumber!: number;
    plate!: string | undefined;
    status!: string | undefined;
    originId!: number;
    originType!: LocationType;
    destinationType!: LocationType;
    destinationId!: number;
    loadDateTime!: DateTime;

    constructor(data?: ITravelAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.travelNumber = _data["travelNumber"];
            this.plate = _data["plate"];
            this.status = _data["status"];
            this.originId = _data["originId"];
            this.originType = _data["originType"];
            this.destinationType = _data["destinationType"];
            this.destinationId = _data["destinationId"];
            this.loadDateTime = _data["loadDateTime"] ? DateTime.fromISO(_data["loadDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TravelAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelNumber"] = this.travelNumber;
        data["plate"] = this.plate;
        data["status"] = this.status;
        data["originId"] = this.originId;
        data["originType"] = this.originType;
        data["destinationType"] = this.destinationType;
        data["destinationId"] = this.destinationId;
        data["loadDateTime"] = this.loadDateTime ? this.loadDateTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITravelAssignmentDto {
    travelNumber: number;
    plate: string | undefined;
    status: string | undefined;
    originId: number;
    originType: LocationType;
    destinationType: LocationType;
    destinationId: number;
    loadDateTime: DateTime;
}

export class TravelDetailDto implements ITravelDetailDto {
    travelNumber!: number;
    plate!: string | undefined;
    estimatedDepartureDateTime!: DateTime;
    loadDateTime!: DateTime;
    specieCode!: number;
    originId!: number;
    destinationId!: number;
    status!: string | undefined;
    loaderFront!: string | undefined;
    cycle!: number;
    tara!: number;
    bruto!: number;
    dateHour!: DateTime;
    originType!: LocationType;
    destinationType!: LocationType;

    constructor(data?: ITravelDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.travelNumber = _data["travelNumber"];
            this.plate = _data["plate"];
            this.estimatedDepartureDateTime = _data["estimatedDepartureDateTime"] ? DateTime.fromISO(_data["estimatedDepartureDateTime"].toString()) : <any>undefined;
            this.loadDateTime = _data["loadDateTime"] ? DateTime.fromISO(_data["loadDateTime"].toString()) : <any>undefined;
            this.specieCode = _data["specieCode"];
            this.originId = _data["originId"];
            this.destinationId = _data["destinationId"];
            this.status = _data["status"];
            this.loaderFront = _data["loaderFront"];
            this.cycle = _data["cycle"];
            this.tara = _data["tara"];
            this.bruto = _data["bruto"];
            this.dateHour = _data["dateHour"] ? DateTime.fromISO(_data["dateHour"].toString()) : <any>undefined;
            this.originType = _data["originType"];
            this.destinationType = _data["destinationType"];
        }
    }

    static fromJS(data: any): TravelDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelNumber"] = this.travelNumber;
        data["plate"] = this.plate;
        data["estimatedDepartureDateTime"] = this.estimatedDepartureDateTime ? this.estimatedDepartureDateTime.toString() : <any>undefined;
        data["loadDateTime"] = this.loadDateTime ? this.loadDateTime.toString() : <any>undefined;
        data["specieCode"] = this.specieCode;
        data["originId"] = this.originId;
        data["destinationId"] = this.destinationId;
        data["status"] = this.status;
        data["loaderFront"] = this.loaderFront;
        data["cycle"] = this.cycle;
        data["tara"] = this.tara;
        data["bruto"] = this.bruto;
        data["dateHour"] = this.dateHour ? this.dateHour.toString() : <any>undefined;
        data["originType"] = this.originType;
        data["destinationType"] = this.destinationType;
        return data;
    }
}

export interface ITravelDetailDto {
    travelNumber: number;
    plate: string | undefined;
    estimatedDepartureDateTime: DateTime;
    loadDateTime: DateTime;
    specieCode: number;
    originId: number;
    destinationId: number;
    status: string | undefined;
    loaderFront: string | undefined;
    cycle: number;
    tara: number;
    bruto: number;
    dateHour: DateTime;
    originType: LocationType;
    destinationType: LocationType;
}

export class TritrainDriverDto implements ITritrainDriverDto {
    driverId!: number;

    constructor(data?: ITritrainDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverId = _data["driverId"];
        }
    }

    static fromJS(data: any): TritrainDriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new TritrainDriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverId"] = this.driverId;
        return data;
    }
}

export interface ITritrainDriverDto {
    driverId: number;
}

export class TruckAndDriverStatusOutput implements ITruckAndDriverStatusOutput {
    isDriverActive!: boolean;
    areTruckAndSemiTrailersActive!: boolean;

    constructor(data?: ITruckAndDriverStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDriverActive = _data["isDriverActive"];
            this.areTruckAndSemiTrailersActive = _data["areTruckAndSemiTrailersActive"];
        }
    }

    static fromJS(data: any): TruckAndDriverStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TruckAndDriverStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDriverActive"] = this.isDriverActive;
        data["areTruckAndSemiTrailersActive"] = this.areTruckAndSemiTrailersActive;
        return data;
    }
}

export interface ITruckAndDriverStatusOutput {
    isDriverActive: boolean;
    areTruckAndSemiTrailersActive: boolean;
}

export class TruckAvailableZoneDto implements ITruckAvailableZoneDto {
    id!: number;
    name!: string | undefined;
    externalId!: number;

    constructor(data?: ITruckAvailableZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): TruckAvailableZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckAvailableZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface ITruckAvailableZoneDto {
    id: number;
    name: string | undefined;
    externalId: number;
}

export enum TruckCategory {
    CAPRODIV = 0,
    CAMA = 1,
    CAMOINTVO = 2,
}

export enum TruckFlowType {
    Wood = 0,
    Products = 1,
}

export class TruckOutputDto implements ITruckOutputDto {
    truckPlate!: string | undefined;
    vendorId!: number;
    isActive!: boolean;
    truckType!: SmartTruckTruckType;
    semis!: SemiTrailerDto[] | undefined;
    semiTrailersQuantity!: number;
    areTruckDocumentsValid!: boolean;
    documents!: DocumentDto[] | undefined;
    isBlockingError!: boolean;
    errorList!: string[] | undefined;
    hashValue!: string | undefined;
    truckFlowType!: TruckFlowType;
    id!: number;

    constructor(data?: ITruckOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlate = _data["truckPlate"];
            this.vendorId = _data["vendorId"];
            this.isActive = _data["isActive"];
            this.truckType = _data["truckType"];
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(SemiTrailerDto.fromJS(item));
            }
            this.semiTrailersQuantity = _data["semiTrailersQuantity"];
            this.areTruckDocumentsValid = _data["areTruckDocumentsValid"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.isBlockingError = _data["isBlockingError"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.hashValue = _data["hashValue"];
            this.truckFlowType = _data["truckFlowType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TruckOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlate"] = this.truckPlate;
        data["vendorId"] = this.vendorId;
        data["isActive"] = this.isActive;
        data["truckType"] = this.truckType;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item.toJSON());
        }
        data["semiTrailersQuantity"] = this.semiTrailersQuantity;
        data["areTruckDocumentsValid"] = this.areTruckDocumentsValid;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["isBlockingError"] = this.isBlockingError;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["hashValue"] = this.hashValue;
        data["truckFlowType"] = this.truckFlowType;
        data["id"] = this.id;
        return data;
    }
}

export interface ITruckOutputDto {
    truckPlate: string | undefined;
    vendorId: number;
    isActive: boolean;
    truckType: SmartTruckTruckType;
    semis: SemiTrailerDto[] | undefined;
    semiTrailersQuantity: number;
    areTruckDocumentsValid: boolean;
    documents: DocumentDto[] | undefined;
    isBlockingError: boolean;
    errorList: string[] | undefined;
    hashValue: string | undefined;
    truckFlowType: TruckFlowType;
    id: number;
}

export class TruckStatusOutput implements ITruckStatusOutput {
    isValid!: boolean;
    reason!: string | undefined;

    constructor(data?: ITruckStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): TruckStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TruckStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ITruckStatusOutput {
    isValid: boolean;
    reason: string | undefined;
}

export class TrucksNextTripIndicatorDto implements ITrucksNextTripIndicatorDto {
    placeId!: number;
    count!: number;
    totalReceipts!: number;
    dateToCompare!: DateTime;
    items!: WoodActivityReportsTruck[] | undefined;
    hasError!: boolean;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    sincedHours!: number;
    message!: string | undefined;

    constructor(data?: ITrucksNextTripIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.count = _data["count"];
            this.totalReceipts = _data["totalReceipts"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportsTruck.fromJS(item));
            }
            this.hasError = _data["hasError"];
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.sincedHours = _data["sincedHours"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TrucksNextTripIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrucksNextTripIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["count"] = this.count;
        data["totalReceipts"] = this.totalReceipts;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["hasError"] = this.hasError;
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["sincedHours"] = this.sincedHours;
        data["message"] = this.message;
        return data;
    }
}

export interface ITrucksNextTripIndicatorDto {
    placeId: number;
    count: number;
    totalReceipts: number;
    dateToCompare: DateTime;
    items: WoodActivityReportsTruck[] | undefined;
    hasError: boolean;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    sincedHours: number;
    message: string | undefined;
}

export class UpdateDiverseProductActivityReportInput implements IUpdateDiverseProductActivityReportInput {
    id!: number;
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    vehicleId!: number;
    vendorId!: number;
    driver!: DriverInputDto;
    articleId!: number;
    netWeight!: number;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    singleCustomDeclarationId!: number;
    state!: ActivityReportState;
    licensePlate!: string | undefined;
    comment!: string | undefined;

    constructor(data?: IUpdateDiverseProductActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vendorId = _data["vendorId"];
            this.driver = _data["driver"] ? DriverInputDto.fromJS(_data["driver"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.singleCustomDeclarationId = _data["singleCustomDeclarationId"];
            this.state = _data["state"];
            this.licensePlate = _data["licensePlate"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateDiverseProductActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDiverseProductActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vendorId"] = this.vendorId;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["singleCustomDeclarationId"] = this.singleCustomDeclarationId;
        data["state"] = this.state;
        data["licensePlate"] = this.licensePlate;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateDiverseProductActivityReportInput {
    id: number;
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    vehicleId: number;
    vendorId: number;
    driver: DriverInputDto;
    articleId: number;
    netWeight: number;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    singleCustomDeclarationId: number;
    state: ActivityReportState;
    licensePlate: string | undefined;
    comment: string | undefined;
}

export class UpdateInternalMovementsInputDto implements IUpdateInternalMovementsInputDto {
    id!: number;
    origin!: LocationInputDto;
    destination!: LocationInputDto;
    date!: DateTime;
    vehicleId!: number;
    vendorId!: number;
    driver!: DriverInputDto;
    articleId!: number;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    netWeight!: number;
    comment!: string | undefined;

    constructor(data?: IUpdateInternalMovementsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.origin = _data["origin"] ? LocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vendorId = _data["vendorId"];
            this.driver = _data["driver"] ? DriverInputDto.fromJS(_data["driver"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateInternalMovementsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternalMovementsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vendorId"] = this.vendorId;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateInternalMovementsInputDto {
    id: number;
    origin: LocationInputDto;
    destination: LocationInputDto;
    date: DateTime;
    vehicleId: number;
    vendorId: number;
    driver: DriverInputDto;
    articleId: number;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    netWeight: number;
    comment: string | undefined;
}

export class UpdatePreActivityReportDriverOutput implements IUpdatePreActivityReportDriverOutput {
    wasUpdated!: boolean;
    reason!: string | undefined;

    constructor(data?: IUpdatePreActivityReportDriverOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasUpdated = _data["wasUpdated"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdatePreActivityReportDriverOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePreActivityReportDriverOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasUpdated"] = this.wasUpdated;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUpdatePreActivityReportDriverOutput {
    wasUpdated: boolean;
    reason: string | undefined;
}

export class UpdateTripDriverOutput implements IUpdateTripDriverOutput {
    reportId!: number;
    errorList!: string[] | undefined;

    constructor(data?: IUpdateTripDriverOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTripDriverOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTripDriverOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IUpdateTripDriverOutput {
    reportId: number;
    errorList: string[] | undefined;
}

export class UserVendorByEmailInput implements IUserVendorByEmailInput {
    userId!: number;
    userEmail!: string | undefined;

    constructor(data?: IUserVendorByEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): UserVendorByEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserVendorByEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IUserVendorByEmailInput {
    userId: number;
    userEmail: string | undefined;
}

export class UserVendorDto implements IUserVendorDto {
    userId!: number;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    vendor!: VendorDto;
    errorList!: string[] | undefined;

    constructor(data?: IUserVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): UserVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IUserVendorDto {
    userId: number;
    userName: string | undefined;
    emailAddress: string | undefined;
    vendor: VendorDto;
    errorList: string[] | undefined;
}

export class UserVendorInput implements IUserVendorInput {
    userId!: number;
    vendor!: VendorDto;
    isUpdate!: boolean;

    constructor(data?: IUserVendorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.isUpdate = _data["isUpdate"];
        }
    }

    static fromJS(data: any): UserVendorInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserVendorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["isUpdate"] = this.isUpdate;
        return data;
    }
}

export interface IUserVendorInput {
    userId: number;
    vendor: VendorDto;
    isUpdate: boolean;
}

export class ValidateDriverVendorOutput implements IValidateDriverVendorOutput {
    isValidDriver!: boolean;
    errorList!: string[] | undefined;

    constructor(data?: IValidateDriverVendorOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValidDriver = _data["isValidDriver"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateDriverVendorOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateDriverVendorOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValidDriver"] = this.isValidDriver;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IValidateDriverVendorOutput {
    isValidDriver: boolean;
    errorList: string[] | undefined;
}

export class ValidateOriginForMassEditInput implements IValidateOriginForMassEditInput {
    newOriginId!: number;
    newOriginType!: LocationType;
    oldOriginId!: number;
    oldOriginType!: LocationType;
    destinationId!: number;

    constructor(data?: IValidateOriginForMassEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOriginId = _data["newOriginId"];
            this.newOriginType = _data["newOriginType"];
            this.oldOriginId = _data["oldOriginId"];
            this.oldOriginType = _data["oldOriginType"];
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): ValidateOriginForMassEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOriginForMassEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newOriginId"] = this.newOriginId;
        data["newOriginType"] = this.newOriginType;
        data["oldOriginId"] = this.oldOriginId;
        data["oldOriginType"] = this.oldOriginType;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IValidateOriginForMassEditInput {
    newOriginId: number;
    newOriginType: LocationType;
    oldOriginId: number;
    oldOriginType: LocationType;
    destinationId: number;
}

export class ValidateOriginForMassEditOutput implements IValidateOriginForMassEditOutput {
    valid!: boolean;
    validationMessage!: string | undefined;

    constructor(data?: IValidateOriginForMassEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.validationMessage = _data["validationMessage"];
        }
    }

    static fromJS(data: any): ValidateOriginForMassEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOriginForMassEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["validationMessage"] = this.validationMessage;
        return data;
    }
}

export interface IValidateOriginForMassEditOutput {
    valid: boolean;
    validationMessage: string | undefined;
}

export class ValidateOriginForReportEditionInput implements IValidateOriginForReportEditionInput {
    originId!: number;
    originType!: LocationType;
    reportId!: number;

    constructor(data?: IValidateOriginForReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originId = _data["originId"];
            this.originType = _data["originType"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): ValidateOriginForReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOriginForReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originId"] = this.originId;
        data["originType"] = this.originType;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IValidateOriginForReportEditionInput {
    originId: number;
    originType: LocationType;
    reportId: number;
}

export class ValidateOriginForReportEditionOutput implements IValidateOriginForReportEditionOutput {
    valid!: boolean;
    validationMessage!: string | undefined;

    constructor(data?: IValidateOriginForReportEditionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.validationMessage = _data["validationMessage"];
        }
    }

    static fromJS(data: any): ValidateOriginForReportEditionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOriginForReportEditionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["validationMessage"] = this.validationMessage;
        return data;
    }
}

export interface IValidateOriginForReportEditionOutput {
    valid: boolean;
    validationMessage: string | undefined;
}

export class ValidateStandForReportEditionInput implements IValidateStandForReportEditionInput {
    newStandId!: number;
    oldStandId!: number;
    articleId!: number;
    originId!: number;
    originType!: LocationType;
    destinationId!: number;

    constructor(data?: IValidateStandForReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newStandId = _data["newStandId"];
            this.oldStandId = _data["oldStandId"];
            this.articleId = _data["articleId"];
            this.originId = _data["originId"];
            this.originType = _data["originType"];
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): ValidateStandForReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateStandForReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newStandId"] = this.newStandId;
        data["oldStandId"] = this.oldStandId;
        data["articleId"] = this.articleId;
        data["originId"] = this.originId;
        data["originType"] = this.originType;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IValidateStandForReportEditionInput {
    newStandId: number;
    oldStandId: number;
    articleId: number;
    originId: number;
    originType: LocationType;
    destinationId: number;
}

export class ValidateStandForReportEditionOutput implements IValidateStandForReportEditionOutput {
    valid!: boolean;
    validationMessage!: string | undefined;
    possibleLoadingServiceVendors!: VendorDto[] | undefined;
    cutServiceVendor!: VendorDto;
    extractionServiceVendor!: VendorDto;
    contract!: ContractDto;

    constructor(data?: IValidateStandForReportEditionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.validationMessage = _data["validationMessage"];
            if (Array.isArray(_data["possibleLoadingServiceVendors"])) {
                this.possibleLoadingServiceVendors = [] as any;
                for (let item of _data["possibleLoadingServiceVendors"])
                    this.possibleLoadingServiceVendors!.push(VendorDto.fromJS(item));
            }
            this.cutServiceVendor = _data["cutServiceVendor"] ? VendorDto.fromJS(_data["cutServiceVendor"]) : <any>undefined;
            this.extractionServiceVendor = _data["extractionServiceVendor"] ? VendorDto.fromJS(_data["extractionServiceVendor"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateStandForReportEditionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateStandForReportEditionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["validationMessage"] = this.validationMessage;
        if (Array.isArray(this.possibleLoadingServiceVendors)) {
            data["possibleLoadingServiceVendors"] = [];
            for (let item of this.possibleLoadingServiceVendors)
                data["possibleLoadingServiceVendors"].push(item.toJSON());
        }
        data["cutServiceVendor"] = this.cutServiceVendor ? this.cutServiceVendor.toJSON() : <any>undefined;
        data["extractionServiceVendor"] = this.extractionServiceVendor ? this.extractionServiceVendor.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateStandForReportEditionOutput {
    valid: boolean;
    validationMessage: string | undefined;
    possibleLoadingServiceVendors: VendorDto[] | undefined;
    cutServiceVendor: VendorDto;
    extractionServiceVendor: VendorDto;
    contract: ContractDto;
}

export class VehicleDto implements IVehicleDto {
    id!: number;
    resourceTypeId!: number;
    licensePlate!: string | undefined;
    type!: string | undefined;
    name!: string | undefined;
    company!: string | undefined;
    semis!: VehicleDto[] | undefined;
    isActive!: boolean;
    isTruck!: boolean;
    errorList!: string[] | undefined;
    truckCategory!: TruckCategory;
    semiTrailersQuantity!: number;
    isBlockingError!: boolean;
    tare!: number;
    vendorId!: number;
    vendor!: VendorDto;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.licensePlate = _data["licensePlate"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.company = _data["company"];
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(VehicleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.isTruck = _data["isTruck"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.truckCategory = _data["truckCategory"];
            this.semiTrailersQuantity = _data["semiTrailersQuantity"];
            this.isBlockingError = _data["isBlockingError"];
            this.tare = _data["tare"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceTypeId"] = this.resourceTypeId;
        data["licensePlate"] = this.licensePlate;
        data["type"] = this.type;
        data["name"] = this.name;
        data["company"] = this.company;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["isTruck"] = this.isTruck;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["truckCategory"] = this.truckCategory;
        data["semiTrailersQuantity"] = this.semiTrailersQuantity;
        data["isBlockingError"] = this.isBlockingError;
        data["tare"] = this.tare;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVehicleDto {
    id: number;
    resourceTypeId: number;
    licensePlate: string | undefined;
    type: string | undefined;
    name: string | undefined;
    company: string | undefined;
    semis: VehicleDto[] | undefined;
    isActive: boolean;
    isTruck: boolean;
    errorList: string[] | undefined;
    truckCategory: TruckCategory;
    semiTrailersQuantity: number;
    isBlockingError: boolean;
    tare: number;
    vendorId: number;
    vendor: VendorDto;
}

export class VendorContactDto implements IVendorContactDto {
    id!: number;
    vendorId!: number;
    name!: string | undefined;
    telephoneNumber!: string | undefined;
    cellphoneNumber!: string | undefined;
    email!: string | undefined;

    constructor(data?: IVendorContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vendorId = _data["vendorId"];
            this.name = _data["name"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.cellphoneNumber = _data["cellphoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): VendorContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vendorId"] = this.vendorId;
        data["name"] = this.name;
        data["telephoneNumber"] = this.telephoneNumber;
        data["cellphoneNumber"] = this.cellphoneNumber;
        data["email"] = this.email;
        return data;
    }
}

export interface IVendorContactDto {
    id: number;
    vendorId: number;
    name: string | undefined;
    telephoneNumber: string | undefined;
    cellphoneNumber: string | undefined;
    email: string | undefined;
}

export class VendorDto implements IVendorDto {
    id!: number;
    fantasyName!: string | undefined;
    isGeneric!: boolean;
    errorList!: string[] | undefined;
    licensePlate!: string | undefined;
    vendorContact!: VendorContactDto[] | undefined;
    vatNumber!: string | undefined;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fantasyName = _data["fantasyName"];
            this.isGeneric = _data["isGeneric"];
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.licensePlate = _data["licensePlate"];
            if (Array.isArray(_data["vendorContact"])) {
                this.vendorContact = [] as any;
                for (let item of _data["vendorContact"])
                    this.vendorContact!.push(VendorContactDto.fromJS(item));
            }
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): VendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fantasyName"] = this.fantasyName;
        data["isGeneric"] = this.isGeneric;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["licensePlate"] = this.licensePlate;
        if (Array.isArray(this.vendorContact)) {
            data["vendorContact"] = [];
            for (let item of this.vendorContact)
                data["vendorContact"].push(item.toJSON());
        }
        data["vatNumber"] = this.vatNumber;
        return data;
    }
}

export interface IVendorDto {
    id: number;
    fantasyName: string | undefined;
    isGeneric: boolean;
    errorList: string[] | undefined;
    licensePlate: string | undefined;
    vendorContact: VendorContactDto[] | undefined;
    vatNumber: string | undefined;
}

export class VendorQRWoodPreActivityReportInput implements IVendorQRWoodPreActivityReportInput {
    receiptPhotoToken!: string | undefined;
    qrCode!: string | undefined;
    driverId!: number;
    truckPlate!: string | undefined;
    semisPlates!: string[] | undefined;
    destinationId!: number;
    isTruckPlateDifferentConfirmed!: boolean;
    truckPlateParsedFromQR!: string | undefined;

    constructor(data?: IVendorQRWoodPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.qrCode = _data["qrCode"];
            this.driverId = _data["driverId"];
            this.truckPlate = _data["truckPlate"];
            if (Array.isArray(_data["semisPlates"])) {
                this.semisPlates = [] as any;
                for (let item of _data["semisPlates"])
                    this.semisPlates!.push(item);
            }
            this.destinationId = _data["destinationId"];
            this.isTruckPlateDifferentConfirmed = _data["isTruckPlateDifferentConfirmed"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
        }
    }

    static fromJS(data: any): VendorQRWoodPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new VendorQRWoodPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["qrCode"] = this.qrCode;
        data["driverId"] = this.driverId;
        data["truckPlate"] = this.truckPlate;
        if (Array.isArray(this.semisPlates)) {
            data["semisPlates"] = [];
            for (let item of this.semisPlates)
                data["semisPlates"].push(item);
        }
        data["destinationId"] = this.destinationId;
        data["isTruckPlateDifferentConfirmed"] = this.isTruckPlateDifferentConfirmed;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        return data;
    }
}

export interface IVendorQRWoodPreActivityReportInput {
    receiptPhotoToken: string | undefined;
    qrCode: string | undefined;
    driverId: number;
    truckPlate: string | undefined;
    semisPlates: string[] | undefined;
    destinationId: number;
    isTruckPlateDifferentConfirmed: boolean;
    truckPlateParsedFromQR: string | undefined;
}

export class ViewDiverseProductPreActivityReportOutput implements IViewDiverseProductPreActivityReportOutput {
    originName!: string | undefined;
    originId!: number;
    destination!: LocationDto;
    paysTransport!: boolean;
    date!: DateTime;
    truckPlate!: string | undefined;
    truckVendorFantasyName!: string | undefined;
    driver!: DriverDto;
    article!: ArticleDiverseProductsDto;
    contract!: ContractDto;
    validationResult!: PreActivityReportValidation;
    preActivityReportErrors!: PreActivityReportErrorDto[] | undefined;
    errorList!: string[] | undefined;
    placeId!: number;

    constructor(data?: IViewDiverseProductPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originName = _data["originName"];
            this.originId = _data["originId"];
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.truckPlate = _data["truckPlate"];
            this.truckVendorFantasyName = _data["truckVendorFantasyName"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.article = _data["article"] ? ArticleDiverseProductsDto.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.validationResult = _data["validationResult"];
            if (Array.isArray(_data["preActivityReportErrors"])) {
                this.preActivityReportErrors = [] as any;
                for (let item of _data["preActivityReportErrors"])
                    this.preActivityReportErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ViewDiverseProductPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ViewDiverseProductPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originName"] = this.originName;
        data["originId"] = this.originId;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["truckPlate"] = this.truckPlate;
        data["truckVendorFantasyName"] = this.truckVendorFantasyName;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["validationResult"] = this.validationResult;
        if (Array.isArray(this.preActivityReportErrors)) {
            data["preActivityReportErrors"] = [];
            for (let item of this.preActivityReportErrors)
                data["preActivityReportErrors"].push(item.toJSON());
        }
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IViewDiverseProductPreActivityReportOutput {
    originName: string | undefined;
    originId: number;
    destination: LocationDto;
    paysTransport: boolean;
    date: DateTime;
    truckPlate: string | undefined;
    truckVendorFantasyName: string | undefined;
    driver: DriverDto;
    article: ArticleDiverseProductsDto;
    contract: ContractDto;
    validationResult: PreActivityReportValidation;
    preActivityReportErrors: PreActivityReportErrorDto[] | undefined;
    errorList: string[] | undefined;
    placeId: number;
}

export class ViewInternalMovementPreActivityReportOutput implements IViewInternalMovementPreActivityReportOutput {
    originName!: string | undefined;
    date!: DateTime;
    truckPlate!: string | undefined;
    vendorFantasyName!: string | undefined;
    driver!: DriverDto;
    article!: ArticleInternalMovementDto;
    validationResult!: PreActivityReportValidation;
    preActivityReportErrors!: PreActivityReportErrorDto[] | undefined;
    errorList!: string[] | undefined;

    constructor(data?: IViewInternalMovementPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originName = _data["originName"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.truckPlate = _data["truckPlate"];
            this.vendorFantasyName = _data["vendorFantasyName"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.article = _data["article"] ? ArticleInternalMovementDto.fromJS(_data["article"]) : <any>undefined;
            this.validationResult = _data["validationResult"];
            if (Array.isArray(_data["preActivityReportErrors"])) {
                this.preActivityReportErrors = [] as any;
                for (let item of _data["preActivityReportErrors"])
                    this.preActivityReportErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): ViewInternalMovementPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ViewInternalMovementPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originName"] = this.originName;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["truckPlate"] = this.truckPlate;
        data["vendorFantasyName"] = this.vendorFantasyName;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["validationResult"] = this.validationResult;
        if (Array.isArray(this.preActivityReportErrors)) {
            data["preActivityReportErrors"] = [];
            for (let item of this.preActivityReportErrors)
                data["preActivityReportErrors"].push(item.toJSON());
        }
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IViewInternalMovementPreActivityReportOutput {
    originName: string | undefined;
    date: DateTime;
    truckPlate: string | undefined;
    vendorFantasyName: string | undefined;
    driver: DriverDto;
    article: ArticleInternalMovementDto;
    validationResult: PreActivityReportValidation;
    preActivityReportErrors: PreActivityReportErrorDto[] | undefined;
    errorList: string[] | undefined;
}

export class ViewWoodPreActivityReportDto implements IViewWoodPreActivityReportDto {
    report!: WoodPreActivityReportFullDto;
    shouldHaveLoaderServiceVendor!: boolean;

    constructor(data?: IViewWoodPreActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["report"] ? WoodPreActivityReportFullDto.fromJS(_data["report"]) : <any>undefined;
            this.shouldHaveLoaderServiceVendor = _data["shouldHaveLoaderServiceVendor"];
        }
    }

    static fromJS(data: any): ViewWoodPreActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewWoodPreActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        data["shouldHaveLoaderServiceVendor"] = this.shouldHaveLoaderServiceVendor;
        return data;
    }
}

export interface IViewWoodPreActivityReportDto {
    report: WoodPreActivityReportFullDto;
    shouldHaveLoaderServiceVendor: boolean;
}

export class VolumeProjectionOutputDto implements IVolumeProjectionOutputDto {
    placeId!: number;
    volumeProjection!: number;
    totalReceipts!: number;
    dateToCompare!: DateTime;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    sincedHours!: number;
    message!: string | undefined;

    constructor(data?: IVolumeProjectionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.volumeProjection = _data["volumeProjection"];
            this.totalReceipts = _data["totalReceipts"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.sincedHours = _data["sincedHours"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VolumeProjectionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VolumeProjectionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["volumeProjection"] = this.volumeProjection;
        data["totalReceipts"] = this.totalReceipts;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["sincedHours"] = this.sincedHours;
        data["message"] = this.message;
        return data;
    }
}

export interface IVolumeProjectionOutputDto {
    placeId: number;
    volumeProjection: number;
    totalReceipts: number;
    dateToCompare: DateTime;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    sincedHours: number;
    message: string | undefined;
}

export class WebPushNotificationParametersOutputDto implements IWebPushNotificationParametersOutputDto {
    publicKey!: string | undefined;

    constructor(data?: IWebPushNotificationParametersOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicKey = _data["publicKey"];
        }
    }

    static fromJS(data: any): WebPushNotificationParametersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebPushNotificationParametersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicKey"] = this.publicKey;
        return data;
    }
}

export interface IWebPushNotificationParametersOutputDto {
    publicKey: string | undefined;
}

export class WebPushSubscriptionOutput implements IWebPushSubscriptionOutput {
    isError!: boolean;
    message!: string | undefined;
    browserIdentifier!: string | undefined;

    constructor(data?: IWebPushSubscriptionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isError = _data["isError"];
            this.message = _data["message"];
            this.browserIdentifier = _data["browserIdentifier"];
        }
    }

    static fromJS(data: any): WebPushSubscriptionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WebPushSubscriptionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError;
        data["message"] = this.message;
        data["browserIdentifier"] = this.browserIdentifier;
        return data;
    }
}

export interface IWebPushSubscriptionOutput {
    isError: boolean;
    message: string | undefined;
    browserIdentifier: string | undefined;
}

export class WeightDto implements IWeightDto {
    id!: number;
    reasonId!: number | undefined;
    reasonComment!: string | undefined;
    value!: number;
    takedWeightTime!: DateTime | undefined;

    constructor(data?: IWeightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reasonId = _data["reasonId"];
            this.reasonComment = _data["reasonComment"];
            this.value = _data["value"];
            this.takedWeightTime = _data["takedWeightTime"] ? DateTime.fromISO(_data["takedWeightTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WeightDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reasonId"] = this.reasonId;
        data["reasonComment"] = this.reasonComment;
        data["value"] = this.value;
        data["takedWeightTime"] = this.takedWeightTime ? this.takedWeightTime.toString() : <any>undefined;
        return data;
    }
}

export interface IWeightDto {
    id: number;
    reasonId: number | undefined;
    reasonComment: string | undefined;
    value: number;
    takedWeightTime: DateTime | undefined;
}

export class WizardInfoOutputDto implements IWizardInfoOutputDto {
    vendor!: VendorDto;
    vehicle!: VehicleDto;
    travelDetail!: TravelDetailDto;
    errorList!: string[] | undefined;
    isBlockingError!: boolean;

    constructor(data?: IWizardInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            this.travelDetail = _data["travelDetail"] ? TravelDetailDto.fromJS(_data["travelDetail"]) : <any>undefined;
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            this.isBlockingError = _data["isBlockingError"];
        }
    }

    static fromJS(data: any): WizardInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WizardInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["travelDetail"] = this.travelDetail ? this.travelDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["isBlockingError"] = this.isBlockingError;
        return data;
    }
}

export interface IWizardInfoOutputDto {
    vendor: VendorDto;
    vehicle: VehicleDto;
    travelDetail: TravelDetailDto;
    errorList: string[] | undefined;
    isBlockingError: boolean;
}

export class WoodActivityReportAbortedScannerReasonDto implements IWoodActivityReportAbortedScannerReasonDto {
    reasonId!: number;
    comment!: string | undefined;

    constructor(data?: IWoodActivityReportAbortedScannerReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): WoodActivityReportAbortedScannerReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportAbortedScannerReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IWoodActivityReportAbortedScannerReasonDto {
    reasonId: number;
    comment: string | undefined;
}

export enum WoodActivityReportCreationSystemFilter {
    All = 0,
    SmartTruck = 1,
    ProvidersModule = 2,
    Api = 3,
    Totem = 4,
}

export class WoodActivityReportDto implements IWoodActivityReportDto {
    operationMode!: ActivityReportOperationMode;
    type!: string | undefined;
    activityReportLines!: WoodControlActivityReportLineDto[] | undefined;
    sampleAssignment!: SampleAssignmentType;
    serial!: string | undefined;
    number!: number;
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    isChip!: boolean;
    chipHumidity!: number | undefined;
    internalDestinationName!: string | undefined;
    externalActivityReportId!: number | undefined;
    sampleAlgorithmExecuted!: boolean;
    loadActivityReportId!: number;
    localId!: number | undefined;
    hasLoadActivityReport!: boolean;
    usesScannerMeasurements!: boolean;
    abortedScannerReason!: WoodActivityReportAbortedScannerReasonDto;
    scannerIntegrationId!: number | undefined;
    creatorUserId!: number | undefined;
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    tripNumber!: number;
    tenantId!: number;
    transport!: VehicleDto;
    driver!: DriverDto;
    origin!: LocationWithPaysTransportDto;
    destination!: LocationDto;
    activityReportDate!: DateTime;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    customsDeclaration!: SingleCustomDeclarationOutput;
    comment!: string | undefined;
    placeId!: number;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    id!: number;

    constructor(data?: IWoodActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationMode = _data["operationMode"];
            this.type = _data["type"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(WoodControlActivityReportLineDto.fromJS(item));
            }
            this.sampleAssignment = _data["sampleAssignment"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.isChip = _data["isChip"];
            this.chipHumidity = _data["chipHumidity"];
            this.internalDestinationName = _data["internalDestinationName"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.sampleAlgorithmExecuted = _data["sampleAlgorithmExecuted"];
            this.loadActivityReportId = _data["loadActivityReportId"];
            this.localId = _data["localId"];
            this.hasLoadActivityReport = _data["hasLoadActivityReport"];
            this.usesScannerMeasurements = _data["usesScannerMeasurements"];
            this.abortedScannerReason = _data["abortedScannerReason"] ? WoodActivityReportAbortedScannerReasonDto.fromJS(_data["abortedScannerReason"]) : <any>undefined;
            this.scannerIntegrationId = _data["scannerIntegrationId"];
            this.creatorUserId = _data["creatorUserId"];
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.tripNumber = _data["tripNumber"];
            this.tenantId = _data["tenantId"];
            this.transport = _data["transport"] ? VehicleDto.fromJS(_data["transport"]) : <any>undefined;
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationWithPaysTransportDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.customsDeclaration = _data["customsDeclaration"] ? SingleCustomDeclarationOutput.fromJS(_data["customsDeclaration"]) : <any>undefined;
            this.comment = _data["comment"];
            this.placeId = _data["placeId"];
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationMode"] = this.operationMode;
        data["type"] = this.type;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["sampleAssignment"] = this.sampleAssignment;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["chipHumidity"] = this.chipHumidity;
        data["internalDestinationName"] = this.internalDestinationName;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["sampleAlgorithmExecuted"] = this.sampleAlgorithmExecuted;
        data["loadActivityReportId"] = this.loadActivityReportId;
        data["localId"] = this.localId;
        data["hasLoadActivityReport"] = this.hasLoadActivityReport;
        data["usesScannerMeasurements"] = this.usesScannerMeasurements;
        data["abortedScannerReason"] = this.abortedScannerReason ? this.abortedScannerReason.toJSON() : <any>undefined;
        data["scannerIntegrationId"] = this.scannerIntegrationId;
        data["creatorUserId"] = this.creatorUserId;
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["tripNumber"] = this.tripNumber;
        data["tenantId"] = this.tenantId;
        data["transport"] = this.transport ? this.transport.toJSON() : <any>undefined;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["customsDeclaration"] = this.customsDeclaration ? this.customsDeclaration.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["placeId"] = this.placeId;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodActivityReportDto {
    operationMode: ActivityReportOperationMode;
    type: string | undefined;
    activityReportLines: WoodControlActivityReportLineDto[] | undefined;
    sampleAssignment: SampleAssignmentType;
    serial: string | undefined;
    number: number;
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    isChip: boolean;
    chipHumidity: number | undefined;
    internalDestinationName: string | undefined;
    externalActivityReportId: number | undefined;
    sampleAlgorithmExecuted: boolean;
    loadActivityReportId: number;
    localId: number | undefined;
    hasLoadActivityReport: boolean;
    usesScannerMeasurements: boolean;
    abortedScannerReason: WoodActivityReportAbortedScannerReasonDto;
    scannerIntegrationId: number | undefined;
    creatorUserId: number | undefined;
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    tripNumber: number;
    tenantId: number;
    transport: VehicleDto;
    driver: DriverDto;
    origin: LocationWithPaysTransportDto;
    destination: LocationDto;
    activityReportDate: DateTime;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    customsDeclaration: SingleCustomDeclarationOutput;
    comment: string | undefined;
    placeId: number;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    id: number;
}

export class WoodActivityReportForMassEditGridDto implements IWoodActivityReportForMassEditGridDto {
    reportId!: number;
    licensePlate!: string | undefined;
    state!: ActivityReportState;
    condition!: ActivityReportStateCondition;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    canEdit!: boolean;
    cantEditMessage!: string | undefined;
    destinationId!: number;
    originId!: number;

    constructor(data?: IWoodActivityReportForMassEditGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.licensePlate = _data["licensePlate"];
            this.state = _data["state"];
            this.condition = _data["condition"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.canEdit = _data["canEdit"];
            this.cantEditMessage = _data["cantEditMessage"];
            this.destinationId = _data["destinationId"];
            this.originId = _data["originId"];
        }
    }

    static fromJS(data: any): WoodActivityReportForMassEditGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportForMassEditGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["licensePlate"] = this.licensePlate;
        data["state"] = this.state;
        data["condition"] = this.condition;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["canEdit"] = this.canEdit;
        data["cantEditMessage"] = this.cantEditMessage;
        data["destinationId"] = this.destinationId;
        data["originId"] = this.originId;
        return data;
    }
}

export interface IWoodActivityReportForMassEditGridDto {
    reportId: number;
    licensePlate: string | undefined;
    state: ActivityReportState;
    condition: ActivityReportStateCondition;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    canEdit: boolean;
    cantEditMessage: string | undefined;
    destinationId: number;
    originId: number;
}

export class WoodActivityReportForSamplesGridDto implements IWoodActivityReportForSamplesGridDto {
    date!: DateTime;
    sampleAssignment!: SampleAssignmentType;
    wasCompleted!: boolean;
    licensePlate!: string | undefined;
    isInPlant!: boolean;
    isChip!: boolean;
    externalId!: number | undefined;
    activityReportState!: ActivityReportState;
    activityReportStateCondition!: ActivityReportStateCondition;
    canRelease!: boolean;
    localId!: number | undefined;
    exitZoneId!: number | undefined;
    originName!: string | undefined;
    standName!: string | undefined;
    id!: number;

    constructor(data?: IWoodActivityReportForSamplesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.sampleAssignment = _data["sampleAssignment"];
            this.wasCompleted = _data["wasCompleted"];
            this.licensePlate = _data["licensePlate"];
            this.isInPlant = _data["isInPlant"];
            this.isChip = _data["isChip"];
            this.externalId = _data["externalId"];
            this.activityReportState = _data["activityReportState"];
            this.activityReportStateCondition = _data["activityReportStateCondition"];
            this.canRelease = _data["canRelease"];
            this.localId = _data["localId"];
            this.exitZoneId = _data["exitZoneId"];
            this.originName = _data["originName"];
            this.standName = _data["standName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodActivityReportForSamplesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportForSamplesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["sampleAssignment"] = this.sampleAssignment;
        data["wasCompleted"] = this.wasCompleted;
        data["licensePlate"] = this.licensePlate;
        data["isInPlant"] = this.isInPlant;
        data["isChip"] = this.isChip;
        data["externalId"] = this.externalId;
        data["activityReportState"] = this.activityReportState;
        data["activityReportStateCondition"] = this.activityReportStateCondition;
        data["canRelease"] = this.canRelease;
        data["localId"] = this.localId;
        data["exitZoneId"] = this.exitZoneId;
        data["originName"] = this.originName;
        data["standName"] = this.standName;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodActivityReportForSamplesGridDto {
    date: DateTime;
    sampleAssignment: SampleAssignmentType;
    wasCompleted: boolean;
    licensePlate: string | undefined;
    isInPlant: boolean;
    isChip: boolean;
    externalId: number | undefined;
    activityReportState: ActivityReportState;
    activityReportStateCondition: ActivityReportStateCondition;
    canRelease: boolean;
    localId: number | undefined;
    exitZoneId: number | undefined;
    originName: string | undefined;
    standName: string | undefined;
    id: number;
}

export class WoodActivityReportGeoLocationInformationDto implements IWoodActivityReportGeoLocationInformationDto {
    latitude!: number;
    longitude!: number;
    precision!: number | undefined;

    constructor(data?: IWoodActivityReportGeoLocationInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.precision = _data["precision"];
        }
    }

    static fromJS(data: any): WoodActivityReportGeoLocationInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportGeoLocationInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["precision"] = this.precision;
        return data;
    }
}

export interface IWoodActivityReportGeoLocationInformationDto {
    latitude: number;
    longitude: number;
    precision: number | undefined;
}

export class WoodActivityReportLineInput implements IWoodActivityReportLineInput {
    standExternalId!: number;
    articleExternalId!: number;
    contractExternalId!: number;
    services!: ServiceActivityDto[] | undefined;
    isPefcCertified!: boolean;
    pileId!: number | undefined;

    constructor(data?: IWoodActivityReportLineInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standExternalId = _data["standExternalId"];
            this.articleExternalId = _data["articleExternalId"];
            this.contractExternalId = _data["contractExternalId"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceActivityDto.fromJS(item));
            }
            this.isPefcCertified = _data["isPefcCertified"];
            this.pileId = _data["pileId"];
        }
    }

    static fromJS(data: any): WoodActivityReportLineInput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportLineInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standExternalId"] = this.standExternalId;
        data["articleExternalId"] = this.articleExternalId;
        data["contractExternalId"] = this.contractExternalId;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["isPefcCertified"] = this.isPefcCertified;
        data["pileId"] = this.pileId;
        return data;
    }
}

export interface IWoodActivityReportLineInput {
    standExternalId: number;
    articleExternalId: number;
    contractExternalId: number;
    services: ServiceActivityDto[] | undefined;
    isPefcCertified: boolean;
    pileId: number | undefined;
}

export class WoodActivityReportLogsInputDto implements IWoodActivityReportLogsInputDto {
    activityReportId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IWoodActivityReportLogsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): WoodActivityReportLogsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportLogsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IWoodActivityReportLogsInputDto {
    activityReportId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class WoodActivityReportsTruck implements IWoodActivityReportsTruck {
    id!: number;
    licensePlate!: string | undefined;

    constructor(data?: IWoodActivityReportsTruck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): WoodActivityReportsTruck {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportsTruck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IWoodActivityReportsTruck {
    id: number;
    licensePlate: string | undefined;
}

export class WoodControlActivityReportLineDto implements IWoodControlActivityReportLineDto {
    tableLineId!: string | undefined;
    contract!: ContractDto;
    stand!: StandOutputDto;
    article!: ArticleDtoOutput;
    netWeight!: number;
    grossWeight!: number;
    tareWeight!: number;
    services!: ServiceActivityDto[] | undefined;
    contractType!: ContractTypeDto;
    vendor!: VendorDto;
    property!: SimpleLocationDto;
    origin!: LocationDto;
    barkSample!: boolean;
    isPefcCertified!: boolean | undefined;
    pile!: PileForViewDto;
    shouldBeSampled!: boolean;
    id!: number;

    constructor(data?: IWoodControlActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableLineId = _data["tableLineId"];
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.stand = _data["stand"] ? StandOutputDto.fromJS(_data["stand"]) : <any>undefined;
            this.article = _data["article"] ? ArticleDtoOutput.fromJS(_data["article"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceActivityDto.fromJS(item));
            }
            this.contractType = _data["contractType"] ? ContractTypeDto.fromJS(_data["contractType"]) : <any>undefined;
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.property = _data["property"] ? SimpleLocationDto.fromJS(_data["property"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.barkSample = _data["barkSample"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.pile = _data["pile"] ? PileForViewDto.fromJS(_data["pile"]) : <any>undefined;
            this.shouldBeSampled = _data["shouldBeSampled"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodControlActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodControlActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableLineId"] = this.tableLineId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["barkSample"] = this.barkSample;
        data["isPefcCertified"] = this.isPefcCertified;
        data["pile"] = this.pile ? this.pile.toJSON() : <any>undefined;
        data["shouldBeSampled"] = this.shouldBeSampled;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodControlActivityReportLineDto {
    tableLineId: string | undefined;
    contract: ContractDto;
    stand: StandOutputDto;
    article: ArticleDtoOutput;
    netWeight: number;
    grossWeight: number;
    tareWeight: number;
    services: ServiceActivityDto[] | undefined;
    contractType: ContractTypeDto;
    vendor: VendorDto;
    property: SimpleLocationDto;
    origin: LocationDto;
    barkSample: boolean;
    isPefcCertified: boolean | undefined;
    pile: PileForViewDto;
    shouldBeSampled: boolean;
    id: number;
}

export class WoodPileCreationInput implements IWoodPileCreationInput {
    pileType!: PileType;
    name!: string | undefined;
    number!: number;
    logyardExternalId!: number;
    articleResourceId!: number;
    isPefcCertified!: boolean;
    isFscCertified!: boolean;
    contractTypeGroupId!: number;
    geneticMaterialTypeId!: number;
    locations!: PileOriginInput[] | undefined;
    allowsEntry!: boolean;
    allowsExit!: boolean;

    constructor(data?: IWoodPileCreationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pileType = _data["pileType"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.logyardExternalId = _data["logyardExternalId"];
            this.articleResourceId = _data["articleResourceId"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.isFscCertified = _data["isFscCertified"];
            this.contractTypeGroupId = _data["contractTypeGroupId"];
            this.geneticMaterialTypeId = _data["geneticMaterialTypeId"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(PileOriginInput.fromJS(item));
            }
            this.allowsEntry = _data["allowsEntry"];
            this.allowsExit = _data["allowsExit"];
        }
    }

    static fromJS(data: any): WoodPileCreationInput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPileCreationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pileType"] = this.pileType;
        data["name"] = this.name;
        data["number"] = this.number;
        data["logyardExternalId"] = this.logyardExternalId;
        data["articleResourceId"] = this.articleResourceId;
        data["isPefcCertified"] = this.isPefcCertified;
        data["isFscCertified"] = this.isFscCertified;
        data["contractTypeGroupId"] = this.contractTypeGroupId;
        data["geneticMaterialTypeId"] = this.geneticMaterialTypeId;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["allowsEntry"] = this.allowsEntry;
        data["allowsExit"] = this.allowsExit;
        return data;
    }
}

export interface IWoodPileCreationInput {
    pileType: PileType;
    name: string | undefined;
    number: number;
    logyardExternalId: number;
    articleResourceId: number;
    isPefcCertified: boolean;
    isFscCertified: boolean;
    contractTypeGroupId: number;
    geneticMaterialTypeId: number;
    locations: PileOriginInput[] | undefined;
    allowsEntry: boolean;
    allowsExit: boolean;
}

export class WoodPileCreationOutput implements IWoodPileCreationOutput {
    pileId!: number;
    validationResult!: boolean;
    pileNumber!: number;
    externalPileId!: number;
    errors!: string[] | undefined;

    constructor(data?: IWoodPileCreationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pileId = _data["pileId"];
            this.validationResult = _data["validationResult"];
            this.pileNumber = _data["pileNumber"];
            this.externalPileId = _data["externalPileId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): WoodPileCreationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPileCreationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pileId"] = this.pileId;
        data["validationResult"] = this.validationResult;
        data["pileNumber"] = this.pileNumber;
        data["externalPileId"] = this.externalPileId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IWoodPileCreationOutput {
    pileId: number;
    validationResult: boolean;
    pileNumber: number;
    externalPileId: number;
    errors: string[] | undefined;
}

export class WoodPileEditionInput implements IWoodPileEditionInput {
    id!: number;
    locations!: PileOriginInput[] | undefined;
    allowsEntry!: boolean;
    allowsExit!: boolean;
    pileType!: PileType;
    articleExternalId!: number;

    constructor(data?: IWoodPileEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(PileOriginInput.fromJS(item));
            }
            this.allowsEntry = _data["allowsEntry"];
            this.allowsExit = _data["allowsExit"];
            this.pileType = _data["pileType"];
            this.articleExternalId = _data["articleExternalId"];
        }
    }

    static fromJS(data: any): WoodPileEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPileEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["allowsEntry"] = this.allowsEntry;
        data["allowsExit"] = this.allowsExit;
        data["pileType"] = this.pileType;
        data["articleExternalId"] = this.articleExternalId;
        return data;
    }
}

export interface IWoodPileEditionInput {
    id: number;
    locations: PileOriginInput[] | undefined;
    allowsEntry: boolean;
    allowsExit: boolean;
    pileType: PileType;
    articleExternalId: number;
}

export class WoodPreActivityCertificationDTO implements IWoodPreActivityCertificationDTO {
    isPefcCertified!: boolean;
    isFscCertified!: boolean;

    constructor(data?: IWoodPreActivityCertificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPefcCertified = _data["isPefcCertified"];
            this.isFscCertified = _data["isFscCertified"];
        }
    }

    static fromJS(data: any): WoodPreActivityCertificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityCertificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPefcCertified"] = this.isPefcCertified;
        data["isFscCertified"] = this.isFscCertified;
        return data;
    }
}

export interface IWoodPreActivityCertificationDTO {
    isPefcCertified: boolean;
    isFscCertified: boolean;
}

export class WoodPreActivityReportCreationDto implements IWoodPreActivityReportCreationDto {
    serial!: string | undefined;
    number!: number;
    origin!: LocationDto;
    date!: DateTime;
    lines!: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken!: string | undefined;
    tripNumber!: number | undefined;
    certification!: WoodPreActivityCertificationDTO;
    truck!: VehicleDto;
    semis!: VehicleDto[] | undefined;
    driver!: BasicDriverDto;
    truckPlateIsSame!: boolean;
    truckPlateParsedFromQR!: string | undefined;
    destinationId!: number;
    destinationType!: LocationType;
    originVendorRut!: string | undefined;

    constructor(data?: IWoodPreActivityReportCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineDto.fromJS(item));
            }
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.tripNumber = _data["tripNumber"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.truck = _data["truck"] ? VehicleDto.fromJS(_data["truck"]) : <any>undefined;
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(VehicleDto.fromJS(item));
            }
            this.driver = _data["driver"] ? BasicDriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.truckPlateIsSame = _data["truckPlateIsSame"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
            this.originVendorRut = _data["originVendorRut"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["tripNumber"] = this.tripNumber;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["truck"] = this.truck ? this.truck.toJSON() : <any>undefined;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item.toJSON());
        }
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["truckPlateIsSame"] = this.truckPlateIsSame;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        data["originVendorRut"] = this.originVendorRut;
        return data;
    }
}

export interface IWoodPreActivityReportCreationDto {
    serial: string | undefined;
    number: number;
    origin: LocationDto;
    date: DateTime;
    lines: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken: string | undefined;
    tripNumber: number | undefined;
    certification: WoodPreActivityCertificationDTO;
    truck: VehicleDto;
    semis: VehicleDto[] | undefined;
    driver: BasicDriverDto;
    truckPlateIsSame: boolean;
    truckPlateParsedFromQR: string | undefined;
    destinationId: number;
    destinationType: LocationType;
    originVendorRut: string | undefined;
}

export class WoodPreActivityReportEditionFromCCInput implements IWoodPreActivityReportEditionFromCCInput {
    preReportId!: number;
    serial!: string | undefined;
    number!: number;
    driver!: DriverDto;
    origin!: LocationDto;
    semiTrailers!: VehicleDto[] | undefined;
    date!: DateTime | undefined;
    lines!: FullWoodPreActivityReportLineDto[] | undefined;
    receiptPhotoToken!: string | undefined;
    certification!: WoodPreActivityCertificationDTO;
    isApproved!: boolean;
    loaderVendorId!: number | undefined;
    continueEntryProcess!: boolean;
    destinationId!: number;
    tripNumber!: number | undefined;

    constructor(data?: IWoodPreActivityReportEditionFromCCInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            if (Array.isArray(_data["semiTrailers"])) {
                this.semiTrailers = [] as any;
                for (let item of _data["semiTrailers"])
                    this.semiTrailers!.push(VehicleDto.fromJS(item));
            }
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(FullWoodPreActivityReportLineDto.fromJS(item));
            }
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.isApproved = _data["isApproved"];
            this.loaderVendorId = _data["loaderVendorId"];
            this.continueEntryProcess = _data["continueEntryProcess"];
            this.destinationId = _data["destinationId"];
            this.tripNumber = _data["tripNumber"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportEditionFromCCInput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportEditionFromCCInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        if (Array.isArray(this.semiTrailers)) {
            data["semiTrailers"] = [];
            for (let item of this.semiTrailers)
                data["semiTrailers"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["isApproved"] = this.isApproved;
        data["loaderVendorId"] = this.loaderVendorId;
        data["continueEntryProcess"] = this.continueEntryProcess;
        data["destinationId"] = this.destinationId;
        data["tripNumber"] = this.tripNumber;
        return data;
    }
}

export interface IWoodPreActivityReportEditionFromCCInput {
    preReportId: number;
    serial: string | undefined;
    number: number;
    driver: DriverDto;
    origin: LocationDto;
    semiTrailers: VehicleDto[] | undefined;
    date: DateTime | undefined;
    lines: FullWoodPreActivityReportLineDto[] | undefined;
    receiptPhotoToken: string | undefined;
    certification: WoodPreActivityCertificationDTO;
    isApproved: boolean;
    loaderVendorId: number | undefined;
    continueEntryProcess: boolean;
    destinationId: number;
    tripNumber: number | undefined;
}

export class WoodPreActivityReportEditionInput implements IWoodPreActivityReportEditionInput {
    preReportId!: number;
    serial!: string | undefined;
    number!: number;
    driver!: DriverDto;
    origin!: LocationDto;
    semiTrailers!: VehicleDto[] | undefined;
    date!: DateTime | undefined;
    lines!: FullWoodPreActivityReportLineDto[] | undefined;
    receiptPhotoToken!: string | undefined;
    certification!: WoodPreActivityCertificationDTO;
    destinationId!: number;

    constructor(data?: IWoodPreActivityReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            if (Array.isArray(_data["semiTrailers"])) {
                this.semiTrailers = [] as any;
                for (let item of _data["semiTrailers"])
                    this.semiTrailers!.push(VehicleDto.fromJS(item));
            }
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(FullWoodPreActivityReportLineDto.fromJS(item));
            }
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        if (Array.isArray(this.semiTrailers)) {
            data["semiTrailers"] = [];
            for (let item of this.semiTrailers)
                data["semiTrailers"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IWoodPreActivityReportEditionInput {
    preReportId: number;
    serial: string | undefined;
    number: number;
    driver: DriverDto;
    origin: LocationDto;
    semiTrailers: VehicleDto[] | undefined;
    date: DateTime | undefined;
    lines: FullWoodPreActivityReportLineDto[] | undefined;
    receiptPhotoToken: string | undefined;
    certification: WoodPreActivityCertificationDTO;
    destinationId: number;
}

export class WoodPreActivityReportEditionOutput implements IWoodPreActivityReportEditionOutput {
    editionResult!: boolean;
    imageExpired!: boolean;
    preReport!: WoodPreActivityReportFullDto;
    errorList!: string[] | undefined;

    constructor(data?: IWoodPreActivityReportEditionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionResult = _data["editionResult"];
            this.imageExpired = _data["imageExpired"];
            this.preReport = _data["preReport"] ? WoodPreActivityReportFullDto.fromJS(_data["preReport"]) : <any>undefined;
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
        }
    }

    static fromJS(data: any): WoodPreActivityReportEditionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportEditionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionResult"] = this.editionResult;
        data["imageExpired"] = this.imageExpired;
        data["preReport"] = this.preReport ? this.preReport.toJSON() : <any>undefined;
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        return data;
    }
}

export interface IWoodPreActivityReportEditionOutput {
    editionResult: boolean;
    imageExpired: boolean;
    preReport: WoodPreActivityReportFullDto;
    errorList: string[] | undefined;
}

export class WoodPreActivityReportForProviderSearchOutputDto implements IWoodPreActivityReportForProviderSearchOutputDto {
    driver!: string | undefined;
    id!: number;
    date!: DateTime;
    origin!: string | undefined;
    destination!: string | undefined;
    licensePlate!: string | undefined;
    scheduledEntryTime!: DateTime | undefined;
    validationResult!: PreActivityReportValidation;
    isApproved!: boolean;
    creationMode!: PreActivityReportCreationMode;
    paysTransport!: boolean;
    tripNumber!: number | undefined;
    isChip!: boolean;
    serial!: string | undefined;
    number!: number | undefined;
    articleResourceName!: string | undefined;

    constructor(data?: IWoodPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driver = _data["driver"];
            this.id = _data["id"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.licensePlate = _data["licensePlate"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.isApproved = _data["isApproved"];
            this.creationMode = _data["creationMode"];
            this.paysTransport = _data["paysTransport"];
            this.tripNumber = _data["tripNumber"];
            this.isChip = _data["isChip"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.articleResourceName = _data["articleResourceName"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driver"] = this.driver;
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["licensePlate"] = this.licensePlate;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["isApproved"] = this.isApproved;
        data["creationMode"] = this.creationMode;
        data["paysTransport"] = this.paysTransport;
        data["tripNumber"] = this.tripNumber;
        data["isChip"] = this.isChip;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["articleResourceName"] = this.articleResourceName;
        return data;
    }
}

export interface IWoodPreActivityReportForProviderSearchOutputDto {
    driver: string | undefined;
    id: number;
    date: DateTime;
    origin: string | undefined;
    destination: string | undefined;
    licensePlate: string | undefined;
    scheduledEntryTime: DateTime | undefined;
    validationResult: PreActivityReportValidation;
    isApproved: boolean;
    creationMode: PreActivityReportCreationMode;
    paysTransport: boolean;
    tripNumber: number | undefined;
    isChip: boolean;
    serial: string | undefined;
    number: number | undefined;
    articleResourceName: string | undefined;
}

export class WoodPreActivityReportFullDto implements IWoodPreActivityReportFullDto {
    woodActivityReportLines!: FullWoodPreActivityReportLineDto[] | undefined;
    origin!: LocationDto;
    destination!: LocationDto;
    transport!: VehicleDto;
    semitrailers!: VehicleDto[] | undefined;
    driver!: DriverDto;
    tripNumber!: number | undefined;
    serial!: string | undefined;
    number!: number;
    reportType!: ActivityReportType;
    creationMode!: PreActivityReportCreationMode;
    scheduledEntryTime!: DateTime | undefined;
    paysTransport!: boolean;
    date!: DateTime;
    validationResult!: PreActivityReportValidation;
    errors!: PreActivityReportErrorDto[] | undefined;
    isApproved!: boolean;
    certification!: WoodPreActivityCertificationDTO;
    isChip!: boolean;
    travelSystemHasError!: boolean | undefined;

    constructor(data?: IWoodPreActivityReportFullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["woodActivityReportLines"])) {
                this.woodActivityReportLines = [] as any;
                for (let item of _data["woodActivityReportLines"])
                    this.woodActivityReportLines!.push(FullWoodPreActivityReportLineDto.fromJS(item));
            }
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.transport = _data["transport"] ? VehicleDto.fromJS(_data["transport"]) : <any>undefined;
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(VehicleDto.fromJS(item));
            }
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.reportType = _data["reportType"];
            this.creationMode = _data["creationMode"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.isApproved = _data["isApproved"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.isChip = _data["isChip"];
            this.travelSystemHasError = _data["travelSystemHasError"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportFullDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportFullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.woodActivityReportLines)) {
            data["woodActivityReportLines"] = [];
            for (let item of this.woodActivityReportLines)
                data["woodActivityReportLines"].push(item.toJSON());
        }
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["transport"] = this.transport ? this.transport.toJSON() : <any>undefined;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["reportType"] = this.reportType;
        data["creationMode"] = this.creationMode;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isApproved"] = this.isApproved;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["travelSystemHasError"] = this.travelSystemHasError;
        return data;
    }
}

export interface IWoodPreActivityReportFullDto {
    woodActivityReportLines: FullWoodPreActivityReportLineDto[] | undefined;
    origin: LocationDto;
    destination: LocationDto;
    transport: VehicleDto;
    semitrailers: VehicleDto[] | undefined;
    driver: DriverDto;
    tripNumber: number | undefined;
    serial: string | undefined;
    number: number;
    reportType: ActivityReportType;
    creationMode: PreActivityReportCreationMode;
    scheduledEntryTime: DateTime | undefined;
    paysTransport: boolean;
    date: DateTime;
    validationResult: PreActivityReportValidation;
    errors: PreActivityReportErrorDto[] | undefined;
    isApproved: boolean;
    certification: WoodPreActivityCertificationDTO;
    isChip: boolean;
    travelSystemHasError: boolean | undefined;
}

export class WoodPreActivityReportQrCreationDto implements IWoodPreActivityReportQrCreationDto {
    isThirdPartyQR!: boolean;
    serial!: string | undefined;
    number!: number;
    origin!: LocationDto;
    date!: DateTime;
    lines!: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken!: string | undefined;
    tripNumber!: number | undefined;
    certification!: WoodPreActivityCertificationDTO;
    truck!: VehicleDto;
    semis!: VehicleDto[] | undefined;
    driver!: BasicDriverDto;
    truckPlateIsSame!: boolean;
    truckPlateParsedFromQR!: string | undefined;
    destinationId!: number;
    destinationType!: LocationType;
    originVendorRut!: string | undefined;

    constructor(data?: IWoodPreActivityReportQrCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isThirdPartyQR = _data["isThirdPartyQR"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineDto.fromJS(item));
            }
            this.receiptPhotoToken = _data["receiptPhotoToken"];
            this.tripNumber = _data["tripNumber"];
            this.certification = _data["certification"] ? WoodPreActivityCertificationDTO.fromJS(_data["certification"]) : <any>undefined;
            this.truck = _data["truck"] ? VehicleDto.fromJS(_data["truck"]) : <any>undefined;
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(VehicleDto.fromJS(item));
            }
            this.driver = _data["driver"] ? BasicDriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.truckPlateIsSame = _data["truckPlateIsSame"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
            this.originVendorRut = _data["originVendorRut"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportQrCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportQrCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isThirdPartyQR"] = this.isThirdPartyQR;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["receiptPhotoToken"] = this.receiptPhotoToken;
        data["tripNumber"] = this.tripNumber;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["truck"] = this.truck ? this.truck.toJSON() : <any>undefined;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item.toJSON());
        }
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["truckPlateIsSame"] = this.truckPlateIsSame;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        data["originVendorRut"] = this.originVendorRut;
        return data;
    }
}

export interface IWoodPreActivityReportQrCreationDto {
    isThirdPartyQR: boolean;
    serial: string | undefined;
    number: number;
    origin: LocationDto;
    date: DateTime;
    lines: WoodControlActivityReportLineDto[] | undefined;
    receiptPhotoToken: string | undefined;
    tripNumber: number | undefined;
    certification: WoodPreActivityCertificationDTO;
    truck: VehicleDto;
    semis: VehicleDto[] | undefined;
    driver: BasicDriverDto;
    truckPlateIsSame: boolean;
    truckPlateParsedFromQR: string | undefined;
    destinationId: number;
    destinationType: LocationType;
    originVendorRut: string | undefined;
}

export class WoodPreReportEntranceRequiredInfoDto implements IWoodPreReportEntranceRequiredInfoDto {
    id!: number;
    validationResult!: PreActivityReportValidation;
    paysTransport!: boolean;
    scheduledTurn!: DateTime | undefined;
    isApproved!: boolean;
    creationSystem!: ActivityReportCreationSystem;
    isChip!: boolean;

    constructor(data?: IWoodPreReportEntranceRequiredInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationResult = _data["validationResult"];
            this.paysTransport = _data["paysTransport"];
            this.scheduledTurn = _data["scheduledTurn"] ? DateTime.fromISO(_data["scheduledTurn"].toString()) : <any>undefined;
            this.isApproved = _data["isApproved"];
            this.creationSystem = _data["creationSystem"];
            this.isChip = _data["isChip"];
        }
    }

    static fromJS(data: any): WoodPreReportEntranceRequiredInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreReportEntranceRequiredInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationResult"] = this.validationResult;
        data["paysTransport"] = this.paysTransport;
        data["scheduledTurn"] = this.scheduledTurn ? this.scheduledTurn.toString() : <any>undefined;
        data["isApproved"] = this.isApproved;
        data["creationSystem"] = this.creationSystem;
        data["isChip"] = this.isChip;
        return data;
    }
}

export interface IWoodPreReportEntranceRequiredInfoDto {
    id: number;
    validationResult: PreActivityReportValidation;
    paysTransport: boolean;
    scheduledTurn: DateTime | undefined;
    isApproved: boolean;
    creationSystem: ActivityReportCreationSystem;
    isChip: boolean;
}

export class WoodReportInputDto implements IWoodReportInputDto {
    reportId!: number | undefined;
    serial!: string | undefined;
    number!: number | undefined;
    vehicleLicensePlate!: string | undefined;
    reportState!: ActivityReportState;
    articleExternalId!: number | undefined;
    tripNumber!: number | undefined;
    woodProviderExternalId!: number | undefined;
    cutServiceVendorExternalId!: number | undefined;
    extractionServiceVendorExternalId!: number | undefined;
    transportVendorExternalId!: number | undefined;
    contractTypeExternalId!: number | undefined;
    driverExternalId!: number | undefined;
    singleCustomDeclaration!: number | undefined;
    pileId!: number | undefined;
    includeDeletedOnes!: boolean;
    operationMode!: ActivityReportOperationMode;
    originExternalId!: number | undefined;
    standExternalId!: number | undefined;
    destinationExternalId!: number | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    placeId!: number;

    constructor(data?: IWoodReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.reportState = _data["reportState"];
            this.articleExternalId = _data["articleExternalId"];
            this.tripNumber = _data["tripNumber"];
            this.woodProviderExternalId = _data["woodProviderExternalId"];
            this.cutServiceVendorExternalId = _data["cutServiceVendorExternalId"];
            this.extractionServiceVendorExternalId = _data["extractionServiceVendorExternalId"];
            this.transportVendorExternalId = _data["transportVendorExternalId"];
            this.contractTypeExternalId = _data["contractTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.singleCustomDeclaration = _data["singleCustomDeclaration"];
            this.pileId = _data["pileId"];
            this.includeDeletedOnes = _data["includeDeletedOnes"];
            this.operationMode = _data["operationMode"];
            this.originExternalId = _data["originExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): WoodReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["reportState"] = this.reportState;
        data["articleExternalId"] = this.articleExternalId;
        data["tripNumber"] = this.tripNumber;
        data["woodProviderExternalId"] = this.woodProviderExternalId;
        data["cutServiceVendorExternalId"] = this.cutServiceVendorExternalId;
        data["extractionServiceVendorExternalId"] = this.extractionServiceVendorExternalId;
        data["transportVendorExternalId"] = this.transportVendorExternalId;
        data["contractTypeExternalId"] = this.contractTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["singleCustomDeclaration"] = this.singleCustomDeclaration;
        data["pileId"] = this.pileId;
        data["includeDeletedOnes"] = this.includeDeletedOnes;
        data["operationMode"] = this.operationMode;
        data["originExternalId"] = this.originExternalId;
        data["standExternalId"] = this.standExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IWoodReportInputDto {
    reportId: number | undefined;
    serial: string | undefined;
    number: number | undefined;
    vehicleLicensePlate: string | undefined;
    reportState: ActivityReportState;
    articleExternalId: number | undefined;
    tripNumber: number | undefined;
    woodProviderExternalId: number | undefined;
    cutServiceVendorExternalId: number | undefined;
    extractionServiceVendorExternalId: number | undefined;
    transportVendorExternalId: number | undefined;
    contractTypeExternalId: number | undefined;
    driverExternalId: number | undefined;
    singleCustomDeclaration: number | undefined;
    pileId: number | undefined;
    includeDeletedOnes: boolean;
    operationMode: ActivityReportOperationMode;
    originExternalId: number | undefined;
    standExternalId: number | undefined;
    destinationExternalId: number | undefined;
    startDate: DateTime;
    endDate: DateTime;
    placeId: number;
}

export class WoodTruckTypeDto implements IWoodTruckTypeDto {
    resourceType!: ExternalResourceTypeDto;
    isTritrain!: boolean;
    id!: number;

    constructor(data?: IWoodTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceType = _data["resourceType"] ? ExternalResourceTypeDto.fromJS(_data["resourceType"]) : <any>undefined;
            this.isTritrain = _data["isTritrain"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceType"] = this.resourceType ? this.resourceType.toJSON() : <any>undefined;
        data["isTritrain"] = this.isTritrain;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodTruckTypeDto {
    resourceType: ExternalResourceTypeDto;
    isTritrain: boolean;
    id: number;
}

export class WoodVendorQuotaDto implements IWoodVendorQuotaDto {
    hourlyQuota!: number;
    tolerance!: number;
    vendors!: BasicVendorDto[] | undefined;
    volumeDailyTolerance!: number;

    constructor(data?: IWoodVendorQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyQuota = _data["hourlyQuota"];
            this.tolerance = _data["tolerance"];
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(BasicVendorDto.fromJS(item));
            }
            this.volumeDailyTolerance = _data["volumeDailyTolerance"];
        }
    }

    static fromJS(data: any): WoodVendorQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodVendorQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyQuota"] = this.hourlyQuota;
        data["tolerance"] = this.tolerance;
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        data["volumeDailyTolerance"] = this.volumeDailyTolerance;
        return data;
    }
}

export interface IWoodVendorQuotaDto {
    hourlyQuota: number;
    tolerance: number;
    vendors: BasicVendorDto[] | undefined;
    volumeDailyTolerance: number;
}

export class ZoneDto implements IZoneDto {
    id!: number;

    constructor(data?: IZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IZoneDto {
    id: number;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}